/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from "react";

class ErrorBoundary extends (require("react").Component) {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(e) { return { hasError: true, error: e }; }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: "monospace", background: "#111", color: "#f00", minHeight: "100vh" }}>
          <h2>❌ Erreur application</h2>
          <pre style={{ whiteSpace: "pre-wrap", color: "#ff6" }}>{this.state.error?.toString()}</pre>
          <pre style={{ whiteSpace: "pre-wrap", color: "#aaa", fontSize: 11 }}>{this.state.error?.stack}</pre>
          <button onClick={() => window.location.reload()} style={{ marginTop: 20, padding: "10px 20px", background: "#F5C800", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 700 }}>🔄 Recharger</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const COLORS = {
  bg: "#111111",
  surface: "#1a1a1a",
  card: "#222222",
  border: "#333333",
  accent: "#F5C800",
  accentGlow: "#F5C80033",
  green: "#22c55e",
  yellow: "#F5C800",
  orange: "#f97316",
  red: "#ef4444",
  text: "#f0f0f0",
  muted: "#888888",
};


// ── COEFFICIENTS EP 3CL-DPE 2021 (Arrêté 31/03/2021) ──
const COEFF_EP = {
  elec: 1.9,            // Électricité
  gaz: 1.1,             // Gaz naturel
  fioul: 1.1,           // Fioul
  gpl: 1.1,             // GPL / Propane
  bois_buches: 1.0,     // Bois bûches
  granules: 1.0,        // Granulés / pellets
  bois_chaudiere: 1.0,  // Chaudière bois
  poele_bois: 1.0,      // Poêle bois bûches
  poele_granules: 1.0,  // Poêle à granulés
  insert: 1.0,          // Insert bois
  reseau: 0.627,        // Réseau de chaleur urbain (moyen national 2021)
  reseau_chaleur: 0.627,
  pac_air_eau: 1.9,     // PAC (coeff appliqué sur EF puis divisé par SCOP)
  pac_air_air: 1.9,
  pac_geo: 1.9,
  default: 1.0,
};
function getCoeffEP(energie) {
  return COEFF_EP[energie] || COEFF_EP.default;
}
// Rendements par défaut 3CL-DPE 2021
const RENDEMENT_DEFAUT = {
  chaudiere_standard: 0.77,
  chaudiere_basse_temp: 0.87,
  chaudiere_condensation: 1.05,
  poele_bois: 0.70,           // Poêle bûches labelisé
  poele_bois_ancien: 0.55,    // Ancien poêle non labelisé
  poele_granules: 0.85,       // Poêle granulés labelisé
  insert: 0.65,
  chaudiere_bois: 0.75,
  convecteur_elec: 1.0,
  reseau: 0.9,
  pac_air_eau: 3.5,   // SCOP
  pac_air_air: 3.5,
  pac_geo: 4.0,
  default: 1.0,
};

const DPE_CLASSES = [
  { label: "A", max: 70, color: "#1a9e3f", textColor: "#fff" },
  { label: "B", max: 110, color: "#4caf50", textColor: "#fff" },
  { label: "C", max: 180, color: "#8bc34a", textColor: "#fff" },
  { label: "D", max: 250, color: "#ffeb3b", textColor: "#000" },
  { label: "E", max: 330, color: "#ff9800", textColor: "#fff" },
  { label: "F", max: 420, color: "#ff5722", textColor: "#fff" },
  { label: "G", max: Infinity, color: "#b71c1c", textColor: "#fff" },
];

// Seuils GES 3CL-DPE 2021 (kg CO₂ éq./m²/an)
const GES_CLASSES = [
  { label: "A", max: 6,   color: "#1a9e3f", textColor: "#fff" },
  { label: "B", max: 11,  color: "#4caf50", textColor: "#fff" },
  { label: "C", max: 30,  color: "#8bc34a", textColor: "#fff" },
  { label: "D", max: 50,  color: "#ffeb3b", textColor: "#000" },
  { label: "E", max: 70,  color: "#ff9800", textColor: "#fff" },
  { label: "F", max: 100, color: "#ff5722", textColor: "#fff" },
  { label: "G", max: Infinity, color: "#b71c1c", textColor: "#fff" },
];

function getDPEClass(value) {
  return DPE_CLASSES.find((c) => value <= c.max) || DPE_CLASSES[6];
}

function getGESClass(value) {
  return GES_CLASSES.find((c) => value <= c.max) || GES_CLASSES[6];
}

// Top-level modules (icônes du menu principal)
const MODULES = [
  { id: "scanner_dpe", icon: "📷",            label: "SCAN/DPE",           shortLabel: "SCAN/DPE",  subLabel: "Scanner équipements", color: "#F5C800" },
  { id: "dpe_xml",     icon: "📁",            label: "DPE Projeté XML",    shortLabel: "DPE XML",   subLabel: "Import ADEME",        color: "#3b82f6" },
  { id: "dpe_saisie",  icon: "📝",            label: "DPE Projeté Saisie", shortLabel: "DPE Saisie", subLabel: "Saisie terrain",     color: "#8b5cf6" },
  { id: "amiante",     icon: "amiante-badge", label: "Amiante",            shortLabel: "Amiante",   subLabel: "Hub NFX 46-020",     color: "#dc2626" },
  { id: "elec",        icon: "💡",            label: "SCAN/ELEC",          shortLabel: "ELEC",      subLabel: "XP C 16-600",        color: "#f97316" },
  { id: "parasite",    icon: "🔬",            label: "PARASITE/SCAN",      shortLabel: "Parasite",  subLabel: "Mérule · Termites · Champignons", color: "#65d11c" },
];

// Module admin caché (accessible via mot de passe en pied de page)
const ADMIN_MODULE = { id: "admin", icon: "⚙️", label: "Admin", shortLabel: "Admin", subLabel: "Gestion utilisateurs", color: "#6b7280" };

// Sous-onglets quand on est dans le module "dpe_xml"
// Onglets du module DPE Projeté XML — 7 étapes avec progression
const DPE_XML_TABS = [
  { id: "le_bien",      label: "🏠 Le Bien",     enabled: true },
  { id: "descriptif",   label: "📋 Descriptif",  enabled: true },
  { id: "reco",         label: "💡 Reco",        enabled: true },
  { id: "dpe_initial",  label: "⚡ DPE Initial", enabled: true },
  { id: "dpe_projete",  label: "🔮 DPE Projeté", enabled: true },
  { id: "synthese",     label: "📊 Synthèse",    enabled: true },
  { id: "rapport",      label: "📄 Rapport",     enabled: true },
];

const styles = {
  app: {
    minHeight: "100vh",
    background: COLORS.bg,
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    color: COLORS.text,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  header: {
    width: "100%",
    maxWidth: 700,
    padding: "32px 20px 0",
    textAlign: "center",
  },
  title: {
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: "-0.5px",
    background: `linear-gradient(135deg, #F5C800, #111111)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    margin: 0,
  },
  subtitle: {
    fontSize: 13,
    color: COLORS.muted,
    marginTop: 6,
    marginBottom: 0,
  },
  tabs: {
    display: "flex",
    gap: 0,
    background: "#1a1a1a",
    borderRadius: "10px 10px 0 0",
    padding: "0 6px",
    margin: "20px auto 0",
    width: "calc(100% - 28px)",
    maxWidth: 700,
    boxSizing: "border-box",
    borderBottom: "2px solid #3b82f6",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
  tab: (active) => ({
    padding: "12px 16px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: active ? 800 : 700,
    color: active ? "#3b82f6" : "#888",
    borderBottom: active ? "3px solid #3b82f6" : "3px solid transparent",
    marginBottom: -2,
    whiteSpace: "nowrap",
    flexShrink: 0,
    transition: "all 0.15s",
  }),
  content: {
    width: "100%",
    maxWidth: 700,
    padding: "20px 14px 40px",
    boxSizing: "border-box",
    overflowX: "hidden",
  },
  card: {
    background: COLORS.card,
    borderRadius: 16,
    border: `1px solid ${COLORS.border}`,
    padding: 20,
    marginBottom: 16,
  },
  cardTitle: {
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 14,
    color: COLORS.accent,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  uploadZone: (drag) => ({
    border: `2px dashed ${drag ? COLORS.accent : COLORS.border}`,
    borderRadius: 12,
    padding: "32px 16px",
    textAlign: "center",
    cursor: "pointer",
    background: drag ? COLORS.accentGlow : "transparent",
    transition: "all 0.2s",
  }),
  btn: (variant = "primary") => ({
    padding: "12px 24px",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 14,
    background: variant === "primary" ? "#F5C800" : COLORS.surface,
    color: variant === "primary" ? "#111111" : COLORS.text,
    border: variant === "secondary" ? `1px solid ${COLORS.border}` : "none",
    transition: "opacity 0.2s",
  }),
  input: {
    width: "100%",
    padding: "10px 14px",
    background: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    color: COLORS.text,
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    background: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    color: COLORS.text,
    fontSize: 14,
    boxSizing: "border-box",
  },
  label: {
    display: "block",
    fontSize: 12,
    color: COLORS.muted,
    marginBottom: 6,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    marginBottom: 12,
  },
  field: { marginBottom: 12 },
  tag: (color) => ({
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: 6,
    background: color + "22",
    color: color,
    fontSize: 12,
    fontWeight: 700,
    border: `1px solid ${color}44`,
    marginRight: 6,
    marginBottom: 6,
  }),
  dpeBar: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  dpeRow: (active, color) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 14px",
    borderRadius: 8,
    background: active ? color + "33" : "transparent",
    border: active ? `2px solid ${color}` : "2px solid transparent",
    transition: "all 0.3s",
  }),
  bigLetter: (color) => ({
    width: 44,
    height: 44,
    borderRadius: 8,
    background: color,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    fontSize: 22,
    flexShrink: 0,
  }),
  analysisBox: {
    background: COLORS.surface,
    borderRadius: 10,
    padding: 14,
    marginTop: 10,
    fontSize: 14,
    lineHeight: 1.6,
    color: COLORS.text,
    border: `1px solid ${COLORS.border}`,
    whiteSpace: "pre-wrap",
  },
};

// ---- Identified Equipment Component ----
function EquipmentCard({ item, onRemove }) {
  return (
    <div
      style={{
        ...styles.card,
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        padding: 14,
      }}
    >
      {item.imageUrl && (
        <img
          src={item.imageUrl}
          style={{
            width: 64,
            height: 64,
            objectFit: "cover",
            borderRadius: 8,
            flexShrink: 0,
          }}
        />
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
          {item.name}
        </div>
        <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 6 }}>
          {item.category}
        </div>
        <div>
          {item.tags?.map((t) => (
            <span key={t} style={styles.tag(COLORS.accent)}>
              {t}
            </span>
          ))}
        </div>
        {item.energyImpact && (
          <div style={{ fontSize: 12, color: COLORS.green, marginTop: 4 }}>
            Impact énergie: {item.energyImpact}
          </div>
        )}
      </div>
      <button
        onClick={onRemove}
        style={{
          background: "none",
          border: "none",
          color: COLORS.muted,
          cursor: "pointer",
          fontSize: 18,
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}

// ─── ScanFollowupChat — Chat IA après analyse + bouton Nouvelle photo ───
// Réutilisable dans SCAN/DPE, AMIANTE, PARASITE.
// Props :
//   - imageBase64 : la photo analysée (data URL ou base64 brut)
//   - imageMime : "image/jpeg" par défaut
//   - context : texte de l'analyse initiale (transmise au LLM pour cohérence)
//   - systemPrompt : préfixe du prompt selon le module ("Tu es expert amiante…")
//   - color : couleur d'accent du module
//   - onReset : callback pour le bouton "Nouvelle photo" (parent reset son state)
function ScanFollowupChat({ imageBase64, imageMime = "image/jpeg", context, systemPrompt, color = "#8b5cf6", onReset }) {
  const [question, setQuestion] = useState("");
  const [conversation, setConversation] = useState([]); // [{ q, a, loading?, error? }]
  const [busy, setBusy] = useState(false);

  const askIA = async () => {
    const q = question.trim();
    if (!q || busy) return;
    setBusy(true);
    // Ajouter Q au tableau, A en loading
    const idx = conversation.length;
    setConversation(prev => [...prev, { q, a: "", loading: true }]);
    setQuestion("");

    try {
      // Reconstituer l'historique pour le LLM
      const messages = [];
      // Premier message utilisateur : analyse initiale + photo
      const cleanB64 = (imageBase64 || "").replace(/^data:[^;]+;base64,/, "");
      const userContent = [];
      if (cleanB64) {
        userContent.push({ type: "image", source: { type: "base64", media_type: imageMime, data: cleanB64 } });
      }
      userContent.push({ type: "text", text: `Voici la photo et l'analyse initiale :\n\n${context || "(pas d'analyse précédente)"}\n\nQuestion du diagnostiqueur : ${q}` });
      messages.push({ role: "user", content: userContent });

      // Inclure les échanges précédents (sauf celui en cours qui est en "loading")
      conversation.forEach(turn => {
        if (turn.a && !turn.error) {
          messages[0].content[messages[0].content.length - 1].text += `\n\n--- Question précédente : ${turn.q}\nRéponse : ${turn.a}`;
        }
      });

      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 800,
          system: systemPrompt || "Tu es un expert en diagnostic immobilier. Réponds de manière professionnelle, concise et factuelle. Reste dans le contexte de la photo et de l'analyse initiale fournies.",
          messages,
        }),
      });
      const d = await res.json();
      const txt = d.content?.map(b => b.text || "").join("") || "Pas de réponse.";
      setConversation(prev => prev.map((t, i) => i === idx ? { q, a: txt, loading: false } : t));
    } catch (e) {
      setConversation(prev => prev.map((t, i) => i === idx ? { q, a: "Erreur : " + (e.message || "réseau"), loading: false, error: true } : t));
    }
    setBusy(false);
  };

  return (
    <div style={{ marginTop: 16, padding: 14, background: "#0a0a0a", border: `1px solid ${color}33`, borderRadius: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color, marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }}>
        <span>💬</span>
        <span>Question complémentaire à l'IA</span>
      </div>

      {/* Historique de conversation */}
      {conversation.length > 0 && (
        <div style={{ marginBottom: 12, maxHeight: 320, overflowY: "auto", paddingRight: 4 }}>
          {conversation.map((turn, i) => (
            <div key={i} style={{ marginBottom: 12, paddingBottom: 12, borderBottom: i < conversation.length - 1 ? "1px solid #222" : "none" }}>
              <div style={{ fontSize: 11, color: "#888", fontWeight: 700, marginBottom: 4 }}>VOUS</div>
              <div style={{ fontSize: 13, color: "#ddd", marginBottom: 8, padding: "6px 10px", background: "#161616", borderRadius: 6 }}>{turn.q}</div>
              <div style={{ fontSize: 11, color, fontWeight: 700, marginBottom: 4 }}>🤖 IA</div>
              {turn.loading ? (
                <div style={{ fontSize: 13, color: "#888", padding: "6px 10px", background: "#0d0d0d", borderRadius: 6, fontStyle: "italic" }}>⏳ Réflexion…</div>
              ) : (
                <div style={{ fontSize: 13, color: turn.error ? "#fca5a5" : "#fff", padding: "8px 10px", background: turn.error ? "#3f0f0f" : "#0d0d0d", borderRadius: 6, lineHeight: 1.5, whiteSpace: "pre-wrap" }}>{turn.a}</div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Champ question + bouton */}
      <div style={{ display: "flex", gap: 8 }}>
        <textarea
          value={question}
          onChange={e => setQuestion(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); askIA(); } }}
          placeholder="Ex : Quelle norme s'applique ? Niveau d'urgence ? Conformité ?"
          disabled={busy}
          rows={2}
          style={{
            flex: 1, padding: 10, fontSize: 13, fontFamily: "inherit",
            background: "#161616", color: "#fff", border: "1px solid #333",
            borderRadius: 8, outline: "none", resize: "vertical", minHeight: 50,
          }}
        />
        <button
          onClick={askIA}
          disabled={busy || !question.trim()}
          style={{
            padding: "0 16px", background: busy || !question.trim() ? "#333" : color,
            color: "#fff", border: "none", borderRadius: 8, fontWeight: 800, fontSize: 13,
            cursor: busy || !question.trim() ? "not-allowed" : "pointer",
            whiteSpace: "nowrap", flexShrink: 0,
          }}
        >
          {busy ? "⏳" : "Envoyer"}
        </button>
      </div>
      <div style={{ fontSize: 10, color: "#666", marginTop: 6 }}>💡 Astuce : Ctrl+Entrée pour envoyer rapidement</div>

      {/* Bouton Nouvelle photo (reset complet) */}
      {onReset && (
        <button
          onClick={onReset}
          style={{
            marginTop: 14, width: "100%", padding: "12px", background: color, color: "#fff",
            border: "none", borderRadius: 8, fontWeight: 800, fontSize: 13, cursor: "pointer",
            boxShadow: `0 2px 8px ${color}44`,
          }}
        >
          📷 Nouvelle photo (effacer et recommencer)
        </button>
      )}
    </div>
  );
}

// ---- Photo / Barcode identifier ----
function IdentifierTab({ onEquipmentAdded }) {
  const [mode, setMode] = useState(null);
  const [barcodeSubMode, setBarcodeSubMode] = useState("manual");
  const [dragging, setDragging] = useState(false);
  const [preview, setPreview] = useState(null);
  const [imageBase64, setImageBase64] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [barcodeText, setBarcodeText] = useState("");
  const fileRef = useRef();
  const barcodePhotoRef = useRef();
  const cameraRef = useRef();

  const processFile = useCallback((file) => {
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      // Comprimer l'image via Canvas avant envoi API (max 4MB)
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX = 1200; // max dimension
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else { w = Math.round(w * MAX / h); h = MAX; }
        }
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        const compressed = canvas.toDataURL("image/jpeg", 0.82);
        setPreview(compressed);
        setImageBase64(compressed.split(",")[1]);
        setResult(null);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    processFile(file);
  };

  const analyzeImage = async () => {
    if (!imageBase64 && !barcodeText) return;
    setLoading(true);
    setResult(null);

    try {
      let userContent;

      if (mode === "barcode" && barcodeSubMode === "barcodePhoto" && imageBase64) {
        userContent = [
          { type: "image", source: { type: "base64", media_type: "image/jpeg", data: imageBase64 } },
          { type: "text", text: `Tu es expert DPE. Lis le code-barres/QR code et identifie l'équipement. Retourne UNIQUEMENT un JSON sans backticks: {codeDetecte, name, category, brand, model, annee_fabrication, puissance_kw, numero_serie, tags, energyImpact, energyRating, estimatedConsumption, recommendations, confidence}${barcodeText ? `. Code saisi: "${barcodeText}"` : ""}` }
        ];
      } else if (mode === "barcode" && barcodeText) {
        userContent = `Identifie cet équipement DPE à partir de la référence: "${barcodeText}". Retourne un JSON sans backticks: {name, category, brand, model, annee_fabrication, puissance_kw, numero_serie, tags, energyImpact, energyRating, estimatedConsumption, recommendations, confidence}.`;
      } else {
        userContent = [
          { type: "image", source: { type: "base64", media_type: "image/jpeg", data: imageBase64 } },
          { type: "text", text: `Tu es expert DPE français. Analyse cette image et identifie l'équipement (chaudière, PAC, VMC, chauffe-eau, fenêtres…). Lis la plaque signalétique. Retourne UNIQUEMENT un JSON sans backticks: {name, category, brand, model, annee_fabrication, puissance_kw, numero_serie, tags, energyImpact, energyRating, estimatedConsumption, recommendations, confidence}` }
        ];
      }

      const response = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 1000, messages: [{ role: "user", content: userContent }] }),
      });
      const data = await response.json();
      if (data.error) throw new Error(data.error.message);
      const text = data.content?.map(b => b.text || "").join("") || "";
      const parsed = JSON.parse(text.replace(/```json|```/g, "").trim());
      setResult(parsed);
    } catch (e) {
      setError(`Erreur d'analyse : ${e.message}`);
    }
    setLoading(false);
  };

  // IdentifierTab return - simplified since XML is separate
  return (
    <div>
      {/* Hero Scanner */}
      {!mode && (
        <div style={{ background: "linear-gradient(135deg, #111 60%, #1a1a00)", borderRadius: 20, padding: "32px 20px", marginBottom: 16, border: `1px solid #F5C80033`, textAlign: "center" }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>📷</div>
          <div style={{ fontSize: 20, fontWeight: 900, color: "#F5C800", marginBottom: 8, letterSpacing: "-0.5px" }}>
            Identifiez vos équipements
          </div>
          <div style={{ fontSize: 14, color: "#aaa", lineHeight: 1.7, marginBottom: 20, maxWidth: 280, margin: "0 auto 20px" }}>
            Prenez une photo de la plaque signalétique d'un équipement.<br/>
            L'IA détecte automatiquement :
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
            {["🔥 Type chauffage", "⚡ Puissance kW", "📅 Année fabrication", "🏷️ Marque & Modèle", "💨 Ventilation"].map((item, i) => (
              <div key={i} style={{ padding: "6px 12px", borderRadius: 20, background: "#F5C80015", border: "1px solid #F5C80044", fontSize: 12, fontWeight: 700, color: "#F5C800" }}>
                {item}
              </div>
            ))}
          </div>
          <button
            onClick={() => { setMode("photo"); }}
            style={{ background: "#F5C800", color: "#111", border: "none", borderRadius: 14, padding: "16px 32px", fontSize: 16, fontWeight: 800, cursor: "pointer", width: "100%", maxWidth: 320, display: "flex", alignItems: "center", justifyContent: "center", gap: 10, margin: "0 auto" }}>
            <span style={{ fontSize: 22 }}>📷</span> Prendre une photo
          </button>
          <div style={{ fontSize: 11, color: "#555", marginTop: 12 }}>
            Chaudière · PAC · VMC · Ventilation · Chauffe-eau · Radiateur · Fenêtres
          </div>
        </div>
      )}

      {/* Zone upload photo */}
      {mode === "photo" && (
        <div style={styles.card}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
            <button onClick={() => { setMode(null); setPreview(null); setImageBase64(null); setResult(null); setError(""); }}
              style={{ background: "none", border: "none", color: COLORS.muted, cursor: "pointer", fontSize: 20, padding: 0 }}>←</button>
            <div style={styles.cardTitle}>📷 Photo de l'équipement</div>
          </div>

          {/* Conseil */}
          <div style={{ background: "#F5C80011", border: "1px solid #F5C80033", borderRadius: 10, padding: "10px 14px", marginBottom: 14, fontSize: 12, color: "#F5C800" }}>
            💡 <strong>Conseil :</strong> Photographiez la <strong>plaque signalétique</strong> à 30-40 cm — c'est l'étiquette avec le nom et les chiffres techniques.
          </div>

          <div
            style={{ border: `2px dashed ${dragging ? COLORS.accent : COLORS.border}`, borderRadius: 14, padding: "20px 16px", textAlign: "center", background: dragging ? COLORS.accentGlow : COLORS.surface, cursor: "pointer", marginBottom: 12 }}
            onClick={() => fileRef.current?.click()}
            onDragOver={e => { e.preventDefault(); setDragging(true); }}
            onDragLeave={() => setDragging(false)}
            onDrop={handleDrop}
          >
            {preview ? (
              <div style={{ textAlign: "center" }}>
                <img alt="" src={preview} style={{ maxHeight: 320, maxWidth: "100%", borderRadius: 10, marginBottom: 10, display: "block", marginLeft: "auto", marginRight: "auto" }} />
                <div style={{ fontSize: 12, color: "#F5C800", fontWeight: 700 }}>✅ Photo chargée — cliquez pour analyser</div>
              </div>
            ) : (
              <>
                <div style={{ fontSize: 48, marginBottom: 10 }}>🖼️</div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Appuyez pour ouvrir l'appareil photo</div>
                <div style={{ fontSize: 12, color: COLORS.muted }}>ou glissez une image ici</div>
                <button onClick={e => { e.stopPropagation(); fileRef.current?.click(); }}
                  style={{ marginTop: 14, padding: "10px 24px", borderRadius: 10, background: "#F5C800", border: "none", color: "#111", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>
                  📷 Ouvrir l'appareil photo
                </button>
              </>
            )}
          </div>
          <input ref={fileRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={e => processFile(e.target.files[0])} />

          {imageBase64 && !loading && (
            <button onClick={analyzeImage} style={{ ...styles.btn("primary"), width: "100%", fontSize: 15, padding: "14px" }}>
              ✨ Identifier avec l'IA
            </button>
          )}
        </div>
      )}

      {loading && (
        <div style={{ ...styles.card, textAlign: "center", padding: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
          <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Analyse en cours…</div>
          <div style={{ fontSize: 13, color: COLORS.muted }}>L'IA identifie l'équipement</div>
        </div>
      )}

      {error && (
        <div style={{ ...styles.card, background: COLORS.red + "15", border: `1px solid ${COLORS.red}44` }}>
          <div style={{ color: COLORS.red, fontSize: 13 }}>❌ {error}</div>
          <button onClick={() => { setError(""); setMode("photo"); }} style={{ ...styles.btn("secondary"), marginTop: 10, fontSize: 12 }}>🔄 Réessayer</button>
        </div>
      )}

      {result && !loading && (
        <div style={{ ...styles.card, border: `2px solid ${COLORS.green}44` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: COLORS.green + "22", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>✅</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 15, color: COLORS.green }}>Équipement identifié !</div>
              <div style={{ fontSize: 12, color: COLORS.muted }}>{result.confidence === "Haute" ? "🟢 Confiance haute" : result.confidence === "Moyenne" ? "🟡 Confiance moyenne" : "🔴 Confiance basse"}</div>
            </div>
          </div>

          <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 12 }}>{result.name}</div>

          {/* Données clés */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
            {[
              ["🏷️ Marque", result.brand],
              ["📋 Modèle", result.model],
              ["📅 Année", result.annee_fabrication],
              ["⚡ Puissance", result.puissance_kw ? `${result.puissance_kw} kW` : null],
              ["🔥 Catégorie", result.category],
              ["⭐ Classe", result.energyRating],
            ].filter(([, v]) => v).map(([k, v]) => (
              <div key={k} style={{ background: COLORS.surface, borderRadius: 8, padding: "8px 10px" }}>
                <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 2 }}>{k}</div>
                <div style={{ fontSize: 13, fontWeight: 700 }}>{v}</div>
              </div>
            ))}
          </div>

          {result.energyImpact && (
            <div style={{ fontSize: 12, color: COLORS.muted, background: COLORS.surface, padding: "8px 10px", borderRadius: 8, marginBottom: 12 }}>
              ⚡ {result.energyImpact}
            </div>
          )}

          {result.recommendations?.length > 0 && (
            <div style={{ marginBottom: 14 }}>
              {result.recommendations.map((r, i) => (
                <div key={i} style={{ fontSize: 12, color: COLORS.muted, padding: "4px 0", borderBottom: `1px solid ${COLORS.border}` }}>→ {r}</div>
              ))}
            </div>
          )}

          {/* Chat IA + bouton Nouvelle photo */}
          <ScanFollowupChat
            imageBase64={imageBase64}
            imageMime="image/jpeg"
            context={`Équipement identifié : ${result.name || "?"}\nCatégorie : ${result.category || "?"}\nMarque : ${result.brand || "?"}\nModèle : ${result.model || "?"}${result.puissance_kw ? "\nPuissance : " + result.puissance_kw + " kW" : ""}${result.annee_fabrication ? "\nAnnée : " + result.annee_fabrication : ""}`}
            systemPrompt="Tu es un expert en équipements thermiques et énergétiques pour le DPE (chauffage, ECS, ventilation, PAC). Réponds aux questions du diagnostiqueur sur l'équipement de la photo : performance, normes applicables, état de vétusté, recommandations. Concis et factuel."
            color="#F5C800"
            onReset={() => { setResult(null); setPreview(null); setImageBase64(null); setMode(null); setError(""); }}
          />
        </div>
      )}
    </div>
  );
}

function XMLImport({ existingData, onChange, onResult, onResultReplace }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [imported, setImported] = useState(null);
  const [preview, setPreview] = useState(null);
  const [importMode, setImportMode] = useState("merge");
  const [xmlTravaux, setXmlTravaux] = useState([]);
  const fileRef = useRef();

  const handleFile = (file) => {
    if (!file) return;
    if (!file.name.endsWith(".xml") && !file.name.endsWith(".XML")) {
      setError("Veuillez sélectionner un fichier XML (.xml)");
      return;
    }
    setPreview(file.name);
    const reader = new FileReader();
    reader.onload = e => parseXML(e.target.result);
    reader.readAsText(file, "UTF-8");
  };

  const parseXML = (xmlText) => {
    setLoading(true); setError(""); setImported(null);
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(xmlText, "text/xml");
      const get = (tag) => doc.getElementsByTagName(tag)[0]?.textContent?.trim() || "";
      const getNum = (tag) => parseFloat(get(tag)) || 0;
      const map = {};

      // ── Helpers ──
      const ORIENT = { "1":"sud","2":"nord","3":"est","4":"ouest","5":"mixte" };
      const ADJACENCE = {
        "1":"ext","2":"ext","3":"terre","4":"lnc","5":"lnc","6":"lnc",
        "7":"lnc","8":"lnc","9":"lnc","10":"lnc","11":"lnc","12":"lnc",
        "13":"lnc","14":"lnc","15":"pc_avec","16":"pc_avec","17":"pc_sans",
        "18":"pc_sans","19":"pc_sans","20":"pc_sans","21":"pc_sans","22":"chauffe"
      };
      const MAT_MUR = {
        // Source : analyse XML Liciel 3CL-DPE 2021
        "1":"pierre",         // Pierre de taille, moellons (1 matériau)
        "2":"pierre",         // Pierre de taille, moellons (ep variable)
        "3":"brique_pleine",  // Briques pleines simples
        "4":"pierre",         // Pisé / béton de terre stabilisé
        "5":"ossature_bois",  // Pan de bois sans remplissage
        "6":"parpaing",       // Bloc béton plein
        "7":"pierre",         // Pierre (autre)
        "8":"brique_pleine",  // Briques pleines simples
        "9":"brique_creuse",  // Briques creuses
        "10":"brique_creuse", // Briques creuses (23cm)
        "11":"parpaing",      // Bloc béton creux
        "12":"parpaing",      // Blocs béton creux (<20cm)
        "13":"beton",         // Béton banché
        "14":"beton_machefer",// Béton de mâchefer
        "15":"inconnu",       // Inconnu
        "16":"beton",         // Béton cellulaire
        "27":"ossature_bois", // Ossature bois avec remplissage tout venant
      };
      const TYPE_BAIE = {
        "1":"fenetre","2":"fenetre","3":"fenetre","4":"fenetre",
        "5":"pf","6":"pf","7":"baie_coulissante","8":"velux","9":"fenetre"
      };
      const TYPE_VITRAGE = {
        "1":"simple","2":"double_peu_emissif","3":"double_ancien",
        "4":"triple","5":"survitrage","6":"double_argon","7":"double_peu_emissif"
      };
      const MAT_MENU = {
        "1":"bois", "2":"pvc", "3":"alu_sans_rpt", "4":"alu_avec_rpt",
        "5":"pvc",  "6":"mixte", "7":"alu_sans_rpt", // 7=métal sans RPT
      };
      const TYPE_FERMETURE = {
        "1":"aucune","2":"volet_battant","3":"volet_roulant","4":"persienne","5":"volet_isolant"
      };
      const TYPE_PH = {
        // Source : analyse XML Liciel
        "1":"toiture_terrasse",  // Toiture-terrasse
        "2":"combles_perdus",    // Combles perdus
        "3":"rampants",          // Plafond solives métalliques
        "4":"plancher_lnc",      // Plafond solives bois / LNC
        "5":"combles_perdus",    // Combles perdus (variante)
        "6":"rampants",          // Rampants
        "7":"plancher_lnc",      // Plafond béton / LNC
        "8":"toiture_terrasse",  // Dalle béton terrasse
        "9":"plancher_lnc",      // Autre plancher haut
        "10":"rampants",         // Rampants isolés
        "12":"rampants",         // Combles aménagés rampants
      };
      const TYPE_PB = {
        // Source : analyse XML Liciel
        "1":"terre_plein",       // Terre-plein
        "2":"vide_sanitaire",    // Vide sanitaire
        "3":"solives_bois_avec", // Solives bois/remplissage
        "4":"solives_bois_sans", // Solives bois sans remplissage
        "5":"dalle_beton",       // Dalle béton
        "6":"voutains_briques",  // Bardeaux et remplissage
        "7":"voutains_pierre",   // Voûtains solives métalliques
        "8":"dalle_beton",       // Plancher poutrelles-hourdis
        "9":"dalle_beton",       // Dalle béton sur local chauffé
        "11":"dalle_beton",      // Plancher lourd entrevous
      };
      const ENERGIE_ID = {
        "1":"elec","2":"gaz","3":"fioul","4":"bois_buches",
        "5":"granules","6":"reseau","7":"gpl","8":"gaz"
      };
      const GEN_CH_ID = {
        "1":"convecteur_elec","2":"panneau_rayonnant","3":"radiateur_inertie",
        "4":"plc_elec","5":"pac_air_eau","6":"pac_air_air","7":"pac_geo",
        "8":"chaudiere_standard","9":"chaudiere_condensation","10":"chaudiere_basse_temp",
        "81":"chaudiere_condensation",  // Fioul basse température
        "82":"chaudiere_condensation",  // Fioul condensation
        "83":"chaudiere_standard",      // Fioul standard
        "84":"chaudiere_condensation",  // Fioul basse temp récent
        "88":"chaudiere_standard",      // Gaz standard 1991-2000
        "89":"chaudiere_standard",      // Gaz standard récent
        "90":"chaudiere_condensation",  // Gaz condensation
        "91":"chaudiere_basse_temp",    // Gaz basse température
        "92":"chaudiere_condensation",  // Gaz condensation récent
        "98":"convecteur_elec",         // Convecteur électrique NFC
        "100":"convecteur_elec","104":"radiateur_inertie",
      };
      const GEN_ECS_ID = {
        "41":"chaudiere_gaz",              // Fioul basse temp 1991-2015
        "42":"chaudiere_gaz",              // Fioul condensation
        "43":"chaudiere_gaz",              // Fioul standard
        "48":"chaudiere_gaz",              // Gaz standard 1991-2000
        "49":"chaudiere_gaz",              // Gaz standard récent
        "50":"chaudiere_gaz",              // Gaz condensation
        "51":"chaudiere_gaz",              // Gaz basse température
        "52":"chaudiere_gaz",              // Gaz condensation récent
        "60":"ballon_elec_vertical","61":"ballon_elec_horizontal",
        "62":"ballon_elec_vertical","63":"chauffe_eau_gaz","64":"cet",
        "65":"solaire_thermique","66":"chaudiere_mixte_instantanee",
        "67":"chaudiere_mixte_accumulation","68":"cet",
        "70":"ballon_elec_vertical","71":"ballon_elec_vertical",  // Catégorie B/2 étoiles
        "72":"ballon_elec_horizontal","73":"cet","74":"solaire_thermique",
        "75":"ecs_collective",
      };
      const VENT_ID = {
        "1":"naturelle_ouverture","2":"naturelle_tirage","3":"vmc_sf_auto",
        "4":"vmc_sf_hygro_a","5":"vmc_sf_hygro_b","6":"vmc_df_eco",
        "7":"extracteurs","8":"aucune"
      };

      // ── Identification ──
      const ademe = get("dpe_a_remplacer") || get("numero_dpe") || "";
      if (ademe) map.ademe_numero = ademe;

      // ── Administratif ──
      const dateVisite = get("date_visite_diagnostiqueur") || get("date_etablissement_dpe") || "";
      if (dateVisite) map.date_visite = dateVisite.split("T")[0];
      if (get("date_etablissement_dpe")) map.date_rapport = get("date_etablissement_dpe").split("T")[0];

      // ── Diagnostiqueur ──
      const nomDiag = get("nom_diagnostiqueur") || "";
      const prenomDiag = get("prenom_diagnostiqueur") || "";
      const entrepriseDiag = get("entreprise_diagnostiqueur") || "";
      const adresseDiag = get("adresse_diagnostiqueur") || "";
      const certifDiag = get("numero_certification_diagnostiqueur") || "";
      if (nomDiag) map.diag_nom = `${prenomDiag} ${nomDiag}`.trim();
      if (entrepriseDiag) map.diag_entreprise = entrepriseDiag;
      if (adresseDiag) map.diag_adresse = adresseDiag;
      if (certifDiag) map.diag_certif = certifDiag;

      // ── Adresse du bien ──
      const adresseBien = get("ban_label") || get("adresse_brut") || get("label_brut") || "";
      const cpBien = get("ban_postcode") || get("code_postal_brut") || "";
      const commBien = get("ban_city") || get("nom_commune_brut") || "";
      if (adresseBien) map.adresse = adresseBien.replace(`, ${cpBien}`, "").replace(`, ${commBien}`, "").trim();
      if (cpBien) map.code_postal = cpBien;
      if (commBien) map.commune = commBien;
      // Compléments
      const etage = get("compl_etage_appartement") || "";
      if (etage) map.etage = etage;
      const batiment = get("compl_ref_batiment") || "";
      if (batiment) map.batiment = batiment;
      const escalier = get("compl_ref_cage_escalier") || "";
      if (escalier) map.escalier = escalier;

      // ── Adresse propriétaire ──
      const adresseProprioNode = doc.querySelector("adresse_proprietaire");
      if (adresseProprioNode) {
        const g = (t) => adresseProprioNode.querySelector(t)?.textContent?.trim() || "";
        const adresseProp = g("ban_label") || g("adresse_brut") || "";
        const cpProp = g("ban_postcode") || g("code_postal_brut") || "";
        const villeProp = g("ban_city") || g("nom_commune_brut") || "";
        if (adresseProp) map.proprio_adresse = adresseProp;
        if (cpProp) map.proprio_cp = cpProp;
        if (villeProp) map.proprio_ville = villeProp;
      }

      // ── Logement ──
      const surface = getNum("surface_habitable_logement") || getNum("surface_habitable");
      if (surface) map.surface = String(surface);
      const annee = get("annee_construction") || "";
      if (annee) map.annee = annee;
      const hsp = getNum("hauteur_sous_plafond");
      if (hsp) map.hauteur_sp = String(hsp);
      const nbNiv = get("nombre_niveau_logement") || "";
      if (nbNiv) map.nb_niveaux = nbNiv;
      const typeBat = get("enum_type_batiment_id") || "";
      if (typeBat === "1") map.type = "maison";
      else if (typeBat === "2") map.type = "appartement";
      else if (typeBat === "3") map.type = "immeuble";

      // ── DPE résultats ──
      const classeE = get("classe_bilan_dpe") || "";
      if (classeE) map.dpe_lettre = classeE;
      const classeG = get("classe_emission_ges") || "";
      if (classeG) map.ges_lettre = classeG;
      const ubat = getNum("ubat");
      if (ubat) map.ademe_u_mur = ubat;

      // Consommations EP et EF — tags réels du XML Liciel/ADEME
      const consoEP = getNum("ep_conso_5_usages_m2") || getNum("conso_5_usages_par_m2_ep") || getNum("consommation_energie_primaire");
      if (consoEP) map.dpe_conso = String(Math.round(consoEP));
      const consoEF = getNum("conso_5_usages_m2") || getNum("conso_5_usages_par_m2_ef") || getNum("consommation_energie_finale");
      if (consoEF) map.dpe_conso_finale = String(Math.round(consoEF));
      const gesVal = getNum("emission_ges_5_usages_m2") || getNum("emission_ges_5_usages_par_m2");
      if (gesVal) map.ges_valeur = String(Math.round(gesVal));
      const cout5 = getNum("cout_5_usages");
      if (cout5) { map.dpe_cout_min = String(Math.round(cout5 * 0.85)); map.dpe_cout_max = String(Math.round(cout5 * 1.15)); }

      // Déperditions
      const depMur = getNum("deperdition_mur");
      const depPh = getNum("deperdition_plancher_haut");
      const depPb = getNum("deperdition_plancher_bas");
      const depBaie = getNum("deperdition_baie_vitree");
      const depPt = getNum("deperdition_pont_thermique");
      const depVent = getNum("deperdition_renouvellement_air") || (getNum("hperm") + getNum("hvent"));
      const depPorte = getNum("deperdition_porte");
      if (depMur) map.ademe_dep_mur = Math.round(depMur);
      if (depPh) map.ademe_dep_ph = Math.round(depPh);
      if (depPb) map.ademe_dep_pb = Math.round(depPb);
      if (depBaie) map.ademe_dep_baie = Math.round(depBaie);
      if (depPt) map.ademe_dep_pt = Math.round(depPt);
      if (depVent) map.ademe_dep_vent = Math.round(depVent);

      // ══════════════════════════════════════════
      // ── MURS ──
      // ══════════════════════════════════════════
      const mursList = [];
      doc.querySelectorAll("mur_collection > mur").forEach((mur, i) => {
        const de = mur.querySelector("donnee_entree");
        const di = mur.querySelector("donnee_intermediaire");
        if (!de) return;
        const g = (t) => de.querySelector(t)?.textContent?.trim() || "";
        const gi = (t) => di?.querySelector(t)?.textContent?.trim() || "";
        const orientId = g("enum_orientation_id");
        const adjacId = g("enum_type_adjacence_id");
        const matId = g("enum_materiaux_structure_mur_id");
        const isoId = g("enum_type_isolation_id"); // 1=inconnu, 2=aucune, 3=ITI, 4=ITE, 5=répartie
        const isoMap = {
          "1":"inconnue", "2":"aucune", "3":"iti", "4":"ite",
          "5":"repartie",  // ossature bois / répartie
          "6":"ite",       // enduit isolant
          "7":"ite",       // ITE (béton cellulaire avec isolation intégrée)
          "8":"iti",       // doublage isolant intérieur
        };
        mursList.push({
          id: Date.now() + i,
          orientation: ORIENT[orientId] || "mixte",
          contact: ADJACENCE[adjacId] || "ext",
          materiau: MAT_MUR[matId] || "inconnu",
          surface: g("surface_paroi_opaque") || g("surface_paroi_totale") || "",
          epaisseur: g("epaisseur_structure") || "",
          isolation: isoMap[isoId] || "aucune",
          epaisseur_iso: "",
          r: "",
          u: gi("umur") || "",
          justif: "defaut",
          amelioration: false,
          _desc: g("description") || `Mur ${i+1}`,
        });
      });
      if (mursList.length > 0) map.murs_list = JSON.stringify(mursList);

      // ══════════════════════════════════════════
      // ── PLANCHERS HAUTS (TOITURES) ──
      // ══════════════════════════════════════════
      const toitsList = [];
      doc.querySelectorAll("plancher_haut_collection > plancher_haut").forEach((ph, i) => {
        const de = ph.querySelector("donnee_entree");
        const di = ph.querySelector("donnee_intermediaire");
        if (!de) return;
        const g = (t) => de.querySelector(t)?.textContent?.trim() || "";
        const gi = (t) => di?.querySelector(t)?.textContent?.trim() || "";
        const typeId = g("enum_type_plancher_haut_id");
        const isoId = g("enum_type_isolation_id");
        const isoMap = { "1":"inconnue","2":"aucune","3":"plancher_combles","4":"rampants","5":"tt_isole" };
        toitsList.push({
          id: Date.now() + 1000 + i,
          type: TYPE_PH[typeId] || "combles_perdus",
          structure: "inconnu",
          surface: g("surface_paroi_opaque") || "",
          isolation: isoMap[isoId] || "aucune",
          epaisseur_iso: "",
          u: gi("uph") || gi("uph0") || "",
          justif: "defaut",
          amelioration: false,
          _desc: g("description") || `Toiture ${i+1}`,
        });
      });
      if (toitsList.length > 0) map.toitures_list = JSON.stringify(toitsList);

      // ══════════════════════════════════════════
      // ── PLANCHERS BAS ──
      // ══════════════════════════════════════════
      const pbList = [];
      doc.querySelectorAll("plancher_bas_collection > plancher_bas").forEach((pb, i) => {
        const de = pb.querySelector("donnee_entree");
        const di = pb.querySelector("donnee_intermediaire");
        if (!de) return;
        const g = (t) => de.querySelector(t)?.textContent?.trim() || "";
        const gi = (t) => di?.querySelector(t)?.textContent?.trim() || "";
        const typeId = g("enum_type_plancher_bas_id");
        const isoId = g("enum_type_isolation_id");
        const adjId = g("enum_type_adjacence_id");
        const isoMap = { "1":"inconnue","2":"aucune","3":"sous_dalle","4":"entre_plots" };
        const adjMap = { "1":"ext","3":"terre","4":"lnc","17":"pc_sans","22":"chauffe" };
        pbList.push({
          id: Date.now() + 2000 + i,
          type: adjMap[adjId] || "cave",
          structure: TYPE_PB[typeId] || "inconnu",
          surface: g("surface_paroi_opaque") || "",
          isolation: isoMap[isoId] || "aucune",
          u: gi("upb") || gi("upb0") || "",
          b: gi("b") || "1",
          _desc: g("description") || `Plancher bas ${i+1}`,
        });
      });
      // Stocker le premier plancher bas dans les champs globaux
      if (pbList.length > 0) {
        const pb0 = pbList[0];
        map.type_plancher_bas = pb0.type;
        map.structure_plancher_bas = pb0.structure;
        map.isolation_plancher_bas = pb0.isolation;
        map.u_plancher_bas = pb0.u;
      }

      // ══════════════════════════════════════════
      // ── FENÊTRES / BAIES VITRÉES ──
      // ══════════════════════════════════════════
      const fensList = [];
      // Récupérer les références des murs pour associer fenêtre → mur
      const murRefs = {};
      mursList.forEach((m, i) => { /* références */ });
      const murRefNodes = doc.querySelectorAll("mur_collection > mur > donnee_entree > reference");
      const murRefMap = {};
      murRefNodes.forEach((n, i) => { murRefMap[n.textContent.trim()] = i + 1; });

      doc.querySelectorAll("baie_vitree_collection > baie_vitree").forEach((baie, i) => {
        const de = baie.querySelector("donnee_entree");
        const di = baie.querySelector("donnee_intermediaire");
        if (!de) return;
        const g = (t) => de.querySelector(t)?.textContent?.trim() || "";
        const gi = (t) => di?.querySelector(t)?.textContent?.trim() || "";
        const typeId = g("enum_type_baie_id");
        const vitrId = g("enum_type_vitrage_id");
        const menuId = g("enum_type_materiaux_menuiserie_id");
        const fermId = g("enum_type_fermeture_id");
        const orientId = g("enum_orientation_id");
        const adjId = g("enum_type_adjacence_id");
        const refParoi = g("reference_paroi");
        const murNum = murRefMap[refParoi] || "";
        const epLame = g("epaisseur_lame") || "6";
        const masque = g("presence_protection_solaire_hors_fermeture") === "1" ? "oui" : "non";
        fensList.push({
          id: Date.now() + 3000 + i,
          type: TYPE_BAIE[typeId] || "fenetre",
          mur_ref: String(murNum),
          orientation: ORIENT[orientId] || "sud",
          nombre: parseInt(g("nb_baie") || "1"),
          surface: g("surface_totale_baie") || "",
          vitrage: TYPE_VITRAGE[vitrId] || "double_ancien",
          epaisseur_lame: epLame,
          menuiserie: MAT_MENU[menuId] || "pvc",
          fermeture: TYPE_FERMETURE[fermId] || "aucune",
          masque,
          contact: ADJACENCE[adjId] || "ext",
          uw: g("uw_saisi") || gi("uw") || "",
          sw: g("sw_1") || gi("sw") || "",
          annee: "",
          justif: "defaut",
          amelioration: false,
          _desc: g("description") || `Fenêtre ${i+1}`,
        });
      });
      if (fensList.length > 0) map.fenetres_list = JSON.stringify(fensList);

      // ══════════════════════════════════════════
      // ── PORTES ──
      // ══════════════════════════════════════════
      const portesList = [];
      doc.querySelectorAll("porte_collection > porte").forEach((porte, i) => {
        const de = porte.querySelector("donnee_entree");
        const di = porte.querySelector("donnee_intermediaire");
        if (!de) return;
        const g = (t) => de.querySelector(t)?.textContent?.trim() || "";
        const gi = (t) => di?.querySelector(t)?.textContent?.trim() || "";
        const adjId = g("enum_type_adjacence_id");
        portesList.push({
          id: Date.now() + 4000 + i,
          label: g("description") || `Porte ${i+1}`,
          type: "inconnu",
          contact: ADJACENCE[adjId] || "ext",
          surface: g("surface_porte") || "2",
          u: gi("uporte") || "",
        });
      });
      if (portesList.length > 0) map.portes_list = JSON.stringify(portesList);

      // ══════════════════════════════════════════
      // ── CHAUFFAGE ──
      // ══════════════════════════════════════════
      const genCh = doc.querySelector("generateur_chauffage_collection > generateur_chauffage > donnee_entree");
      if (genCh) {
        const g = (t) => genCh.querySelector(t)?.textContent?.trim() || "";
        const energieId = g("enum_type_energie_id");
        const genId = g("enum_type_generateur_ch_id");
        map.chauffage = ENERGIE_ID[energieId] || "elec";
        map.generateur_ch = GEN_CH_ID[genId] || "convecteur_elec";
        map.type_energie_principale_chauffage = g("description") || "";
        map.annee_ch = g("annee_generateur") || "";
        if (g("position_volume_chauffe") === "1") map.reseau_distribution_ch = "int_chauffe";
      }
      const emetteurCh = doc.querySelector("emetteur_chauffage_collection > emetteur_chauffage > donnee_entree");
      if (emetteurCh) {
        const g = (t) => emetteurCh.querySelector(t)?.textContent?.trim() || "";
        const regId = g("enum_type_regulation_id");
        const regMap = { "1":"aucune","2":"thermostat","3":"programmateur","4":"rbt","5":"sonde_ext","6":"piece_par_piece" };
        map.regulation_ch = regMap[regId] || "aucune";
        map.reseau_ch_isole = g("reseau_distribution_isole") === "1" ? "oui" : "non";
      }

      // ══════════════════════════════════════════
      // ── ECS ──
      // ══════════════════════════════════════════
      const genEcs = doc.querySelector("generateur_ecs_collection > generateur_ecs > donnee_entree");
      if (genEcs) {
        const g = (t) => genEcs.querySelector(t)?.textContent?.trim() || "";
        const energieId = g("enum_type_energie_id");
        const genId = g("enum_type_generateur_ecs_id");
        map.ecs = GEN_ECS_ID[genId] || (ENERGIE_ID[energieId] === "elec" ? "ballon_elec_vertical" : "chaudiere_gaz");
        map.volume_ballon = g("volume_stockage") || "";
        if (g("position_volume_chauffe") === "1") map.emplacement_ecs = "volume_chauffe";
      }

      // ══════════════════════════════════════════
      // ── VENTILATION ──
      // ══════════════════════════════════════════
      const vent = doc.querySelector("ventilation_collection > ventilation > donnee_entree");
      if (vent) {
        const g = (t) => vent.querySelector(t)?.textContent?.trim() || "";
        const ventId = g("enum_type_ventilation_id");
        map.ventilation = VENT_ID[ventId] || "naturelle_ouverture";
      }

      if (Object.keys(map).length === 0) {
        setError("Fichier XML non reconnu — vérifiez qu'il s'agit d'un fichier DPE Liciel.");
        setLoading(false);
        return;
      }

      setImported(map);
      setLoading(false);
    } catch (e) {
      setError(`Erreur de lecture XML : ${e.message}`);
      setLoading(false);
    }
  };

  const applyImport = () => {
    if (!imported) return;
    if (importMode === "merge") {
      // Fusionner — importe uniquement les champs absents dans les données existantes
      Object.entries(imported).forEach(([k, v]) => {
        if (!existingData || !existingData[k]) onChange(k, v);
      });
    } else {
      // Remplacer — importe tous les champs XML
      Object.entries(imported).forEach(([k, v]) => onChange(k, v));
    }
    onResult({});
  };

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 10 }}>
        📄 Importez le fichier XML DPE Liciel pour pré-remplir automatiquement toutes les données techniques.
      </div>

      {/* Zone dépôt fichier */}
      <div
        style={{ border: `2px dashed ${COLORS.border}`, borderRadius: 12, padding: "24px 16px", textAlign: "center", background: COLORS.surface, cursor: "pointer", marginBottom: 10 }}
        onClick={() => fileRef.current?.click()}
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); handleFile(e.dataTransfer.files[0]); }}
      >
        {loading ? (
          <div style={{ color: COLORS.muted, fontSize: 13 }}>⏳ Lecture du fichier XML en cours…</div>
        ) : preview ? (
          <div>
            <div style={{ fontSize: 28, marginBottom: 6 }}>📄</div>
            <div style={{ fontWeight: 700, fontSize: 13, color: COLORS.text }}>{preview}</div>
            <div style={{ fontSize: 12, color: COLORS.muted, marginTop: 4 }}>Fichier chargé ✅</div>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📄</div>
            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>Glissez le fichier XML ou cliquez</div>
            <div style={{ fontSize: 12, color: COLORS.muted }}>Fichier XML DPE Liciel (.xml)</div>
            <button onClick={e => { e.stopPropagation(); fileRef.current?.click(); }}
              style={{ marginTop: 12, padding: "8px 18px", borderRadius: 8, background: "#F5C800", border: "none", color: "#111", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
              📁 Choisir le fichier
            </button>
          </>
        )}
      </div>
      <input ref={fileRef} type="file" accept=".xml,.XML" style={{ display: "none" }}
        onChange={e => handleFile(e.target.files[0])} />

      {error && (
        <div style={{ padding: "10px 14px", borderRadius: 8, background: COLORS.red + "15", color: COLORS.red, fontSize: 13, marginBottom: 10 }}>
          ❌ {error}
        </div>
      )}

      {/* Résultat de l'import */}
      {imported && !loading && (
        <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.green}44` }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green, marginBottom: 10 }}>
            ✅ Fichier XML analysé — {Object.keys(imported).length} données extraites
          </div>

          {/* Résumé données clés */}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
            {[
              ["⚡ DPE", imported.dpe_lettre],
              ["💨 GES", imported.ges_lettre],
              ["🏠 Surface", imported.surface ? `${imported.surface} m²` : null],
              ["📅 Période", imported.periode_construction_label],
              ["🔥 Chauffage", imported.chauffage],
              ["📊 Conso", imported.dpe_conso ? `${imported.dpe_conso} kWh/m²` : null],
            ].filter(([, v]) => v).map(([k, v]) => (
              <div key={k} style={{ padding: "4px 8px", borderRadius: 6, background: COLORS.card, border: `1px solid ${COLORS.border}`, fontSize: 11 }}>
                <span style={{ color: COLORS.muted }}>{k} : </span>
                <span style={{ fontWeight: 700 }}>{v}</span>
              </div>
            ))}
          </div>

          {/* Déperditions */}
          {imported.ademe_dep_mur > 0 && (
            <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 12, padding: "8px 10px", borderRadius: 8, background: COLORS.card }}>
              📊 <strong>Déperditions :</strong> murs {imported.ademe_dep_mur} W/K · toiture {imported.ademe_dep_ph} W/K · plancher {imported.ademe_dep_pb} W/K · baies {imported.ademe_dep_baie} W/K · ponts {imported.ademe_dep_pt} W/K · ventilation {imported.ademe_dep_vent} W/K
            </div>
          )}

          {/* Travaux recommandés depuis XML */}
          {xmlTravaux.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>
                🔨 Recommandations travaux du DPE ({xmlTravaux.length} pack{xmlTravaux.length > 1 ? "s" : ""})
              </div>
              {xmlTravaux.map((pack) => (
                <div key={pack.id} style={{ marginBottom: 8, padding: "10px 12px", borderRadius: 8, background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                  <div style={{ fontWeight: 700, fontSize: 12, color: COLORS.accent, marginBottom: 6 }}>
                    📦 Pack {pack.id}
                    {pack.conso_apres && <span style={{ color: COLORS.green, marginLeft: 8 }}>→ {pack.conso_apres} kWh/m²/an après travaux</span>}
                  </div>
                  {pack.travaux.map((t, i) => (
                    <div key={i} style={{ fontSize: 11, color: COLORS.muted, marginBottom: 4, paddingLeft: 8, borderLeft: `2px solid ${COLORS.accent}` }}>
                      • {t.description}
                      {t.performance && <span style={{ color: COLORS.yellow, marginLeft: 6 }}>{t.performance}</span>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}

          {/* Mode import */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>Mode d'import</div>
            <div style={{ display: "flex", gap: 8 }}>
              {[
                { key: "merge", label: "🔀 Fusionner", desc: "Complète les champs vides sans écraser" },
                { key: "replace", label: "🔄 Remplacer", desc: "Réinitialise et remplace tout" },
              ].map(m => (
                <button key={m.key} onClick={() => setImportMode(m.key)}
                  style={{ flex: 1, padding: "8px 10px", borderRadius: 8, cursor: "pointer", textAlign: "left",
                    border: `2px solid ${importMode === m.key ? COLORS.accent : COLORS.border}`,
                    background: importMode === m.key ? COLORS.accent + "15" : COLORS.surface }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: importMode === m.key ? COLORS.accent : COLORS.text }}>{m.label}</div>
                  <div style={{ fontSize: 10, color: COLORS.muted }}>{m.desc}</div>
                </button>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={applyImport}
              style={{ ...styles.btn("primary"), flex: 1 }}>
              ✅ Importer dans le dossier
            </button>
            <button onClick={() => { setImported(null); setPreview(null); setXmlTravaux([]); }}
              style={{ ...styles.btn("secondary"), padding: "10px 14px" }}>
              🔄
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ---- ADEME Lookup ----
function mapAdemeToState(rec) {
  const map = {};
  // Identification
  if (rec.numero_dpe) map.ademe_numero = rec.numero_dpe;
  if (rec.date_etablissement_dpe) map.ademe_date = rec.date_etablissement_dpe?.split("T")[0];
  // Adresse — nouveau dataset dpe03existant
  if (rec.adresse_ban) map.adresse = rec.adresse_ban;
  else if (rec.adresse_complete_brut) map.adresse = rec.adresse_complete_brut;
  if (rec.code_postal_ban) map.code_postal = String(rec.code_postal_ban);
  else if (rec.code_postal_brut) map.code_postal = String(rec.code_postal_brut);
  if (rec.nom_commune_ban) map.commune = rec.nom_commune_ban;
  else if (rec.nom_commune_brut) map.commune = rec.nom_commune_brut;
  // Logement
  if (rec.surface_habitable_logement) map.surface = String(rec.surface_habitable_logement);
  // Période construction → année estimée
  if (rec.annee_construction) map.annee = String(rec.annee_construction);
  else if (rec.periode_construction) {
    const p = rec.periode_construction;
    if (p.includes("avant 1948")) map.annee = "1940";
    else if (p.includes("1948") && p.includes("1974")) map.annee = "1960";
    else if (p.includes("1975") && p.includes("1977")) map.annee = "1976";
    else if (p.includes("1978") && p.includes("1982")) map.annee = "1980";
    else if (p.includes("1983") && p.includes("1988")) map.annee = "1985";
    else if (p.includes("1989") && p.includes("2000")) map.annee = "1995";
    else if (p.includes("2001") && p.includes("2005")) map.annee = "2003";
    else if (p.includes("2006") && p.includes("2012")) map.annee = "2009";
    else if (p.includes("après 2012") || p.includes("apres 2012")) map.annee = "2015";
    map.periode_construction_label = p;
  }
  if (rec.type_batiment) {
    const t = (rec.type_batiment || "").toLowerCase();
    map.type = t.includes("maison") ? "maison" : t.includes("appart") ? "appartement" : "immeuble";
  }
  if (rec.nombre_niveau_logement) map.etages = String(rec.nombre_niveau_logement);
  if (rec.hauteur_sous_plafond) map.hauteur_sp = String(rec.hauteur_sous_plafond);
  // DPE étiquettes
  if (rec.etiquette_dpe) map.dpe_lettre = rec.etiquette_dpe;
  if (rec.etiquette_ges) map.ges_lettre = rec.etiquette_ges;
  // Consommations — nouveaux noms dpe03existant
  if (rec.conso_5_usages_par_m2_ep) map.dpe_conso = String(Math.round(rec.conso_5_usages_par_m2_ep));
  else if (rec.consommation_energie) map.dpe_conso = String(Math.round(rec.consommation_energie));
  if (rec.conso_5_usages_par_m2_ef) map.dpe_conso_finale = String(Math.round(rec.conso_5_usages_par_m2_ef));
  else if (rec.consommation_energie_finale) map.dpe_conso_finale = String(Math.round(rec.consommation_energie_finale));
  if (rec.emission_ges_5_usages_par_m2) map.ges_valeur = String(Math.round(rec.emission_ges_5_usages_par_m2));
  else if (rec.estimation_ges) map.ges_valeur = String(Math.round(rec.estimation_ges));
  if (rec.cout_total_5_usages) {
    map.dpe_cout_min = String(Math.round(rec.cout_total_5_usages * 0.85));
    map.dpe_cout_max = String(Math.round(rec.cout_total_5_usages * 1.15));
  }
  // Consommations par usage — nouveaux noms
  if (rec.conso_chauffage_ef) map.ademe_conso_ch = Math.round(rec.conso_chauffage_ef);
  else if (rec.consommation_chauffage) map.ademe_conso_ch = Math.round(rec.consommation_chauffage);
  if (rec.conso_ecs_ef) map.ademe_conso_ecs = Math.round(rec.conso_ecs_ef);
  else if (rec.consommation_ecs) map.ademe_conso_ecs = Math.round(rec.consommation_ecs);
  if (rec.conso_eclairage_ef) map.ademe_conso_ecl = Math.round(rec.conso_eclairage_ef);
  if (rec.conso_auxiliaires_ef) map.ademe_conso_aux = Math.round(rec.conso_auxiliaires_ef);
  if (rec.conso_refroidissement_ef) map.ademe_conso_froid = Math.round(rec.conso_refroidissement_ef);
  // Chauffage
  if (rec.type_energie_principale_chauffage) {
    const e = (rec.type_energie_principale_chauffage || "").toLowerCase();
    if (e.includes("gaz")) map.chauffage = "gaz";
    else if (e.includes("fioul") || e.includes("fuel")) map.chauffage = "fioul";
    else if (e.includes("électricité") || e.includes("elec")) map.chauffage = "elec";
    else if (e.includes("bois") || e.includes("granulé")) map.chauffage = "bois_chaudiere";
    else if (e.includes("réseau") || e.includes("urbain")) map.chauffage = "reseau";
    else if (e.includes("pompe") || e.includes("pac")) map.chauffage = "pac_air_eau";
    map.ademe_energie_ch_label = rec.type_energie_principale_chauffage;
  }
  if (rec.type_installation_chauffage) map.ademe_install_ch = rec.type_installation_chauffage;
  if (rec.type_generateur_chauffage_principal) map.ademe_type_gen_ch = rec.type_generateur_chauffage_principal;
  // ECS
  if (rec.type_energie_principale_ecs) map.ademe_energie_ecs = rec.type_energie_principale_ecs;
  if (rec.type_installation_ecs) map.ademe_install_ecs = rec.type_installation_ecs;
  if (rec.type_generateur_chauffage_principal_ecs) map.ademe_type_gen_ecs = rec.type_generateur_chauffage_principal_ecs;
  // Ventilation
  if (rec.type_ventilation) {
    map.ademe_ventilation = rec.type_ventilation;
    const v = (rec.type_ventilation || "").toLowerCase();
    if (v.includes("vmc") && v.includes("double")) map.ventilation = "vmc_df_eco";
    else if (v.includes("vmc") && v.includes("hygro") && v.includes("b")) map.ventilation = "vmc_sf_hygro_b";
    else if (v.includes("vmc") && v.includes("hygro")) map.ventilation = "vmc_sf_hygro_a";
    else if (v.includes("vmc")) map.ventilation = "vmc_sf_auto";
    else if (v.includes("naturelle") && v.includes("conduit")) map.ventilation = "naturelle_tirage";
    else if (v.includes("naturelle")) map.ventilation = "naturelle_grilles";
  }
  // Déperditions — nouveaux noms dpe03existant
  if (rec.deperditions_murs) map.ademe_dep_mur = Math.round(rec.deperditions_murs);
  if (rec.deperditions_planchers_hauts) map.ademe_dep_ph = Math.round(rec.deperditions_planchers_hauts);
  if (rec.deperditions_planchers_bas) map.ademe_dep_pb = Math.round(rec.deperditions_planchers_bas);
  if (rec.deperditions_baies_vitrees) map.ademe_dep_baie = Math.round(rec.deperditions_baies_vitrees);
  if (rec.deperditions_ponts_thermiques) map.ademe_dep_pt = Math.round(rec.deperditions_ponts_thermiques);
  if (rec.deperditions_renouvellement_air) map.ademe_dep_vent = Math.round(rec.deperditions_renouvellement_air);
  // Coefficient Ubat
  if (rec.ubat_w_par_m2_k) map.ademe_u_mur = rec.ubat_w_par_m2_k;
  // Qualité isolation
  if (rec.qualite_isolation_murs) map.ademe_qualite_murs = rec.qualite_isolation_murs;
  if (rec.qualite_isolation_menuiseries) map.ademe_qualite_menuiseries = rec.qualite_isolation_menuiseries;
  if (rec.qualite_isolation_plancher_bas) map.ademe_qualite_pb = rec.qualite_isolation_plancher_bas;
  if (rec.qualite_isolation_plancher_haut_comble_perdu) map.ademe_qualite_ph = rec.qualite_isolation_plancher_haut_comble_perdu;
  if (rec.qualite_isolation_enveloppe) map.ademe_qualite_enveloppe = rec.qualite_isolation_enveloppe;
  return map;
}

// Compute total deperditions from ADEME data
function _totalDeperditions(data) {
  const items = [
    data.ademe_dep_mur, data.ademe_dep_pb, data.ademe_dep_ph,
    data.ademe_dep_baie, data.ademe_dep_pt, data.ademe_dep_vent
  ].filter(Boolean);
  return items.reduce((s, v) => s + v, 0);
}

function ADEMELookup({ onChange, data }) {
  const [mode, setMode] = useState(null);
  const [numero, setNumero] = useState(data?.ademe_numero || "");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [qrPreview, setQrPreview] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [_showTravaux, _setShowTravaux] = useState(false);
  // XML import states
  const [imported, setImported] = useState(null);
  const [preview, setPreview] = useState(null);
  const [importMode, setImportMode] = useState("merge");
  const [xmlTravaux, setXmlTravaux] = useState([]);
  const [travauxSel, setTravauxSelRaw] = useState(() => {
    try { const s = localStorage.getItem("fndi_travaux_sel"); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  const setTravauxSel = (val) => {
    const newVal = typeof val === 'function' ? val(travauxSel) : val;
    setTravauxSelRaw(newVal);
    try { localStorage.setItem("fndi_travaux_sel", JSON.stringify(newVal)); } catch {}
  };
  const [loadingProj, setLoadingProj] = useState(false);
  const [projection, setProjectionRaw] = useState(() => {
    try { const s = localStorage.getItem("fndi_projection"); return s ? JSON.parse(s) : null; } catch { return null; }
  });
  const setProjection = (val) => {
    setProjectionRaw(val);
    try { if (val) localStorage.setItem("fndi_projection", JSON.stringify(val)); else localStorage.removeItem("fndi_projection"); } catch {}
  };
  const fileRef = useRef();
  const cameraRef = useRef();

  const searchAdeme = async (num) => {
    const n = (num || "").trim();
    if (n.length < 10) { setError("Numéro ADEME invalide (13 caractères)"); return; }
    setLoading(true); setError(""); setResult(null); setProjection(null);
    try {
      const datasets = [
        "dpe-v2-logements-existants",
        "dpe-v2-logements-neufs",
      ];
      let found = null;
      try {
        // Appel via proxy Vercel (évite les problèmes CORS)
        const proxyUrl = `/api/ademe?numero=${encodeURIComponent(n)}`;
        const res = await fetch(proxyUrl);
        if (res.ok) {
          const json = await res.json();
          if (json.found && json.data) {
            found = json.data;
          }
        }
      } catch { /* continue */ }

      if (found) setResult(found);
      else setError("Aucun DPE trouvé. Vérifiez le numéro (13 caractères) ou utilisez le fichier XML.");
    } catch { setError("Erreur de connexion à la base ADEME. Vérifiez votre réseau."); }
    setLoading(false);
  };

  const readQRFromPhoto = async (base64) => {
    setLoading(true); setError("");
    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({
          model: "claude-sonnet-4-6", max_tokens: 200,
          messages: [{ role: "user", content: [
            { type: "image", source: { type: "base64", media_type: "image/jpeg", data: base64 } },
            { type: "text", text: "Lis le QR code ou code-barres sur cette image. Extrais UNIQUEMENT le numéro ADEME DPE (13 caractères alphanumériques) ou l'URL qui le contient. Retourne UNIQUEMENT ce numéro, rien d'autre. Si introuvable: INTROUVABLE" }
          ]}]
        })
      });
      const d = await res.json();
      const txt = (d.content?.map(b => b.text || "").join("") || "").trim();
      const match = txt.match(/[A-Z0-9]{13}/i);
      if (match) { setNumero(match[0]); await searchAdeme(match[0]); }
      else setError("QR code illisible. Saisissez le numéro manuellement.");
    } catch { setError("Erreur lecture QR code."); }
    setLoading(false);
  };

  const handleFile = (file) => {
    if (!file) return;
    const r = new FileReader();
    r.onload = e => {
      // Compresser avant envoi
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const MAX = 1200;
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else { w = Math.round(w * MAX / h); h = MAX; }
        }
        canvas.width = w; canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        const compressed = canvas.toDataURL("image/jpeg", 0.82);
        setQrPreview(compressed);
        readQRFromPhoto(compressed.split(",")[1]);
      };
      img.src = e.target.result;
    };
    r.readAsDataURL(file);
  };

  const applyResult = () => {
    if (!result) return;
    const mapped = mapAdemeToState(result);
    Object.entries(mapped).forEach(([k, v]) => onChange(k, v));
    setMode(null);
  };

  const toggleTravail = (id) => setTravauxSel(p => p.includes(id) ? p.filter(t => t !== id) : [...p, id]);

  // Build travaux suggestions from ADEME data
  const suggestTravaux = (r) => {
    const suggestions = [];
    const dm = r.deperditions_murs||r.deperdition_mur||0;
    const dpb = r.deperditions_planchers_bas||r.deperdition_plancher_bas||0;
    const dph = r.deperditions_planchers_hauts||r.deperdition_plancher_haut||0;
    const dbaie = r.deperditions_baies_vitrees||r.deperdition_baie_vitree||0;
    const dpt = r.deperditions_ponts_thermiques||r.deperdition_pont_thermique||0;
    const dvent = r.deperditions_renouvellement_air||r.deperdition_renouvellement_air||0;
    const totalDep = dm+dpb+dph+dbaie+dpt+dvent;

    const pctMur = totalDep ? Math.round(dm/totalDep*100) : 0;
    const pctPB = totalDep ? Math.round(dpb/totalDep*100) : 0;
    const pctPH = totalDep ? Math.round(dph/totalDep*100) : 0;
    const pctBaie = totalDep ? Math.round(dbaie/totalDep*100) : 0;
    const pctVent = totalDep ? Math.round(dvent/totalDep*100) : 0;

    if (pctMur > 15) suggestions.push({ id:"ite", label:"Isolation murs (ITE/ITI)", pct: pctMur, priorite:"haute", gain:25, cout_min:12000, cout_max:35000 });
    if (pctPH > 15) suggestions.push({ id:"combles", label:"Isolation combles/plancher haut", pct: pctPH, priorite: pctPH>25?"haute":"moyenne", gain:28, cout_min:1500, cout_max:6000 });
    if (pctPB > 10) suggestions.push({ id:"plancher_bas", label:"Isolation plancher bas", pct: pctPB, priorite:"moyenne", gain:12, cout_min:3000, cout_max:9000 });
    if (pctBaie > 15) suggestions.push({ id:"double_vitrage", label:"Remplacement vitrage performant", pct: pctBaie, priorite:"moyenne", gain:12, cout_min:5000, cout_max:18000 });
    if (pctVent > 20) suggestions.push({ id:"vmc_df", label:"VMC double flux", pct: pctVent, priorite:"haute", gain:15, cout_min:4000, cout_max:9000 });

    const en = (r.type_energie_principale_chauffage||"").toLowerCase();
    if (en.includes("fioul")) suggestions.push({ id:"pac_air_eau", label:"Remplacement chaudière fioul → PAC air/eau", pct:null, priorite:"haute", gain:45, cout_min:8000, cout_max:18000 });
    else if (en.includes("gaz")) {
      const gen = (r.type_generateur_chauffage_principal||r.type_generateur_chauffage_anciennete||"").toLowerCase();
      if (!gen.includes("condensation")) {
        suggestions.push({ id:"chaudiere_cond", label:"Chaudière gaz → condensation", pct:null, priorite:"moyenne", gain:18, cout_min:3000, cout_max:7000 });
      }
    }
    return suggestions;
  };

  const generateProjection = async () => {
    if (!result || travauxSel.length === 0) return;
    setLoadingProj(true); setProjection(null);
    const sugg = suggestTravaux(result);
    const selItems = travauxSel.map(id => sugg.find(s => s.id === id)).filter(Boolean);
    const dm   = parseFloat(result.deperditions_murs||result.deperdition_mur||0);
    const dph  = parseFloat(result.deperditions_planchers_hauts||result.deperdition_plancher_haut||0);
    const dpb  = parseFloat(result.deperditions_planchers_bas||result.deperdition_plancher_bas||0);
    const dbaie= parseFloat(result.deperditions_baies_vitrees||result.deperdition_baie_vitree||0);
    const dvent= parseFloat(result.deperditions_renouvellement_air||0);
    const gainTotal = calculGain3CL(travauxSel, dm, dph, dpb, dbaie, dvent, consoActuelle);
    const coutMin = selItems.reduce((s, t) => s + t.cout_min, 0);
    const coutMax = selItems.reduce((s, t) => s + t.cout_max, 0);
    const consoActuelle = parseFloat(data?.dpe_conso || result.conso_5_usages_par_m2_ep || result.consommation_energie || 250);
    const gesActuelle = result.emission_ges_5_usages_par_m2 || result.estimation_ges || 0;
    const consoProjete = Math.max(30, consoActuelle * (1 - gainTotal/100));
    const lettreProjete = getDPEClass(consoProjete).label;
    const dpt = result.deperditions_ponts_thermiques||result.deperdition_pont_thermique||0;

    const prompt = `Expert DPE certifié FNDI. DPE existant récupéré de la base ADEME :
- N° ADEME : ${result.numero_dpe}
- Adresse : ${result.adresse_ban||"?"}, ${result.code_postal_ban||""} ${result.nom_commune_ban||""}
- Surface : ${result.surface_habitable_logement||"?"}m², Période : ${result.periode_construction||result.annee_construction||"?"}
- Classe DPE : ${result.etiquette_dpe||"?"} (${Math.round(consoActuelle)} kWh EP/m²/an)
- Classe GES : ${result.etiquette_ges||"?"} (${Math.round(gesActuelle)} kg CO₂/m²/an)
- Énergie chauffage : ${result.type_energie_principale_chauffage||"?"}
- Déperditions murs : ${dm}W/K, plancher bas : ${dpb}W/K, plancher haut : ${dph}W/K, baies : ${dbaie}W/K, ponts th. : ${dpt}W/K, ventilation : ${dvent}W/K
- Ubat : ${result.ubat_w_par_m2_k||"?"} W/m²K

TRAVAUX RETENUS (gain estimé ${gainTotal}%) :
${selItems.map(t => `- ${t.label} : gain ${t.gain}%, coût ${t.cout_min.toLocaleString("fr-FR")}–${t.cout_max.toLocaleString("fr-FR")} €`).join("\n")}

DPE PROJETÉ ESTIMÉ : ${Math.round(consoProjete)} kWh EP/m²/an → Classe ${lettreProjete}

Génère un JSON UNIQUEMENT sans backticks :
{
  "synthese": "texte pro 3 phrases sur le gain",
  "classe_projetee": "${lettreProjete}",
  "conso_projetee": ${Math.round(consoProjete)},
  "gain_pct": ${gainTotal},
  "cout_travaux": {"min": ${coutMin}, "max": ${coutMax}, "apres_aides": number},
  "gain_facture": {"min": number, "max": number},
  "aides": [{"nom": string, "montant": string, "condition": string}],
  "retour_investissement": string,
  "travaux_detail": [{"label": string, "gain_kwh_m2": number, "economie_annuelle": number, "priorite": string}]
}`;

    try {
      const res2 = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST", headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 1000, messages: [{ role: "user", content: prompt }] })
      });
      const d2 = await res2.json();
      if (d2.error) throw new Error(d2.error.message);
      const text2 = d2.content?.map(b => b.text || "").join("") || "";
      setProjection(JSON.parse(text2.replace(/```json|```/g, "").trim()));
    } catch {
      setProjection({ synthese: `Avec les travaux sélectionnés (gain estimé ${gainTotal}%), la consommation passerait à ${Math.round(consoProjete)} kWh EP/m²/an, classe ${lettreProjete}.`, classe_projetee: lettreProjete, conso_projetee: Math.round(consoProjete) });
    }
    setLoadingProj(false);
  };

  const sugg = result ? suggestTravaux(result) : [];
  const totalDep = result ? 
    (result.deperditions_murs||result.deperdition_mur||0)+
    (result.deperditions_planchers_bas||result.deperdition_plancher_bas||0)+
    (result.deperditions_planchers_hauts||result.deperdition_plancher_haut||0)+
    (result.deperditions_baies_vitrees||result.deperdition_baie_vitree||0)+
    (result.deperditions_ponts_thermiques||result.deperdition_pont_thermique||0)+
    (result.deperditions_renouvellement_air||result.deperdition_renouvellement_air||0) : 0;

  const deperdItems = result ? [
    { label: "Murs", val: result.deperditions_murs||result.deperdition_mur||0, color: "#ef4444", icon: "🧱" },
    { label: "Plancher haut", val: result.deperditions_planchers_hauts||result.deperdition_plancher_haut||0, color: "#f97316", icon: "🏚️" },
    { label: "Plancher bas", val: result.deperditions_planchers_bas||result.deperdition_plancher_bas||0, color: "#eab308", icon: "⬇️" },
    { label: "Baies vitrées", val: result.deperditions_baies_vitrees||result.deperdition_baie_vitree||0, color: "#3b82f6", icon: "🪟" },
    { label: "Ponts thermiques", val: result.deperditions_ponts_thermiques||result.deperdition_pont_thermique||0, color: "#8b5cf6", icon: "⚠️" },
    { label: "Ventilation", val: result.deperditions_renouvellement_air||result.deperdition_renouvellement_air||0, color: "#06b6d4", icon: "💨" },
  ].filter(d => d.val > 0) : [];

  const consoItems = result ? [
    { label: "Chauffage", val: result.conso_chauffage_ef||result.consommation_chauffage||0, color: "#ef4444" },
    { label: "ECS", val: result.conso_ecs_ef||result.consommation_ecs||0, color: "#3b82f6" },
    { label: "Éclairage", val: result.conso_eclairage_ef||result.consommation_eclairage||0, color: "#eab308" },
    { label: "Auxiliaires", val: result.conso_auxiliaires_ef||result.consommation_auxiliaires||0, color: "#8b5cf6" },
    { label: "Refroidissement", val: result.conso_refroidissement_ef||result.consommation_refroidissement||0, color: "#06b6d4" },
  ].filter(c => c.val > 0) : [];

  return (
    <div style={{ ...styles.card, border: `2px solid #F5C800`, background: "#F5C80008", marginBottom: 16 }}>
      <div style={styles.cardTitle}>🏛️ Recherche DPE — Base ADEME</div>
      <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 14 }}>
        Récupérez toutes les données techniques du DPE existant par numéro ADEME ou QR code pour générer un DPE projeté précis.
      </div>

      {/* Mode selector */}
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {[
          { key: "numero", icon: "🔢", label: "N° ADEME" },
          { key: "xml",    icon: "📄", label: "Fichier XML" },
        ].map(m => (
          <button key={m.key} onClick={() => { setMode(mode === m.key ? null : m.key); setResult(null); setError(""); setProjection(null); }}
            style={{ flex: 1, padding: "11px 8px", borderRadius: 10, cursor: "pointer", border: `2px solid ${mode === m.key ? "#F5C800" : COLORS.border}`, background: mode === m.key ? "#F5C800" : COLORS.surface, color: mode === m.key ? "#111" : COLORS.muted, fontWeight: 700, fontSize: 13, textAlign: "center" }}>
            <div style={{ fontSize: 20, marginBottom: 3 }}>{m.icon}</div>{m.label}
          </button>
        ))}
      </div>

      {/* Saisie numéro */}
      {mode === "numero" && (
        <div style={{ marginBottom: 10 }}>
          <label style={styles.label}>Numéro ADEME (13 caractères)</label>
          <div style={{ display: "flex", gap: 8 }}>
            <input style={{ ...styles.input, flex: 1, letterSpacing: "2px", fontWeight: 700 }}
              type="text" maxLength={13} placeholder="ex: 2301E0123456A"
              value={numero} onChange={e => { setNumero(e.target.value); setError(""); }}
              onKeyDown={e => e.key === "Enter" && searchAdeme(numero)} />
            <button onClick={() => searchAdeme(numero)} disabled={loading || !numero}
              style={{ ...styles.btn("primary"), padding: "10px 18px", flexShrink: 0 }}>
              {loading ? "⏳" : "🔍"}
            </button>
          </div>
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>
            Figurant sur la 1ère page du rapport DPE, sous le QR code officiel.
          </div>
        </div>
      )}

      {/* Scan QR */}
      {mode === "qr" && (
        <div style={{ marginBottom: 10 }}>
          <div style={{ border: `2px dashed ${COLORS.border}`, borderRadius: 12, padding: "18px", textAlign: "center", background: COLORS.surface, marginBottom: 10 }}
            onClick={() => fileRef.current?.click()}>
            {qrPreview ? <img alt="" src={qrPreview} style={{ maxHeight: 140, maxWidth: "100%", borderRadius: 8 }} /> : (
              <><div style={{ fontSize: 32, marginBottom: 6 }}>📷</div>
              <div style={{ fontWeight: 600, fontSize: 13 }}>QR code du rapport DPE</div>
              <div style={{ fontSize: 12, color: COLORS.muted }}>Page de garde du rapport officiel</div></>
            )}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => fileRef.current?.click()} style={{ ...styles.btn("secondary"), flex: 1, fontSize: 12 }}>🖼️ Galerie</button>
            <button onClick={() => cameraRef.current?.click()} style={{ ...styles.btn("primary"), flex: 1, fontSize: 12 }}>📷 Appareil photo</button>
          </div>
          <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={e => handleFile(e.target.files[0])} />
          <input ref={cameraRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={e => handleFile(e.target.files[0])} />
          {loading && <div style={{ textAlign: "center", padding: "10px", color: COLORS.muted, fontSize: 12 }}>⏳ Lecture QR et recherche ADEME…</div>}
          {qrPreview && !loading && (
            <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
              <input style={{ ...styles.input, flex: 1, letterSpacing: "1px" }} value={numero}
                onChange={e => setNumero(e.target.value)} placeholder="N° détecté ou saisie manuelle" />
              <button onClick={() => searchAdeme(numero)} disabled={!numero}
                style={{ ...styles.btn("primary"), padding: "10px 14px" }}>🔍</button>
            </div>
          )}
        </div>
      )}

      {/* ===== XML IMPORT ===== */}
      {mode === "xml" && (
        <XMLImport
          existingData={data}
          onChange={onChange}
          onResult={(mapped) => {
            // Mode fusionner — ajoute champ par champ sans effacer l'existant
            Object.entries(mapped).forEach(([k, v]) => onChange(k, v));
            setMode(null);
          }}
          onResultReplace={() => {
            // Mode remplacer — même chose car onChange ne réinitialise pas
            setMode(null);
          }}
        />
      )}

      {error && <div style={{ padding: "10px 14px", borderRadius: 8, background: COLORS.red+"15", color: COLORS.red, fontSize: 13, marginBottom: 10 }}>❌ {error}</div>}

      {/* ===== RÉSULTAT ADEME ===== */}
      {result && (
        <div>
          {/* En-tête résultat */}
          <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.green}44`, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green, marginBottom: 8 }}>✅ DPE trouvé — {result.numero_dpe}</div>
            {result.adresse_ban && <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>📍 {result.adresse_ban}, {result.code_postal_ban} {result.nom_commune_ban}</div>}

            {/* Classes DPE + GES */}
            <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 12, flexWrap: "wrap" }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 4 }}>ÉNERGIE</div>
                <DPELetterBadge letter={result.etiquette_dpe} size={52} />
                <div style={{ fontSize: 11, fontWeight: 700, marginTop: 4 }}>{Math.round(result.conso_5_usages_par_m2_ep||result.consommation_energie||0)} kWh/m²/an</div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 4 }}>GES</div>
                <DPELetterBadge letter={result.etiquette_ges} size={52} />
                <div style={{ fontSize: 11, fontWeight: 700, marginTop: 4 }}>{Math.round(result.emission_ges_5_usages_par_m2||result.estimation_ges||0)} kg CO₂/m²/an</div>
              </div>
              <div style={{ flex: 1, minWidth: 120 }}>
                {[
                  ["Surface", result.surface_habitable_logement ? `${result.surface_habitable_logement} m²` : null],
                  ["Année", result.annee_construction],
                  ["Énergie chauffage", result.type_energie_principale_chauffage],
                  ["Coût annuel", result.cout_total_5_usages_min ? `${result.cout_total_5_usages_min}–${result.cout_total_5_usages_max} €` : null],
                  ["Date DPE", result.date_etablissement_dpe?.split("T")[0]],
                ].filter(([,v]) => v).map(([k,v]) => (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, padding: "3px 0", borderBottom: `1px solid ${COLORS.border}` }}>
                    <span style={{ color: COLORS.muted }}>{k}</span>
                    <span style={{ fontWeight: 600 }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* ---- DÉPERDITIONS ---- */}
            {deperdItems.length > 0 && (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>📊 Déperditions thermiques (W/K)</div>
                {deperdItems.map(d => {
                  const pct = totalDep ? Math.round(d.val/totalDep*100) : 0;
                  return (
                    <div key={d.label} style={{ marginBottom: 6 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                        <span>{d.icon} {d.label}</span>
                        <span style={{ fontWeight: 700 }}>{d.val} W/K <span style={{ color: d.color }}>({pct}%)</span></span>
                      </div>
                      <div style={{ height: 8, borderRadius: 4, background: COLORS.border, overflow: "hidden" }}>
                        <div style={{ height: "100%", width: `${pct}%`, background: d.color, borderRadius: 4, transition: "width 0.5s" }} />
                      </div>
                    </div>
                  );
                })}
                <div style={{ fontSize: 11, color: COLORS.muted, textAlign: "right", marginTop: 4 }}>Total : {totalDep} W/K</div>
              </div>
            )}

            {/* ---- CONSOMMATIONS PAR USAGE ---- */}
            {consoItems.length > 0 && (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>⚡ Consommations par usage (kWh EP/m²/an)</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {consoItems.map(c => (
                    <div key={c.label} style={{ flex: 1, minWidth: 80, padding: "8px 6px", borderRadius: 8, background: c.color+"15", border: `1px solid ${c.color}33`, textAlign: "center" }}>
                      <div style={{ fontWeight: 800, fontSize: 15, color: c.color }}>{c.val}</div>
                      <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 2 }}>{c.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ---- COEFFICIENTS U ---- */}
            {(result.coefficient_transmission_thermique_mur || result.coefficient_transmission_thermique_baie_vitree) && (
              <div style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>🌡️ Coefficients de transmission (W/m²K)</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {[
                    ["U mur", result.coefficient_transmission_thermique_mur],
                    ["U plancher bas", result.coefficient_transmission_thermique_plancher_bas],
                    ["U plancher haut", result.coefficient_transmission_thermique_plancher_haut],
                    ["U baies", result.coefficient_transmission_thermique_baie_vitree],
                  ].filter(([,v]) => v).map(([k,v]) => {
                    const color = v <= 0.5 ? COLORS.green : v <= 1.5 ? COLORS.yellow : COLORS.red;
                    return (
                      <div key={k} style={{ flex: 1, minWidth: 80, padding: "8px 6px", borderRadius: 8, background: color+"15", border: `1px solid ${color}33`, textAlign: "center" }}>
                        <div style={{ fontWeight: 800, fontSize: 14, color }}>{typeof v === "number" ? v.toFixed(2) : v}</div>
                        <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 2 }}>{k}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Détail technique toggle */}
            <button onClick={() => setShowDetail(p => !p)}
              style={{ ...styles.btn("secondary"), width: "100%", fontSize: 12, marginBottom: 8 }}>
              {showDetail ? "▲ Masquer" : "▼ Voir"} les données techniques complètes
            </button>

            {showDetail && (
              <div style={{ fontSize: 12, background: COLORS.card, borderRadius: 8, padding: 10 }}>
                {[
                  ["Type ventilation", result.type_ventilation],
                  ["Type vitrage", result.type_vitrage_1],
                  ["Gaz lame", result.type_gaz_lame_1],
                  ["Isolation mur ext.", result.isolation_mur_exterieur_1],
                  ["Ep. isolation mur", result.epaisseur_isolation_mur_exterieur_1 ? `${result.epaisseur_isolation_mur_exterieur_1} cm` : null],
                  ["Isolation plancher bas", result.isolation_plancher_bas_1],
                  ["Ep. isolation PB", result.epaisseur_isolation_plancher_bas_1 ? `${result.epaisseur_isolation_plancher_bas_1} cm` : null],
                  ["Isolation plancher haut", result.isolation_plancher_haut_1],
                  ["Ep. isolation PH", result.epaisseur_isolation_plancher_haut_1 ? `${result.epaisseur_isolation_plancher_haut_1} cm` : null],
                  ["Surface mur déperd.", result.surface_mur_deperditif ? `${result.surface_mur_deperditif} m²` : null],
                  ["Surface plancher bas", result.surface_plancher_bas_deperditif ? `${result.surface_plancher_bas_deperditif} m²` : null],
                  ["Surface plancher haut", result.surface_plancher_haut_deperditif ? `${result.surface_plancher_haut_deperditif} m²` : null],
                  ["Baies Nord", result.surface_baie_vitree_nord ? `${result.surface_baie_vitree_nord} m²` : null],
                  ["Baies Sud", result.surface_baie_vitree_sud ? `${result.surface_baie_vitree_sud} m²` : null],
                  ["Baies Est", result.surface_baie_vitree_est ? `${result.surface_baie_vitree_est} m²` : null],
                  ["Baies Ouest", result.surface_baie_vitree_ouest ? `${result.surface_baie_vitree_ouest} m²` : null],
                  ["Install. chauffage", result.type_installation_chauffage],
                  ["Ancienneté générateur", result.type_generateur_chauffage_anciennete],
                  ["ECS énergie", result.type_energie_principale_ecs],
                  ["ECS installation", result.type_installation_ecs],
                ].filter(([,v]) => v).map(([k,v]) => (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: `1px solid ${COLORS.border}` }}>
                    <span style={{ color: COLORS.muted }}>{k}</span>
                    <span style={{ fontWeight: 600, textAlign: "right", maxWidth: "60%" }}>{v}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Importer */}
            <button onClick={applyResult} style={{ ...styles.btn("primary"), width: "100%", marginTop: 10 }}>
              ✅ Importer dans le dossier
            </button>
          </div>

          {/* ===== DPE PROJETÉ DEPUIS ADEME ===== */}
          {sugg.length > 0 && (
            <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid #F5C80044` }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#F5C800", marginBottom: 10 }}>🔮 DPE Projeté — Travaux suggérés par l'analyse des déperditions</div>
              <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 12 }}>
                Basé sur les déperditions réelles du DPE ADEME. Sélectionnez les travaux pour simuler le gain.
              </div>

              {sugg.map(t => {
                const sel = travauxSel.includes(t.id);
                const pColor = t.priorite === "haute" ? COLORS.red : COLORS.yellow;
                return (
                  <div key={t.id} onClick={() => { toggleTravail(t.id); setProjection(null); }}
                    style={{ padding: "10px 12px", borderRadius: 10, marginBottom: 8, cursor: "pointer", border: `2px solid ${sel ? COLORS.accent : COLORS.border}`, background: sel ? COLORS.accentGlow : COLORS.card, transition: "all 0.15s" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 18, height: 18, borderRadius: 4, flexShrink: 0, background: sel ? "#F5C800" : "transparent", border: `2px solid ${sel ? "#F5C800" : COLORS.muted}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#111", fontWeight: 900 }}>{sel ? "✓" : ""}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: sel ? 700 : 400, color: sel ? COLORS.accent : COLORS.text }}>{t.label}</div>
                        <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>
                          {t.pct ? <span style={{ color: COLORS.red, fontWeight: 700 }}>{t.pct}% des déperditions · </span> : ""}
                          {t.cout_min.toLocaleString("fr-FR")}–{t.cout_max.toLocaleString("fr-FR")} €
                        </div>
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green }}>-{t.gain}%</div>
                        <div style={{ fontSize: 10, padding: "1px 6px", borderRadius: 5, background: pColor+"22", color: pColor, fontWeight: 700 }}>{t.priorite}</div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {travauxSel.length > 0 && (
                <button onClick={generateProjection} disabled={loadingProj}
                  style={{ ...styles.btn("primary"), width: "100%", marginTop: 4 }}>
                  {loadingProj ? "⏳ Calcul du DPE projeté…" : "✨ Générer le DPE projeté"}
                </button>
              )}

              {/* Résultat projection */}
              {projection && !projection.error && (
                <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
                  {/* Comparaison avant/après */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: 14, borderRadius: 10, background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 4 }}>ACTUEL</div>
                      <DPELetterBadge letter={result.etiquette_dpe} size={54} />
                      <div style={{ fontSize: 11, fontWeight: 700, marginTop: 4 }}>{Math.round(result.conso_5_usages_par_m2_ep||result.consommation_energie||0)} kWh/m²/an</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 28, color: COLORS.accent }}>→</div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green }}>-{projection.gain_pct}%</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 4 }}>PROJETÉ</div>
                      <DPELetterBadge letter={projection.classe_projetee} size={54} />
                      <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.green, marginTop: 4 }}>{projection.conso_projetee} kWh/m²/an</div>
                    </div>
                  </div>

                  {/* Synthèse */}
                  <div style={{ padding: 12, borderRadius: 8, background: COLORS.card, border: `1px solid ${COLORS.accent}33`, fontSize: 13, lineHeight: 1.6 }}>{projection.synthese}</div>

                  {/* Résumé financier */}
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {[
                      ["💰 Coût travaux", `${(projection.cout_travaux?.min||0).toLocaleString("fr-FR")}–${(projection.cout_travaux?.max||0).toLocaleString("fr-FR")} €`, COLORS.orange],
                      ["🏛️ Après aides", `${(projection.cout_travaux?.apres_aides||0).toLocaleString("fr-FR")} €`, "#F5C800"],
                      ["💚 Économie/an", `${(projection.gain_facture?.min||0).toLocaleString("fr-FR")}–${(projection.gain_facture?.max||0).toLocaleString("fr-FR")} €`, COLORS.green],
                      ["⏱️ Retour invest.", projection.retour_investissement, COLORS.muted],
                    ].map(([k,v,c]) => (
                      <div key={k} style={{ flex: 1, minWidth: 120, padding: "10px 8px", borderRadius: 8, textAlign: "center", background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                        <div style={{ fontWeight: 800, fontSize: 13, color: c }}>{v}</div>
                        <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 3 }}>{k}</div>
                      </div>
                    ))}
                  </div>

                  {/* Aides */}
                  {projection.aides?.length > 0 && (
                    <div style={{ padding: 12, borderRadius: 8, background: COLORS.card, border: `1px solid #F5C80033` }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#F5C800", marginBottom: 8 }}>🏛️ Aides mobilisables</div>
                      {projection.aides.map((a, i) => (
                        <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, padding: "5px 0", borderBottom: `1px solid ${COLORS.border}` }}>
                          <div><span style={{ fontWeight: 700 }}>{a.nom}</span><div style={{ fontSize: 11, color: COLORS.muted }}>{a.condition}</div></div>
                          <span style={{ color: COLORS.green, fontWeight: 700, flexShrink: 0, marginLeft: 8 }}>{a.montant}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {projection?.error && <div style={{ padding: 10, borderRadius: 8, background: COLORS.red+"15", color: COLORS.red, fontSize: 13, marginTop: 10 }}>❌ {projection.error}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ---- Bibliothèque de commentaires types DPE ----
const COMMENTS_BIBLIOTHEQUE = {
  general: [
    { texte: "Le logement a fait l'objet d'une visite complète le jour du diagnostic. Les informations recueillies sont issues de l'observation visuelle et des déclarations du propriétaire.", label: "Visite complète" },
    { texte: "Le logement présente un niveau de performance énergétique insuffisant, caractéristique des constructions de cette époque, principalement dû à l'absence d'isolation et à un système de chauffage vieillissant.", label: "Performance insuffisante" },
    { texte: "L'état général du logement est correct. Aucune pathologie majeure n'a été observée lors de la visite, hormis les points détaillés ci-après.", label: "État général correct" },
    { texte: "Certaines parties du logement n'ont pas été accessibles lors de la visite (combles, vide sanitaire). Les valeurs retenues sont celles par défaut de la méthode 3CL.", label: "Zones inaccessibles" },
    { texte: "Le logement est actuellement inoccupé. Les données recueillies sont basées sur les documents fournis et l'observation visuelle lors de la visite.", label: "Logement inoccupé" },
    { texte: "Des travaux de rénovation ont été partiellement réalisés. Les éléments récents ont été pris en compte dans le calcul.", label: "Travaux partiels réalisés" },
  ],
  isolation: [
    { texte: "Les murs ne présentent aucune isolation thermique. Il s'agit d'une maçonnerie traditionnelle (pierre / moellons / parpaing) sans doublage. Les déperditions par les parois opaques sont importantes.", label: "Murs non isolés" },
    { texte: "L'isolation des murs est réalisée par l'intérieur (ITI) avec un doublage de type plaque de plâtre sur ossature. L'épaisseur d'isolant n'a pu être déterminée avec précision — valeur conventionnelle retenue.", label: "ITI présente, épaisseur inconnue" },
    { texte: "Les combles sont perdus et non isolés. Il s'agit du principal poste de déperdition thermique du logement. Une isolation des combles par soufflage ou rouleaux est fortement recommandée en priorité.", label: "Combles perdus non isolés" },
    { texte: "L'isolation des combles a été réalisée par soufflage de laine minérale. L'épaisseur observée est d'environ [X] cm, correspondant à une résistance thermique R ≈ [X] m²·K/W.", label: "Combles isolés — soufflage" },
    { texte: "Le plancher bas donne sur un vide sanitaire non ventilé. Aucune isolation n'est présente sous le plancher. Les déperditions vers le sol sont significatives.", label: "Plancher bas non isolé" },
    { texte: "Le plancher bas repose sur terre-plein. Les déperditions sont calculées selon la méthode 3CL tenant compte de la résistance thermique du sol.", label: "Plancher sur terre-plein" },
    { texte: "Une isolation thermique par l'extérieur (ITE) a été mise en œuvre sur la façade principale. L'épaisseur et le type d'isolant n'ont pu être identifiés précisément — déclaration propriétaire retenue.", label: "ITE présente" },
    { texte: "Présence d'un doublage intérieur sur les murs du séjour et des chambres. Épaisseur estimée à [X] cm de laine de verre. Valeur R prise en compte dans le calcul.", label: "Doublage intérieur présent" },
  ],
  chauffage: [
    { texte: "Le chauffage est assuré par une chaudière gaz à condensation installée en [année]. L'appareil est en bon état de fonctionnement. L'entretien annuel a été réalisé (attestation fournie).", label: "Chaudière gaz condensation — bon état" },
    { texte: "Le chauffage est assuré par une chaudière gaz atmosphérique (standard) installée en [année]. Ce type d'appareil présente un rendement inférieur aux chaudières à condensation. Son remplacement est recommandé.", label: "Chaudière gaz standard — à remplacer" },
    { texte: "Le chauffage est assuré par une chaudière fioul installée en [année]. Compte tenu de l'interdiction progressive du fioul pour le chauffage et du coût du combustible, le remplacement par une pompe à chaleur est fortement conseillé.", label: "Chaudière fioul — remplacement recommandé" },
    { texte: "Le chauffage est électrique par convecteurs de type « grille-pain ». Ce mode de chauffage, bien que simple, présente une consommation d'énergie finale élevée et un confort thermique limité.", label: "Convecteurs électriques" },
    { texte: "Le logement est équipé d'une pompe à chaleur air/eau installée en [année]. Cet équipement est performant (COP ≈ 3 à 4). L'entretien annuel est à assurer pour maintenir les performances.", label: "PAC air/eau — performante" },
    { texte: "Le chauffage est assuré par un poêle à granulés comme appoint principal. Il n'existe pas de système de chauffage central dans ce logement. La distribution de chaleur est limitée aux pièces directement reliées.", label: "Poêle à granulés — chauffage d'appoint" },
    { texte: "Le logement est raccordé au réseau de chaleur urbain. Le type d'énergie primaire dépend du mix du réseau local, déclaré comme [type].", label: "Réseau de chaleur urbain" },
    { texte: "L'émetteur de chaleur est un plancher chauffant basse température. Ce système est adapté à la pompe à chaleur et optimise le confort thermique. Aucune anomalie n'a été observée.", label: "Plancher chauffant — conforme" },
    { texte: "Les radiateurs en fonte sont en bon état mais dimensionnés pour une haute température (80°C). Ils sont compatibles avec la chaudière actuelle mais devront être vérifiés en cas de remplacement par une PAC.", label: "Radiateurs fonte — haute température" },
  ],
  ventilation: [
    { texte: "Le logement est équipé d'une VMC simple flux autoréglable. Le réseau de gaines et les bouches d'extraction ont été vérifiés visuellement. L'entretien des filtres et bouches est recommandé.", label: "VMC SF autoréglable — vérifiée" },
    { texte: "Le logement est équipé d'une VMC simple flux hygroréglable de type B. Les bouches d'extraction et les entrées d'air hygroréglables ont été observées. Ce système adapte le débit selon le taux d'humidité.", label: "VMC SF hygro B — conforme" },
    { texte: "La ventilation est assurée uniquement par l'ouverture des fenêtres et des grilles hautes de façade. Ce mode de ventilation naturelle est insuffisant pour garantir une bonne qualité d'air intérieur.", label: "Ventilation naturelle insuffisante" },
    { texte: "Aucun système de ventilation mécanique n'est présent. Le renouvellement d'air est assuré par les infiltrations et l'ouverture des fenêtres. Risque de condensation et de dégradation de la qualité d'air.", label: "Absence de VMC — risque hygrométrique" },
    { texte: "Le logement est équipé d'une VMC double flux avec échangeur thermique. Ce système récupère la chaleur de l'air extrait pour préchauffer l'air neuf. Rendement observé [X]%. Entretien régulier nécessaire.", label: "VMC DF avec échangeur — performante" },
    { texte: "La VMC est présente mais son état de fonctionnement n'a pu être vérifié. Les bouches d'extraction présentent des dépôts importants indiquant un défaut d'entretien. Nettoyage et vérification recommandés.", label: "VMC présente — entretien déficient" },
  ],
  vitrage: [
    { texte: "Les fenêtres sont équipées d'un simple vitrage. Ce type de vitrage est le plus défavorable en termes de performance thermique (Uw ≈ 5,8 W/m²K). Le remplacement par du double vitrage est prioritaire.", label: "Simple vitrage — à remplacer" },
    { texte: "Les menuiseries sont en double vitrage standard installé avant 2000. Les performances sont moyennes (Uw ≈ 2,8 à 3,0 W/m²K). Un remplacement par du double vitrage peu émissif argon est conseillé.", label: "Double vitrage ancien — peu performant" },
    { texte: "Les menuiseries en PVC double vitrage peu émissif avec lame d'argon sont en bon état (Uw ≈ 1,4 W/m²K). Les performances thermiques sont satisfaisantes. Aucun remplacement nécessaire à court terme.", label: "Double vitrage peu émissif — performant" },
    { texte: "Les portes-fenêtres du séjour présentent des joints usés entraînant des infiltrations d'air perceptibles. Remplacement des joints ou des ouvrants recommandé.", label: "Joints usés — infiltrations d'air" },
    { texte: "Les volets roulants avec caisson intégré réduisent les déperditions nocturnes. Ils contribuent positivement à la performance énergétique du logement.", label: "Volets roulants — performance nocturne" },
    { texte: "Les fenêtres de toiture (type Velux) sont en simple ou double vitrage ancien. Leur inclinaison les expose davantage aux déperditions. Un remplacement est envisageable lors des prochains travaux de toiture.", label: "Velux — à surveiller" },
    { texte: "Les menuiseries sont en aluminium sans rupture de pont thermique. Ce type de cadre dégrade la performance globale de la fenêtre (correction +0,3 W/m²K sur Uw). Remplacement recommandé lors d'une rénovation.", label: "Alu sans RPT — pont thermique cadre" },
  ],
  ecs: [
    { texte: "La production d'eau chaude sanitaire est assurée par la chaudière gaz (système mixte). La chaudière assure simultanément le chauffage et l'ECS. L'entretien annuel conditionne les performances ECS.", label: "ECS liée à la chaudière gaz" },
    { texte: "L'eau chaude sanitaire est produite par un chauffe-eau électrique à accumulation d'une capacité de [X] litres. Ce système présente une consommation électrique significative. L'installation d'un chauffe-eau thermodynamique est recommandée.", label: "Chauffe-eau électrique — à optimiser" },
    { texte: "Le logement est équipé d'un chauffe-eau thermodynamique (PAC ECS). Ce système est très performant (COP ≈ 2,5 à 3). Il peut être positionné dans un espace non chauffé pour optimiser l'extraction de chaleur.", label: "Chauffe-eau thermodynamique — performant" },
    { texte: "Un chauffe-eau solaire thermique (CESI) est installé. Il couvre environ 50 à 70% des besoins ECS selon l'ensoleillement. L'appoint électrique prend le relais en cas d'irradiation insuffisante.", label: "Solaire thermique CESI — efficace" },
    { texte: "La production ECS est assurée par un ballon de stockage couplé à la chaudière fioul. Ce système entraîne des pertes de stockage importantes. Le remplacement par un système plus performant est conseillé.", label: "ECS fioul — peu performante" },
  ],
  toiture: [
    { texte: "La toiture est en bon état général. Aucune infiltration n'a été signalée par le propriétaire. Les combles sont accessibles et ont fait l'objet d'une inspection visuelle lors de la visite.", label: "Toiture en bon état" },
    { texte: "Les combles aménagés sont chauffés et isolés sur les rampants. L'isolant observé est de type [laine minérale / fibre de bois] d'épaisseur estimée à [X] cm.", label: "Combles aménagés — isolés sur rampants" },
    { texte: "Les combles perdus sont accessibles. Une couche d'isolant insufflé est présente, d'épaisseur estimée à [X] cm. La résistance thermique est inférieure aux recommandations actuelles (R ≥ 7 m²·K/W).", label: "Combles perdus — isolation insuffisante" },
    { texte: "La toiture-terrasse est accessible. Aucune information sur la composition de l'étanchéité et l'isolant n'a pu être obtenue. Valeur par défaut 3CL retenue.", label: "Toiture terrasse — composition inconnue" },
    { texte: "Le toit présente des signes de dégradation (tuiles cassées, infiltrations signalées). Des travaux de couverture sont nécessaires avant d'envisager une isolation par sarking.", label: "Toiture dégradée — travaux nécessaires" },
  ],
  pont: [
    { texte: "Des ponts thermiques linéaires sont présents au niveau des liaisons mur/plancher (refends, dalles). Ils ont été pris en compte selon la valeur forfaitaire de la méthode 3CL.", label: "Ponts thermiques — valeur forfaitaire 3CL" },
    { texte: "Le tableau des fenêtres est nu (non isolé). Ce pont thermique linéaire génère des déperditions supplémentaires et un risque de condensation superficielle. Un traitement par isolation du tableau est recommandé.", label: "Tableau nu — pont thermique baie" },
    { texte: "Le caisson de volet roulant intégré à la maçonnerie constitue un pont thermique important. L'absence d'isolation du caisson entraîne des déperditions significatives et un risque de condensation.", label: "Caisson VR non isolé" },
    { texte: "La jonction entre les murs extérieurs et le plancher haut (toiture) constitue un pont thermique continu. Son traitement nécessiterait une ITE ou un traitement spécifique de la liaison.", label: "Pont thermique liaison toiture/mur" },
    { texte: "Les linteaux béton au-dessus des baies vitrées sont apparents et non isolés. Ces éléments constituent des ponts thermiques ponctuels traités selon les valeurs forfaitaires 3CL.", label: "Linteaux béton — ponts thermiques" },
    { texte: "Aucun pont thermique significatif n'a été identifié lors de la visite. Le bâtiment présente une bonne continuité de l'isolation sans rupture thermique apparente.", label: "Pas de pont thermique significatif" },
  ],
};

// ---- Logement Tab ----
const CHAUDIERE_TYPES = [
  { value: "condensation", label: "🟢 Condensation", desc: "Rendement > 100%, la plus efficace", rendement: "105-109%" },
  { value: "basse_temp", label: "🟡 Basse température", desc: "Rendement 90-95%, eau < 60°C", rendement: "90-95%" },
  { value: "standard", label: "🔴 Standard / Atmosphérique", desc: "Ancienne génération, moins efficace", rendement: "70-85%" },
  { value: "micro_cogene", label: "⚡ Micro-cogénération", desc: "Produit chaleur + électricité", rendement: "85-90%" },
];

function EnveloppeSection({ data, onChange }) {
  const sel = (key, label, options) => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <select style={styles.select} value={data[key] || ""} onChange={e => onChange(key, e.target.value)}>
        <option value="">— Sélectionner —</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
  const inp = (key, label, placeholder, type="text") => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input style={styles.input} type={type} placeholder={placeholder}
        value={data[key] || ""} onChange={e => onChange(key, e.target.value)} />
    </div>
  );

  return (
    <div style={styles.card}>
      <div style={styles.cardTitle}>🧱 Enveloppe thermique</div>

      {/* Murs */}
      <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, marginBottom: 8 }}>Murs</div>
      <div style={styles.row}>
        {sel("isolation_murs", "Isolation murs", [
          { value: "non_isole", label: "Non isolé" },
          { value: "iti", label: "Isolation intérieure (ITI)" },
          { value: "ite", label: "Isolation extérieure (ITE)" },
          { value: "iti_ite", label: "ITI + ITE" },
        ])}
        {inp("epaisseur_isolation_murs", "Épaisseur isolation (cm)", "ex: 10")}
      </div>
      {sel("materiaux_murs", "Matériaux des murs", [
        { value: "beton", label: "Béton" },
        { value: "brique", label: "Brique" },
        { value: "pierre", label: "Pierre / Moellons" },
        { value: "parpaing", label: "Parpaing" },
        { value: "ossature_bois", label: "Ossature bois" },
        { value: "autre", label: "Autre" },
      ])}

      {/* Toiture */}
      <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, margin: "12px 0 8px" }}>Toiture / Plancher haut</div>
      {sel("isolation_toit", "Isolation toiture", [
        { value: "non_isole", label: "Non isolé" },
        { value: "combles_perdus", label: "Combles perdus isolés" },
        { value: "rampants", label: "Rampants isolés" },
        { value: "toiture_terrasse", label: "Toiture-terrasse isolée" },
      ])}
      {inp("epaisseur_isolation_toit", "Épaisseur isolation toiture (cm)", "ex: 20")}

      {/* Plancher bas */}
      <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, margin: "12px 0 8px" }}>Plancher bas</div>
      {sel("isolation_plancher_bas", "Isolation plancher bas", [
        { value: "non_isole", label: "Non isolé" },
        { value: "vide_sanitaire", label: "Vide sanitaire isolé" },
        { value: "sous_sol", label: "Sur sous-sol isolé" },
        { value: "terre_plein", label: "Terre-plein" },
      ])}

      {/* Fenêtres */}
      <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, margin: "12px 0 8px" }}>Fenêtres et vitrages</div>
      {sel("vitrage", "Type de vitrage", [
        { value: "simple", label: "Simple vitrage" },
        { value: "double", label: "Double vitrage standard" },
        { value: "double_peu_emissif", label: "Double vitrage peu émissif" },
        { value: "triple", label: "Triple vitrage" },
      ])}
      <div style={styles.row}>
        {inp("surface_vitree", "Surface vitrée totale (m²)", "ex: 12")}
        {inp("annee_menuiseries", "Année menuiseries", "ex: 1995")}
      </div>
    </div>
  );
}

function EtatGeneralField({ data, onChange }) {
  const [loading, setLoading] = useState(false);
  const [commentaireIA, setCommentaireIA] = useState(data.etat_general_commentaire || "");

  const generateComment = async (etat) => {
    if (!etat) return;
    setLoading(true);
    const etatLabels = { bon: "bon état général", moyen: "état moyen avec quelques dégradations", degrade: "état dégradé avec pathologies importantes" };
    const prompt = `Tu es expert DPE certifié FNDI. Rédige un commentaire professionnel concis (2-3 phrases maximum) sur l'état général d'un logement pour un rapport DPE officiel.

Logement : ${data.type || "logement"}, ${data.surface || "?"}m², construit en ${data.annee || "?"}
État général observé : ${etatLabels[etat]}
Chauffage : ${data.chauffage || "non renseigné"}

Le commentaire doit être factuel, professionnel, à la 3ème personne. Maximum 3 phrases.`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "", "anthropic-version": "2023-06-01", "anthropic-dangerous-direct-browser-access": "true" },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 300, messages: [{ role: "user", content: prompt }] })
      });
      const d = await res.json();
      const txt = d.content?.map(b => b.text || "").join("") || "";
      setCommentaireIA(txt);
      onChange("etat_general_commentaire", txt);
    } catch {
      const fallback = { bon: "Le logement présente un état général satisfaisant. Aucune pathologie majeure n'a été observée lors de la visite.", moyen: "Le logement présente un état général moyen avec quelques dégradations à surveiller.", degrade: "Le logement présente un état général dégradé nécessitant des travaux de remise en état." };
      setCommentaireIA(fallback[etat] || "");
      onChange("etat_general_commentaire", fallback[etat] || "");
    }
    setLoading(false);
  };

  return (
    <div style={{ marginBottom: 14 }}>
      <label style={styles.label}>État général du logement</label>
      <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
        {[
          { val: "bon", label: "✅ Bon", color: "#16a34a" },
          { val: "moyen", label: "⚠️ Moyen", color: "#d97706" },
          { val: "degrade", label: "❌ Dégradé", color: "#dc2626" },
        ].map(({ val, label, color }) => (
          <button key={val}
            onClick={() => { onChange("etat_general", val); generateComment(val); }}
            style={{
              flex: 1, padding: "10px 8px", borderRadius: 10, cursor: "pointer",
              border: `2px solid ${data.etat_general === val ? color : COLORS.border}`,
              background: data.etat_general === val ? color + "15" : COLORS.surface,
              color: data.etat_general === val ? color : COLORS.muted,
              fontWeight: 700, fontSize: 13,
            }}>{label}</button>
        ))}
      </div>
      {loading && <div style={{ fontSize: 12, color: COLORS.muted, padding: "8px 0" }}>⏳ Génération du commentaire IA…</div>}
      {commentaireIA && !loading && (
        <div style={{ background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.accent, marginBottom: 5 }}>💬 Commentaire généré par l'IA — inclus dans le rapport</div>
          <textarea
            style={{ ...styles.input, minHeight: 70, resize: "vertical", fontFamily: "inherit", fontSize: 12 }}
            value={commentaireIA}
            onChange={e => { setCommentaireIA(e.target.value); onChange("etat_general_commentaire", e.target.value); }}
          />
        </div>
      )}
    </div>
  );
}

// ── MUR (multi-murs) ──
function MursSection({ data, onChange }) {
  const murs = JSON.parse(data.murs_list || "[]");
  const setMurs = (list) => onChange("murs_list", JSON.stringify(list));
  const addMur = () => setMurs([...murs, { id: Date.now(), orientation: "nord", materiau: "inconnu", surface: "", epaisseur: "", isolation: "aucune", epaisseur_iso: "", r: "", u: "", contact: "ext", justif: "defaut" }]);
  const updMur = (id, key, val) => setMurs(murs.map(m => m.id === id ? { ...m, [key]: val } : m));
  const delMur = (id) => setMurs(murs.filter(m => m.id !== id));

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent }}>🧱 Murs ({murs.length})</div>
        <button onClick={addMur} style={{ ...styles.btn("primary"), fontSize: 11, padding: "5px 12px" }}>+ Ajouter un mur</button>
      </div>
      {murs.length === 0 && <div style={{ fontSize: 12, color: COLORS.muted, padding: "8px 0" }}>Aucun mur saisi — cliquez "Ajouter un mur"</div>}
      {murs.map((m, i) => (
        <div key={m.id} style={{ background: COLORS.surface, borderRadius: 10, padding: 12, marginBottom: 10, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: COLORS.accent }}>Mur {i + 1}</div>
            <button onClick={() => delMur(m.id)} style={{ background: "none", border: "none", color: COLORS.red, cursor: "pointer", fontSize: 18 }}>×</button>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Orientation</label>
              <select style={styles.select} value={m.orientation} onChange={e => updMur(m.id, "orientation", e.target.value)}>
                {[["nord","Nord"],["sud","Sud"],["est","Est"],["ouest","Ouest"],["mixte","Mixte"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Contact</label>
              <select style={styles.select} value={m.contact} onChange={e => updMur(m.id, "contact", e.target.value)}>
                <option value="ext">Extérieur</option>
                <option value="lnc">Local non chauffé</option>
                <option value="pc_avec">Parties communes avec ouverture</option>
                <option value="pc_sans">Parties communes sans ouverture</option>
                <option value="terre">Terre</option>
                <option value="chauffe">Local chauffé</option>
              </select>
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Matériau</label>
              <select style={styles.select} value={m.materiau} onChange={e => updMur(m.id, "materiau", e.target.value)}>
                {[
                  ["pierre","Pierre / Moellons"],
                  ["brique_pleine","Brique pleine"],
                  ["brique_creuse","Brique creuse"],
                  ["beton_machefer","Béton mâchefer"],
                  ["parpaing","Parpaing / Bloc béton"],
                  ["beton","Béton banché"],
                  ["ossature_bois","Ossature bois"],
                  ["inconnu","Inconnu"],
                ].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Épaisseur mur (cm)</label>
              <input style={styles.input} type="number" placeholder="ex: 50" value={m.epaisseur} onChange={e => updMur(m.id, "epaisseur", e.target.value)} />
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Surface (m²)</label>
              <input style={styles.input} type="number" placeholder="ex: 25" value={m.surface} onChange={e => updMur(m.id, "surface", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Isolation</label>
              <select style={styles.select} value={m.isolation} onChange={e => updMur(m.id, "isolation", e.target.value)}>
                {[["aucune","❌ Aucune"],["iti","ITI"],["ite","ITE"],["repartie","Répartie"],["inconnue","Inconnue"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          {(m.isolation !== "aucune" && m.isolation !== "inconnue") && (
            <div style={styles.row}>
              <div style={styles.field}>
                <label style={styles.label}>Épaisseur isolant (cm)</label>
                <input style={styles.input} type="number" placeholder="ex: 10" value={m.epaisseur_iso} onChange={e => updMur(m.id, "epaisseur_iso", e.target.value)} />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>R isolant (m².K/W)</label>
                <input style={styles.input} type="number" placeholder="ex: 2.8" value={m.r} onChange={e => updMur(m.id, "r", e.target.value)} />
              </div>
            </div>
          )}
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>U mur (W/m².K)</label>
              <input style={styles.input} type="number" placeholder="ex: 1.8" value={m.u} onChange={e => updMur(m.id, "u", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Justificatif</label>
              <select style={styles.select} value={m.justif} onChange={e => updMur(m.id, "justif", e.target.value)}>
                {[["defaut","Valeur par défaut 3CL"],["mesure","Mesure / plan"],["facture","Facture travaux"],["attestation","Attestation"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          {/* Case amélioration recommandée */}
          <div
            onClick={() => updMur(m.id, "amelioration", !m.amelioration)}
            style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, padding: "10px 12px", borderRadius: 8, cursor: "pointer",
              background: m.amelioration ? "#ef444415" : COLORS.card,
              border: `2px solid ${m.amelioration ? "#ef4444" : COLORS.border}` }}>
            <div style={{ width: 22, height: 22, borderRadius: 5, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
              background: m.amelioration ? "#ef4444" : "transparent", border: `2px solid ${m.amelioration ? "#ef4444" : COLORS.muted}`,
              fontSize: 13, color: "#fff", fontWeight: 900 }}>{m.amelioration ? "✓" : ""}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: m.amelioration ? "#ef4444" : COLORS.muted }}>
                ⚠️ Amélioration thermique recommandée
              </div>
              <div style={{ fontSize: 11, color: COLORS.muted }}>
                {m.amelioration ? `Mur ${i+1} — ${m.orientation?.toUpperCase()} — ${m.surface||"?"}m² — signalé comme prioritaire` : "Cochez si ce mur nécessite une amélioration (isolation, ITE, ITI…)"}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── TOITURE (multi) ──
function ToitureSection({ data, onChange }) {
  const toits = JSON.parse(data.toitures_list || "[]");
  const setToits = (list) => onChange("toitures_list", JSON.stringify(list));
  const addToit = () => setToits([...toits, { id: Date.now(), type: "combles_perdus", structure: "beton", contact: "ext", surface: "", isolation: "aucune", epaisseur_iso: "", r: "", u: "", justif: "defaut" }]);
  const updToit = (id, key, val) => setToits(toits.map(t => t.id === id ? { ...t, [key]: val } : t));
  const delToit = (id) => setToits(toits.filter(t => t.id !== id));

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent }}>🏚️ Toiture / Plancher haut ({toits.length})</div>
        <button onClick={addToit} style={{ ...styles.btn("primary"), fontSize: 11, padding: "5px 12px" }}>+ Ajouter</button>
      </div>
      {toits.length === 0 && <div style={{ fontSize: 12, color: COLORS.muted, padding: "8px 0" }}>Aucune toiture saisie</div>}
      {toits.map((t, i) => (
        <div key={t.id} style={{ background: COLORS.surface, borderRadius: 10, padding: 12, marginBottom: 10, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: COLORS.accent }}>Toiture / Plancher haut {i + 1}</div>
            <button onClick={() => delToit(t.id)} style={{ background: "none", border: "none", color: COLORS.red, cursor: "pointer", fontSize: 18 }}>×</button>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Type</label>
              <select style={styles.select} value={t.type} onChange={e => updToit(t.id, "type", e.target.value)}>
                {[
                  ["combles_perdus","Combles perdus"],
                  ["rampants","Rampants / combles aménagés"],
                  ["toiture_terrasse","Toiture-terrasse"],
                  ["plancher_lnc","Plafond sous local non chauffé"],
                  ["local_chauffe","Sur local chauffé"],
                ].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Surface (m²)</label>
              <input style={styles.input} type="number" placeholder="ex: 50" value={t.surface} onChange={e => updToit(t.id, "surface", e.target.value)} />
            </div>
          </div>

          {/* Structure plancher haut */}
          <div style={styles.field}>
            <label style={styles.label}>Structure du plancher haut</label>
            <select style={styles.select} value={t.structure} onChange={e => updToit(t.id, "structure", e.target.value)}>
              {[
                ["beton","Dalle béton"],
                ["voutains_pierre","Voûtains en pierre"],
                ["voutains_briques","Voûtains en briques"],
                ["solives_bois_sans","Solives bois sans remplissage"],
                ["solives_bois_avec","Solives bois avec remplissage"],
                ["bac_acier","Bac acier"],
                ["inconnu","Inconnu"],
              ].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>

          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Isolation</label>
              <select style={styles.select} value={t.isolation} onChange={e => updToit(t.id, "isolation", e.target.value)}>
                {[
                  ["aucune","❌ Aucune"],
                  ["plancher_combles","Sur plancher des combles perdus"],
                  ["rampants","Sur les rampants"],
                  ["tt_isole","Toiture-terrasse isolée"],
                  ["inconnue","Inconnue"],
                ].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            {(t.isolation !== "aucune" && t.isolation !== "inconnue") && (
              <div style={styles.field}>
                <label style={styles.label}>Épaisseur isolant (cm)</label>
                <input style={styles.input} type="number" placeholder="ex: 20" value={t.epaisseur_iso} onChange={e => updToit(t.id, "epaisseur_iso", e.target.value)} />
              </div>
            )}
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>U toiture (W/m².K)</label>
              <input style={styles.input} type="number" placeholder="ex: 0.25" value={t.u} onChange={e => updToit(t.id, "u", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Justificatif</label>
              <select style={styles.select} value={t.justif} onChange={e => updToit(t.id, "justif", e.target.value)}>
                {[["defaut","Valeur par défaut 3CL"],["mesure","Mesure / plan"],["facture","Facture travaux"],["attestation","Attestation"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div
            onClick={() => updToit(t.id, "amelioration", !t.amelioration)}
            style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, padding: "10px 12px", borderRadius: 8, cursor: "pointer",
              background: t.amelioration ? "#ef444415" : COLORS.card,
              border: `2px solid ${t.amelioration ? "#ef4444" : COLORS.border}` }}>
            <div style={{ width: 22, height: 22, borderRadius: 5, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
              background: t.amelioration ? "#ef4444" : "transparent", border: `2px solid ${t.amelioration ? "#ef4444" : COLORS.muted}`,
              fontSize: 13, color: "#fff", fontWeight: 900 }}>{t.amelioration ? "✓" : ""}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: t.amelioration ? "#ef4444" : COLORS.muted }}>
                ⚠️ Amélioration thermique recommandée
              </div>
              <div style={{ fontSize: 11, color: COLORS.muted }}>
                {t.amelioration ? `Toiture ${i+1} — ${t.type} — ${t.surface||"?"}m² — signalé comme prioritaire` : "Cochez si ce plancher haut nécessite une amélioration (isolation combles, rampants…)"}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── FENÊTRES (multi) ──
function FenetresSection({ data, onChange }) {
  const fens = JSON.parse(data.fenetres_list || "[]");
  const setFens = (list) => onChange("fenetres_list", JSON.stringify(list));
  const addFen = () => setFens([...fens, { id: Date.now(), type: "fenetre", mur_ref: "1", orientation: "sud", nombre: 1, surface: "", vitrage: "double_ancien", epaisseur_lame: "6", menuiserie: "pvc", fermeture: "aucune", masque: "non", uw: "", sw: "", annee: "", contact: "ext", justif: "defaut" }]);
  const updFen = (id, key, val) => setFens(fens.map(f => f.id === id ? { ...f, [key]: val } : f));
  const delFen = (id) => setFens(fens.filter(f => f.id !== id));

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent }}>🪟 Fenêtres & Baies ({fens.length})</div>
        <button onClick={addFen} style={{ ...styles.btn("primary"), fontSize: 11, padding: "5px 12px" }}>+ Ajouter</button>
      </div>
      {fens.length === 0 && <div style={{ fontSize: 12, color: COLORS.muted, padding: "8px 0" }}>Aucune fenêtre saisie</div>}
      {fens.map((f, i) => (
        <div key={f.id} style={{ background: COLORS.surface, borderRadius: 10, padding: 12, marginBottom: 10, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: COLORS.accent }}>Fenêtre {i + 1}</div>
            <button onClick={() => delFen(f.id)} style={{ background: "none", border: "none", color: COLORS.red, cursor: "pointer", fontSize: 18 }}>×</button>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>N° du mur</label>
              <input style={styles.input} type="number" min="1" placeholder="ex: 1" value={f.mur_ref} onChange={e => updFen(f.id, "mur_ref", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Type</label>
              <select style={styles.select} value={f.type} onChange={e => updFen(f.id, "type", e.target.value)}>
                {[["fenetre","Fenêtre"],["pf","Porte-fenêtre"],["baie_coulissante","Baie coulissante"],["velux","Fenêtre de toit (Velux)"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Orientation</label>
              <select style={styles.select} value={f.orientation} onChange={e => updFen(f.id, "orientation", e.target.value)}>
                {[["nord","Nord"],["sud","Sud"],["est","Est"],["ouest","Ouest"],["mixte","Mixte"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Nombre</label>
              <input style={styles.input} type="number" min="1" placeholder="ex: 3" value={f.nombre} onChange={e => updFen(f.id, "nombre", e.target.value)} />
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Vitrage</label>
              <select style={styles.select} value={f.vitrage} onChange={e => updFen(f.id, "vitrage", e.target.value)}>
                {[["simple","Simple vitrage"],["survitrage","Survitrage"],["double_ancien","Double vitrage ancien"],["double_peu_emissif","Double peu émissif"],["double_argon","Double argon"],["triple","Triple vitrage"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            {(f.vitrage.startsWith("double") || f.vitrage === "triple") && (
              <div style={styles.field}>
                <label style={styles.label}>Épaisseur lame (mm)</label>
                <select style={styles.select} value={f.epaisseur_lame} onChange={e => updFen(f.id, "epaisseur_lame", e.target.value)}>
                  {["6","10","12","15","16","18","20"].map(v => <option key={v} value={v}>{v} mm</option>)}
                </select>
              </div>
            )}
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Menuiserie</label>
              <select style={styles.select} value={f.menuiserie} onChange={e => updFen(f.id, "menuiserie", e.target.value)}>
                {[["bois","Bois"],["pvc","PVC"],["alu_sans_rpt","Alu sans RPT"],["alu_avec_rpt","Alu avec RPT"],["mixte","Mixte"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Fermeture</label>
              <select style={styles.select} value={f.fermeture} onChange={e => updFen(f.id, "fermeture", e.target.value)}>
                {[["aucune","Aucune"],["volet_battant","Volet battant"],["volet_roulant","Volet roulant"],["persienne","Persienne"],["volet_isolant","Volet isolant"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Masque (ombrage)</label>
              <select style={styles.select} value={f.masque} onChange={e => updFen(f.id, "masque", e.target.value)}>
                <option value="non">❌ Non</option>
                <option value="oui">✅ Oui</option>
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Donne sur</label>
              <select style={styles.select} value={f.contact} onChange={e => updFen(f.id, "contact", e.target.value)}>
                <option value="ext">Extérieur</option>
                <option value="lnc">Local non chauffé</option>
              </select>
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Uw (W/m².K)</label>
              <input style={styles.input} type="number" placeholder="ex: 1.8" value={f.uw} onChange={e => updFen(f.id, "uw", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Sw (facteur solaire)</label>
              <input style={styles.input} type="number" placeholder="ex: 0.6" value={f.sw} onChange={e => updFen(f.id, "sw", e.target.value)} />
            </div>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Année de pose</label>
            <input style={styles.input} type="number" placeholder="ex: 1995" value={f.annee} onChange={e => updFen(f.id, "annee", e.target.value)} />
          </div>
          <div
            onClick={() => updFen(f.id, "amelioration", !f.amelioration)}
            style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, padding: "10px 12px", borderRadius: 8, cursor: "pointer",
              background: f.amelioration ? "#ef444415" : COLORS.card,
              border: `2px solid ${f.amelioration ? "#ef4444" : COLORS.border}` }}>
            <div style={{ width: 22, height: 22, borderRadius: 5, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
              background: f.amelioration ? "#ef4444" : "transparent", border: `2px solid ${f.amelioration ? "#ef4444" : COLORS.muted}`,
              fontSize: 13, color: "#fff", fontWeight: 900 }}>{f.amelioration ? "✓" : ""}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: f.amelioration ? "#ef4444" : COLORS.muted }}>
                ⚠️ Remplacement recommandé
              </div>
              <div style={{ fontSize: 11, color: COLORS.muted }}>
                {f.amelioration ? `Fenêtre ${i+1} — ${f.orientation?.toUpperCase()} — ${f.nombre||1} unité(s) — vitrage ${f.vitrage} — signalée comme prioritaire` : "Cochez si cette fenêtre nécessite un remplacement (double vitrage, triple vitrage…)"}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── PORTES (multi) ──
function PortesSection({ data, onChange }) {
  const portes = JSON.parse(data.portes_list || "[]");
  const setPortes = (list) => onChange("portes_list", JSON.stringify(list));
  const addPorte = () => setPortes([...portes, { id: Date.now(), label: "Porte d'entrée", type: "isolee", contact: "ext", surface: "2", u: "" }]);
  const updPorte = (id, key, val) => setPortes(portes.map(p => p.id === id ? { ...p, [key]: val } : p));
  const delPorte = (id) => setPortes(portes.filter(p => p.id !== id));

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent }}>🚪 Portes ({portes.length})</div>
        <button onClick={addPorte} style={{ ...styles.btn("primary"), fontSize: 11, padding: "5px 12px" }}>+ Ajouter</button>
      </div>
      {portes.length === 0 && <div style={{ fontSize: 12, color: COLORS.muted, padding: "8px 0" }}>Aucune porte saisie</div>}
      {portes.map((p, i) => (
        <div key={p.id} style={{ background: COLORS.surface, borderRadius: 10, padding: 12, marginBottom: 10, border: `1px solid ${COLORS.border}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: COLORS.accent }}>Porte {i + 1}</div>
            <button onClick={() => delPorte(p.id)} style={{ background: "none", border: "none", color: COLORS.red, cursor: "pointer", fontSize: 18 }}>×</button>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Désignation</label>
            <input style={styles.input} type="text" placeholder="ex: Porte d'entrée" value={p.label} onChange={e => updPorte(p.id, "label", e.target.value)} />
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Type</label>
              <select style={styles.select} value={p.type} onChange={e => updPorte(p.id, "type", e.target.value)}>
                {[["bois_plein","Bois plein — U ≈ 3.0"],["isolee","Isolée — U ≈ 1.5"],["metalique","Métal non isolé — U ≈ 5.8"],["vitree_double","Vitrée DV — U ≈ 2.6"],["garage_isole","Garage isolée — U ≈ 1.5"],["garage_non_isole","Garage non isolée — U ≈ 4.0"],["inconnu","Inconnue"]].map(([v,l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Donne sur</label>
              <select style={styles.select} value={p.contact} onChange={e => updPorte(p.id, "contact", e.target.value)}>
                <option value="ext">Extérieur — b = 1.0</option>
                <option value="lnc">Local non chauffé — b = 0.5</option>
                <option value="chauffe">Local chauffé — b = 0</option>
              </select>
            </div>
          </div>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Surface (m²)</label>
              <input style={styles.input} type="number" placeholder="ex: 2.0" value={p.surface} onChange={e => updPorte(p.id, "surface", e.target.value)} />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>U porte (W/m².K)</label>
              <input style={styles.input} type="number" placeholder="ex: 1.5" value={p.u} onChange={e => updPorte(p.id, "u", e.target.value)} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── DATE PICKER ──
function DatePicker({ label, value, onChange }) {
  // Normalise vers AAAA-MM-JJ pour l'input type=date
  const toInputVal = (v) => {
    if (!v) return "";
    // Déjà AAAA-MM-JJ
    if (/^\d{4}-\d{2}-\d{2}/.test(v)) return v.substring(0, 10);
    // Format JJ/MM/AAAA
    const parts = v.split("/");
    if (parts.length === 3 && parts[2].length === 4) return `${parts[2]}-${parts[1].padStart(2,"0")}-${parts[0].padStart(2,"0")}`;
    return "";
  };
  const toDisplay = (v) => {
    if (!v) return "";
    // Garder AAAA-MM-JJ (plus simple pour le rapport)
    return v;
  };
  return (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input
        style={styles.input}
        type="date"
        value={toInputVal(value)}
        onChange={e => onChange(e.target.value)}
      />
      {value && <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>
        {toInputVal(value) ? new Date(toInputVal(value)).toLocaleDateString("fr-FR") : ""}
      </div>}
    </div>
  );
}

// ── ADRESSE AUTOCOMPLETE (API Adresse gouv.fr) ──
function AdresseAutocomplete({ label, value, onChange, onSelect, placeholder }) {
  const [suggestions, setSuggestions] = useState([]);
  const [showSug, setShowSug] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);
  const timerRef = useRef(null);

  const search = async (q) => {
    if (q.length < 3) { setSuggestions([]); setShowSug(false); return; }
    setLoading(true);
    try {
      const res = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(q)}&limit=6`, {
        headers: { "Accept": "application/json" }
      });
      if (!res.ok) throw new Error("API indisponible");
      const data = await res.json();
      const results = data.features || [];
      setSuggestions(results);
      setShowSug(results.length > 0);
    } catch {
      setSuggestions([]);
      setShowSug(false);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(false); // L'utilisateur retape — réactiver la recherche
    onChange(v);
    clearTimeout(timerRef.current);
    // Ne pas chercher si c'est une adresse déjà sélectionnée
    if (!selected) {
      timerRef.current = setTimeout(() => search(v), 400);
    }
  };

  const handleSelect = (feature) => {
    const p = feature.properties;
    const adresse = p.name || "";
    setSelected(true); // Marquer comme sélectionné pour stopper la recherche
    setSuggestions([]);
    setShowSug(false);
    onChange(adresse); // Mettre uniquement le nom de rue dans le champ
    if (onSelect) onSelect({
      adresse: adresse,
      code_postal: p.postcode || "",
      commune: p.city || "",
      full: p.label || "",
    });
  };

  return (
    <div style={{ ...styles.field, position: "relative" }}>
      <label style={styles.label}>{label}</label>
      <div style={{ position: "relative" }}>
        <input
          style={{ ...styles.input, paddingRight: loading ? 36 : 12 }}
          type="text"
          placeholder={placeholder || "ex: 86 Avenue du Bac"}
          value={value}
          onChange={handleChange}
          onBlur={() => setTimeout(() => setShowSug(false), 200)}
          onFocus={() => !selected && suggestions.length > 0 && setShowSug(true)}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
        />
        {loading && (
          <div style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14 }}>⏳</div>
        )}
      </div>
      {showSug && suggestions.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: COLORS.card, border: `1px solid ${COLORS.border}`, borderRadius: 10, zIndex: 100, boxShadow: "0 8px 24px rgba(0,0,0,0.3)", overflow: "hidden" }}>
          {suggestions.map((f, i) => (
            <div key={i} onMouseDown={() => handleSelect(f)}
              style={{ padding: "10px 14px", cursor: "pointer", borderBottom: i < suggestions.length - 1 ? `1px solid ${COLORS.border}` : "none", fontSize: 13 }}
              onMouseEnter={e => e.currentTarget.style.background = COLORS.surface}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <div style={{ fontWeight: 600 }}>{f.properties.name}</div>
              <div style={{ fontSize: 11, color: COLORS.muted }}>{f.properties.postcode} {f.properties.city}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Helper component for collapsible sections
function Section({ num, icon, title, isComplete, children, defaultOpen = false }) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div style={{ marginBottom: 8, borderRadius: 12, overflow: "hidden", border: `1px solid ${isComplete ? COLORS.green + "44" : COLORS.border}` }}>
      <div
        onClick={() => setOpen(!open)}
        style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", cursor: "pointer",
          background: isComplete ? COLORS.green + "08" : COLORS.surface,
          borderBottom: open ? `1px solid ${COLORS.border}` : "none" }}>
        <div style={{ width: 28, height: 28, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
          background: isComplete ? COLORS.green : COLORS.card,
          border: `2px solid ${isComplete ? COLORS.green : COLORS.border}`,
          fontSize: 12, fontWeight: 800, color: isComplete ? "#fff" : COLORS.muted }}>
          {isComplete ? "✓" : num}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: isComplete ? COLORS.green : COLORS.text }}>
            {icon} {title}
          </div>
        </div>
        <div style={{ fontSize: 18, color: COLORS.muted, transform: open ? "rotate(180deg)" : "none", transition: "0.2s" }}>⌄</div>
      </div>
      {open && <div style={{ padding: "16px", background: COLORS.bg }}>{children}</div>}
    </div>
  );
}

function LogementTab({ data, onChange, equipments, setActiveTab, view = "general" }) {
  const isGeneral = view === "general";
  const isDescriptif = view === "descriptif";
  const sel = (key, label, options) => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <select style={styles.select} value={data[key] || ""} onChange={e => onChange(key, e.target.value)}>
        <option value="">— Choisir —</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
  const inp = (key, label, placeholder, type="text") => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input style={styles.input} type={type} placeholder={placeholder}
        value={data[key] || ""} onChange={e => onChange(key, e.target.value)} />
    </div>
  );

  // Completion checks
  const c1 = !!(data.dpe_lettre || data.ademe_numero || data.adresse);
  const c2 = !!(data.proprio_nom);
  const c3 = !!(data.surface || data.type);
  // c4 : enveloppe — au moins 1 mur OU données ADEME OU plancher bas renseigné
  const mursListC4 = JSON.parse(data.murs_list || "[]");
  const toitsListC4 = JSON.parse(data.toitures_list || "[]");
  const c4 = !!(mursListC4.length > 0 || toitsListC4.length > 0 || data.ademe_dep_mur || data.type_plancher_bas || data.isolation_murs);
  // c5 : menuiseries — au moins 1 fenêtre OU données ADEME
  const fensListC5 = JSON.parse(data.fenetres_list || "[]");
  const c5 = !!(fensListC5.length > 0 || data.ademe_dep_baie || data.vitrage);
  const c6 = !!(data.chauffage);
  const c7 = !!(data.ecs);
  const c8 = !!(data.ventilation);

  return (
    <div>
      {/* ADEME / XML import — uniquement sur Le Bien */}
      {isGeneral && <ADEMELookup onChange={onChange} data={data} />}

      {/* Progress bar */}
      {(() => {
        const steps = [c1,c2,c3,c4,c5,c6,c7,c8];
        const done = steps.filter(Boolean).length;
        const pct = Math.round(done/steps.length*100);
        return (
          <div style={{ marginBottom: 12, padding: "12px 14px", borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.text }}>Avancement du dossier</div>
              <div style={{ fontSize: 12, fontWeight: 800, color: pct === 100 ? COLORS.green : COLORS.accent }}>{done}/8 sections — {pct}%</div>
            </div>
            <div style={{ height: 6, background: COLORS.card, borderRadius: 4, overflow: "hidden" }}>
              <div style={{ height: "100%", width: pct + "%", background: pct === 100 ? COLORS.green : COLORS.accent, borderRadius: 4, transition: "width 0.3s" }} />
            </div>
          </div>
        );
      })()}

      {/* 1 · DOSSIER */}
      {isGeneral && (
      <Section num="1" icon="📁" title="Dossier" isComplete={c1} defaultOpen={!c1}>
        <div style={styles.row}>
          {inp("ademe_numero", "N° ADEME", "ex: 2301E0743361A")}
          <DatePicker label="Date de visite" value={data.date_visite} onChange={v => onChange("date_visite", v)} />
        </div>
        <div style={styles.row}>
          <DatePicker label="Date du rapport" value={data.date_rapport} onChange={v => onChange("date_rapport", v)} />
          {sel("type_mission", "Type de mission", [
            { value: "vente", label: "Vente" },
            { value: "location", label: "Location" },
            { value: "renouvellement", label: "Renouvellement" },
            { value: "audit", label: "Audit / Autre" },
          ])}
        </div>
        {sel("statut_dossier", "Statut du dossier", [
          { value: "brouillon", label: "📝 Brouillon" },
          { value: "a_controler", label: "🔍 À contrôler" },
          { value: "transmis", label: "📤 Transmis" },
        ])}
      </Section>
      )}

      {/* 2 · PROPRIÉTAIRE */}
      {isGeneral && (
      <Section num="2" icon="👤" title="Propriétaire" isComplete={c2}>
        <div style={styles.row}>
          {inp("proprio_nom", "Nom", "ex: DUPONT")}
          {inp("proprio_prenom", "Prénom", "ex: Jean")}
        </div>
        <AdresseAutocomplete
          label="Adresse du propriétaire"
          value={data.proprio_adresse || ""}
          onChange={v => onChange("proprio_adresse", v)}
          onSelect={sel => {
            onChange("proprio_adresse", sel.adresse);
            onChange("proprio_cp", sel.code_postal);
            onChange("proprio_ville", sel.commune);
          }}
        />
        <div style={styles.row}>
          {inp("proprio_cp", "Code postal", "ex: 75001")}
          {inp("proprio_ville", "Commune", "ex: Paris")}
        </div>
        {inp("proprio_tel", "Téléphone", "ex: 06 12 34 56 78")}
        {inp("proprio_email", "Email", "ex: dupont@email.com")}

        <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, margin: "14px 0 10px" }}>Donneur d'ordre (si différent)</div>
        {inp("donneur_nom", "Nom donneur d'ordre", "ex: Agence Immobilière ABC")}
        {sel("donneur_qualite", "Qualité", [
          { value: "proprietaire", label: "Propriétaire" },
          { value: "agence", label: "Agence immobilière" },
          { value: "notaire", label: "Notaire" },
          { value: "mandataire", label: "Mandataire" },
          { value: "autre", label: "Autre" },
        ])}
      </Section>
      )}

      {/* 3 · BIEN */}
      {isGeneral && (
      <Section num="3" icon="🏠" title="Bien diagnostiqué" isComplete={c3}>
        <AdresseAutocomplete
          label="Adresse du bien"
          value={data.adresse || ""}
          onChange={v => onChange("adresse", v)}
          onSelect={sel => {
            onChange("adresse", sel.adresse);
            onChange("code_postal", sel.code_postal);
            onChange("commune", sel.commune);
          }}
        />
        <div style={styles.row}>
          {inp("code_postal", "Code postal", "ex: 94210")}
          {inp("commune", "Commune", "ex: Saint-Maur-des-Fossés")}
        </div>
        <div style={styles.row}>
          {inp("batiment", "Bâtiment / Résidence", "ex: Bât A")}
          {inp("escalier", "Escalier", "ex: B")}
        </div>
        <div style={styles.row}>
          {inp("etage", "Étage", "ex: 3")}
          {inp("porte", "N° de porte / appartement", "ex: 12")}
        </div>
        <div style={styles.row}>
          {inp("lot_copropriete", "Lot copropriété", "ex: 45")}
          {inp("ref_cadastrale", "Référence cadastrale", "ex: AB 0012")}
        </div>

        {sel("type", "Type de bien", [
          { value: "maison", label: "Maison individuelle" },
          { value: "appartement", label: "Appartement" },
          { value: "immeuble", label: "Immeuble entier" },
        ])}

        <div style={styles.row}>
          {inp("surface", "Surface habitable (m²)", "ex: 82.4", "number")}
          {inp("hauteur_sp", "Hauteur sous plafond (m)", "ex: 2.50", "number")}
        </div>
        <div style={styles.row}>
          {inp("nb_niveaux", "Nombre de niveaux", "ex: 2", "number")}
          {inp("nb_logements", "Nb logements (immeuble)", "ex: 6", "number")}
        </div>

        {sel("periode_construction", "Période de construction", [
          { value: "avant_1948", label: "Avant 1948" },
          { value: "1948_1974", label: "1948 – 1974" },
          { value: "1975_1981", label: "1975 – 1981" },
          { value: "1982_1988", label: "1982 – 1988" },
          { value: "1989_2000", label: "1989 – 2000" },
          { value: "2001_2012", label: "2001 – 2012" },
          { value: "apres_2012", label: "Après 2012 (RT 2012)" },
        ])}
        {inp("annee", "Année de construction (si connue)", "ex: 1968", "number")}

        <EtatGeneralField data={data} onChange={onChange} />
      </Section>
      )}

      {/* 4 · ENVELOPPE — début du bloc Descriptif */}
      {isDescriptif && (
      <>
      <Section num="4" icon="🧱" title="Enveloppe thermique" isComplete={c4}>

        {/* Résumé des zones à améliorer */}
        {(() => {
          const murs = JSON.parse(data.murs_list || "[]").filter(m => m.amelioration);
          const toits = JSON.parse(data.toitures_list || "[]").filter(t => t.amelioration);
          const fens = JSON.parse(data.fenetres_list || "[]").filter(f => f.amelioration);
          const nb = murs.length + toits.length + fens.length + (data.pb_amelioration ? 1 : 0);
          if (nb === 0) return null;
          return (
            <div style={{ background: "#ef444415", border: "2px solid #ef444444", borderRadius: 10, padding: "12px 14px", marginBottom: 14 }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: "#ef4444", marginBottom: 8 }}>⚠️ {nb} zone{nb > 1 ? "s" : ""} à améliorer identifiée{nb > 1 ? "s" : ""}</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {murs.map((m, i) => (
                  <div key={i} style={{ padding: "4px 10px", borderRadius: 20, background: "#ef444422", border: "1px solid #ef444444", fontSize: 11, fontWeight: 700, color: "#ef4444" }}>
                    🧱 Mur {JSON.parse(data.murs_list || "[]").indexOf(m) + 1} — {m.orientation?.toUpperCase()} {m.surface ? `${m.surface}m²` : ""}
                  </div>
                ))}
                {toits.map((t, i) => (
                  <div key={i} style={{ padding: "4px 10px", borderRadius: 20, background: "#ef444422", border: "1px solid #ef444444", fontSize: 11, fontWeight: 700, color: "#ef4444" }}>
                    🏚️ Toiture {JSON.parse(data.toitures_list || "[]").indexOf(t) + 1} — {t.surface ? `${t.surface}m²` : ""}
                  </div>
                ))}
                {data.pb_amelioration && (
                  <div style={{ padding: "4px 10px", borderRadius: 20, background: "#ef444422", border: "1px solid #ef444444", fontSize: 11, fontWeight: 700, color: "#ef4444" }}>
                    ⬇️ Plancher bas
                  </div>
                )}
                {fens.map((f, i) => (
                  <div key={i} style={{ padding: "4px 10px", borderRadius: 20, background: "#ef444422", border: "1px solid #ef444444", fontSize: 11, fontWeight: 700, color: "#ef4444" }}>
                    🪟 Fenêtre {JSON.parse(data.fenetres_list || "[]").indexOf(f) + 1} — {f.orientation?.toUpperCase()} — {f.nombre||1} unité{f.nombre > 1 ? "s" : ""}
                  </div>
                ))}
              </div>
            </div>
          );
        })()}

        {/* ── MURS ── */}
        <MursSection data={data} onChange={onChange} />

        {/* ── TOITURE ── */}
        <ToitureSection data={data} onChange={onChange} />

        {/* ── PLANCHER BAS ── */}
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent, margin: "16px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>⬇️ Plancher bas</div>
        {sel("type_plancher_bas", "Type de plancher bas (contact)", [
          { value: "terre_plein", label: "Terre-plein" },
          { value: "vide_sanitaire", label: "Vide sanitaire" },
          { value: "cave", label: "Cave / sous-sol non chauffé" },
          { value: "garage", label: "Garage non chauffé" },
          { value: "local_chauffe", label: "Sur local chauffé (pas de déperdition)" },
          { value: "pc_avec", label: "Parties communes avec ouverture" },
          { value: "pc_sans", label: "Parties communes sans ouverture" },
        ])}
        {sel("structure_plancher_bas", "Structure du plancher bas", [
          { value: "dalle_beton", label: "Dalle béton" },
          { value: "voutains_pierre", label: "Voûtains en pierre" },
          { value: "voutains_briques", label: "Voûtains en briques" },
          { value: "solives_bois_sans", label: "Solives bois sans remplissage" },
          { value: "solives_bois_avec", label: "Solives bois avec remplissage" },
          { value: "inconnu", label: "Inconnu" },
        ])}
        {sel("isolation_plancher_bas", "Isolation plancher bas", [
          { value: "aucune", label: "❌ Aucune" },
          { value: "sous_dalle", label: "Sous la dalle" },
          { value: "entre_plots", label: "Entre les plots (vide sanitaire)" },
          { value: "inconnue", label: "Inconnue" },
        ])}
        {inp("u_plancher_bas", "Coefficient U plancher bas (W/m².K)", "ex: 0.45", "number")}
        <div
          onClick={() => onChange("pb_amelioration", !data.pb_amelioration)}
          style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 6, padding: "10px 12px", borderRadius: 8, cursor: "pointer",
            background: data.pb_amelioration ? "#ef444415" : COLORS.card,
            border: `2px solid ${data.pb_amelioration ? "#ef4444" : COLORS.border}` }}>
          <div style={{ width: 22, height: 22, borderRadius: 5, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
            background: data.pb_amelioration ? "#ef4444" : "transparent", border: `2px solid ${data.pb_amelioration ? "#ef4444" : COLORS.muted}`,
            fontSize: 13, color: "#fff", fontWeight: 900 }}>{data.pb_amelioration ? "✓" : ""}</div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: data.pb_amelioration ? "#ef4444" : COLORS.muted }}>⚠️ Amélioration plancher bas recommandée</div>
            <div style={{ fontSize: 11, color: COLORS.muted }}>Cochez si le plancher bas nécessite une isolation (vide sanitaire, sous-dalle…)</div>
          </div>
        </div>

        {/* ── PONTS THERMIQUES ── */}
        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent, margin: "16px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>⚠️ Ponts thermiques</div>
        {sel("pt_methode", "Méthode ponts thermiques", [
          { value: "forfait_non_isole", label: "Forfaitaire — bâtiment non isolé" },
          { value: "forfait_isole", label: "Forfaitaire — bâtiment isolé" },
          { value: "calcul_detail", label: "Calcul détaillé par liaison" },
        ])}
        {sel("pt_traitement", "Traitement des ponts thermiques", [
          { value: "aucun", label: "❌ Aucun traitement" },
          { value: "partiel", label: "⚠️ Partiel" },
          { value: "complet", label: "✅ Complet (rupteurs, coupures)" },
        ])}
      </Section>

      {/* 5 · MENUISERIES */}
      <Section num="5" icon="🪟" title="Menuiseries & Baies vitrées" isComplete={c5}>
        <FenetresSection data={data} onChange={onChange} />
        <PortesSection data={data} onChange={onChange} />
      </Section>

      {/* 6 · CHAUFFAGE */}
      <Section num="6" icon="🔥" title="Chauffage" isComplete={c6}>
        {sel("type_installation_ch", "Type d'installation", [
          { value: "individuelle", label: "Individuelle" },
          { value: "collective", label: "Collective" },
          { value: "appareil_ind", label: "Appareil indépendant" },
        ])}
        {sel("chauffage", "Énergie principale", [
          { value: "gaz", label: "🔵 Gaz naturel" },
          { value: "gpl", label: "🔵 GPL / Propane" },
          { value: "fioul", label: "🟤 Fioul" },
          { value: "elec", label: "⚡ Électricité" },
          { value: "bois_buches", label: "🪵 Bois bûches" },
          { value: "granules", label: "🪵 Granulés (pellets)" },
          { value: "reseau", label: "🏙️ Réseau de chaleur" },
          { value: "pac_air_eau", label: "♨️ PAC air/eau" },
          { value: "pac_air_air", label: "❄️ PAC air/air" },
          { value: "pac_geo", label: "🌍 PAC géothermique" },
        ])}
        {sel("generateur_ch", "Type de générateur", [
          { value: "chaudiere_standard", label: "Chaudière standard" },
          { value: "chaudiere_basse_temp", label: "Chaudière basse température" },
          { value: "chaudiere_condensation", label: "Chaudière à condensation" },
          { value: "convecteur_elec", label: "Convecteur électrique" },
          { value: "panneau_rayonnant", label: "Panneau rayonnant électrique" },
          { value: "radiateur_inertie", label: "Radiateur à inertie électrique" },
          { value: "plc_elec", label: "Plancher chauffant électrique" },
          { value: "pac_air_eau", label: "PAC air/eau" },
          { value: "pac_air_air", label: "PAC air/air" },
          { value: "pac_geo", label: "PAC géothermique" },
          { value: "poele_bois", label: "Poêle à bois" },
          { value: "insert", label: "Insert" },
          { value: "poele_granules", label: "Poêle à granulés" },
          { value: "reseau_chaleur", label: "Réseau de chaleur" },
        ])}
        <div style={styles.row}>
          {inp("annee_ch", "Année d'installation", "ex: 2008", "number")}
          {inp("puissance_ch", "Puissance (kW)", "ex: 24", "number")}
        </div>
        {inp("rendement_ch", "Rendement (%)", "ex: 85", "number")}
        {sel("emetteurs_ch", "Émetteurs", [
          { value: "radiateurs_eau", label: "Radiateurs eau chaude" },
          { value: "plancher_chauffant", label: "Plancher chauffant eau" },
          { value: "ventilo_convecteurs", label: "Ventilo-convecteurs" },
          { value: "soufflage_air", label: "Soufflage air" },
          { value: "emetteurs_elec", label: "Émetteurs électriques" },
        ])}
        {sel("regulation_ch", "Régulation", [
          { value: "aucune", label: "Aucune régulation" },
          { value: "thermostat", label: "Thermostat d'ambiance" },
          { value: "programmateur", label: "Programmateur" },
          { value: "rbt", label: "Robinets thermostatiques" },
          { value: "sonde_ext", label: "Sonde extérieure" },
          { value: "piece_par_piece", label: "Régulation pièce par pièce" },
        ])}
        {sel("reseau_distribution_ch", "Réseau de distribution", [
          { value: "absent", label: "Absent (émetteurs électriques)" },
          { value: "int_chauffe", label: "Intérieur volume chauffé" },
          { value: "hors_isole", label: "Hors volume chauffé — isolé" },
          { value: "hors_non_isole", label: "Hors volume chauffé — non isolé" },
        ])}
        {sel("reseau_ch_isole", "Réseau de chauffage isolé ?", [
          { value: "oui", label: "✅ Oui — réseau isolé" },
          { value: "non", label: "❌ Non — réseau non isolé" },
          { value: "inconnu", label: "❓ Inconnu" },
        ])}
        {(data.chauffage === "pac_air_eau" || data.chauffage === "pac_air_air" || data.chauffage === "pac_geo" ||
          data.generateur_ch === "pac_air_eau" || data.generateur_ch === "pac_air_air" || data.generateur_ch === "pac_geo") && (
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginTop: 10, marginBottom: 6 }}>🌡️ Performances PAC</div>
            <div style={styles.row}>
              {inp("cop_scop", "COP / SCOP (saison)", "ex: 3.2", "number")}
              {inp("scop_certifie", "SCOP certifié (si connu)", "ex: 3.5", "number")}
            </div>
            <div style={{ fontSize: 11, color: COLORS.muted }}>Le SCOP est indiqué sur l'étiquette énergie de la PAC. Valeur conventionnelle 3CL si inconnue.</div>
          </div>
        )}
        {sel("usage_ch", "Usage système principal", [
          { value: "principal", label: "Principal" },
          { value: "appoint", label: "Appoint" },
        ])}

        {/* 2ème système de chauffage */}
        <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, marginTop: 14, marginBottom: 8, paddingTop: 10, borderTop: `1px dashed ${COLORS.border}` }}>
          🔥 2ème système de chauffage (optionnel)
        </div>
        {sel("chauffage2", "Énergie 2ème système", [
          { value: "", label: "— Aucun —" },
          { value: "elec", label: "⚡ Électrique" },
          { value: "gaz", label: "🔵 Gaz naturel" },
          { value: "fioul", label: "🛢️ Fioul" },
          { value: "bois_buches", label: "🪵 Bois bûches" },
          { value: "granules", label: "🌿 Granulés/pellets" },
          { value: "pac_air_eau", label: "♨️ PAC air/eau" },
          { value: "pac_air_air", label: "❄️ PAC air/air" },
        ])}
        {data.chauffage2 && (
          <>
            {sel("generateur_ch2", "Type de générateur", [
              { value: "chaudiere_condensation", label: "Chaudière à condensation" },
              { value: "chaudiere_basse_temp", label: "Chaudière basse température" },
              { value: "chaudiere_standard", label: "Chaudière standard" },
              { value: "convecteur_elec", label: "Convecteurs électriques" },
              { value: "radiateur_inertie", label: "Radiateurs à inertie" },
              { value: "pac_air_eau", label: "PAC air/eau" },
              { value: "pac_air_air", label: "PAC air/air" },
              { value: "poele_bois", label: "Poêle à bois / insert" },
              { value: "cheminee", label: "Cheminée" },
            ])}
            {sel("usage_ch2", "Usage", [
              { value: "appoint", label: "Appoint" },
              { value: "principal", label: "Principal" },
            ])}
          </>
        )}
      </Section>

      {/* 7 · ECS */}
      <Section num="7" icon="🚿" title="Eau Chaude Sanitaire (ECS)" isComplete={c7}>
        {sel("ecs", "Type de production ECS", [
          { value: "chaudiere_gaz", label: "Chaudière gaz (mixte)" },
          { value: "chaudiere_fioul", label: "Chaudière fioul (mixte)" },
          { value: "ballon_elec_vertical", label: "Ballon électrique vertical" },
          { value: "ballon_elec_horizontal", label: "Ballon électrique horizontal" },
          { value: "chauffe_eau_gaz", label: "Chauffe-eau gaz instantané" },
          { value: "cet", label: "Chauffe-eau thermodynamique (CET)" },
          { value: "solaire_thermique", label: "Solaire thermique (CESI)" },
          { value: "ecs_collective", label: "ECS collective" },
        ])}
        {sel("type_installation_ecs", "Type d'installation", [
          { value: "individuelle", label: "Individuelle" },
          { value: "collective", label: "Collective" },
        ])}
        {sel("production_ecs", "Mode de production", [
          { value: "instantanee", label: "Instantanée" },
          { value: "accumulation", label: "Accumulation" },
          { value: "semi_accumulation", label: "Semi-accumulation" },
        ])}
        <div style={styles.row}>
          {inp("volume_ballon", "Volume ballon (litres)", "ex: 200", "number")}
          {inp("annee_ecs", "Année d'installation", "ex: 2010", "number")}
        </div>
        {sel("emplacement_ecs", "Emplacement du générateur ECS", [
          { value: "volume_chauffe", label: "Volume chauffé" },
          { value: "garage", label: "Garage" },
          { value: "cave", label: "Cave" },
          { value: "combles", label: "Combles" },
          { value: "local_technique", label: "Local technique" },
        ])}
        {sel("reseau_ecs", "Réseau de distribution ECS", [
          { value: "court", label: "Court (< 5m)" },
          { value: "moyen", label: "Moyen (5 à 10m)" },
          { value: "long", label: "Long (> 10m)" },
          { value: "boucle", label: "Bouclé" },
          { value: "inconnu", label: "Inconnu" },
        ])}
        {sel("reseau_ecs_isole", "Réseau ECS isolé ?", [
          { value: "oui", label: "✅ Oui" },
          { value: "non", label: "❌ Non" },
          { value: "inconnu", label: "❓ Inconnu" },
        ])}

        {/* 2ème système ECS */}
        <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent, marginTop: 14, marginBottom: 8, paddingTop: 10, borderTop: `1px dashed ${COLORS.border}` }}>
          🚿 2ème système ECS (optionnel)
        </div>
        {sel("ecs2", "2ème production ECS", [
          { value: "", label: "— Aucun —" },
          { value: "chaudiere_gaz", label: "Chaudière gaz" },
          { value: "ballon_elec_vertical", label: "Ballon électrique vertical" },
          { value: "ballon_elec_horizontal", label: "Ballon électrique horizontal" },
          { value: "cet", label: "Chauffe-eau thermodynamique (CET)" },
          { value: "solaire_thermique", label: "Chauffe-eau solaire (CESI)" },
          { value: "chaudiere_fioul", label: "Chaudière fioul" },
          { value: "instantane_gaz", label: "Chauffe-eau instantané gaz" },
        ])}
        {data.ecs2 && data.ecs2.includes("ballon") && (
          <>
            {inp("volume_ballon2", "Volume ballon 2ème système (L)", "ex: 150", "number")}
            {sel("emplacement_ecs2", "Emplacement", [
              { value: "volume_chauffe", label: "Dans le volume chauffé" },
              { value: "hors_volume", label: "Hors volume chauffé" },
            ])}
          </>
        )}
      </Section>

      {/* 8 · VENTILATION + CLIM */}
      <Section num="8" icon="💨" title="Ventilation & Refroidissement" isComplete={c8}>
        {sel("ventilation", "Type de ventilation", [
          { value: "naturelle_tirage", label: "Ventilation naturelle par conduits" },
          { value: "naturelle_ouverture", label: "Ventilation naturelle par ouverture" },
          { value: "vmc_sf_auto", label: "VMC simple flux autoréglable" },
          { value: "vmc_sf_hygro_a", label: "VMC simple flux hygroréglable type A" },
          { value: "vmc_sf_hygro_b", label: "VMC simple flux hygroréglable type B" },
          { value: "vmc_df_eco", label: "VMC double flux avec échangeur" },
          { value: "extracteurs", label: "Extracteurs ponctuels" },
          { value: "aucune", label: "❌ Aucune ventilation identifiée" },
        ])}
        {sel("entrees_air", "Entrées d'air", [
          { value: "menuiseries", label: "Dans les menuiseries" },
          { value: "murs", label: "Dans les murs (grilles)" },
          { value: "absentes", label: "Absentes" },
          { value: "non_visibles", label: "Non visibles" },
        ])}
        {inp("annee_vmc", "Année d'installation VMC", "ex: 2005", "number")}
        {data.ventilation === "vmc_df_eco" && inp("rendement_df", "Rendement double flux (%)", "ex: 85", "number")}

        <div style={{ fontSize: 13, fontWeight: 800, color: COLORS.accent, margin: "16px 0 10px", paddingBottom: 6, borderBottom: `1px solid ${COLORS.border}` }}>❄️ Refroidissement</div>
        {sel("clim_presence", "Système de refroidissement", [
          { value: "non", label: "❌ Aucun" },
          { value: "oui_fixe", label: "✅ Fixe (split, gainable)" },
          { value: "oui_mobile", label: "🔌 Mobile (non pris en compte 3CL)" },
          { value: "reversible", label: "♻️ PAC réversible" },
        ])}
        {(data.clim_presence === "oui_fixe" || data.clim_presence === "reversible") && (
          <div>
            {sel("clim_type", "Type", [
              { value: "split_mural", label: "Split mural mono-split" },
              { value: "multi_split", label: "Multi-split" },
              { value: "gainable", label: "Gainable" },
              { value: "pac_reversible", label: "PAC réversible air/eau" },
              { value: "pac_air_air", label: "PAC air/air" },
              { value: "collectif", label: "Collectif" },
            ])}
            <div style={styles.row}>
              {inp("clim_seer", "SEER (efficacité saisonnière froid)", "ex: 5.1", "number")}
              {inp("clim_scop", "SCOP (efficacité saisonnière chaud)", "ex: 3.8", "number")}
            </div>
            <div style={styles.row}>
              {inp("clim_annee", "Année d'installation", "ex: 2018", "number")}
              {inp("clim_surface", "Surface desservie (m²)", "ex: 45", "number")}
            </div>
            <div style={{ fontSize: 11, color: COLORS.muted }}>Le SEER et SCOP sont indiqués sur l'étiquette énergie de l'appareil. En l'absence, valeur conventionnelle 3CL retenue.</div>
          </div>
        )}
      </Section>
      </>
      )}

      {/* Boutons navigation */}
      {isGeneral && (c1 && c2 && c3) && (
        <div style={{ padding: "14px", borderRadius: 12, background: COLORS.green + "10", border: `1px solid ${COLORS.green}44`, marginTop: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.green, marginBottom: 10 }}>✅ Dossier en cours — prochaines étapes</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button onClick={() => setActiveTab && setActiveTab(1)} style={{ ...styles.btn("secondary"), fontSize: 12 }}>📋 Descriptif →</button>
            <button onClick={() => setActiveTab && setActiveTab(2)} style={{ ...styles.btn("secondary"), fontSize: 12 }}>💡 Reco →</button>
            <button onClick={() => setActiveTab && setActiveTab(6)} style={{ ...styles.btn("primary"), fontSize: 12 }}>📋 Rapport PDF →</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ---- DPE Result Gauge ----
function DPEGauge({ value, label, unit }) {
  const isGES = unit && unit.includes("CO₂");
  const classes = isGES ? GES_CLASSES : DPE_CLASSES;
  const cls = isGES ? getGESClass(value) : getDPEClass(value);
  const displayUnit = unit || "kWh EP/m²/an";
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: COLORS.muted,
          marginBottom: 8,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </div>
      <div style={styles.dpeBar}>
        {classes.map((c) => {
          const active = c.label === cls.label;
          const w = Math.min(
            100,
            c.label === "A"
              ? 30
              : c.label === "B"
              ? 42
              : c.label === "C"
              ? 54
              : c.label === "D"
              ? 66
              : c.label === "E"
              ? 78
              : c.label === "F"
              ? 88
              : 100
          );
          return (
            <div key={c.label} style={styles.dpeRow(active, c.color)}>
              <div
                style={{
                  ...styles.bigLetter(c.color),
                  width: 34,
                  height: 34,
                  fontSize: 16,
                  color: c.textColor,
                }}
              >
                {c.label}
              </div>
              <div
                style={{
                  height: 10,
                  width: `${w}%`,
                  background: c.color,
                  borderRadius: 5,
                  opacity: active ? 1 : 0.3,
                }}
              />
              {active && (
                <div style={{ fontWeight: 800, color: c.color, marginLeft: 4 }}>
                  {Math.round(value)} {displayUnit}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ---- Comments & Travaux Tab ----
const RECOMMANDATION_TYPES = [
  { id: "isolation_murs", label: "🧱 Isolation murs", color: "#8b5cf6" },
  { id: "isolation_combles", label: "🏚️ Isolation combles", color: "#f97316" },
  { id: "isolation_plancher", label: "⬇️ Isolation plancher", color: "#eab308" },
  { id: "chauffage", label: "🔥 Chauffage", color: "#ef4444" },
  { id: "ecs", label: "🚿 Eau chaude", color: "#f59e0b" },
  { id: "ventilation", label: "💨 Ventilation", color: "#06b6d4" },
  { id: "vitrage", label: "🪟 Vitrage", color: "#10b981" },
  { id: "regulation", label: "🌡️ Régulation", color: "#3b82f6" },
  { id: "bois", label: "🪵 Bois / Biomasse", color: "#92400e" },
  { id: "reseau", label: "🏙️ Réseau de chaleur", color: "#0891b2" },
];

const RECOMMANDATIONS_BIBLIO = {
  isolation_murs: [
    { label: "ITE recommandée", texte: "Isolation thermique par l'extérieur (ITE) recommandée. Les murs présentent une déperdition importante. Résistance thermique cible R ≥ 3,7 m².K/W." },
    { label: "ITI recommandée", texte: "Isolation thermique par l'intérieur (ITI) recommandée avec doublage sur ossature. Résistance thermique cible R ≥ 3,7 m².K/W. Attention aux ponts thermiques en périphérie." },
    { label: "Enduit isolant", texte: "Application d'un enduit isolant sur façade recommandée pour améliorer les performances thermiques des murs." },
  ],
  isolation_combles: [
    { label: "Soufflage combles perdus", texte: "Isolation des combles perdus par soufflage de laine minérale ou cellulose recommandée. Résistance thermique cible R ≥ 7 m².K/W." },
    { label: "Isolation rampants", texte: "Isolation des rampants de toiture recommandée. Résistance thermique cible R ≥ 6 m².K/W." },
    { label: "Toiture-terrasse", texte: "Isolation de la toiture-terrasse par l'extérieur recommandée. Résistance thermique cible R ≥ 4,5 m².K/W." },
  ],
  isolation_plancher: [
    { label: "Vide sanitaire", texte: "Isolation du plancher bas sur vide sanitaire recommandée par projection ou panneau rigide. Résistance thermique cible R ≥ 3 m².K/W." },
    { label: "Sous-sol non chauffé", texte: "Isolation du plancher bas sur sous-sol non chauffé recommandée. Résistance thermique cible R ≥ 3 m².K/W." },
  ],
  chauffage: [
    { label: "Remplacement chaudière → PAC", texte: "Remplacement de la chaudière existante par une pompe à chaleur air/eau recommandé. COP cible ≥ 3,5. Éligible MaPrimeRénov' et CEE." },
    { label: "Chaudière à condensation", texte: "Remplacement de la chaudière par un modèle à condensation recommandé. Rendement cible ≥ 109 %. Éligible CEE." },
    { label: "Poêle à granulés", texte: "Installation d'un poêle à granulés certifié Flamme Verte 7 étoiles recommandée en complément du système existant." },
    { label: "PAC air/air", texte: "Installation d'une pompe à chaleur air/air recommandée pour le chauffage et le rafraîchissement. Éligible CEE." },
  ],
  ecs: [
    { label: "Chauffe-eau thermodynamique", texte: "Remplacement du chauffe-eau par un modèle thermodynamique recommandé. COP cible ≥ 2,5. Éligible MaPrimeRénov' et CEE." },
    { label: "Chauffe-eau solaire", texte: "Installation d'un chauffe-eau solaire individuel (CESI) recommandée. Taux de couverture solaire estimé 60-70 %. Éligible MaPrimeRénov' et CEE." },
    { label: "Ballon connecté", texte: "Remplacement du ballon électrique par un modèle connecté avec programmation horaire recommandé pour optimiser la consommation." },
  ],
  ventilation: [
    { label: "VMC hygro B — recommandée", texte: "Installation d'une VMC simple flux hygroréglable de type B recommandée. Débit modulé en fonction de l'humidité, conforme à la réglementation. Rendement d'échange supérieur à la hygro A. Éligible CEE. Coût indicatif : 1 500 – 3 500 € pose comprise." },
    { label: "VMC simple flux hygro A", texte: "Installation d'une VMC simple flux hygroréglable de type A recommandée. Débit nominal conforme à la réglementation. Coût indicatif : 800 – 1 500 € pose comprise." },
    { label: "VMC double flux", texte: "Installation d'une VMC double flux avec récupérateur de chaleur recommandée. Rendement échangeur cible ≥ 85 %. Éligible MaPrimeRénov' et CEE. Coût indicatif : 4 000 – 8 000 € pose comprise." },
    { label: "Reprise réseau VMC", texte: "Reprise du réseau de ventilation existant recommandée : remplacement des bouches, nettoyage des gaines et vérification des débits conformément à la réglementation." },
  ],
  vitrage: [
    { label: "Double vitrage peu émissif", texte: "Remplacement des fenêtres par double vitrage à isolation renforcée (Uw ≤ 1,3 W/m².K) recommandé. Menuiseries PVC ou aluminium à rupture de pont thermique." },
    { label: "Triple vitrage", texte: "Remplacement par triple vitrage recommandé en zone climatique froide (Uw ≤ 0,9 W/m².K). Gain thermique et acoustique significatif." },
    { label: "Volets et protection solaire", texte: "Installation de volets isolants ou de protections solaires extérieures recommandée pour limiter les apports solaires estivaux et les déperditions nocturnes." },
  ],
  regulation: [
    { label: "Thermostat programmable", texte: "Installation d'un thermostat programmable ou connecté recommandée. Économies estimées 10-15 % sur la facture de chauffage." },
    { label: "Robinets thermostatiques", texte: "Pose de robinets thermostatiques sur tous les radiateurs recommandée pour une régulation pièce par pièce." },
    { label: "Système GTB", texte: "Installation d'un système de gestion technique du bâtiment (GTB) recommandée pour optimiser l'ensemble des consommations énergétiques." },
  ],
  bois: [
    { label: "Poêle à granulés — recommandé", texte: "Installation d'un poêle à granulés (pellets) labellisé Flamme Verte 7 étoiles recommandée. Rendement 3CL cible ≥ 85 %. Coeff EP bois = 1,0 (vs 1,9 élec). Gain EP estimé 38 % sur le poste chauffage. Éligible MaPrimeRénov' et CEE. Coût indicatif : 3 000 – 7 000 € pose comprise." },
    { label: "Poêle à bois bûches", texte: "Installation d'un poêle à bois bûches labellisé Flamme Verte recommandée. Rendement 3CL cible ≥ 70 %. Coeff EP bois = 1,0. Gain EP estimé 25 % sur le poste chauffage. Attention : approvisionnement en bois sec (humidité < 20 %) indispensable." },
    { label: "Chaudière bois/granulés", texte: "Remplacement de la chaudière actuelle par une chaudière biomasse (bois bûches ou granulés) recommandée. Rendement 3CL cible ≥ 85 %. Coeff EP bois = 1,0. Éligible MaPrimeRénov' catégorie biomasse et Éco-PTZ. Coût indicatif : 8 000 – 20 000 €." },
    { label: "Insert cheminée", texte: "Remplacement de la cheminée ouverte par un insert à bois fermé recommandé. Rendement amélioré de 10-15 % à 70-75 %. Réduction des émissions de particules fines. Label Flamme Verte recommandé." },
  ],
  reseau: [
    { label: "Raccordement réseau de chaleur", texte: "Raccordement au réseau de chaleur urbain recommandé. Coeff EP réseau = 0,627 (3CL-DPE 2021), inférieur au gaz (1,1) et à l'électricité (1,9). Gain EP variable selon la source du réseau : biomasse, géothermie ou cogénération. Éligible MaPrimeRénov' et CEE. Se renseigner auprès du gestionnaire du réseau local." },
    { label: "Réseau de chaleur — bilan GES", texte: "Le réseau de chaleur présente un bilan carbone avantageux lorsqu'il est alimenté majoritairement par des énergies renouvelables (biomasse, géothermie) ou fatales (cogénération). Vérifier le contenu CO₂ du réseau local auprès du gestionnaire (obligatoire depuis 2021)." },
  ],
};

const TRAVAUX_TYPES = [
  // ── ISOLATION ENVELOPPE ──
  // 3CL-DPE 2021 : ITE sur mur en pierre U=1.8 → U=0.27 soit gain ~30-45% selon surface
  { id: "isolation_ext", label: "ITE - Isolation thermique par l'extérieur", urgence: "haute", gain: "20-45%", cout: "150-250€/m²", aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    unite: "m²", cout_unitaire_min: 150, cout_unitaire_max: 250,
    note: "R cible ≥ 3,7 m².K/W — U résultant ≤ 0,27 W/m².K (3CL-DPE 2021)" },
  // 3CL-DPE 2021 : ITI mur pierre U=1.8 → U=0.30 soit gain ~20-35%
  { id: "isolation_int", label: "ITI - Isolation thermique par l'intérieur", urgence: "haute", gain: "15-35%", cout: "50-120€/m²", aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    unite: "m²", cout_unitaire_min: 50, cout_unitaire_max: 120,
    note: "R cible ≥ 3,7 m².K/W — U résultant ≤ 0,30 W/m².K (3CL-DPE 2021) — attention ponts thermiques" },
  // 3CL-DPE 2021 : combles R=0 → R=7 soit gain 20-30% sur déperditions totales
  { id: "combles", label: "Isolation des combles perdus", urgence: "haute", gain: "20-30%", cout: "20-50€/m²", aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    unite: "m²", cout_unitaire_min: 20, cout_unitaire_max: 50,
    note: "R cible ≥ 7 m².K/W — U résultant ≤ 0,14 W/m².K (3CL-DPE 2021)" },
  { id: "plancher_bas", label: "Isolation plancher bas / vide sanitaire / sous-sol", urgence: "moyenne", gain: "7-15%", cout: "30-80€/m²", aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    unite: "m²", cout_unitaire_min: 30, cout_unitaire_max: 80,
    note: "R cible ≥ 3 m².K/W (3CL-DPE 2021)" },
  { id: "pont_thermique", label: "Traitement des ponts thermiques", urgence: "haute", gain: "5-15%", cout: "Variable", aides: ["CEE"],
    note: "Passage de forfait non isolé à isolé — gain sur coefficient Ψ linéique (3CL-DPE 2021)" },

  // ── CHAUFFAGE ──
  // 3CL-DPE 2021 : PAC air/eau SCOP 3.5 vs chaudière gaz rdt 0.85 → gain 35-55%
  { id: "pac", label: "Installation pompe à chaleur air/eau", urgence: "moyenne", gain: "35-55%", cout: "8000-15000€", aides: ["MaPrimeRénov'","CEE"],
    note: "SCOP cible ≥ 3,5 — coefficient 3CL EP : 1,9 élec vs 1,1 gaz (3CL-DPE 2021)" },
  // 3CL-DPE 2021 : condensation rdt 109% vs standard 85% → gain 15-25%
  { id: "chaudiere_gaz", label: "Chaudière gaz à condensation", urgence: "moyenne", gain: "15-25%", cout: "3000-6000€", aides: ["CEE"],
    note: "Rendement PCS cible ≥ 109 % — remplace chaudière standard rdt 85 % (3CL-DPE 2021)" },
  // 3CL-DPE 2021 : radiateurs NG avec régulation → gain 10-20% vs convecteurs fil pilote
  { id: "convecteurs_ng", label: "Remplacement convecteurs par radiateurs électriques nouvelle génération (programmation pièce par pièce)", urgence: "moyenne", gain: "10-20%", cout: "200-600€/unité", aides: ["CEE"],
    note: "Classe énergétique A recommandée — régulation pièce par pièce — gain sur modulation de puissance (3CL-DPE 2021)" },
  { id: "pac_air_air_conv", label: "Remplacement convecteurs électriques par PAC air/air (SCOP ≥ 3,5)", urgence: "moyenne", gain: "40-60%", cout: "3000-8000€", aides: ["MaPrimeRénov'","CEE"],
    note: "SCOP cible ≥ 3,5 — coeff EP élec 1,9 → gain 71% poste CH — solution idéale appt sans réseau eau (3CL-DPE 2021)" },

  // ── ECS ──
  // 3CL-DPE 2021 : CET COP 2.5 vs ballon élec → gain 40-60% sur poste ECS
  { id: "cet", label: "Chauffe-eau thermodynamique (CET)", urgence: "moyenne", gain: "40-60% ECS", cout: "1500-3500€", aides: ["MaPrimeRénov'","CEE"],
    note: "COP cible ≥ 2,5 — coefficient EP élec 1,9 divisé par COP (3CL-DPE 2021)" },
  { id: "ballon_ng", label: "Remplacement ballon eau chaude par modèle nouvelle génération basse consommation", urgence: "moyenne", gain: "10-20% ECS", cout: "400-900€", aides: ["CEE"],
    note: "Classe énergétique A recommandée — réduction pertes statiques (3CL-DPE 2021)" },
  { id: "solaire_therm", label: "Chauffe-eau solaire thermique (CESI)", urgence: "basse", gain: "40-70% ECS", cout: "3000-7000€", aides: ["MaPrimeRénov'","CEE"],
    note: "Taux de couverture solaire 60-70 % selon orientation (3CL-DPE 2021)" },

  // ── VENTILATION ──
  // 3CL-DPE 2021 : VMC hygro B vs naturelle → gain 10-20% sur déperditions renouvellement air
  { id: "vmc_hygro_b", label: "VMC simple flux hygroréglable type B", urgence: "moyenne", gain: "10-20%", cout: "1500-3500€", aides: ["CEE"],
    note: "Débit modulé — qv réf réduit par rapport à ventilation naturelle (3CL-DPE 2021)" },
  // 3CL-DPE 2021 : VMC DF échangeur 85% → gain 10-25% sur déperditions ventilation
  { id: "vmc_df", label: "VMC double flux avec échangeur (rendement ≥ 85 %)", urgence: "moyenne", gain: "10-25%", cout: "4000-8000€", aides: ["MaPrimeRénov'","CEE"],
    note: "Rendement échangeur ≥ 85 % — qv réduit par récupération chaleur (3CL-DPE 2021)" },

  // ── MENUISERIES ──
  // 3CL-DPE 2021 : DV peu émissif Uw=1.3 vs SV Uw=5.8 → gain 10-15%
  { id: "double_vitrage", label: "Remplacement fenêtres double vitrage peu émissif (Uw ≤ 1,3)", urgence: "basse", gain: "10-15%", cout: "300-800€/fenêtre", aides: ["MaPrimeRénov'","CEE"],
    unite: "fenêtre", cout_unitaire_min: 300, cout_unitaire_max: 800,
    note: "Uw cible ≤ 1,3 W/m².K — Sw ≥ 0,36 (3CL-DPE 2021)" },
  { id: "triple_vitrage", label: "Triple vitrage (Uw ≤ 0,9 W/m².K)", urgence: "basse", gain: "15-20%", cout: "500-1200€/fenêtre", aides: ["MaPrimeRénov'","CEE"],
    unite: "fenêtre", cout_unitaire_min: 500, cout_unitaire_max: 1200,
    note: "Uw cible ≤ 0,9 W/m².K — recommandé zone H1 (3CL-DPE 2021)" },

  // ── RÉGULATION ──
  { id: "thermostat", label: "Thermostat programmable / régulation pièce par pièce", urgence: "basse", gain: "5-15%", cout: "200-1500€", aides: ["CEE"],
    note: "Gain sur intermittence — réduction température de consigne hors occupation (3CL-DPE 2021)" },

  // ── BOIS / BIOMASSE ──
  { id: "poele_granules", label: "Installation poêle à granulés (pellets) — rdt ≥ 85%", urgence: "moyenne", gain: "30-50%", cout: "3000-7000€", aides: ["MaPrimeRénov'","CEE"],
    note: "Rdt 3CL-DPE 2021 : 85% labelisé — coeff EP bois 1,0 vs élec 1,9 ou gaz 1,1 — émissions CO₂ très faibles" },
  { id: "poele_bois", label: "Installation poêle à bois bûches — rdt ≥ 70%", urgence: "basse", gain: "20-40%", cout: "1500-5000€", aides: ["MaPrimeRénov'","CEE"],
    note: "Rdt 3CL-DPE 2021 : 70% labelisé / 55% non labelisé — coeff EP bois 1,0 — label Flamme Verte recommandé" },
  { id: "chaudiere_bois", label: "Chaudière bois bûches ou granulés — rdt ≥ 85%", urgence: "moyenne", gain: "30-55%", cout: "8000-20000€", aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    note: "Rdt 3CL-DPE 2021 : 85% — coeff EP bois 1,0 — éligible MaPrimeRénov' catégorie biomasse" },

  // ── RÉSEAU DE CHALEUR ──
  { id: "raccordement_reseau", label: "Raccordement au réseau de chaleur urbain", urgence: "moyenne", gain: "20-60%", cout: "3000-15000€", aides: ["MaPrimeRénov'","CEE"],
    note: "Coeff EP réseau 0,627 (3CL-DPE 2021) — gain variable selon source du réseau (biomasse, géothermie, cogénération)" },
];

const URGENCE_COLORS = { haute: "#ef4444", moyenne: "#f97316", basse: "#22c55e" };

function CommentsTravauxTab({ data, onChange, comments, setComments, travaux, setTravaux }) {
  const [newReco, setNewReco] = useState({ type: "chauffage", texte: "" });
  const [showBiblio, setShowBiblio] = useState(false);
  const [biblioType, setBiblioType] = useState("chauffage");

  // Bibliothèque personnalisée sauvegardée en localStorage
  const [biblioPers, setBiblioPers] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fndi_biblio_perso") || "{}"); } catch { return {}; }
  });

  const saveBiblioPers = (newBiblio) => {
    setBiblioPers(newBiblio);
    try { localStorage.setItem("fndi_biblio_perso", JSON.stringify(newBiblio)); } catch {}
  };

  const addToBiblio = () => {
    if (!newReco.texte.trim()) return;
    const type = newReco.type;
    const current = biblioPers[type] || [];
    const label = newReco.texte.substring(0, 50) + (newReco.texte.length > 50 ? "…" : "");
    const newEntry = { label, texte: newReco.texte, custom: true, id: Date.now() };
    saveBiblioPers({ ...biblioPers, [type]: [...current, newEntry] });
    alert("✅ Recommandation ajoutée à votre bibliothèque !");
  };

  const removeFromBiblio = (type, id) => {
    const current = (biblioPers[type] || []).filter(e => e.id !== id);
    saveBiblioPers({ ...biblioPers, [type]: current });
  };

  // Fusionner biblio par défaut + personnalisée
  const getBiblio = (type) => [
    ...(RECOMMANDATIONS_BIBLIO[type] || []),
    ...(biblioPers[type] || []),
  ];

  const addReco = () => {
    if (!newReco.texte.trim()) return;
    setComments(prev => [...prev, { ...newReco, id: Date.now(), date: new Date().toLocaleDateString("fr-FR") }]);
    setNewReco(p => ({ ...p, texte: "" }));
    setReformuled(false);
  };

  const [loadingReformule, setLoadingReformule] = useState(false);
  const [reformuled, setReformuled] = useState(false);

  const reformulerIA = async () => {
    if (!newReco.texte.trim()) return;
    setLoadingReformule(true);
    const prompt = `Tu es un expert DPE certifié FNDI. Reformule ce commentaire de diagnostiqueur en termes techniques professionnels, clairs et précis, adaptés à un rapport DPE officiel. 
Conserve les informations essentielles, améliore la formulation, ajoute les valeurs cibles 3CL-DPE 2021 si pertinent.
Réponds UNIQUEMENT avec le texte reformulé, sans introduction ni explication.

Catégorie : ${newReco.type}
Texte original : "${newReco.texte}"`;
    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 400, messages: [{ role: "user", content: prompt }] })
      });
      const d = await res.json();
      if (d.error) throw new Error(d.error.message);
      const txt = d.content?.map(b => b.text || "").join("") || "";
      if (txt) {
        setNewReco(p => ({ ...p, texte: txt }));
        setReformuled(true);
      }
    } catch (e) {
      alert(`❌ Erreur IA : ${e.message}`);
    }
    setLoadingReformule(false);
  };

  const removeReco = (id) => setComments(prev => prev.filter(c => c.id !== id));

  const toggleTravaux = (id) => {
    setTravaux(prev => prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]);
  };

  return (
    <div>
      {/* RECOMMANDATIONS TRAVAUX */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>🔨 Recommandations de travaux</div>
        <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 14 }}>
          Ajoutez vos recommandations de travaux ou de remplacement d'équipement qui figureront dans le rapport.
        </div>

        {/* Type selector */}
        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>Catégorie</label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {RECOMMANDATION_TYPES.map(rt => (
              <button key={rt.id} onClick={() => setNewReco(p => ({ ...p, type: rt.id }))}
                style={{
                  padding: "5px 10px", borderRadius: 20, border: `2px solid ${rt.color}`,
                  background: newReco.type === rt.id ? rt.color : "transparent",
                  color: newReco.type === rt.id ? "#fff" : rt.color,
                  fontSize: 11, fontWeight: 700, cursor: "pointer",
                }}>{rt.label}</button>
            ))}
          </div>
        </div>

        {/* Bibliothèque */}
        <button onClick={() => { setShowBiblio(p => !p); setBiblioType(newReco.type); }}
          style={{ fontSize: 12, padding: "6px 12px", marginBottom: 10, display: "flex", alignItems: "center", gap: 6, borderRadius: 8, cursor: "pointer", background: showBiblio ? "#F5C80022" : COLORS.surface, border: `1px solid ${showBiblio ? "#F5C800" : COLORS.border}`, color: showBiblio ? "#F5C800" : COLORS.muted, fontWeight: 700 }}>
          📚 {showBiblio ? "Fermer la bibliothèque" : "Recommandations types — cliquez pour utiliser"}
        </button>

        {showBiblio && (
          <div style={{ background: COLORS.card, borderRadius: 12, border: `1px solid #F5C80044`, padding: 14, marginBottom: 10 }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 10 }}>
              {RECOMMANDATION_TYPES.map(rt => (
                <button key={rt.id} onClick={() => setBiblioType(rt.id)}
                  style={{ padding: "3px 8px", borderRadius: 14, cursor: "pointer", fontWeight: 700, fontSize: 11, border: `1.5px solid ${rt.color}`, background: biblioType === rt.id ? rt.color : "transparent", color: biblioType === rt.id ? "#fff" : rt.color }}>
                  {rt.label}
                </button>
              ))}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 300, overflowY: "auto" }}>
              {getBiblio(biblioType).map((item, i) => (
                <div key={item.id || i} style={{ padding: "10px 12px", borderRadius: 8, background: COLORS.surface, border: `1px solid ${item.custom ? COLORS.accent + "44" : COLORS.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                    <div style={{ flex: 1, cursor: "pointer" }} onClick={() => { setNewReco(p => ({ ...p, texte: item.texte, type: biblioType })); setShowBiblio(false); }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: item.custom ? COLORS.accent : "#F5C800", marginBottom: 3 }}>
                        {item.custom ? "⭐ " : ""}{item.label}
                      </div>
                      <div style={{ fontSize: 12, color: COLORS.muted, lineHeight: 1.5 }}>{item.texte}</div>
                      <div style={{ fontSize: 10, color: "#F5C800", marginTop: 4, fontWeight: 600 }}>👆 Cliquez pour utiliser</div>
                    </div>
                    {item.custom && (
                      <button onClick={() => removeFromBiblio(biblioType, item.id)}
                        style={{ background: "none", border: "none", color: COLORS.red, cursor: "pointer", fontSize: 16, padding: 0, flexShrink: 0 }}>×</button>
                    )}
                  </div>
                </div>
              ))}
              {getBiblio(biblioType).length === 0 && (
                <div style={{ fontSize: 12, color: COLORS.muted, padding: 8 }}>Aucune recommandation pour cette catégorie.</div>
              )}
            </div>
          </div>
        )}

        <textarea style={{ ...styles.input, minHeight: 80, resize: "vertical", fontFamily: "inherit", marginBottom: 8,
          border: reformuled ? `2px solid ${COLORS.green}` : undefined }}
          placeholder="Décrivez la recommandation de travaux ou de remplacement d'équipement…"
          value={newReco.texte}
          onChange={e => { setNewReco(p => ({ ...p, texte: e.target.value })); setReformuled(false); }} />

        {/* Bouton reformuler IA */}
        {newReco.texte.trim() && (
          <button onClick={reformulerIA} disabled={loadingReformule}
            style={{ ...styles.btn("secondary"), width: "100%", marginBottom: 8, fontSize: 13,
              border: `1.5px solid #8b5cf6`, color: "#8b5cf6", background: "#8b5cf611" }}>
            {loadingReformule ? "⏳ Reformulation en cours…" : reformuled ? "✅ Reformulé par l'IA — modifiez si besoin" : "✨ Reformuler avec l'IA (termes techniques DPE)"}
          </button>
        )}
        {reformuled && (
          <div style={{ fontSize: 11, color: COLORS.green, marginBottom: 8, padding: "4px 10px", background: COLORS.green + "15", borderRadius: 6 }}>
            ✅ Texte reformulé — vérifiez et ajoutez ou modifiez avant d'enregistrer.
          </div>
        )}

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={addReco} disabled={!newReco.texte.trim()} style={{ ...styles.btn("primary"), flex: 1 }}>
            ➕ Ajouter la recommandation
          </button>
          <button onClick={addToBiblio} disabled={!newReco.texte.trim()}
            title="Sauvegarder dans la bibliothèque pour réutiliser"
            style={{ ...styles.btn("secondary"), padding: "10px 14px", flexShrink: 0 }}>
            📚 Sauvegarder
          </button>
        </div>
        {newReco.texte.trim() && !reformuled && (
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 6 }}>
            💡 <strong>✨ Reformuler</strong> pour améliorer le texte · <strong>📚 Sauvegarder</strong> pour la bibliothèque
          </div>
        )}
      </div>

      {/* Liste des recommandations */}
      {comments.length > 0 && (
        <div style={styles.card}>
          <div style={styles.cardTitle}>📋 Recommandations ({comments.length})</div>
          {comments.map(c => {
            const rt = RECOMMANDATION_TYPES.find(t => t.id === c.type);
            return (
              <div key={c.id} style={{ padding: "10px 0", borderBottom: `1px solid ${COLORS.border}`, display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0, background: (rt?.color || COLORS.accent) + "22", border: `1px solid ${rt?.color || COLORS.accent}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>
                  {rt?.label.split(" ")[0]}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: rt?.color || COLORS.accent, marginBottom: 3 }}>{rt?.label}</div>
                  <div style={{ fontSize: 13, color: COLORS.text, lineHeight: 1.5 }}>{c.texte}</div>
                </div>
                <button onClick={() => removeReco(c.id)} style={{ background: "none", border: "none", color: COLORS.muted, cursor: "pointer", fontSize: 18, padding: 0, flexShrink: 0 }}>×</button>
              </div>
            );
          })}
        </div>
      )}

      {/* Travaux à préconiser */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>✅ Travaux à préconiser dans le rapport</div>
        <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 12 }}>Cochez les travaux qui figureront en section "Travaux préconisés"</div>
        {(() => {
          // Parser les quantités saisies
          let quantites = {};
          try { quantites = JSON.parse(data.travaux_quantites || "{}"); } catch {}
          const setQuantite = (id, val) => {
            const newQ = { ...quantites };
            if (val === "" || val === null) delete newQ[id];
            else newQ[id] = parseFloat(val) || 0;
            onChange && onChange("travaux_quantites", JSON.stringify(newQ));
          };

          return (
            <>
              {["haute", "moyenne", "basse"].map(urgence => (
                <div key={urgence} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: URGENCE_COLORS[urgence], textTransform: "uppercase", letterSpacing: "1px", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ width: 8, height: 8, borderRadius: "50%", background: URGENCE_COLORS[urgence], display: "inline-block" }} />
                    Priorité {urgence}
                  </div>
                  {TRAVAUX_TYPES.filter(t => t.urgence === urgence).map(t => {
                    const selected = travaux.includes(t.id);
                    const qty = quantites[t.id];
                    const costMin = t.cout_unitaire_min && qty ? Math.round(t.cout_unitaire_min * qty) : null;
                    const costMax = t.cout_unitaire_max && qty ? Math.round(t.cout_unitaire_max * qty) : null;
                    return (
                      <div key={t.id} style={{ marginBottom: 5 }}>
                        <div onClick={() => toggleTravaux(t.id)} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 8, cursor: "pointer", background: selected ? "#F5C80011" : COLORS.surface, border: `1px solid ${selected ? "#F5C800" : COLORS.border}` }}>
                          <div style={{ width: 20, height: 20, borderRadius: 4, flexShrink: 0, background: selected ? "#F5C800" : "transparent", border: `2px solid ${selected ? "#F5C800" : COLORS.muted}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, color: "#111", fontWeight: 900 }}>{selected ? "✓" : ""}</div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 13, fontWeight: selected ? 700 : 400 }}>{t.label}</div>
                            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 1 }}>{t.cout} · Gain estimé : {t.gain}</div>
                          </div>
                        </div>
                        {/* Input quantité + estimation (uniquement si sélectionné ET unité définie) */}
                        {selected && t.unite && (
                          <div style={{ marginTop: 4, marginLeft: 32, padding: "8px 12px", background: "#F5C80008", borderRadius: 6, border: `1px solid #F5C80033`, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                            <label style={{ fontSize: 11, fontWeight: 700, color: "#F5C800", minWidth: 70 }}>Quantité :</label>
                            <input
                              type="number"
                              min="0"
                              step="0.5"
                              value={qty || ""}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => setQuantite(t.id, e.target.value)}
                              placeholder="0"
                              style={{ width: 80, padding: "5px 8px", borderRadius: 4, border: `1px solid ${COLORS.border}`, background: COLORS.card, color: COLORS.text, fontSize: 13, fontWeight: 700 }}
                            />
                            <span style={{ fontSize: 12, color: COLORS.muted, fontWeight: 600 }}>{t.unite}</span>
                            {costMin !== null && (
                              <span style={{ marginLeft: "auto", fontSize: 12, fontWeight: 800, color: "#22c55e", background: "#14532d33", padding: "3px 8px", borderRadius: 4 }}>
                                ≈ {costMin.toLocaleString("fr-FR")} – {costMax.toLocaleString("fr-FR")} €
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}

              {/* Total estimé global */}
              {(() => {
                let totalMin = 0, totalMax = 0;
                let nbChiffres = 0;
                travaux.forEach(id => {
                  const t = TRAVAUX_TYPES.find(x => x.id === id);
                  const qty = quantites[id];
                  if (t && t.cout_unitaire_min && qty) {
                    totalMin += t.cout_unitaire_min * qty;
                    totalMax += t.cout_unitaire_max * qty;
                    nbChiffres++;
                  }
                });
                if (nbChiffres > 0) {
                  return (
                    <div style={{ marginTop: 14, padding: "14px 16px", borderRadius: 10, background: "linear-gradient(135deg, #F5C80022, #F5C80008)", border: "2px solid #F5C800", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                      <div>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#F5C800", letterSpacing: 1 }}>ESTIMATION TOTALE</div>
                        <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 2 }}>{nbChiffres} travail{nbChiffres > 1 ? "x" : ""} chiffré{nbChiffres > 1 ? "s" : ""} sur {travaux.length}</div>
                      </div>
                      <div style={{ fontSize: 18, fontWeight: 900, color: "#F5C800" }}>
                        {Math.round(totalMin).toLocaleString("fr-FR")} – {Math.round(totalMax).toLocaleString("fr-FR")} €
                      </div>
                    </div>
                  );
                }
                return null;
              })()}
            </>
          );
        })()}
        {travaux.length > 0 && (
          <div style={{ marginTop: 8, padding: 10, borderRadius: 8, background: "#F5C80011", border: "1px solid #F5C800", fontSize: 13, fontWeight: 700, color: "#F5C800", textAlign: "center" }}>
            {travaux.length} travaux sélectionné{travaux.length > 1 ? "s" : ""}
          </div>
        )}
      </div>
    </div>
  );
}

// ---- Result Tab ----
// ---- DPE Letter Badge ----
const DPE_LETTERS = ["A","B","C","D","E","F","G"];
const DPE_LETTER_COLORS = {
  A: "#1a9e3f", B: "#4caf50", C: "#8bc34a",
  D: "#ffeb3b", E: "#ff9800", F: "#ff5722", G: "#b71c1c"
};
const DPE_LETTER_TEXT = { A:"#fff",B:"#fff",C:"#fff",D:"#000",E:"#fff",F:"#fff",G:"#fff" };

function DPELetterBadge({ letter, size = 48, label }) {
  const color = DPE_LETTER_COLORS[letter] || COLORS.muted;
  const textColor = DPE_LETTER_TEXT[letter] || "#fff";
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: size, height: size, borderRadius: size * 0.2,
        background: letter ? color : COLORS.surface,
        border: letter ? "none" : `2px dashed ${COLORS.border}`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontWeight: 900, fontSize: size * 0.5, color: letter ? textColor : COLORS.muted,
        margin: "0 auto",
      }}>{letter || "?"}</div>
      {label && <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 4, textAlign: "center" }}>{label}</div>}
    </div>
  );
}

// ---- DPE Réalisé Saisie ----
function DPERealise({ data, onChange }) {
  const [section, setSection] = useState("energie");
  return (
    <div style={styles.card}>
      <div style={styles.cardTitle}>📋 DPE Réalisé — Saisie officielle</div>
      <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 14 }}>
        Saisissez les valeurs du DPE réalisé (issu du logiciel agréé)
      </div>

      {/* Toggle énergie / GES */}
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {[["energie", "⚡ Énergie"], ["ges", "💨 GES"]].map(([key, lbl]) => (
          <button key={key} onClick={() => setSection(key)} style={{
            flex: 1, padding: "8px", borderRadius: 8, border: "none", cursor: "pointer",
            fontWeight: 700, fontSize: 13,
            background: section === key ? "#F5C800" : COLORS.surface,
            color: section === key ? "#111" : COLORS.muted,
          }}>{lbl}</button>
        ))}
      </div>

      {section === "energie" && (
        <div>
          {/* Étiquette énergie */}
          <label style={styles.label}>Classe énergie (étiquette DPE)</label>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
            {DPE_LETTERS.map(l => {
              const sel = data.dpe_lettre === l;
              return (
                <div key={l} onClick={() => onChange("dpe_lettre", l)}
                  style={{
                    cursor: "pointer", padding: "6px",
                    borderRadius: 10, border: `2px solid ${sel ? DPE_LETTER_COLORS[l] : COLORS.border}`,
                    background: sel ? DPE_LETTER_COLORS[l] + "22" : COLORS.surface,
                    transition: "all 0.15s",
                  }}>
                  <DPELetterBadge letter={l} size={42} />
                </div>
              );
            })}
          </div>

          {/* Consommation énergie primaire */}
          <div style={styles.field}>
            <label style={styles.label}>Consommation énergie primaire (kWh/m²/an)</label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input style={{ ...styles.input, width: 120 }} type="number" min="0" placeholder="ex: 285"
                value={data.dpe_conso || ""} onChange={e => onChange("dpe_conso", e.target.value)} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>kWh EP/m²/an</span>
            </div>
          </div>

          {/* Consommation énergie finale */}
          <div style={styles.field}>
            <label style={styles.label}>Consommation énergie finale (kWh/m²/an)</label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input style={{ ...styles.input, width: 120 }} type="number" min="0" placeholder="ex: 195"
                value={data.dpe_conso_finale || ""} onChange={e => onChange("dpe_conso_finale", e.target.value)} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>kWh EF/m²/an</span>
            </div>
          </div>

          {/* Coût énergétique annuel */}
          <div style={styles.field}>
            <label style={styles.label}>Coût énergétique annuel estimé (€/an)</label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input style={{ ...styles.input, width: 120 }} type="number" min="0" placeholder="ex: 1850"
                value={data.dpe_cout_min || ""} onChange={e => onChange("dpe_cout_min", e.target.value)} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>€ min</span>
              <input style={{ ...styles.input, width: 120 }} type="number" min="0" placeholder="ex: 2500"
                value={data.dpe_cout_max || ""} onChange={e => onChange("dpe_cout_max", e.target.value)} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>€ max</span>
            </div>
          </div>
        </div>
      )}

      {section === "ges" && (
        <div>
          {/* Étiquette GES */}
          <label style={styles.label}>Classe GES (étiquette climat)</label>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
            {DPE_LETTERS.map(l => {
              const sel = data.ges_lettre === l;
              return (
                <div key={l} onClick={() => onChange("ges_lettre", l)}
                  style={{
                    cursor: "pointer", padding: "6px",
                    borderRadius: 10, border: `2px solid ${sel ? DPE_LETTER_COLORS[l] : COLORS.border}`,
                    background: sel ? DPE_LETTER_COLORS[l] + "22" : COLORS.surface,
                    transition: "all 0.15s",
                  }}>
                  <DPELetterBadge letter={l} size={42} />
                </div>
              );
            })}
          </div>

          {/* Émissions GES */}
          <div style={styles.field}>
            <label style={styles.label}>Émissions GES (kg CO₂ éq./m²/an)</label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input style={{ ...styles.input, width: 120 }} type="number" min="0" step="0.1" placeholder="ex: 52"
                value={data.ges_valeur || ""} onChange={e => onChange("ges_valeur", e.target.value)} />
              <span style={{ fontSize: 12, color: COLORS.muted }}>kg CO₂ éq./m²/an</span>
            </div>
          </div>
        </div>
      )}

      {/* Résumé badges si rempli */}
      {(data.dpe_lettre || data.ges_lettre) && (
        <div style={{ marginTop: 16, padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}`, display: "flex", justifyContent: "space-around", alignItems: "center" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: COLORS.muted, marginBottom: 6 }}>CLASSE ÉNERGIE</div>
            <DPELetterBadge letter={data.dpe_lettre} size={56} />
            {data.dpe_conso && <div style={{ fontSize: 12, color: COLORS.text, marginTop: 6, fontWeight: 700 }}>{data.dpe_conso} kWh/m²/an</div>}
          </div>
          <div style={{ fontSize: 30, color: COLORS.border }}>→</div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: COLORS.muted, marginBottom: 6 }}>CLASSE GES</div>
            <DPELetterBadge letter={data.ges_lettre} size={56} />
            {data.ges_valeur && <div style={{ fontSize: 12, color: COLORS.text, marginTop: 6, fontWeight: 700 }}>{data.ges_valeur} kg CO₂/m²/an</div>}
          </div>
        </div>
      )}
    </div>
  );
}

// ---- DPE Projeté ----
// ── TRAVAUX_PROJETE — Coefficients 3CL-DPE 2021 ──
// Gains calculés par composant sur la BASE des déperditions réelles
// Méthode : réduction des besoins chauffage par poste de déperdition

// ── calculGain3CL — Méthode 3CL-DPE v1.3 calibrée sur données Liciel ──
// Facteur variable selon type d'énergie :
// - Chauffage gaz/fioul : facteur 0.46 (calibré dossier Lantiez)
// - Chauffage électrique : facteur 0.25 (PAC domine le gain EP)
// Coefficients EP officiels 3CL-DPE 2021 : élec=1.9, gaz=1.1, fioul=1.1
function calculGain3CL(selectedIds, depMur, depPh, depPb, depBaie, depVent, chauffageType) {
  const depTotal = (depMur||0) + (depPh||0) + (depPb||0) + (depBaie||0) + (depVent||0);
  const isElec = ['elec','pac_air_air','pac_air_eau','pac_geo','convecteur_elec','radiateur_inertie'].includes(chauffageType);
  const isGaz = ['gaz','chaudiere_gaz','chaudiere_condensation','chaudiere_basse_temp'].includes(chauffageType);
  const FACTEUR_3CL = isElec ? 0.25 : 0.46;

  let gainBesoins = 0;
  let gainConsoDirecte = 0;

  for (const id of selectedIds) {
    const t = TRAVAUX_PROJETE.find(t => t.id === id);
    if (!t) continue;
    if (t.gain_poste !== null && depTotal > 0) {
      let depPoste = 0;
      if (t.poste === "mur")  depPoste = depMur||0;
      if (t.poste === "ph")   depPoste = depPh||0;
      if (t.poste === "pb")   depPoste = depPb||0;
      if (t.poste === "baie") depPoste = depBaie||0;
      if (t.poste === "vent") depPoste = depVent||0;
      gainBesoins += t.gain_poste * (depPoste / depTotal) * FACTEUR_3CL * 100;
    } else {
      // Gains directs adaptés selon énergie — coeff EP : élec=1.9, gaz=1.1, fioul=1.1
      let g = t.gain_defaut || 0;
      if (id === "pac_air_eau") {
        g = isElec ? 57 : (isGaz ? 43 : 40);
      } else if (id === "pac_air_air_conv") {
        g = 57;
      } else if (id === "poele_granules" || id === "chaudiere_bois") {
        // coeff EP bois 1.0 — vs élec: gain=(1-1.0/0.85/1.9)=38% | vs gaz: (1-1.0/0.85/1.1)=7%
        g = isElec ? 38 : (isGaz ? 7 : 25);
      } else if (id === "poele_bois") {
        g = isElec ? 25 : 5;
      } else if (id === "raccordement_reseau") {
        // coeff réseau 0.627 — vs élec: (1-0.627/1.9)=67% | vs gaz: (1-0.627/1.1)=43%
        g = isElec ? 67 : 43;
      } else if (id === "pac_ecs") {
        // CET COP2.5 : EP avant=Ef×1.9 → EP après=Ef×1.9/2.5 → gain 60% poste ECS × 20% = 12%
        g = 12;
      } else if (id === "chaudiere_cond") {
        // Rdt 85%→109% : gain = 1 - 0.85/1.09 = 22% poste × 75% = 15%
        g = 15;
      }
      gainConsoDirecte += g;
    }
  }
  return Math.min(85, Math.round(gainBesoins + gainConsoDirecte));
}

const TRAVAUX_PROJETE = [
  // ── MURS — U défaut 3CL-DPE v1.3 (tableau 3 arrêté 2021) ──
  // Pierre 20cm : U=2.10, 40cm : U=1.45, Brique pleine : U=1.97, Parpaing : U=1.48
  // ITI R=4.5 : U_résultant = 1/(1/U_init + 4.5) → gain poste murs 88-91%
  { id: "iti", label: "ITI — Isolation par l'intérieur (R=4,5 m².K/W)",
    gain_poste: 0.88, poste: "mur", gain_defaut: 24,
    cout_min_base: 50, cout_max_base: 120, cout_mode: "surface_mur",
    aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    note: "U pierre 20cm : 2,10→0,20 W/m².K | 40cm : 1,45→0,19 W/m².K (3CL v1.3)" },
  { id: "ite", label: "ITE — Isolation par l'extérieur (R=4,5 m².K/W)",
    gain_poste: 0.90, poste: "mur", gain_defaut: 26,
    cout_min_base: 150, cout_max_base: 250, cout_mode: "surface_mur",
    aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    note: "U pierre 20cm : 2,10→0,198 W/m².K | 40cm : 1,45→0,191 W/m².K (3CL v1.3)" },
  // ── TOITURE ──
  { id: "combles", label: "Isolation combles perdus (R=7 m².K/W)",
    gain_poste: 0.90, poste: "ph", gain_defaut: 20,
    cout_min_base: 20, cout_max_base: 50, cout_mode: "surface_hab",
    aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    note: "U PH non isolé → 0,14 W/m².K (R=7, 3CL v1.3)" },
  // ── PLANCHER BAS ──
  { id: "plancher_bas", label: "Isolation plancher bas (R=3 m².K/W)",
    gain_poste: 0.75, poste: "pb", gain_defaut: 4,
    cout_min_base: 30, cout_max_base: 80, cout_mode: "surface_hab",
    aides: ["MaPrimeRénov'","CEE"],
    note: "U PB → 0,27 W/m².K (R=3, 3CL v1.3)" },
  // ── MENUISERIES ──
  { id: "double_vitrage", label: "Double vitrage peu émissif (Uw=1,3 W/m².K)",
    gain_poste: 0.78, poste: "baie", gain_defaut: 8,
    cout_min: 5000, cout_max: 15000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Uw : 5,8→1,3 W/m².K (3CL v1.3)" },
  { id: "triple_vitrage", label: "Triple vitrage (Uw=0,9 W/m².K)",
    gain_poste: 0.85, poste: "baie", gain_defaut: 9,
    cout_min: 8000, cout_max: 20000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'"],
    note: "Uw : 5,8→0,9 W/m².K (3CL v1.3)" },
  // ── CHAUFFAGE ──
  { id: "pac_air_eau", label: "Pompe à chaleur air/eau (SCOP=3,5)",
    gain_poste: null, gain_defaut: 45,
    cout_min: 8000, cout_max: 18000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "SCOP 3,5 — coeff EP : élec 1,9 / gaz 1,1 / fioul 1,1 (3CL-DPE 2021)" },
  { id: "pac_air_air_conv", label: "Remplacement convecteurs → PAC air/air (SCOP=3,5)",
    gain_poste: null, gain_defaut: 57,
    // Élec convecteurs → PAC air/air SCOP 3.5 : gain 71% poste CH × part CH ~80% = 57%
    cout_min: 8000, cout_max: 12000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "SCOP 3,5 — élec→PAC : gain 71% poste CH — coeff EP 1,9 (3CL-DPE 2021)" },
  { id: "chaudiere_cond", label: "Chaudière gaz condensation (rdt=109%)",
    gain_poste: null, gain_defaut: 15,
    // EP gaz : rdt 85% → 109% → gain = 1 - 0.85/1.09 = 22% sur poste CH × part CH ~75% ≈ 15%
    cout_min: 3000, cout_max: 7000, cout_mode: "forfait",
    aides: ["CEE"],
    note: "Rdt PCS 109% vs 85% standard — coeff EP gaz 1,1 (3CL-DPE 2021)" },
  // ── VENTILATION ──
  { id: "vmc_hygro_b", label: "VMC hygro B (débit modulé)",
    gain_poste: 0.40, poste: "vent", gain_defaut: 8,
    cout_min: 1500, cout_max: 3500, cout_mode: "forfait",
    aides: ["CEE"],
    note: "qv réduit 40% vs naturelle (3CL v1.3)" },
  { id: "vmc_df", label: "VMC double flux (échangeur ≥ 85%)",
    gain_poste: 0.85, poste: "vent", gain_defaut: 16,
    cout_min: 4000, cout_max: 9000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Échangeur 85% (3CL v1.3)" },
  // ── ECS ──
  { id: "pac_ecs", label: "Chauffe-eau thermodynamique CET (COP=2,5)",
    gain_poste: null, gain_defaut: 8,
    cout_min: 2000, cout_max: 4000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "COP 2,5 (3CL v1.3)" },
  { id: "solaire_therm", label: "Chauffe-eau solaire thermique (CESI)",
    gain_poste: null, gain_defaut: 7,
    cout_min: 3000, cout_max: 7000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Taux couverture 60-70% (3CL v1.3)" },
  // ── RÉGULATION ──
  { id: "thermostat", label: "Thermostat programmable / pièce par pièce",
    gain_poste: null, gain_defaut: 8,
    cout_min: 300, cout_max: 1500, cout_mode: "forfait",
    aides: ["CEE"],
    note: "Intermittence (3CL v1.3)" },

  // ── BOIS / BIOMASSE ──
  // Poêle granulés rdt 85% vs convecteur élec rdt 100% :
  // EP avant = Ef×1.9 → EP après = Ef×1.0/0.85
  // Gain = 1 - (1.0/0.85)/1.9 = 1 - 0.621 = 38% sur poste CH
  { id: "poele_granules", label: "Poêle à granulés (rdt=85%, Flamme Verte)",
    gain_poste: null, gain_defaut: 38,
    cout_min: 3000, cout_max: 7000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Rdt 85% — coeff EP bois 1,0 vs élec 1,9 — gain 38% poste CH (3CL-DPE 2021)" },

  // Poêle bois bûches rdt 70% :
  // EP avant = Ef×1.9 → EP après = Ef×1.0/0.70
  // Gain = 1 - (1.0/0.70)/1.9 = 1 - 0.752 = 25% sur poste CH
  { id: "poele_bois", label: "Poêle à bois bûches (rdt=70%, Flamme Verte)",
    gain_poste: null, gain_defaut: 25,
    cout_min: 1500, cout_max: 5000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Rdt 70% labelisé — coeff EP bois 1,0 vs élec 1,9 — gain 25% poste CH (3CL-DPE 2021)" },

  // Chaudière bois/granulés rdt 85% :
  { id: "chaudiere_bois", label: "Chaudière bois/granulés (rdt=85%)",
    gain_poste: null, gain_defaut: 38,
    cout_min: 8000, cout_max: 20000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE","Éco-PTZ"],
    note: "Rdt 85% — coeff EP bois 1,0 — gain similaire poêle granulés (3CL-DPE 2021)" },

  // ── RÉSEAU DE CHALEUR ──
  // Coeff EP réseau = 0.627 (3CL-DPE 2021)
  // vs gaz : EP avant = Ef×1.1 → EP après = Ef×0.627 → gain = 1 - 0.627/1.1 = 43%
  // vs élec : EP avant = Ef×1.9 → EP après = Ef×0.627 → gain = 1 - 0.627/1.9 = 67%
  { id: "raccordement_reseau", label: "Raccordement réseau de chaleur urbain",
    gain_poste: null, gain_defaut: 43,
    // gaz→réseau: 43% | élec→réseau: 67% | fioul→réseau: 43%
    cout_min: 3000, cout_max: 15000, cout_mode: "forfait",
    aides: ["MaPrimeRénov'","CEE"],
    note: "Coeff EP réseau 0,627 — gaz→réseau: 43% — élec→réseau: 67% (3CL-DPE 2021)" },
];

// Calcul coût travaux basé sur surface réelle quand disponible
function calculCoutTravaux(selectedIds, data) {
  let min = 0, max = 0;
  const surface = parseFloat(data.surface) || 80;
  const surfaceMurs = (() => {
    try {
      const murs = JSON.parse(data.murs_list || "[]");
      const s = murs.reduce((t, m) => t + parseFloat(m.surface || 0), 0);
      return s > 0 ? s : surface * 1.2;
    } catch { return surface * 1.2; }
  })();
  for (const id of selectedIds) {
    const t = TRAVAUX_PROJETE.find(t => t.id === id);
    if (!t) continue;
    if (t.cout_mode === "surface_mur") {
      min += (t.cout_min_base || 50) * surfaceMurs;
      max += (t.cout_max_base || 120) * surfaceMurs;
    } else if (t.cout_mode === "surface_hab") {
      min += (t.cout_min_base || 20) * surface;
      max += (t.cout_max_base || 50) * surface;
    } else {
      min += t.cout_min || 0;
      max += t.cout_max || 0;
    }
  }
  return { min: Math.round(min), max: Math.round(max) };
}
function dpeLettreFromConso(conso) {
  return getDPEClass(conso).label;
}

function DPEProjete({ data, onChange, equipments, travaux: travauxExternes, setTravaux: setTravauxExternes }) {
  // Utiliser le state global des travaux (partagé avec l'onglet Commentaires)
  const selectedTravaux = travauxExternes || [];
  const setSelectedTravaux = (val) => {
    if (setTravauxExternes) {
      const newVal = typeof val === 'function' ? val(selectedTravaux) : val;
      setTravauxExternes(newVal);
    }
  };

  const [loadingProjete, setLoadingProjete] = useState(false);
  const [dpeProjete, setDpeProjeteRaw] = useState(() => {
    try { const s = localStorage.getItem("fndi_dpe_projete"); return s ? JSON.parse(s) : null; } catch { return null; }
  });
  const setDpeProjete = (val) => {
    setDpeProjeteRaw(val);
    try { if (val) localStorage.setItem("fndi_dpe_projete", JSON.stringify(val)); else localStorage.removeItem("fndi_dpe_projete"); } catch {}
  };

  // Consommation actuelle — priorité : valeur ADEME > valeur XML calculée > estimation
  const consoActuelle = (() => {
    if (data.dpe_conso) return parseFloat(data.dpe_conso);
    // Calcul à partir des déperditions XML si disponibles
    const depTot = (parseFloat(data.ademe_dep_mur)||0) + (parseFloat(data.ademe_dep_ph)||0) +
                   (parseFloat(data.ademe_dep_pb)||0) + (parseFloat(data.ademe_dep_baie)||0) +
                   (parseFloat(data.ademe_dep_vent)||0) + (parseFloat(data.ademe_dep_pt)||0);
    if (depTot > 0) {
      const surface = parseFloat(data.surface) || 80;
      // Besoins CH ≈ déperditions × DJU × facteur intermittence / surface
      const dju = 2500; // DJU Paris zone H2
      const besoinsKwh = depTot * dju * 0.001 * 0.85; // W/K × K.h → kWh × facteur
      // EP = besoins / rdt × coeff_EP
      const coeffEP = ['elec','convecteur_elec','radiateur_inertie'].includes(data.chauffage) ? 1.9 :
                      ['gaz','chaudiere_gaz'].includes(data.chauffage) ? 1.1 : 1.1;
      const rdt = ['gaz','chaudiere_gaz'].includes(data.chauffage) ? 0.85 : 1.0;
      const ecsKwh = surface * 25 * coeffEP; // estimation ECS
      return Math.round((besoinsKwh / rdt * coeffEP + ecsKwh) / surface);
    }
    return estimateConsumption(data, equipments);
  })();
  const gesActuel = parseFloat(data.ges_valeur) || consoActuelle * 0.057;
  const lettreActuelle = data.dpe_lettre || dpeLettreFromConso(consoActuelle);

  const toggleTravail = (id) => {
    setSelectedTravaux(prev => prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]);
    setDpeProjete(null); // Reset projection quand on change les travaux
  };

  const depMur  = parseFloat(data.ademe_dep_mur)  || 0;
  const depPh   = parseFloat(data.ademe_dep_ph)   || 0;
  const depPb   = parseFloat(data.ademe_dep_pb)   || 0;
  const depBaie = parseFloat(data.ademe_dep_baie) || 0;
  const depVent = parseFloat(data.ademe_dep_vent) || 0;

  // Gain calculé par méthode 3CL pondérée par déperditions réelles
  const totalGainPct = calculGain3CL(selectedTravaux, depMur, depPh, depPb, depBaie, depVent, data.chauffage || "gaz");

  // Coûts calculés sur surface réelle (€/m² × surface murs/hab)
  const { min: coutMin, max: coutMax } = calculCoutTravaux(selectedTravaux, data);

  const consoProjete = Math.max(30, consoActuelle * (1 - totalGainPct / 100));
  const _gesProjete = consoProjete * 0.057;
  const lettreProjete = dpeLettreFromConso(consoProjete);

  const aidesUniques = [...new Set(selectedTravaux.flatMap(id => TRAVAUX_PROJETE.find(t => t.id === id)?.aides || []))];

  const generateDPEProjete = async () => {
    setLoadingProjete(true);
    setDpeProjete(null);

    const travauxChoisis = selectedTravaux.map(id => {
      const t = TRAVAUX_TYPES.find(t => t.id === id);
      return t ? `${t.label} (${t.gain}, ${t.cout})` : null;
    }).filter(Boolean).join(" | ");

    const coutAides = Math.round(coutMin * 0.40);
    // Prix énergie 2024 (source : Engie/EDF)
    const PRIX_ENERGIE = { elec: 0.2516, gaz: 0.1302, fioul: 0.1100, bois: 0.060, default: 0.15 };
    const prixEnergie = PRIX_ENERGIE[data.chauffage] || PRIX_ENERGIE.default;
    const surface = parseFloat(data.surface) || 80;
    const econMin = Math.round((consoActuelle - consoProjete) * surface * prixEnergie * 0.85);
    const econMax = Math.round((consoActuelle - consoProjete) * surface * prixEnergie * 1.15);
    const aideRate = 0.35; // MaPrimeRénov' + CEE ~35% en moyenne
  const coutNet = Math.round(coutMin * (1 - aideRate));
  const econMoyenne = (econMin + econMax) / 2;
  const roiMin = econMoyenne > 0 ? Math.ceil(coutNet / (econMax * 1.1)) : 0;
  const roiMax = econMoyenne > 0 ? Math.ceil(coutNet / (econMin * 0.9)) : 0;
  const roi = econMoyenne > 0 ? `${Math.max(2, roiMin)}-${Math.max(3, roiMax)} ans` : "—";

    const prompt = `Expert DPE FNDI. Génère un JSON UNIQUEMENT (sans backticks, sans texte avant/après).
Logement : ${data.type||"?"} ${data.surface||"?"}m² classe ${lettreActuelle} ${Math.round(consoActuelle)} kWhEP/m²/an
Travaux : ${travauxChoisis}
Résultats calculés : classe ${lettreProjete}, ${Math.round(consoProjete)} kWhEP/m²/an, gain ${totalGainPct}%

JSON attendu (valeurs numériques sans unité, textes courts) :
{"synthese":"2 phrases max sur gain energetique","classe_projetee":"${lettreProjete}","conso_projetee":${Math.round(consoProjete)},"gain_pct":${totalGainPct},"cout_travaux":{"min":${coutMin},"max":${coutMax},"apres_aides":${coutAides}},"gain_facture_annuel":{"min":${econMin},"max":${econMax}},"ges_projete":${Math.round(consoProjete*0.057)},"retour_investissement":"${roi}","recommandation_prioritaire":"1 phrase courte"}`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 600, messages: [{ role: "user", content: prompt }] }),
      });
      const d = await res.json();
      if (d.error) throw new Error(d.error.message);
      const text = d.content?.map(b => b.text || "").join("") || "";
      const cleaned = text.replace(/```json|```/g, "").trim();
      // Extraire le JSON même si du texte precede/suit
      const jsonMatch = cleaned.match(/\{[\s\S]*\}/);
      if (!jsonMatch) throw new Error("Pas de JSON valide dans la réponse");
      const parsed = JSON.parse(jsonMatch[0]);
      setDpeProjete(parsed);
      onChange("dpe_lettre_projete", parsed.classe_projetee);
      onChange("dpe_conso_projete", parsed.conso_projetee);
      onChange("dpe_gain_pct", parsed.gain_pct);
      onChange("ges_valeur_projete", parsed.ges_projete);
      onChange("dpe_projete_cout_min", (parsed.cout_travaux?.min||coutMin).toLocaleString("fr-FR"));
      onChange("dpe_projete_cout_max", (parsed.cout_travaux?.max||coutMax).toLocaleString("fr-FR"));
      onChange("dpe_projete_cout_aides", (parsed.cout_travaux?.apres_aides||coutAides).toLocaleString("fr-FR"));
      onChange("dpe_projete_economie", `${(parsed.gain_facture_annuel?.min||econMin).toLocaleString("fr-FR")}–${(parsed.gain_facture_annuel?.max||econMax).toLocaleString("fr-FR")}`);
      onChange("dpe_projete_roi", parsed.retour_investissement || roi);
    } catch (e) {
      // Fallback sans IA si JSON invalide
      const fallback = {
        synthese: `La rénovation énergétique permettrait de réduire la consommation de ${totalGainPct}%, passant de ${Math.round(consoActuelle)} à ${Math.round(consoProjete)} kWh EP/m²/an, soit la classe ${lettreProjete}.`,
        classe_projetee: lettreProjete,
        conso_projetee: Math.round(consoProjete),
        gain_pct: totalGainPct,
        cout_travaux: { min: coutMin, max: coutMax, apres_aides: coutAides },
        gain_facture_annuel: { min: econMin, max: econMax },
        ges_projete: Math.round(consoProjete * 0.057),
        retour_investissement: roi,
        recommandation_prioritaire: "Réalisation des travaux recommandée dans le cadre d'une rénovation globale.",
      };
      setDpeProjete(fallback);
      onChange("dpe_lettre_projete", fallback.classe_projetee);
      onChange("dpe_conso_projete", fallback.conso_projetee);
      onChange("dpe_gain_pct", fallback.gain_pct);
      onChange("ges_valeur_projete", fallback.ges_projete);
      onChange("dpe_projete_cout_min", coutMin.toLocaleString("fr-FR"));
      onChange("dpe_projete_cout_max", coutMax.toLocaleString("fr-FR"));
      onChange("dpe_projete_cout_aides", coutAides.toLocaleString("fr-FR"));
      onChange("dpe_projete_economie", `${econMin.toLocaleString("fr-FR")}–${econMax.toLocaleString("fr-FR")}`);
      onChange("dpe_projete_roi", roi);
    }
    setLoadingProjete(false);
  };

  return (
    <div style={styles.card}>
      <div style={styles.cardTitle}>🔮 DPE Projeté — Simulation travaux</div>

      {/* Comparaison actuel → projeté */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "16px 10px", marginBottom: 16, background: COLORS.surface, borderRadius: 12, border: `1px solid ${COLORS.border}` }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 11, color: COLORS.muted, marginBottom: 6, fontWeight: 700, textTransform: "uppercase" }}>Actuel</div>
          <DPELetterBadge letter={lettreActuelle} size={60} />
          <div style={{ fontSize: 12, color: COLORS.text, marginTop: 6, fontWeight: 700 }}>{Math.round(consoActuelle)} kWh/m²/an</div>
        </div>

        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 24, color: COLORS.accent }}>→</div>
          {selectedTravaux.length > 0 && (
            <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.green, marginTop: 4 }}>-{totalGainPct}%</div>
          )}
        </div>

        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 11, color: COLORS.muted, marginBottom: 6, fontWeight: 700, textTransform: "uppercase" }}>Projeté</div>
          <DPELetterBadge letter={selectedTravaux.length > 0 ? lettreProjete : null} size={60} />
          {selectedTravaux.length > 0 && (
            <div style={{ fontSize: 12, color: COLORS.green, marginTop: 6, fontWeight: 700 }}>{Math.round(consoProjete)} kWh/m²/an</div>
          )}
        </div>
      </div>

      {/* Sélection travaux — partagés avec l'onglet Reco & Travaux */}
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <label style={styles.label}>Travaux à inclure dans le DPE projeté</label>
          {selectedTravaux.length > 0 && (
            <div style={{ fontSize: 11, background: COLORS.green + "15", color: COLORS.green, padding: "3px 10px", borderRadius: 20, fontWeight: 700, border: `1px solid ${COLORS.green}44` }}>
              ✅ {selectedTravaux.length} travaux sélectionné{selectedTravaux.length > 1 ? "s" : ""} depuis Reco & Travaux
            </div>
          )}
        </div>

        {selectedTravaux.length > 0 && (
          <div style={{ background: COLORS.green + "08", border: `1px solid ${COLORS.green}33`, borderRadius: 10, padding: "10px 14px", marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green, marginBottom: 8 }}>
              ✅ Travaux repris depuis l'onglet Reco & Travaux
            </div>
            {selectedTravaux.map(id => {
              const t = TRAVAUX_TYPES.find(t => t.id === id);
              return t ? (
                <div key={id} style={{ fontSize: 12, color: COLORS.text, padding: "3px 0", display: "flex", justifyContent: "space-between" }}>
                  <span>• {t.label}</span>
                  <span style={{ color: COLORS.green, fontWeight: 700 }}>{t.gain}</span>
                </div>
              ) : null;
            })}
          </div>
        )}

        {/* Tous les travaux disponibles — TRAVAUX_TYPES partagés */}
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {["haute", "moyenne", "basse"].map(urgence => (
            <div key={urgence}>
              <div style={{ fontSize: 11, fontWeight: 700, color: URGENCE_COLORS[urgence], textTransform: "uppercase", letterSpacing: "1px", margin: "8px 0 5px", display: "flex", alignItems: "center", gap: 5 }}>
                <span style={{ width: 7, height: 7, borderRadius: "50%", background: URGENCE_COLORS[urgence], display: "inline-block" }} />
                Priorité {urgence}
              </div>
              {TRAVAUX_TYPES.filter(t => t.urgence === urgence).map(t => {
                const sel = selectedTravaux.includes(t.id);

                // ── Calcul détaillé par composant (si données XML disponibles) ──
                const detailComposants = (() => {
                  if (!sel) return null;
                  const murs = JSON.parse(data.murs_list || "[]");
                  const toits = JSON.parse(data.toitures_list || "[]");
                  const fens = JSON.parse(data.fenetres_list || "[]");

                  // ITI ou ITE — détail par mur
                  if ((t.id === "iti" || t.id === "ite" || t.id === "isolation_int" || t.id === "isolation_ext") && murs.length > 0) {
                    const R_iso = 4.5;
                    const rows = murs.filter(m => parseFloat(m.b||1) > 0).map(m => {
                      const U0 = parseFloat(m.u) || 2.0;
                      const S = parseFloat(m.surface) || 0;
                      const b = parseFloat(m.b || 1);
                      const U1 = 1 / (1/U0 + R_iso);
                      const depAvant = U0 * S * b;
                      const depApres = U1 * S * b;
                      return { desc: `Mur ${m.orientation?.toUpperCase()} ${S}m²`, U0, U1, depAvant, depApres, gain: depAvant - depApres };
                    });
                    const totalAvant = rows.reduce((s, r) => s + r.depAvant, 0);
                    const totalApres = rows.reduce((s, r) => s + r.depApres, 0);
                    const gainDep = totalAvant - totalApres;
                    const gainGlobal = depTotal > 0 ? Math.round(gainDep / depTotal * FACTEUR_3CL_DISPLAY * 100) : 0;
                    const consoApres = Math.round(consoActuelle * (1 - gainGlobal/100));
                    const classeApres = dpeLettreFromConso(consoApres);
                    return { rows, totalAvant, totalApres, gainDep, gainGlobal, consoApres, classeApres, type: "murs" };
                  }

                  // Combles — détail planchers hauts
                  if ((t.id === "combles" || t.id === "isolation_combles") && toits.length > 0) {
                    const R_iso = 7.0;
                    const rows = toits.filter(tt => parseFloat(tt.b||1) > 0 && tt.type !== "local_chauffe").map(tt => {
                      const U0 = parseFloat(tt.u) || 2.0;
                      const S = parseFloat(tt.surface) || 0;
                      const b = parseFloat(tt.b || 1);
                      const U1 = 1 / (1/U0 + R_iso);
                      const depAvant = U0 * S * b;
                      const depApres = U1 * S * b;
                      return { desc: `${tt.type || "Toiture"} ${S}m²`, U0, U1, depAvant, depApres };
                    });
                    const totalAvant = rows.reduce((s, r) => s + r.depAvant, 0);
                    const totalApres = rows.reduce((s, r) => s + r.depApres, 0);
                    const gainDep = totalAvant - totalApres;
                    const gainGlobal = depTotal > 0 ? Math.round(gainDep / depTotal * FACTEUR_3CL_DISPLAY * 100) : 0;
                    const consoApres = Math.round(consoActuelle * (1 - gainGlobal/100));
                    const classeApres = dpeLettreFromConso(consoApres);
                    return { rows, totalAvant, totalApres, gainDep, gainGlobal, consoApres, classeApres, type: "toits" };
                  }

                  // Fenêtres — détail baies
                  if ((t.id === "double_vitrage" || t.id === "triple_vitrage") && fens.length > 0) {
                    const Uw1 = t.id === "triple_vitrage" ? 0.9 : 1.3;
                    const rows = fens.map(f => {
                      const Uw0 = parseFloat(f.uw) || 3.0;
                      const S = parseFloat(f.surface) * parseInt(f.nombre||1) || 0;
                      const depAvant = Uw0 * S;
                      const depApres = Uw1 * S;
                      return { desc: `Fen. ${f.orientation?.toUpperCase()} ${f.nombre||1}×${f.surface}m²`, Uw0, Uw1, depAvant, depApres };
                    });
                    const totalAvant = rows.reduce((s, r) => s + r.depAvant, 0);
                    const totalApres = rows.reduce((s, r) => s + r.depApres, 0);
                    const gainDep = totalAvant - totalApres;
                    const gainGlobal = depBaie > 0 ? Math.round(gainDep / depTotal * FACTEUR_3CL_DISPLAY * 100) : 0;
                    const consoApres = Math.round(consoActuelle * (1 - gainGlobal/100));
                    const classeApres = dpeLettreFromConso(consoApres);
                    return { rows, totalAvant, totalApres, gainDep, gainGlobal, consoApres, classeApres, type: "fens" };
                  }
                  return null;
                })();

                const FACTEUR_3CL_DISPLAY = ['elec','convecteur_elec','radiateur_inertie'].includes(data.chauffage) ? 0.25 : 0.46;

                return (
                  <div key={t.id} onClick={() => toggleTravail(t.id)}
                    style={{ padding: "10px 14px", borderRadius: 10, cursor: "pointer", border: `2px solid ${sel ? COLORS.accent : COLORS.border}`, background: sel ? COLORS.accentGlow : COLORS.surface, transition: "all 0.15s" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1 }}>
                        <div style={{ width: 18, height: 18, borderRadius: 4, flexShrink: 0, background: sel ? "#F5C800" : "transparent", border: `2px solid ${sel ? "#F5C800" : COLORS.muted}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#111", fontWeight: 900 }}>{sel ? "✓" : ""}</div>
                        <div>
                          <span style={{ fontSize: 13, fontWeight: sel ? 700 : 400, color: sel ? COLORS.accent : COLORS.text }}>{t.label}</span>
                          {t.note && <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 2 }}>📐 {t.note}</div>}
                        </div>
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.green }}>{t.gain}</div>
                        <div style={{ fontSize: 11, color: COLORS.muted }}>{t.cout}</div>
                      </div>
                    </div>

                    {/* Détail composants si données XML disponibles */}
                    {detailComposants && (
                      <div onClick={e => e.stopPropagation()} style={{ marginTop: 10, padding: "10px 12px", borderRadius: 8, background: COLORS.card, border: `1px solid ${COLORS.accent}33` }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.accent, marginBottom: 6 }}>
                          📐 Calcul 3CL sur {detailComposants.type === "murs" ? "vos murs" : detailComposants.type === "toits" ? "vos toitures" : "vos fenêtres"}
                        </div>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 10 }}>
                          <thead>
                            <tr style={{ color: COLORS.muted }}>
                              <td style={{ padding: "2px 4px" }}>Élément</td>
                              <td style={{ padding: "2px 4px", textAlign: "right" }}>U avant</td>
                              <td style={{ padding: "2px 4px", textAlign: "right" }}>U après</td>
                              <td style={{ padding: "2px 4px", textAlign: "right" }}>Gain W/K</td>
                            </tr>
                          </thead>
                          <tbody>
                            {detailComposants.rows.map((r, i) => (
                              <tr key={i} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                                <td style={{ padding: "3px 4px", color: COLORS.text }}>{r.desc}</td>
                                <td style={{ padding: "3px 4px", textAlign: "right", color: COLORS.red }}>{(r.U0||r.Uw0)?.toFixed(2)}</td>
                                <td style={{ padding: "3px 4px", textAlign: "right", color: COLORS.green }}>{(r.U1||r.Uw1)?.toFixed(2)}</td>
                                <td style={{ padding: "3px 4px", textAlign: "right", color: COLORS.green, fontWeight: 700 }}>-{(r.depAvant - r.depApres).toFixed(1)}</td>
                              </tr>
                            ))}
                            <tr style={{ borderTop: `2px solid ${COLORS.accent}44`, fontWeight: 700 }}>
                              <td style={{ padding: "4px 4px", color: COLORS.accent }}>Total</td>
                              <td style={{ padding: "4px 4px", textAlign: "right", color: COLORS.muted }}>{detailComposants.totalAvant.toFixed(1)} W/K</td>
                              <td style={{ padding: "4px 4px", textAlign: "right", color: COLORS.green }}>{detailComposants.totalApres.toFixed(1)} W/K</td>
                              <td style={{ padding: "4px 4px", textAlign: "right", color: COLORS.green }}>-{detailComposants.gainDep.toFixed(1)}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                          <div style={{ fontSize: 11, color: COLORS.muted }}>
                            Impact EP global : <span style={{ color: COLORS.green, fontWeight: 700 }}>-{detailComposants.gainGlobal}%</span>
                          </div>
                          <div style={{ fontSize: 11, color: COLORS.muted }}>→</div>
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <div style={{ background: getDPEClass(consoActuelle).color, color: getDPEClass(consoActuelle).textColor, borderRadius: 4, padding: "1px 6px", fontSize: 11, fontWeight: 800 }}>
                              {lettreActuelle}
                            </div>
                            <span style={{ fontSize: 11, color: COLORS.muted }}>→</span>
                            <div style={{ background: getDPEClass(detailComposants.consoApres).color, color: getDPEClass(detailComposants.consoApres).textColor, borderRadius: 4, padding: "1px 6px", fontSize: 11, fontWeight: 800 }}>
                              {detailComposants.classeApres}
                            </div>
                            <span style={{ fontSize: 11, color: COLORS.green, fontWeight: 700 }}>
                              {detailComposants.consoApres} kWh/m²/an
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Récap coût si travaux sélectionnés */}
      {selectedTravaux.length > 0 && (
        <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: COLORS.muted }}>Coût total estimé</span>
            <span style={{ fontWeight: 700, fontSize: 14 }}>{coutMin.toLocaleString("fr-FR")} – {coutMax.toLocaleString("fr-FR")} €</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: COLORS.muted }}>Gain de consommation</span>
            <span style={{ fontWeight: 700, color: COLORS.green }}>-{totalGainPct}% ({Math.round(consoActuelle - consoProjete)} kWh/m²/an)</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontSize: 13, color: COLORS.muted }}>Aides mobilisables</span>
            <span style={{ fontSize: 12, color: "#F5C800", fontWeight: 700 }}>{aidesUniques.join(", ")}</span>
          </div>
        </div>
      )}

      {/* Bouton générer DPE projeté */}
      {selectedTravaux.length > 0 && (
        <button onClick={generateDPEProjete} disabled={loadingProjete}
          style={{ ...styles.btn("primary"), width: "100%", marginBottom: 16 }}>
          {loadingProjete ? "⏳ Génération du DPE projeté…" : "✨ Générer le DPE projeté officiel"}
        </button>
      )}

      {/* Résultat DPE projeté IA */}
      {dpeProjete && !dpeProjete.error && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

          {/* Synthèse */}
          <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.accent}33` }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginBottom: 8, textTransform: "uppercase" }}>Synthèse</div>
            <p style={{ fontSize: 13, lineHeight: 1.6, margin: 0, color: COLORS.text }}>{dpeProjete.synthese}</p>
          </div>

          {/* Classe + Conso projetées */}
          <div style={{ display: "flex", gap: 10 }}>
            {[
              { label: "Classe projetée", val: <DPELetterBadge letter={dpeProjete.classe_projetee} size={44} />, },
              { label: "Conso. projetée", val: `${dpeProjete.conso_projetee} kWh/m²/an`, color: COLORS.green },
              { label: "Économie/an", val: `${(dpeProjete.gain_facture_annuel?.min || 0).toLocaleString("fr-FR")}–${(dpeProjete.gain_facture_annuel?.max || 0).toLocaleString("fr-FR")} €`, color: COLORS.green },
            ].map((b, i) => (
              <div key={i} style={{ flex: 1, padding: "12px 8px", borderRadius: 10, textAlign: "center", background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
                <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>{b.label}</div>
                {typeof b.val === "string"
                  ? <div style={{ fontWeight: 800, fontSize: 15, color: b.color || COLORS.text }}>{b.val}</div>
                  : b.val}
              </div>
            ))}
          </div>

          {/* Aides */}
          {dpeProjete.aides?.length > 0 && (
            <div style={{ padding: 14, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#F5C800", marginBottom: 10, textTransform: "uppercase" }}>🏛️ Aides financières</div>
              {dpeProjete.aides.map((a, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid ${COLORS.border}`, fontSize: 13 }}>
                  <div>
                    <span style={{ fontWeight: 700 }}>{a.nom}</span>
                    <span style={{ fontSize: 11, color: COLORS.muted, display: "block" }}>{a.condition}</span>
                  </div>
                  <span style={{ color: COLORS.green, fontWeight: 700 }}>{a.montant_estime}</span>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, fontSize: 13 }}>
                <span style={{ color: COLORS.muted }}>Coût après aides estimé</span>
                <span style={{ fontWeight: 800, color: COLORS.accent }}>{dpeProjete.cout_travaux?.apres_aides?.toLocaleString("fr-FR")} €</span>
              </div>
            </div>
          )}

          {/* Retour investissement + recommandation */}
          <div style={{ padding: 14, borderRadius: 10, background: "#F5C80011", border: "1px solid #F5C80033" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: COLORS.muted }}>Retour sur investissement</span>
              <span style={{ fontWeight: 700, color: "#F5C800" }}>{dpeProjete.retour_investissement}</span>
            </div>
            <div style={{ fontSize: 13, color: COLORS.text, fontStyle: "italic" }}>
              💡 {dpeProjete.recommandation_prioritaire}
            </div>
          </div>
        </div>
      )}

      {dpeProjete?.error && (
        <div style={{ padding: 12, borderRadius: 8, background: COLORS.red + "15", color: COLORS.red, fontSize: 13 }}>❌ {dpeProjete.error}</div>
      )}
    </div>
  );
}

function ResultTab({ data, equipments, comments, travaux, setTravaux, onChange, section }) {
  const [analysis, setAnalysis] = useState("");
  const [loading, setLoading] = useState(false);

  const conso = estimateConsumption(data, equipments);
  const consoReelle = parseFloat(data.dpe_conso) || conso;
  const ges = parseFloat(data.ges_valeur) || consoReelle * 0.057;
  const cls = getDPEClass(consoReelle);
  const missing = !data.surface || !data.chauffage;

  // Use official DPE if entered, else estimated
  const lettreAffichee = data.dpe_lettre || cls.label;
  const gesLettre = data.ges_lettre || getGESClass(ges).label;
  const consoAffichee = data.dpe_conso || Math.round(conso);

  async function generateAnalysis() {
    setLoading(true);
    setAnalysis("");
    const equipList = equipments.length > 0 ? equipments.map(e => `- ${e.name} (${e.category})`).join("\n") : "Aucun";
    const commentsList = comments.length > 0 ? comments.map(c => `- [${c.type}] ${c.texte}`).join("\n") : "Aucun";
    const travauxList = travaux.length > 0 ? travaux.map(id => TRAVAUX_TYPES.find(t => t.id === id)?.label).filter(Boolean).join(", ") : "Non définis";

    const prompt = `Tu es un expert DPE FNDI certifié. Génère une synthèse professionnelle.
Logement: ${data.type || "?"}, ${data.surface || "?"}m², ${data.annee || "?"}
DPE réalisé: Classe ${lettreAffichee}, ${consoAffichee} kWh/m²/an, GES classe ${gesLettre}
Chauffage: ${data.chauffage || "?"}
Commentaires: ${commentsList}
Travaux préconisés: ${travauxList}
Équipements: ${equipList}

Synthèse professionnelle DPE en 3 paragraphes (performance, points faibles, recommandations). Max 300 mots.`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "", "anthropic-version": "2023-06-01", "anthropic-dangerous-direct-browser-access": "true" },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 600, messages: [{ role: "user", content: prompt }] })
      });
      const d = await res.json();
      const txt = d.content?.map(b => b.text || "").join("") || "";
      setAnalysis(txt);
    } catch { setAnalysis("Erreur de génération."); }
    setLoading(false);
  }

  // Bandeau warning commun à toutes les sections
  const warningBlock = missing ? (
    <div style={{ ...styles.card, borderColor: COLORS.orange, color: COLORS.orange, fontSize: 14 }}>
      ⚠️ Complétez au moins la surface et le type de chauffage dans l'onglet Le Bien.
    </div>
  ) : null;

  // ─── DPE Réalisé (= DPE Initial) ───
  if (section === "realise") {
    return (
      <div>
        {warningBlock}
        <DPERealise data={data} onChange={onChange} />
        <div style={styles.card}>
          <div style={styles.cardTitle}>📊 Étiquettes DPE (estimation)</div>
          <DPEGauge value={consoReelle} label={data.dpe_conso ? "Consommation d'énergie primaire" : "Consommation d'énergie primaire estimée"} unit="kWh EP/m²/an" />
          <DPEGauge value={ges} label={data.ges_valeur ? "Émissions GES" : "Émissions GES estimées"} unit="kg CO₂ éq./m²/an" />
        </div>
      </div>
    );
  }

  // ─── DPE Projeté ───
  if (section === "projete") {
    return (
      <div>
        {warningBlock}
        <DPEProjete data={data} onChange={onChange} equipments={equipments} travaux={travaux} setTravaux={setTravaux} />
      </div>
    );
  }

  // ─── Synthèse ───
  if (section === "synthese") {
    return (
      <div>
        {warningBlock}
        {/* Badges résumé */}
        <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
          {[
            { label: "💬 Commentaires", val: comments.length, color: "#3b82f6" },
            { label: "🔨 Travaux", val: travaux.length, color: "#f97316" },
            { label: "⚙️ Équipements", val: equipments.length, color: "#F5C800" },
          ].map(b => (
            <div key={b.label} style={{ flex: 1, padding: "12px 10px", borderRadius: 10, textAlign: "center", background: b.color + "15", border: `1px solid ${b.color}33` }}>
              <div style={{ fontSize: 22, fontWeight: 900, color: b.color }}>{b.val}</div>
              <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>{b.label}</div>
            </div>
          ))}
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>🤖 Synthèse IA du DPE</div>
          {!analysis && !loading && (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ color: COLORS.muted, fontSize: 14, marginBottom: 16 }}>
                Synthèse intégrant DPE réalisé, commentaires et travaux
              </div>
              <button onClick={generateAnalysis} style={styles.btn("primary")}>✨ Générer la synthèse</button>
            </div>
          )}
          {loading && <div style={{ textAlign: "center", padding: "20px 0", color: COLORS.muted }}>⏳ Génération…</div>}
          {analysis && (
            <>
              <div style={styles.analysisBox}>{analysis}</div>
              <button onClick={generateAnalysis} style={{ ...styles.btn("secondary"), marginTop: 12 }}>🔄 Régénérer</button>
            </>
          )}
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>📋 Récapitulatif</div>
          <div style={{ fontSize: 14 }}>
            {[
              ["Surface", data.surface ? `${data.surface} m²` : "—"],
              ["Année", data.annee || "—"],
              ["Chauffage", data.chauffage || "—"],
              ["Classe DPE réalisée", data.dpe_lettre || cls.label],
              ["Conso. réalisée", data.dpe_conso ? `${data.dpe_conso} kWh/m²/an` : `${Math.round(conso)} kWh/m²/an (estimée)`],
              ["Classe GES", data.ges_lettre || "—"],
              ["GES", data.ges_valeur ? `${data.ges_valeur} kg CO₂/m²/an` : `${ges.toFixed(1)} kg CO₂/m²/an (estimé)`],
              ["Coût énergétique", data.dpe_cout_min ? `${data.dpe_cout_min}–${data.dpe_cout_max} €/an` : "—"],
              ["Commentaires", comments.length],
              ["Travaux préconisés", travaux.length],
            ].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${COLORS.border}` }}>
                <span style={{ color: COLORS.muted }}>{k}</span>
                <span style={{ fontWeight: 600 }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Fallback (section non reconnue)
  return null;
}

// ---- Consumption estimator ----
function estimateConsumption(data, equipments) {
  let base = 250;

  const annee = parseInt(data.annee) || 1980;
  if (annee >= 2012) base -= 80;
  else if (annee >= 2000) base -= 50;
  else if (annee >= 1990) base -= 30;
  else if (annee < 1950) base += 50;

  // Basé sur coeff EP 3CL-DPE 2021 : élec=1.9, gaz=1.1, fioul=1.1
  const chauffageBonus = {
    pac_air_eau: -90, pac_air_air: -60, pac_geo: -100,
    bois_buches: -40, granules: -45, bois_chaudiere: -40,
    reseau: -30,
    gaz: 0, fioul: 10,
    elec: 40,  // coeff EP 1.9 vs gaz 1.1 → ~+40 kWh/m² pour même besoin
    convecteur_elec: 40,
  };
  base += chauffageBonus[data.chauffage] || 0;

  const mursBonus = { ite: -40, iti: -35, doublage: -20, aucune: 30 };
  base += mursBonus[data.isolation_murs] || 0;

  const toitBonus = { rigide: -35, rouleaux: -30, soufflage: -25, aucune: 30 };
  base += toitBonus[data.isolation_toit] || 0;

  const vitrageBonus = {
    triple: -30,
    double_perf: -20,
    double: -10,
    simple: 20,
  };
  base += vitrageBonus[data.vitrage] || 0;

  const ventBonus = { vmc_df: -15, puits: -10, vmc_sf: 0, naturelle: 10 };
  base += ventBonus[data.ventilation] || 0;

  // Bonus from scanned equipments
  equipments.forEach((eq) => {
    if (eq.category === "Pompe à chaleur") base -= 20;
    if (eq.energyRating === "A" || eq.energyRating === "A+") base -= 10;
  });

  return Math.max(30, Math.min(600, base));
}

// ---- Main App ----
// ---- Rapport Tab ----
function RapportTab({ data, equipments, comments, travaux, diag, onDiagChange, setDiag, setActiveTab, onLogementChange, saisieMode }) {
  const [logoBase64, setLogoBase64] = useState(diag.logoBase64 || null);
  const [logoPreview, setLogoPreview] = useState(diag.logoBase64 || null);
  const [generating, setGenerating] = useState(false);
  const [syntheseIA, setSyntheseIA] = useState(() => {
    // Priorité 1 : data.synthese_ia (mode Saisie) — ce champ vient du wizard étape 5
    if (data && data.synthese_ia) return data.synthese_ia;
    // Priorité 2 : localStorage XML (legacy)
    try {
      const s = localStorage.getItem("fndi_dpe_projete");
      return s ? (JSON.parse(s).synthese || "") : "";
    } catch { return ""; }
  });
  const [loadingSynthese, setLoadingSynthese] = useState(false);
  const [syntheseSaved, setSyntheseSaved] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [validations, setValidations] = useState({});
  const logoRef = useRef();

  const conso = estimateConsumption(data, equipments);
  const ges = conso * 0.057;
  const cls = getDPEClass(conso);
  const lettre = data.dpe_lettre || cls.label;
  const gesLettre = data.ges_lettre || cls.label;
  const consoVal = data.dpe_conso || Math.round(conso);
  const gesVal = data.ges_valeur || ges.toFixed(1);

  // ── Checklist pré-génération ──
  const checklistItems = [
    {
      id: "dpe_realise",
      label: "DPE réalisé importé",
      desc: "N° ADEME, XML ou DPE saisi",
      ok: !!(data.dpe_lettre && data.dpe_conso),
      tab: 1,
      tabLabel: "🏠 Logement",
    },
    {
      id: "proprietaire",
      label: "Propriétaire renseigné",
      desc: "Nom et prénom du propriétaire",
      ok: !!(data.proprio_nom),
      tab: 1,
      tabLabel: "🏠 Logement",
    },
    {
      id: "travaux",
      label: "Travaux sélectionnés",
      desc: "Au moins un travail coché",
      ok: travaux.length > 0,
      tab: 2,
      tabLabel: "✏️ Reco & Travaux",
    },
    {
      id: "dpe_projete",
      label: "DPE Projeté généré",
      desc: "Classe projetée calculée",
      ok: !!(data.dpe_lettre_projete),
      tab: 3,
      tabLabel: "🔮 DPE Projeté",
    },
    {
      id: "synthese",
      label: "Synthèse rédigée",
      desc: "Synthèse IA générée ou saisie",
      ok: !!syntheseIA,
      tab: null,
      tabLabel: null,
    },
    {
      id: "diagnostiqueur",
      label: "Coordonnées diagnostiqueur",
      desc: "Nom, entreprise, SIRET",
      ok: !!(diag.nom && diag.entreprise),
      tab: null,
      tabLabel: null,
    },
  ];

  const nbOk = checklistItems.filter(c => c.ok).length;
  const allOk = nbOk === checklistItems.length;
  const canGenerate = nbOk >= 4; // minimum: DPE + propriétaire + travaux + DPE projeté

  const handleLogoFile = (file) => {
    if (!file) return;
    const r = new FileReader();
    r.onload = e => {
      const b64 = e.target.result;
      setLogoBase64(b64);
      setLogoPreview(b64);
      onDiagChange("logoBase64", b64);
    };
    r.readAsDataURL(file);
  };

  const inp = (key, label, placeholder, type = "text") => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input style={styles.input} type={type} placeholder={placeholder}
        value={diag[key] || ""} onChange={e => onDiagChange(key, e.target.value)} />
    </div>
  );

  const generateSynthese = async () => {
    setLoadingSynthese(true); setSyntheseIA("");

    const depTotal = (data.ademe_dep_mur||0)+(data.ademe_dep_ph||0)+(data.ademe_dep_pb||0)+(data.ademe_dep_baie||0)+(data.ademe_dep_pt||0)+(data.ademe_dep_vent||0);
    const travauxList = travaux.map(id => TRAVAUX_TYPES.find(t=>t.id===id)?.label).filter(Boolean).join(", ");
    const depSection = depTotal > 0 ? `Déperditions : murs ${data.ademe_dep_mur||0}W/K (${Math.round((data.ademe_dep_mur||0)/depTotal*100)}%), plancher haut ${data.ademe_dep_ph||0}W/K, ventilation ${data.ademe_dep_vent||0}W/K, baies ${data.ademe_dep_baie||0}W/K` : "";
    const pLettre = data.dpe_lettre_projete || "";
    const pConso = data.dpe_conso_projete || "";
    const pGain = data.dpe_gain_pct || "";

    const prompt = `Tu es expert DPE certifié FNDI. Rédige une synthèse professionnelle pour un rapport DPE Projeté officiel.

LOGEMENT : ${data.type||"?"}, ${data.surface||"?"}m², ${data.periode_construction_label||data.annee||"?"}
Adresse : ${data.adresse||""} ${data.code_postal||""} ${data.commune||""}
Propriétaire : ${data.proprio_prenom||""} ${data.proprio_nom||""}
Chauffage : ${data.chauffage||"?"} · ECS : ${data.ecs||"?"} · Ventilation : ${data.ventilation||"?"}

DPE RÉALISÉ : Classe ${lettre} — ${consoVal} kWh EP/m²/an · GES ${gesLettre} — ${gesVal} kg CO₂/m²/an · Coût ${data.dpe_cout_min||"?"}–${data.dpe_cout_max||"?"} €/an
${depSection}
${pLettre ? `DPE PROJETÉ : Classe ${pLettre} — ${pConso} kWh EP/m²/an — Gain ${pGain}%` : ""}
TRAVAUX : ${travauxList || "À définir"}

Rédige 4 paragraphes professionnels sans markdown :
1. Performance énergétique actuelle (classe, conso, coût, GES)
2. Analyse des déperditions thermiques (postes principaux, causes)
3. Recommandations de travaux (améliorations, aides MaPrimeRénov'/CEE/Éco-PTZ)
4. Conclusion et DPE projeté (gain attendu, nouvelle classe)

Style : professionnel, factuel, 3ème personne. Maximum 320 mots.`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "", "anthropic-version": "2023-06-01", "anthropic-dangerous-direct-browser-access": "true" },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 900, messages: [{ role: "user", content: prompt }] })
      });
      const d = await res.json();
      if (d.error) throw new Error(d.error.message);
      const txt = d.content?.map(b => b.text||"").join("") || "";
      setSyntheseIA(txt || "Réponse vide — réessayez.");
      // Persistance localStorage : merge dans fndi_dpe_projete
      if (txt) {
        try {
          const existing = JSON.parse(localStorage.getItem("fndi_dpe_projete") || "{}");
          existing.synthese = txt;
          localStorage.setItem("fndi_dpe_projete", JSON.stringify(existing));
        } catch {}
        // Mode Saisie : persister aussi dans le logement (data.synthese_ia)
        if (onLogementChange) onLogementChange("synthese_ia", txt);
      }
    } catch (e) {
      setSyntheseIA(`❌ Erreur : ${e.message}`);
    }
    setLoadingSynthese(false);
  };

  // Sauvegarde manuelle (bouton "Enregistrer") — feedback visuel 2.5s
  const saveSynthese = () => {
    try {
      const existing = JSON.parse(localStorage.getItem("fndi_dpe_projete") || "{}");
      existing.synthese = syntheseIA;
      localStorage.setItem("fndi_dpe_projete", JSON.stringify(existing));
      // Mode Saisie : persister aussi dans le logement
      if (onLogementChange) onLogementChange("synthese_ia", syntheseIA);
      setSyntheseSaved(true);
      setTimeout(() => setSyntheseSaved(false), 2500);
    } catch (e) {
      alert("Erreur sauvegarde : " + e.message);
    }
  };

  // Suppression : nettoie aussi localStorage et data.synthese_ia
  const clearSynthese = () => {
    if (!window.confirm("Supprimer la synthèse ? Vous pourrez la régénérer.")) return;
    setSyntheseIA("");
    try {
      const existing = JSON.parse(localStorage.getItem("fndi_dpe_projete") || "{}");
      delete existing.synthese;
      localStorage.setItem("fndi_dpe_projete", JSON.stringify(existing));
    } catch {}
    if (onLogementChange) onLogementChange("synthese_ia", "");
  };

  const _dpeColor = DPE_LETTER_COLORS[lettre] || "#888";
  const _gesColor = DPE_LETTER_COLORS[gesLettre] || "#888";
  const _dpeTextColor = DPE_LETTER_TEXT[lettre] || "#fff";

  const generateRapport = async () => {
    setGenerating(true);
    const today = new Date().toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
    const travauxSelList = travaux.map(id => TRAVAUX_TYPES.find(t => t.id === id)).filter(Boolean);

    const depItems = [
      { label: "Murs",            val: data.ademe_dep_mur,  color: "#ef4444" },
      { label: "Plancher haut",   val: data.ademe_dep_ph,   color: "#f97316" },
      { label: "Plancher bas",    val: data.ademe_dep_pb,   color: "#eab308" },
      { label: "Baies vitrées",   val: data.ademe_dep_baie, color: "#3b82f6" },
      { label: "Ponts thermiques",val: data.ademe_dep_pt,   color: "#8b5cf6" },
      { label: "Ventilation",     val: data.ademe_dep_vent, color: "#06b6d4" },
    ].filter(d => d.val > 0);
    const totalDep = depItems.reduce((s, d) => s + parseFloat(d.val), 0);

    // ── Zones à améliorer (cochées dans l'onglet Logement) ──
    const mursAmeli = JSON.parse(data.murs_list || "[]").filter(m => m.amelioration);
    const toitsAmeli = JSON.parse(data.toitures_list || "[]").filter(t => t.amelioration);
    const fensAmeli = JSON.parse(data.fenetres_list || "[]").filter(f => f.amelioration);
    const hasZonesAmeli = mursAmeli.length > 0 || toitsAmeli.length > 0 || fensAmeli.length > 0 || data.pb_amelioration;

    // DPE projeté — lire depuis localStorage si non disponible dans data
    let dprojLettre = data.dpe_lettre_projete || "";
    let dprojConso  = data.dpe_conso_projete || "";
    let dprojGain   = data.dpe_gain_pct || "";
    let dprojGesP   = data.ges_valeur_projete || "";
    let dprojCoutMin = data.dpe_projete_cout_min || "";
    let dprojCoutMax = data.dpe_projete_cout_max || "";
    let dprojCoutAides = data.dpe_projete_cout_aides || "";
    let dprojEconomie = data.dpe_projete_economie || "";
    let dprojRoi = data.dpe_projete_roi || "";

    // Fallback : lire depuis localStorage
    if (!dprojLettre) {
      try {
        const saved = localStorage.getItem("fndi_dpe_projete");
        if (saved) {
          const dp = JSON.parse(saved);
          dprojLettre = dp.classe_projetee || "";
          dprojConso  = dp.conso_projetee || "";
          dprojGain   = dp.gain_pct || "";
          dprojGesP   = dp.ges_projete || "";
          if (dp.cout_travaux) {
            dprojCoutMin = dp.cout_travaux.min?.toLocaleString("fr-FR") || "";
            dprojCoutMax = dp.cout_travaux.max?.toLocaleString("fr-FR") || "";
            dprojCoutAides = dp.cout_travaux.apres_aides?.toLocaleString("fr-FR") || "";
          }
          if (dp.gain_facture_annuel) {
            dprojEconomie = `${dp.gain_facture_annuel.min?.toLocaleString("fr-FR") || ""}–${dp.gain_facture_annuel.max?.toLocaleString("fr-FR") || ""}`;
          }
          dprojRoi = dp.retour_investissement || "";
        }
      } catch {}
    }

    const DPE_COLORS_MAP = { A:"#1a9e3f",B:"#4caf50",C:"#8bc34a",D:"#ffeb3b",E:"#ff9800",F:"#ff5722",G:"#b71c1c" };
    const DPE_TEXT_MAP   = { A:"white",B:"white",C:"white",D:"black",E:"white",F:"white",G:"white" };
    const DPE_CLASSES_LIST = [["A",70],["B",110],["C",180],["D",250],["E",330],["F",420],["G",999]];
    const BAR_WIDTHS = [28,40,52,64,76,88,100];

    const dpeGauge = (activeLettre, val, unit) => DPE_CLASSES_LIST.map(([ltr], i) => {
      const col = DPE_COLORS_MAP[ltr] || "#888";
      const tc  = DPE_TEXT_MAP[ltr] || "#fff";
      const isActive = ltr === activeLettre;
      const bw = BAR_WIDTHS[i];
      return `<div style="display:flex;align-items:center;gap:6px;margin-bottom:3px;">
        <div style="width:22px;height:22px;border-radius:4px;background:${col};display:flex;align-items:center;justify-content:center;font-weight:900;font-size:10pt;color:${tc};flex-shrink:0;">${ltr}</div>
        <div style="height:11px;border-radius:3px;background:${isActive ? col : "#EBEBEB"};width:${bw}px;"></div>
        ${isActive ? `<span style="font-size:8pt;font-weight:700;color:${col};">${val} ${unit}</span>` : ""}
      </div>`;
    }).join("");

    // Page de garde HTML
    const coverHTML = `
    <div class="cover-page" style="width:210mm;height:297mm;background:#111;position:relative;page-break-after:always;font-family:'Helvetica Neue',Arial,sans-serif;overflow:hidden;">
      <!-- Zone blanche haut -->
      <div style="background:#fff;padding:16mm 18mm 12mm;position:relative;">
        <!-- Triangle jaune -->
        <div style="position:absolute;top:0;right:0;width:0;height:0;border-style:solid;border-width:0 80mm 60mm 0;border-color:transparent #F5C800 transparent transparent;"></div>
        <!-- Logo + FNDI -->
        <div style="position:relative;z-index:1;display:flex;align-items:center;gap:14px;">
          ${logoPreview
            ? `<img alt="" src="${logoPreview}" style="height:130px;width:130px;object-fit:contain;" />`
            : `<div style="width:130px;height:130px;border-radius:50%;background:#0066cc;display:flex;align-items:center;justify-content:center;font-family:Arial Black,sans-serif;font-weight:900;font-size:28pt;color:#fff;">FNDi</div>`}
        </div>
        <!-- Séparateur -->
        <div style="border-top:1px solid #e0e0e0;margin:12px 0 10px;"></div>
        <!-- Coordonnées diagnostiqueur — ordre : Société / Nom / Certif / Adresse / Tél / Mail / SIRET -->
        <div style="font-size:8.5pt;color:#222;">
          <div style="font-weight:900;font-size:11pt;color:#111;text-transform:uppercase;">${diag.entreprise || "—"}</div>
          <div style="font-weight:700;font-size:9.5pt;color:#111;margin-top:1px;text-transform:uppercase;">${diag.nom || "—"}</div>
          ${diag.certification ? `<div style="color:#555;margin-top:2px;">Certif. N° ${diag.certification}</div>` : ""}
          ${diag.adresse_diag ? `<div style="color:#555;margin-top:1px;">${diag.adresse_diag}</div>` : ""}
          ${diag.tel ? `<div style="color:#555;margin-top:1px;">Téléphone : ${diag.tel}</div>` : ""}
          ${diag.email ? `<div style="color:#555;margin-top:1px;">Mail : ${diag.email}</div>` : ""}
          ${diag.siret ? `<div style="color:#555;margin-top:1px;">SIRET : ${diag.siret}</div>` : ""}
        </div>
      </div>

      <!-- Zone noire bas -->
      <div style="background:#111;padding:16mm 18mm;color:#fff;">
        <!-- Titre -->
        <div style="font-size:8pt;font-weight:700;color:#F5C800;letter-spacing:2px;margin-bottom:6px;">RAPPORT OFFICIEL</div>
        <div style="font-size:26pt;font-weight:900;color:#fff;line-height:1.1;margin-bottom:10px;">DPE PROJETÉ</div>
        <div style="height:2px;background:#F5C800;width:80mm;margin-bottom:14px;"></div>

        <!-- Adresse -->
        <div style="font-size:8pt;font-weight:700;color:#F5C800;letter-spacing:1px;margin-bottom:4px;">BIEN DIAGNOSTIQUÉ</div>
        <div style="font-size:16pt;font-weight:700;color:#fff;">${data.adresse || "—"}</div>
        <div style="font-size:12pt;color:#ccc;margin-bottom:16px;">${data.code_postal || ""} ${data.commune || ""}</div>

        <!-- Étiquettes côte à côte -->
        <div style="display:flex;gap:20px;margin-bottom:16px;">
          <div style="flex:1;">
            <div style="font-size:7pt;color:#888;font-weight:700;text-transform:uppercase;margin-bottom:6px;">CLASSE ÉNERGIE</div>
            ${dpeGauge(lettre, consoVal, "kWh/m²/an")}
          </div>
          ${dprojLettre ? `<div style="min-width:120px;">
            <div style="font-size:7pt;color:#fff;font-weight:700;text-transform:uppercase;margin-bottom:6px;">CLASSE PROJETÉE APRÈS TRAVAUX</div>
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="width:50px;height:54px;border-radius:6px;background:${DPE_COLORS_MAP[dprojLettre]||"#888"};display:flex;align-items:center;justify-content:center;font-size:28pt;font-weight:900;color:${DPE_TEXT_MAP[dprojLettre]||"#fff"};">${dprojLettre}</div>
              <div>
                <div style="color:#22c55e;font-weight:900;font-size:14pt;">-${dprojGain}%</div>
                <div style="color:#ccc;font-size:9pt;">${dprojConso} kWh/m²/an</div>
                <div style="color:#888;font-size:8pt;">de gain estimé</div>
              </div>
            </div>
          </div>` : ""}
        </div>

        <!-- Bas de page couverture -->
        <div style="border-top:1px solid #333;padding-top:12px;display:flex;gap:20px;">
          <div style="flex:1;">
            <div style="font-size:7pt;font-weight:700;color:#F5C800;letter-spacing:1px;">PROPRIÉTAIRE</div>
            <div style="font-size:12pt;font-weight:700;color:#fff;margin-top:2px;">${data.proprio_prenom||""} ${data.proprio_nom||""}</div>
          </div>
          <div style="border-left:1px solid #F5C800;padding-left:16px;">
            <div style="font-size:7pt;font-weight:700;color:#F5C800;letter-spacing:1px;">DATE DU DIAGNOSTIC</div>
            <div style="font-size:12pt;font-weight:700;color:#fff;margin-top:2px;">${data.ademe_date || today}</div>
          </div>
        </div>
      </div>

      <!-- Bande jaune bas -->
      <div style="background:#F5C800;padding:5px 18mm;font-size:7.5pt;font-weight:700;color:#111;text-align:center;">
        Méthode de calcul 3CL-DPE 2021 — Document informatif
      </div>
    </div>`;

    // Rapport HTML (pages intérieures)
    const rapportHTML = `
    <div style="width:210mm;font-family:'Helvetica Neue',Arial,sans-serif;font-size:10pt;color:#1a1a1a;">

      <div style="padding:14mm 14mm 14mm 14mm;">
        <!-- En-tête diagnostiqueur -->
        <div style="display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:10px;border-bottom:4px solid #F5C800;margin-bottom:14px;">
          <div style="font-size:9pt;">
            ${logoPreview ? `<img alt="" src="${logoPreview}" style="max-height:55px;max-width:140px;object-fit:contain;margin-bottom:4px;" /><br/>` : ""}
            <div style="font-weight:800;font-size:12pt;color:#111;">${diag.entreprise || "—"}</div>
            <div style="color:#555;">${diag.adresse_diag || ""}</div>
            <div style="color:#555;">${diag.tel ? "Tél : " + diag.tel : ""} ${diag.email ? "· " + diag.email : ""}</div>
            <div style="color:#888;font-size:8.5pt;">SIRET : ${diag.siret || "—"} · Certif. ${diag.certification || "—"}</div>
            ${diag.assurance ? `<div style="color:#888;font-size:8.5pt;">Assurance : ${diag.assurance} ${diag.assurance_num ? "· N° " + diag.assurance_num : ""}</div>` : ""}
          </div>
          <div style="text-align:right;">
            <div style="font-weight:800;font-size:12pt;color:#111;line-height:1.2;">RAPPORT DE DPE<br/>PROJETÉ</div>
            <div style="font-size:8pt;color:#888;margin-top:4px;">Date : ${data.ademe_date || today}</div>
            ${data.ademe_numero ? `<div style="font-size:8pt;color:#888;">N° ADEME : ${data.ademe_numero}</div>` : ""}
          </div>
        </div>

        <!-- 1. IDENTIFICATION -->
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">1 · IDENTIFICATION</div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
            <div>
              <div style="font-size:7.5pt;font-weight:800;color:#888;text-transform:uppercase;margin-bottom:3px;">PROPRIÉTAIRE</div>
              <div style="font-weight:800;font-size:11pt;">${data.proprio_prenom||""} ${data.proprio_nom||""}</div>
              ${data.proprio_adresse ? `<div style="font-size:9pt;">${data.proprio_adresse}</div>` : ""}
              ${(data.proprio_cp||data.proprio_ville) ? `<div style="font-size:9pt;">${data.proprio_cp||""} ${data.proprio_ville||""}</div>` : ""}
            </div>
            <div>
              <div style="font-size:7.5pt;font-weight:800;color:#888;text-transform:uppercase;margin-bottom:3px;">LOGEMENT DIAGNOSTIQUÉ</div>
              <div style="font-size:9.5pt;">${data.adresse||"—"}</div>
              <div style="font-size:9.5pt;">${data.code_postal||""} ${data.commune||""}</div>
              <table style="width:100%;font-size:8.5pt;margin-top:6px;border-collapse:collapse;">
                ${[
                  ["Type", data.type||"—"],
                  ["Surface", data.surface ? data.surface+" m²" : "—"],
                  ["Année constr.", data.annee||data.periode_construction_label||"—"],
                  ["Étages", data.etages||"—"],
                  ["Chauffage", data.chauffage||"—"],
                  ["ECS", data.ecs||"—"],
                  ["Ventilation", data.ventilation||"—"],
                  ["Date DPE", data.ademe_date||today],
                ].filter(([,v])=>v&&v!=="—").map(([k,v])=>`
                  <tr style="border-bottom:0.3px solid #f0f0f0;">
                    <td style="color:#666;padding:2px 0;">${k}</td>
                    <td style="font-weight:700;text-align:right;padding:2px 0;">${v}</td>
                  </tr>`).join("")}
              </table>
            </div>
          </div>
        </div>

        <!-- 2. ÉTIQUETTES DPE -->
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">2 · ÉTIQUETTES DPE RÉALISÉ</div>
          <div style="display:flex;gap:12px;align-items:flex-start;">
            <div style="flex:1;">
              <div style="font-size:7.5pt;font-weight:700;color:#666;text-transform:uppercase;margin-bottom:5px;">CONSOMMATION D'ÉNERGIE PRIMAIRE</div>
              ${dpeGauge(lettre, consoVal, "kWh EP/m²/an")}
            </div>
            <div style="flex:1;">
              <div style="font-size:7.5pt;font-weight:700;color:#666;text-transform:uppercase;margin-bottom:5px;">ÉMISSIONS DE GAZ À EFFET DE SERRE</div>
              ${dpeGauge(gesLettre, gesVal, "kg CO₂ éq./m²/an")}
            </div>
            <div style="min-width:110px;background:#f8f8f8;border-radius:8px;padding:10px;text-align:left;">
              <div style="font-size:7pt;font-weight:700;color:#888;text-transform:uppercase;margin-bottom:4px;">COÛT ANNUEL ESTIMÉ</div>
              <div style="font-size:12pt;font-weight:900;color:#111;">${data.dpe_cout_min && data.dpe_cout_max ? data.dpe_cout_min+" – "+data.dpe_cout_max : "—"}</div>
              <div style="font-size:8pt;color:#666;">€/an</div>
              ${data.dpe_conso_finale ? `<div style="margin-top:8px;font-size:7.5pt;font-weight:700;color:#888;text-transform:uppercase;">ÉNERGIE FINALE</div><div style="font-size:10pt;font-weight:900;">${data.dpe_conso_finale} kWh/m²/an</div>` : ""}
            </div>
          </div>
        </div>

        <!-- 3. DÉPERDITIONS -->
        ${depItems.length > 0 ? `
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">3 · ANALYSE DES DÉPERDITIONS THERMIQUES</div>
          <div style="font-size:8pt;color:#888;margin-bottom:8px;">
            Déperditions totales : ${Math.round(totalDep)} W/K
            ${data.ademe_u_mur ? ` — Coefficients U : Murs ${data.ademe_u_mur}` : ""}
            ${data.ademe_u_pb   ? ` | Plancher bas ${data.ademe_u_pb}` : ""}
            ${data.ademe_u_ph   ? ` | Plancher haut ${data.ademe_u_ph}` : ""}
            ${data.ademe_u_baie ? ` | Baies ${data.ademe_u_baie} W/m²K` : ""}
          </div>
          ${depItems.map(d => {
            const pct = totalDep ? Math.round(d.val/totalDep*100) : 0;
            const bw = Math.max(4, pct);
            return `<div style="margin-bottom:6px;">
              <div style="display:flex;justify-content:space-between;font-size:8.5pt;margin-bottom:2px;">
                <span>${d.label}</span>
                <span style="font-weight:700;">${d.val} W/K &nbsp; ${pct}%</span>
              </div>
              <div style="background:#f0f0f0;height:10px;border-radius:3px;">
                <div style="background:${d.color};height:10px;border-radius:3px;width:${bw}%;"></div>
              </div>
            </div>`;
          }).join("")}
        </div>` : ""}

        <!-- 3bis. ZONES À AMÉLIORER -->
        ${hasZonesAmeli ? `
        <div style="margin-bottom:12px;">
          <div style="background:#ef4444;color:#fff;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">⚠️ ZONES NÉCESSITANT UNE AMÉLIORATION THERMIQUE</div>
          <table style="width:100%;border-collapse:collapse;font-size:8pt;">
            <tr style="background:#ef444415;">
              <td style="padding:5px 8px;font-weight:700;border:0.3px solid #ef444433;color:#ef4444;width:18%;">Élément</td>
              <td style="padding:5px 8px;font-weight:700;border:0.3px solid #ef444433;color:#ef4444;width:28%;">Localisation</td>
              <td style="padding:5px 8px;font-weight:700;border:0.3px solid #ef444433;color:#ef4444;width:27%;">Caractéristiques</td>
              <td style="padding:5px 8px;font-weight:700;border:0.3px solid #ef444433;color:#ef4444;width:27%;">Action recommandée</td>
            </tr>
            ${mursAmeli.map((m, i) => {
              const murIdx = JSON.parse(data.murs_list||"[]").indexOf(m)+1;
              const matLabel = {pierre:"Pierre",brique_pleine:"Brique pleine",brique_creuse:"Brique creuse",beton_machefer:"Béton mâchefer",parpaing:"Parpaing",beton:"Béton",ossature_bois:"Ossature bois",inconnu:"Inconnu"}[m.materiau]||m.materiau;
              const isoLabel = {aucune:"Non isolé",iti:"ITI",ite:"ITE",repartie:"Répartie",inconnue:"Inconnue"}[m.isolation]||m.isolation;
              return `<tr style="background:${i%2===0?"#fff":"#fef2f2"};">
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;font-weight:700;">🧱 Mur ${murIdx}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">Exp. ${(m.orientation||"").toUpperCase()} · ${m.surface||"?"}m² · ${m.contact==="pc_avec"?"PC av. ouv.":m.contact==="pc_sans"?"PC ss ouv.":"Extérieur"}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${matLabel} · Ép.${m.epaisseur||"?"}cm · ${isoLabel}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;color:#ef4444;font-weight:600;">${!m.isolation||m.isolation==="aucune"?"ITE ou ITI — R ≥ 3,7 m².K/W":"Renforcement isolation"}</td>
              </tr>`;
            }).join("")}
            ${toitsAmeli.map((t, i) => {
              const toitIdx = JSON.parse(data.toitures_list||"[]").indexOf(t)+1;
              const typeLabel = {combles_perdus:"Combles perdus",rampants:"Rampants",toiture_terrasse:"Toiture-terrasse",plancher_lnc:"Plafond/LNC",local_chauffe:"Local chauffé"}[t.type]||t.type;
              const structLabel = {beton:"Dalle béton",voutains_pierre:"Voûtains pierre",voutains_briques:"Voûtains briques",solives_bois_sans:"Solives bois",solives_bois_avec:"Solives+remplissage",bac_acier:"Bac acier",inconnu:"Inconnu"}[t.structure]||"";
              return `<tr style="background:${(mursAmeli.length+i)%2===0?"#fff":"#fef2f2"};">
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;font-weight:700;">🏚️ Toiture ${toitIdx}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${typeLabel} · ${t.surface||"?"}m²</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${structLabel} · ${!t.isolation||t.isolation==="aucune"?"Non isolé":t.isolation} ${t.epaisseur_iso?`(${t.epaisseur_iso}cm)`:""}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;color:#ef4444;font-weight:600;">Isolation — R ≥ 7 m².K/W</td>
              </tr>`;
            }).join("")}
            ${data.pb_amelioration ? `<tr style="background:${(mursAmeli.length+toitsAmeli.length)%2===0?"#fff":"#fef2f2"};">
              <td style="padding:5px 8px;border:0.3px solid #e0e0e0;font-weight:700;">⬇️ Plancher bas</td>
              <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${{terre_plein:"Terre-plein",vide_sanitaire:"Vide sanitaire",cave:"Cave/SS",garage:"Garage",local_chauffe:"Local chauffé",pc_avec:"PC av. ouv.",pc_sans:"PC ss ouv."}[data.type_plancher_bas]||"—"}</td>
              <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${{dalle_beton:"Dalle béton",voutains_pierre:"Voûtains pierre",voutains_briques:"Voûtains briques",solives_bois_sans:"Solives bois",solives_bois_avec:"Solives+remplissage",inconnu:"Inconnu"}[data.structure_plancher_bas]||"—"} · ${!data.isolation_plancher_bas||data.isolation_plancher_bas==="aucune"?"Non isolé":"Isolé"}</td>
              <td style="padding:5px 8px;border:0.3px solid #e0e0e0;color:#ef4444;font-weight:600;">Isolation — R ≥ 3 m².K/W</td>
            </tr>` : ""}
            ${fensAmeli.map((f, i) => {
              const fenIdx = JSON.parse(data.fenetres_list||"[]").indexOf(f)+1;
              const typeLabel = {fenetre:"Fenêtre",pf:"Porte-fen.",baie_coulissante:"Baie coul.",velux:"Velux"}[f.type]||f.type;
              const vitrLabel = {simple:"Simple vit.",survitrage:"Survitrage",double_ancien:"DV ancien",double_peu_emissif:"DV peu émissif",double_argon:"DV argon",triple:"Triple vit."}[f.vitrage]||f.vitrage;
              return `<tr style="background:${(mursAmeli.length+toitsAmeli.length+(data.pb_amelioration?1:0)+i)%2===0?"#fff":"#fef2f2"};">
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;font-weight:700;">🪟 Fen. ${fenIdx}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${typeLabel} · ${(f.orientation||"").toUpperCase()} · ${f.nombre||1} unité(s) · Mur n°${f.mur_ref||"?"}</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;">${vitrLabel} · Ép.${f.epaisseur_lame||"?"}mm · Uw ${f.uw||"?"}W/m².K</td>
                <td style="padding:5px 8px;border:0.3px solid #e0e0e0;color:#ef4444;font-weight:600;">Remplacement DV peu émissif (Uw ≤ 1,3)</td>
              </tr>`;
            }).join("")}
          </table>
        </div>` : ""}

        <!-- 4. OBSERVATIONS -->
        ${comments.length > 0 ? `
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">${depItems.length > 0 ? "4" : "3"} · OBSERVATIONS DU DIAGNOSTIQUEUR</div>
          ${comments.map(c => `
            <div style="border-left:3px solid #F5C800;background:#fffef0;padding:6px 10px;margin-bottom:5px;border-radius:0 4px 4px 0;">
              <div style="font-weight:700;font-size:8pt;color:#888;text-transform:uppercase;margin-bottom:2px;">■ ${c.type||"Recommandation"}</div>
              <div style="font-size:9pt;">${c.texte}</div>
            </div>`).join("")}
          ${data.etat_general_commentaire ? `
            <div style="border-left:3px solid #3b82f6;background:#eff6ff;padding:6px 10px;margin-bottom:5px;border-radius:0 4px 4px 0;">
              <div style="font-weight:700;font-size:8pt;color:#1d4ed8;text-transform:uppercase;margin-bottom:2px;">■ ÉTAT GÉNÉRAL</div>
              <div style="font-size:9pt;">${data.etat_general_commentaire}</div>
            </div>` : ""}
        </div>` : ""}

        <!-- 5. TRAVAUX -->
        ${(saisieMode && data.saisieEtapes && data.saisieEtapes.some(e => e.items.length > 0)) ? `
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">${(depItems.length>0?4:3)+(comments.length>0?1:0)+1} · TRAVAUX PRÉCONISÉS PAR ÉTAPE</div>
          ${data.saisieEtapes.filter(e => e.items.length > 0).map((etape, idx) => {
            // Helpers de badges colorés (mêmes couleurs que la couverture du rapport)
            const _DPE_COLORS = { A:"#1a9e3f",B:"#4caf50",C:"#8bc34a",D:"#ffeb3b",E:"#ff9800",F:"#ff5722",G:"#b71c1c" };
            const _DPE_TEXT   = { A:"#fff",B:"#fff",C:"#fff",D:"#000",E:"#fff",F:"#fff",G:"#fff" };
            const renderLetterBadge = (letter) => {
              const up = (letter || "").toUpperCase();
              if (!up) return `<span style="color:#999">—</span>`;
              return `<span style="display:inline-block;padding:1px 7px;border-radius:3px;font-weight:900;font-size:9pt;background:${_DPE_COLORS[up]||"#888"};color:${_DPE_TEXT[up]||"#fff"};vertical-align:middle;">${up}</span>`;
            };
            return `
            <!-- Sous-section ${etape.label} -->
            <div class="keep-together" style="margin-bottom:10px;border:1px solid #e5e5e5;border-radius:6px;overflow:hidden;">
              <div style="background:#fff7e6;padding:7px 10px;border-bottom:1px solid #f5c80055;">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;">
                  <div style="font-size:9.5pt;font-weight:800;color:#111;">
                    <span style="display:inline-block;background:#F5C800;color:#111;padding:2px 7px;border-radius:3px;font-size:8pt;font-weight:900;margin-right:6px;">${etape.num}</span>
                    ${etape.label}
                  </div>
                  ${etape.min > 0 ? `<div style="font-size:8.5pt;color:#111;font-weight:700;">Coût : ${etape.min.toLocaleString("fr-FR")} – ${etape.max.toLocaleString("fr-FR")} €</div>` : ""}
                </div>
                <div style="font-size:8.5pt;color:#666;display:flex;gap:14px;flex-wrap:wrap;align-items:center;">
                  ${etape.consoFin ? `<span><strong style="color:#111">Conso :</strong> ${etape.consoFin} kWh/m²/an</span>` : ""}
                  ${etape.lettreFin ? `<span><strong style="color:#111">DPE :</strong> ${renderLetterBadge(etape.lettreFin)}</span>` : ""}
                  ${etape.gesL ? `<span><strong style="color:#111">GES :</strong> ${renderLetterBadge(etape.gesL)}${etape.gesV ? ` <span style="color:#888;font-size:8pt;">(${etape.gesV} kg CO₂/m²/an)</span>` : ""}</span>` : ""}
                  ${etape.gainPct > 0 ? `<span style="color:#16a34a;font-weight:700;">⚡ Gain énergétique : -${etape.gainPct}%</span>` : ""}
                </div>
              </div>
              <div style="padding:4px 8px;">
                ${etape.items.map(it => {
                  const t = it.t;
                  if (!t) return "";
                  const pc = t.urgence==="haute" ? "#fee2e2" : t.urgence==="moyenne" ? "#fef3c7" : "#dcfce7";
                  const tc = t.urgence==="haute" ? "#dc2626" : t.urgence==="moyenne" ? "#d97706" : "#16a34a";
                  const coutItem = (it.costMin !== null) ? `${it.costMin.toLocaleString("fr-FR")} – ${it.costMax.toLocaleString("fr-FR")} €` : (t.cout || "—");
                  return `<div style="display:flex;align-items:flex-start;gap:8px;padding:6px 4px;border-bottom:0.3px solid #f5f5f5;">
                    <div style="padding:2px 7px;border-radius:4px;background:${pc};color:${tc};font-size:7.5pt;font-weight:700;flex-shrink:0;">${t.urgence}</div>
                    <div style="flex:1;">
                      <div style="font-weight:700;font-size:9.5pt;">${t.label}${it.quantite ? ` <span style="color:#888;font-weight:500;">(${it.quantite}${t.unite ? ` ${t.unite}` : ""})</span>` : ""}</div>
                      <div style="font-size:8pt;color:#d97706;">Aides pouvant atteindre : MaPrimeRénov' jusqu'à 70 % · CEE${t.urgence==="haute"?" · Éco-PTZ 0 %":""}</div>
                    </div>
                    <div style="text-align:right;font-size:8pt;color:#666;flex-shrink:0;">${coutItem}<br/><span style="color:#16a34a;font-weight:700;">-${t.gain}</span></div>
                  </div>`;
                }).join("")}
              </div>
            </div>
          `;
          }).join("")}
        </div>` : (travauxSelList.length > 0 ? `
        <div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">${(depItems.length>0?4:3)+(comments.length>0?1:0)+1} · TRAVAUX PRÉCONISÉS</div>
          ${travauxSelList.map(t => {
            const pc = t.urgence==="haute" ? "#fee2e2" : t.urgence==="moyenne" ? "#fef3c7" : "#dcfce7";
            const tc = t.urgence==="haute" ? "#dc2626" : t.urgence==="moyenne" ? "#d97706" : "#16a34a";
            return `<div style="display:flex;align-items:flex-start;gap:8px;padding:6px 8px;border-bottom:0.3px solid #e5e5e5;margin-bottom:3px;">
              <div style="padding:2px 7px;border-radius:4px;background:${pc};color:${tc};font-size:7.5pt;font-weight:700;flex-shrink:0;">${t.urgence}</div>
              <div style="flex:1;">
                <div style="font-weight:700;font-size:9.5pt;">${t.label}</div>
                <div style="font-size:8pt;color:#d97706;">Aides pouvant atteindre : MaPrimeRénov' jusqu'à 70 % · CEE${t.urgence==="haute"?" · Éco-PTZ 0 %":""}</div>
              </div>
              <div style="text-align:right;font-size:8pt;color:#666;flex-shrink:0;">${t.cout}<br/><span style="color:#16a34a;font-weight:700;">-${t.gain}</span></div>
            </div>`;
          }).join("")}
        </div>` : "")}

        <!-- 6. SYNTHÈSE — démarre toujours sur une nouvelle page pour ne pas être coupée -->
        ${(syntheseIA || data.dpe_projete_synthese || (() => { try { const s = localStorage.getItem("fndi_dpe_projete"); return s ? JSON.parse(s).synthese : ""; } catch { return ""; } })()) ? `
        <div style="margin-bottom:12px;page-break-before:always;break-before:page;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:8px;">${(depItems.length>0?4:3)+(comments.length>0?1:0)+(travauxSelList.length>0?1:0)+1} · SYNTHÈSE GÉNÉRALE</div>
          <div style="background:#f8f8f8;border-left:4px solid #F5C800;padding:10px 14px;font-size:9.5pt;line-height:1.7;border-radius:0 4px 4px 0;">${(() => {
            const syn = syntheseIA || data.dpe_projete_synthese || (() => { try { const s = localStorage.getItem("fndi_dpe_projete"); return s ? (JSON.parse(s).synthese||"") : ""; } catch { return ""; } })();
            if (!syn) return "";
            // Chaque paragraphe (séparé par double-saut) devient un bloc keep-together
            // pour empêcher toute coupure en plein milieu d'un paragraphe lors de l'impression
            return syn.split(/\n\n+/).map(para => {
              const html = para.replace(/\n/g, "<br/>");
              return `<div class="synthese-paragraph" style="margin-bottom:10px;">${html}</div>`;
            }).join("");
          })()}</div>
        </div>` : ""}

        <!-- 7. DPE PROJETÉ -->
        ${(dprojLettre) ? (() => {
          const pLettre = dprojLettre;
          const pConso = dprojConso || "—";
          const pGain = dprojGain || "?";
          const pGesProjete = dprojGesP || Math.round(parseFloat(pConso) * 0.057) || "—";
          const pCoutMin = dprojCoutMin || "—";
          const pCoutMax = dprojCoutMax || "—";
          const pCoutAides = dprojCoutAides || "—";
          const pEconomie = dprojEconomie || "—";
          const pRoi = dprojRoi || "—";
          const secNum = (depItems.length>0?4:3)+(comments.length>0?1:0)+(travauxSelList.length>0?1:0)+((syntheseIA||data.dpe_projete_synthese)?1:0)+1;

          return `<div style="margin-bottom:12px;">
          <div style="background:#111;color:#F5C800;padding:4px 10px;font-size:8pt;font-weight:800;text-transform:uppercase;letter-spacing:1px;border-radius:4px;margin-bottom:10px;">${secNum} · DPE PROJETÉ — SIMULATION APRÈS TRAVAUX</div>

          <!-- Étiquettes côte à côte avec barres -->
          <div style="display:flex;gap:16px;margin-bottom:12px;">
            <!-- Actuel -->
            <div style="flex:1;">
              <div style="font-size:7pt;color:#888;font-weight:700;text-transform:uppercase;margin-bottom:5px;">ÉTAT ACTUEL</div>
              ${DPE_CLASSES_LIST.map(([ltr],i) => {
                const col = DPE_COLORS_MAP[ltr]||"#888";
                const tc = DPE_TEXT_MAP[ltr]||"#fff";
                const isActive = ltr === lettre;
                return `<div style="display:flex;align-items:center;gap:5px;margin-bottom:2px;">
                  <div style="width:18px;height:18px;border-radius:3px;background:${col};display:flex;align-items:center;justify-content:center;font-weight:900;font-size:9pt;color:${tc};flex-shrink:0;">${ltr}</div>
                  <div style="height:10px;border-radius:2px;background:${isActive?col:"#EBEBEB"};width:${BAR_WIDTHS[i]}px;"></div>
                  ${isActive ? `<span style="font-size:7.5pt;font-weight:700;color:${col};">${consoVal} kWh/m²</span>` : ""}
                </div>`;
              }).join("")}
            </div>

            <!-- Flèche gain -->
            <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;padding:10px;min-width:60px;">
              <div style="font-size:20pt;color:#ccc;">→</div>
              <div style="font-size:14pt;font-weight:900;color:#22c55e;">-${pGain}%</div>
              <div style="font-size:7pt;color:#888;">de gain</div>
            </div>

            <!-- Projeté -->
            <div style="flex:1;">
              <div style="font-size:7pt;color:#22c55e;font-weight:700;text-transform:uppercase;margin-bottom:5px;">APRÈS TRAVAUX</div>
              ${DPE_CLASSES_LIST.map(([ltr],i) => {
                const col = DPE_COLORS_MAP[ltr]||"#888";
                const tc = DPE_TEXT_MAP[ltr]||"#fff";
                const isActive = ltr === pLettre;
                return `<div style="display:flex;align-items:center;gap:5px;margin-bottom:2px;">
                  <div style="width:18px;height:18px;border-radius:3px;background:${col};display:flex;align-items:center;justify-content:center;font-weight:900;font-size:9pt;color:${tc};flex-shrink:0;">${ltr}</div>
                  <div style="height:10px;border-radius:2px;background:${isActive?col:"#EBEBEB"};width:${BAR_WIDTHS[i]}px;"></div>
                  ${isActive ? `<span style="font-size:7.5pt;font-weight:700;color:${col};">${pConso} kWh/m²</span>` : ""}
                </div>`;
              }).join("")}
            </div>
          </div>

          <!-- Tableau synthèse chiffres -->
          <table style="width:100%;border-collapse:collapse;font-size:8.5pt;">
            <tr style="background:#111;color:#fff;">
              <td colspan="4" style="padding:5px 8px;font-weight:700;font-size:8pt;text-transform:uppercase;letter-spacing:0.5px;">Synthèse financière et énergétique</td>
            </tr>
            <tr style="background:#f8f8f8;">
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;width:25%;">Consommation projetée</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;color:#22c55e;">${pConso} kWh EP/m²/an</td>
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;width:25%;">Émissions GES projetées</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;">${pGesProjete} kg CO₂/m²/an</td>
            </tr>
            <tr>
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;">Coût estimé des travaux</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;">${pCoutMin} – ${pCoutMax} €</td>
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;">Après aides maximales</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;color:#F5C800;">${pCoutAides} €</td>
            </tr>
            <tr style="background:#f8f8f8;">
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;">Économies annuelles</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;color:#22c55e;">${pEconomie} €/an</td>
              <td style="padding:6px 8px;color:#666;border:0.3px solid #e0e0e0;">Retour sur investissement</td>
              <td style="padding:6px 8px;font-weight:700;border:0.3px solid #e0e0e0;">${pRoi}</td>
            </tr>
          </table>

          <!-- Encart d'information sur les aides (MaPrimeRénov' / CEE) -->
          <div class="keep-together" style="margin-top:10px;padding:10px 14px;border-radius:6px;background:#fffbe6;border:1px solid #f5c80055;border-left:3px solid #F5C800;">
            <div style="font-size:8pt;font-weight:800;color:#a16207;margin-bottom:5px;text-transform:uppercase;letter-spacing:0.5px;">ℹ️ À propos des aides « Après aides maximales »</div>
            <div style="font-size:8pt;color:#555;line-height:1.6;">
              <p style="margin-bottom:6px;">
                MaPrimeRénov' et les aides CEE (Certificats d'Économies d'Énergie) sont accordées <strong>sous certaines conditions de ressources</strong>. Le montant des aides varie selon plusieurs critères : <strong>vos revenus fiscaux, la composition de votre foyer, la localisation de votre logement</strong> ainsi que les <strong>travaux réalisés</strong>.
              </p>
              <p style="margin-bottom:6px;">
                Les montants d'aides indiqués dans nos estimations sont donnés <strong>à titre indicatif</strong>. N'ayant pas connaissance de votre situation fiscale ni de vos plafonds de ressources, il est indispensable d'effectuer une <strong>simulation personnalisée sur les sites officiels</strong> afin de connaître précisément vos droits et le montant réel des aides auxquelles vous pouvez prétendre.
              </p>
              <p>
                Vous pouvez réaliser votre simulation directement sur le site officiel France Rénov' :
                <a href="https://mesaides.france-renov.gouv.fr/" style="color:#1d4ed8;font-weight:700;text-decoration:underline;" target="_blank" rel="noopener">Faire une simulation MaPrimeRénov'</a>.
              </p>
            </div>
          </div>
        </div>`;
        })() : ""}

      </div>

      <!-- FOOTER -->
      <div style="margin:8px 16mm 0;padding:8px 0;display:flex;flex-direction:column;align-items:center;gap:3px;">
        <!-- AVERTISSEMENT JURIDIQUE -->
        <div class="keep-together" style="margin-top:16px;padding:10px 14px;border-radius:6px;background:#f8f8f8;border:1px solid #e0e0e0;border-left:3px solid #888;">
          <div style="font-size:7.5pt;font-weight:800;color:#555;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.5px;">⚖️ Avertissement</div>
          <div style="font-size:7pt;color:#666;line-height:1.6;">
            Ce DPE projeté est un outil indicatif d'aide à la décision, fondé sur des hypothèses de travaux et la réglementation en vigueur à la date d'édition. Il ne vaut pas DPE réglementaire, n'a pas de valeur juridique opposable et ne garantit en aucun cas le résultat final des travaux ni la classe énergétique qui sera obtenue lors d'un futur DPE réglementaire. Calcul des gains suivant la Méthode 3CL-DPE 2021.
          </div>
        </div>
      </div>
    </div>`;

    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8"/>
<title>Rapport DPE Projeté — ${data.adresse || "Logement"}</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family:'Helvetica Neue',Arial,sans-serif; background:#fff; }
  @media print {
    /* Couverture full-bleed : pas de marges. Pages intérieures : marges minimales (2-3mm) pour barre jaune presque en bord */
    @page :first { size: A4; margin: 0; }
    @page { size: A4; margin: 3mm 0 3mm 0; }
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .page-break { page-break-after: always; break-after: page; }

    /* Empêcher la coupure d'éléments cohérents entre 2 pages */
    p, li, blockquote { page-break-inside: avoid; break-inside: avoid; orphans: 3; widows: 3; }
    table, tr, td, th { page-break-inside: avoid; break-inside: avoid; }
    .keep-together,
    .section-block,
    .commentaire,
    .info-aides,
    .synthese-paragraph { page-break-inside: avoid; break-inside: avoid; }

    /* Les titres ne restent pas seuls en bas de page */
    h1, h2, h3, h4 { page-break-after: avoid; break-after: avoid; page-break-inside: avoid; break-inside: avoid; }

    /* Bandeau jaune en HAUT — fixed pour répétition automatique par Chromium sur chaque page */
    .print-header-bar {
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      background: #F5C800;
      color: #111;
      font-size: 9pt;
      font-weight: 700;
      padding: 6px 14mm;
      min-height: 9mm;
      justify-content: space-between;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      z-index: 1000;
    }

    /* Bandeau jaune en BAS — fixed, répété automatiquement */
    .print-footer-bar {
      display: flex;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      background: #F5C800;
      color: #111;
      font-size: 8pt;
      font-weight: 600;
      padding: 6px 14mm;
      min-height: 9mm;
      justify-content: space-between;
      align-items: center;
      gap: 14mm;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      z-index: 1000;
    }
    .print-footer-bar .footer-page {
      font-weight: 800;
      font-size: 9pt;
      flex-shrink: 0;
      padding-right: 8mm;
      border-right: 1px solid rgba(0,0,0,0.25);
    }
    .print-footer-bar .footer-info {
      color: #1a1a1a;
      flex: 1;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /* Compteur de page CSS pour Chromium print */
    .print-footer-bar .page-num::before { content: counter(page); }

    /* La couverture (page 1) masque les bandeaux fixes grâce à son z-index plus élevé */
    .cover-page {
      position: relative !important;
      z-index: 2000 !important;
    }
  }
  /* En écran : bandeaux invisibles */
  .print-header-bar,
  .print-footer-bar { display: none; }

  /* Bannière d'aide (écran uniquement) — masquée totalement à l'impression */
  .screen-only-banner {
    background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
    border-bottom: 3px solid #F5C800;
    padding: 16px 20px;
    font-family: 'Helvetica Neue', Arial, sans-serif;
    color: #1a1a1a;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  }
  .screen-only-banner-inner {
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
  }
  .screen-only-banner .banner-title {
    font-size: 15px;
    font-weight: 800;
    color: #92400e;
    flex-shrink: 0;
  }
  .screen-only-banner .banner-text {
    font-size: 13px;
    color: #1f2937;
    line-height: 1.5;
    flex: 1;
    min-width: 280px;
  }
  .screen-only-banner .banner-text strong { color: #b45309; }
  .screen-only-banner .banner-text em { font-style: italic; color: #6b7280; }
  .screen-only-banner .banner-print-btn {
    background: #F5C800;
    color: #111;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    font-weight: 800;
    font-size: 13px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    flex-shrink: 0;
    transition: background 0.15s;
  }
  .screen-only-banner .banner-print-btn:hover { background: #e8b900; }
  @media print {
    .screen-only-banner { display: none !important; }
  }
</style>
</head>
<body>
${coverHTML}
${rapportHTML}
</body>
</html>`;

    // ── Génération PDF SERVEUR via Browserless.io (api/generate-pdf.js) ──
    // Vrai rendu Chromium côté serveur EU (RGPD), pas de parasites navigateur,
    // marche identique sur Chrome/Firefox/Safari/mobile, marges au pixel près.
    try {
      const filename = `rapport_dpe_projete_${(data.adresse || "logement").replace(/[^a-zA-Z0-9]/g, "_")}.pdf`;
      const userToken = localStorage.getItem("fndi_session_token") || "";
      const adresseBien = `${data.adresse || ""} ${data.code_postal || ""} ${data.commune || ""}`.trim();

      console.log(`[PDF] Envoi du HTML à l'API (${(html.length / 1024).toFixed(1)} KB)…`);

      const response = await fetch("/api/generate-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${userToken}`,
        },
        body: JSON.stringify({ html, filename, adresseBien }),
      });

      if (!response.ok) {
        let errMsg = `HTTP ${response.status}`;
        try {
          const errJson = await response.json();
          if (errJson.error) errMsg = errJson.error;
        } catch {}
        throw new Error(errMsg);
      }

      const blob = await response.blob();
      console.log(`[PDF] Reçu ${(blob.size / 1024).toFixed(1)} KB, téléchargement…`);

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      console.error("Erreur génération PDF :", e);
      alert("❌ Erreur génération PDF : " + (e.message || e) + "\n\nLa génération est faite côté serveur. Vérifiez votre connexion ou contactez l'admin.");
    }
    setGenerating(false);
  };


  const isReady = data.surface && (data.dpe_lettre || data.chauffage);

  // Détection du mode : import ADEME/XML ou saisie manuelle complète
  const modeImport = !!(data.dpe_lettre && data.dpe_conso);

  // Points de validation adaptés selon le mode
  const travauxSelList = travaux.map(id => TRAVAUX_TYPES.find(t => t.id === id)).filter(Boolean);

  const VALIDATION_ITEMS = modeImport ? [
    // Mode import — validation simplifiée sans travaux obligatoires
    { id: "identification", cat: "📋 Données logement", label: `Adresse et surface vérifiées : ${data.adresse || "—"} · ${data.surface || "—"} m²` },
    { id: "proprietaire",   cat: "📋 Données logement", label: "Coordonnées du propriétaire confirmées" },
    { id: "dpe_realise",    cat: "📋 Données logement", label: `Classe DPE réalisée validée : ${lettre} — ${consoVal} kWh/m²/an` },
    { id: "ges_valide",     cat: "📋 Données logement", label: `Classe GES validée : ${gesLettre} — ${gesVal} kg CO₂/m²/an` },
    { id: "rapport_val",    cat: "📄 Rapport", label: "Le rapport reflète fidèlement les données du DPE réalisé" },
  ] : [
    // Mode saisie complète — validation exhaustive
    { id: "identification", cat: "📋 Données logement", label: "Identification du logement vérifiée (adresse, surface, année)" },
    { id: "proprietaire",   cat: "📋 Données logement", label: "Coordonnées du propriétaire confirmées" },
    { id: "dpe_realise",    cat: "📋 Données logement", label: `Classe DPE réalisée validée : ${lettre} — ${consoVal} kWh/m²/an` },
    { id: "ges_valide",     cat: "📋 Données logement", label: `Classe GES validée : ${gesLettre} — ${gesVal} kg CO₂/m²/an` },
    { id: "enveloppe",      cat: "🧱 Enveloppe", label: "Composition des murs, planchers et toiture vérifiée" },
    { id: "fenetres",       cat: "🧱 Enveloppe", label: "Type de vitrage et menuiseries confirmés" },
    { id: "chauffage_val",  cat: "⚙️ Équipements", label: `Système de chauffage validé : ${data.chauffage || "non renseigné"}` },
    { id: "ecs_val",        cat: "⚙️ Équipements", label: `ECS validée : ${data.ecs || "non renseignée"}` },
    { id: "ventilation_val",cat: "⚙️ Équipements", label: `Ventilation validée : ${data.ventilation || "non renseignée"}` },
    ...travauxSelList.map(t => ({ id: `travail_${t.id}`, cat: "🔨 Recommandations travaux", label: `Travail préconisé validé : ${t.label}` })),
    { id: "synthese_val",   cat: "📄 Rapport", label: "Synthèse IA relue et validée" },
    { id: "rapport_val",    cat: "📄 Rapport", label: "Le rapport reflète fidèlement les observations terrain" },
  ];

  const cats = [...new Set(VALIDATION_ITEMS.map(i => i.cat))];
  const allChecked = VALIDATION_ITEMS.every(i => validations[i.id]);
  const checkedCount = VALIDATION_ITEMS.filter(i => validations[i.id]).length;
  const toggleVal = (id) => setValidations(p => ({ ...p, [id]: !p[id] }));
  const checkAll = () => {
    const all = {};
    VALIDATION_ITEMS.forEach(i => all[i.id] = true);
    setValidations(all);
  };

  return (
    <div>
      {/* ── CHECKLIST PRÉ-GÉNÉRATION ── */}
      <div style={{ ...styles.card, border: `2px solid ${allOk ? COLORS.green : nbOk >= 4 ? COLORS.yellow : COLORS.red}44` }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div style={{ fontWeight: 800, fontSize: 15, color: allOk ? COLORS.green : COLORS.accent }}>
            {allOk ? "✅ Dossier complet" : `📋 Avant de générer — ${nbOk}/${checklistItems.length} étapes`}
          </div>
          <div style={{ fontSize: 12, color: COLORS.muted }}>{Math.round(nbOk/checklistItems.length*100)}%</div>
        </div>

        {/* Barre de progression */}
        <div style={{ height: 6, background: COLORS.card, borderRadius: 4, marginBottom: 14, overflow: "hidden" }}>
          <div style={{ height: "100%", width: `${nbOk/checklistItems.length*100}%`, background: allOk ? COLORS.green : COLORS.accent, borderRadius: 4, transition: "width 0.3s" }} />
        </div>

        {/* Items */}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {checklistItems.map(item => (
            <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 8, background: item.ok ? COLORS.green + "08" : COLORS.red + "08", border: `1px solid ${item.ok ? COLORS.green + "33" : COLORS.red + "33"}` }}>
              <div style={{ width: 26, height: 26, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, background: item.ok ? COLORS.green : COLORS.red + "22", border: `2px solid ${item.ok ? COLORS.green : COLORS.red}` }}>
                {item.ok ? "✓" : "!"}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: item.ok ? COLORS.green : COLORS.text }}>{item.label}</div>
                <div style={{ fontSize: 11, color: COLORS.muted }}>{item.desc}</div>
              </div>
              {!item.ok && item.tab !== null && setActiveTab && (
                <button onClick={() => setActiveTab(item.tab)}
                  style={{ ...styles.btn("primary"), fontSize: 11, padding: "5px 10px", flexShrink: 0, background: COLORS.red }}>
                  Aller → {item.tabLabel}
                </button>
              )}
              {!item.ok && item.tab === null && item.id === "synthese" && (
                <div style={{ fontSize: 11, color: COLORS.muted, fontStyle: "italic" }}>Ci-dessous ↓</div>
              )}
              {!item.ok && item.tab === null && item.id === "diagnostiqueur" && (
                <div style={{ fontSize: 11, color: COLORS.muted, fontStyle: "italic" }}>Ci-dessous ↓</div>
              )}
            </div>
          ))}
        </div>

        {/* Message si bloqué */}
        {!canGenerate && (
          <div style={{ marginTop: 12, padding: "10px 14px", borderRadius: 8, background: COLORS.red + "15", border: `1px solid ${COLORS.red}44`, fontSize: 12, color: COLORS.red, fontWeight: 600 }}>
            ❌ Complétez au minimum les 4 premières étapes pour générer le rapport (DPE, propriétaire, travaux, DPE projeté).
          </div>
        )}
      </div>

      {/* Indicateur de mode */}
      {modeImport ? (
        <div style={{ padding: "10px 14px", borderRadius: 10, background: COLORS.green + "15", border: `1px solid ${COLORS.green}44`, marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 18 }}>✅</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.green }}>Mode Import ADEME/XML — Validation simplifiée</div>
            <div style={{ fontSize: 11, color: COLORS.muted }}>DPE {lettre} · {consoVal} kWh/m²/an · {data.surface} m² · N° {data.ademe_numero}</div>
          </div>
        </div>
      ) : (
        <div style={{ padding: "10px 14px", borderRadius: 10, background: COLORS.accent + "15", border: `1px solid ${COLORS.accent}44`, marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 18 }}>📝</span>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.accent }}>Mode Saisie Complète — Validation exhaustive</div>
            <div style={{ fontSize: 11, color: COLORS.muted }}>Vérifiez tous les points avant de générer le rapport</div>
          </div>
        </div>
      )}
      <div style={styles.card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={styles.cardTitle}>👤 Coordonnées du diagnostiqueur</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {diag.nom && (
              <span style={{ fontSize: 11, fontWeight: 700, color: COLORS.green, background: COLORS.green + "15", padding: "3px 10px", borderRadius: 20, border: `1px solid ${COLORS.green}33` }}>
                ✅ Profil sauvegardé
              </span>
            )}
            {diag.nom && (
              <button onClick={() => {
                if (window.confirm("Effacer le profil diagnostiqueur ?")) {
                  try { localStorage.removeItem("fndi_diag_profil"); } catch {}
                  setDiag({});
                  setLogoPreview(null); setLogoBase64(null);
                }
              }} style={{ background: "none", border: "none", color: COLORS.muted, cursor: "pointer", fontSize: 12 }}>
                🗑️ Effacer
              </button>
            )}
          </div>
        </div>

        {/* Logo upload */}
        <div style={{ marginBottom: 16 }}>
          <label style={styles.label}>Logo de la société</label>
          <div style={{
            display: "flex", gap: 12, alignItems: "center",
            padding: 12, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}`,
          }}>
            {logoPreview
              ? <img alt="" src={logoPreview} style={{ height: 56, maxWidth: 140, objectFit: "contain", borderRadius: 6 }} />
              : <div style={{ width: 100, height: 56, background: COLORS.card, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", color: COLORS.muted, fontSize: 12 }}>Aucun logo</div>}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <button onClick={() => logoRef.current?.click()} style={{ ...styles.btn("primary"), fontSize: 12, padding: "8px 14px" }}>
                📁 Choisir un logo
              </button>
              {logoPreview && (
                <button onClick={() => { setLogoPreview(null); setLogoBase64(null); onDiagChange("logoBase64", null); }}
                  style={{ ...styles.btn("secondary"), fontSize: 12, padding: "6px 14px", color: COLORS.red }}>
                  🗑️ Supprimer
                </button>
              )}
            </div>
          </div>
          <input ref={logoRef} type="file" accept="image/*" style={{ display: "none" }}
            onChange={e => handleLogoFile(e.target.files[0])} />
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>PNG, JPG — le logo apparaîtra en haut du rapport</div>
        </div>

        <div style={styles.row}>
          {inp("nom", "Nom du diagnostiqueur", "Prénom NOM")}
          {inp("certification", "N° certification", "ex: CERTIBAT-12345")}
        </div>
        {inp("entreprise", "Société / Entreprise", "ex: DPE Expert Île-de-France")}
        <AdresseAutocomplete
          label="Adresse professionnelle"
          value={diag.adresse_diag || ""}
          onChange={v => onDiagChange("adresse_diag", v)}
          onSelect={sel => onDiagChange("adresse_diag", sel.full)}
        />
        <div style={styles.row}>
          {inp("tel", "Téléphone", "ex: 06 12 34 56 78", "tel")}
          {inp("email", "Email", "ex: contact@dpe-expert.fr", "email")}
        </div>
        {inp("siret", "SIRET", "ex: 12345678900012")}
        {inp("assurance", "Assurance professionnelle", "ex: Allianz N° 123456789")}
      </div>

      {/* SYNTHÈSE IA */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>🤖 Synthèse IA pour le rapport</div>
        {!syntheseIA && !loadingSynthese && (
          <div style={{ padding: "8px 0 16px" }}>
            <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 10 }}>
              L'IA analyse toutes les données du dossier pour rédiger une synthèse professionnelle en 4 paragraphes :
              performance actuelle · déperditions · recommandations travaux · DPE projeté
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 14 }}>
              {[
                data.dpe_lettre && `⚡ DPE ${data.dpe_lettre} — ${consoVal} kWh/m²`,
                data.ademe_dep_mur && `🧱 Déperditions murs ${data.ademe_dep_mur}W/K`,
                data.ademe_dep_baie && `🪟 Baies ${data.ademe_dep_baie}W/K`,
                travaux.length > 0 && `🔨 ${travaux.length} travaux sélectionnés`,
                comments.length > 0 && `💬 ${comments.length} observations`,
                data.dpe_lettre_projete && `🔮 Projeté : classe ${data.dpe_lettre_projete}`,
              ].filter(Boolean).map((item, i) => (
                <span key={i} style={{ padding: "3px 8px", borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}`, fontSize: 11, fontWeight: 600 }}>{item}</span>
              ))}
            </div>
            <button onClick={generateSynthese} style={{ ...styles.btn("primary"), width: "100%" }}>
              ✨ Générer la synthèse IA
            </button>
          </div>
        )}
        {loadingSynthese && (
          <div style={{ textAlign: "center", padding: "20px", color: COLORS.muted }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>⏳</div>
            <div>Analyse du dossier et rédaction en cours…</div>
          </div>
        )}
        {syntheseIA && (
          <>
            <div style={styles.analysisBox}>{syntheseIA}</div>
            <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
              <button
                onClick={saveSynthese}
                disabled={syntheseSaved}
                style={{
                  ...styles.btn(syntheseSaved ? "secondary" : "primary"),
                  flex: 1,
                  minWidth: 130,
                  background: syntheseSaved ? "#22c55e" : undefined,
                  color: syntheseSaved ? "#fff" : undefined,
                  cursor: syntheseSaved ? "default" : "pointer",
                  transition: "all 0.2s",
                }}>
                {syntheseSaved ? "✓ Enregistrée" : "💾 Enregistrer"}
              </button>
              <button onClick={generateSynthese} style={{ ...styles.btn("secondary"), flex: 1, minWidth: 110 }}>🔄 Régénérer</button>
              <button onClick={clearSynthese} style={{ ...styles.btn("secondary"), flex: 1, minWidth: 110, color: COLORS.red }}>🗑️ Supprimer</button>
            </div>
            <div style={{ fontSize: 10.5, color: COLORS.muted, marginTop: 8, fontStyle: "italic" }}>
              💡 La synthèse est sauvegardée automatiquement après génération. Le bouton Enregistrer force une nouvelle sauvegarde.
            </div>
          </>
        )}
      </div>

      {/* APERÇU DU RAPPORT */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📄 Aperçu & génération du rapport</div>

        {/* Résumé de ce qui sera inclus */}
        <div style={{ padding: 12, borderRadius: 10, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 16 }}>
          {[
            ["👤 Propriétaire", (data.proprio_prenom || data.proprio_nom) ? `${data.proprio_prenom || ""} ${data.proprio_nom || ""}`.trim() : "—"],
            ["📍 Adresse logement", data.adresse ? `${data.adresse}, ${data.commune || ""}` : "—"],
            ["🏠 Surface", data.surface ? `${data.surface} m²` : "—"],
            ["⚡ Classe DPE", data.dpe_lettre || cls.label],
            ["💨 Classe GES", data.ges_lettre || cls.label],
            ["💰 Coût annuel", data.dpe_cout_min ? `${data.dpe_cout_min}–${data.dpe_cout_max} €/an` : "—"],
            ["💬 Commentaires", `${comments.length} observation${comments.length > 1 ? "s" : ""}`],
            ["🔨 Travaux", `${travaux.length} travaux préconisés`],
            ["📊 Synthèse IA", syntheseIA ? "✅ Incluse" : "Non générée"],
            ["🖼️ Logo", logoPreview ? "✅ Présent" : "Non chargé"],
          ].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "5px 0", borderBottom: `1px solid ${COLORS.border}` }}>
              <span style={{ color: COLORS.muted }}>{k}</span>
              <span style={{ fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>

        {!isReady && (
          <div style={{ padding: "10px 14px", borderRadius: 8, background: COLORS.orange + "15", color: COLORS.orange, fontSize: 13, marginBottom: 12 }}>
            ⚠️ Complétez au moins la surface et la classe DPE dans l'onglet Logement / Résultat avant de générer le rapport.
          </div>
        )}

        {/* Bouton ouvrir validation */}
        {!showValidation && (
          <button
            onClick={() => setShowValidation(true)}
            disabled={!isReady}
            style={{ ...styles.btn("primary"), width: "100%", fontSize: 15, padding: "16px", marginBottom: 10 }}
          >
            ✅ Valider les recommandations avant génération
          </button>
        )}

        {/* Écran de validation */}
        {showValidation && (
          <div style={{ background: COLORS.surface, borderRadius: 14, border: `2px solid ${allChecked ? COLORS.green : COLORS.accent}`, padding: 16, marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: allChecked ? COLORS.green : COLORS.accent }}>
                  {allChecked ? "✅ Validation complète" : "📋 Validation diagnostiqueur"}
                </div>
                <div style={{ fontSize: 12, color: COLORS.muted, marginTop: 2 }}>
                  {checkedCount}/{VALIDATION_ITEMS.length} points validés
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={checkAll}
                  style={{ ...styles.btn("secondary"), fontSize: 12, padding: "6px 12px" }}>
                  ☑️ Tout valider
                </button>
                <button onClick={() => setShowValidation(false)}
                  style={{ background: "none", border: "none", color: COLORS.muted, cursor: "pointer", fontSize: 18 }}>×</button>
              </div>
            </div>

            {/* Barre de progression */}
            <div style={{ height: 6, borderRadius: 4, background: COLORS.card, marginBottom: 16, overflow: "hidden" }}>
              <div style={{
                height: "100%", borderRadius: 4, transition: "width 0.3s",
                background: allChecked ? COLORS.green : COLORS.accent,
                width: `${(checkedCount / VALIDATION_ITEMS.length) * 100}%`,
              }} />
            </div>

            {/* Items par catégorie */}
            {cats.map(cat => (
              <div key={cat} style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.muted, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>
                  {cat}
                </div>
                {VALIDATION_ITEMS.filter(i => i.cat === cat).map(item => {
                  const checked = validations[item.id];
                  return (
                    <div key={item.id} onClick={() => toggleVal(item.id)}
                      style={{
                        display: "flex", alignItems: "flex-start", gap: 10, padding: "9px 12px",
                        marginBottom: 5, borderRadius: 8, cursor: "pointer",
                        background: checked ? COLORS.green + "11" : COLORS.card,
                        border: `1px solid ${checked ? COLORS.green + "44" : COLORS.border}`,
                        transition: "all 0.15s",
                      }}>
                      <div style={{
                        width: 20, height: 20, borderRadius: 5, flexShrink: 0, marginTop: 1,
                        background: checked ? COLORS.green : "transparent",
                        border: `2px solid ${checked ? COLORS.green : COLORS.muted}`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 12, color: "#fff", fontWeight: 900,
                      }}>{checked ? "✓" : ""}</div>
                      <div style={{ fontSize: 13, color: checked ? COLORS.text : COLORS.muted, lineHeight: 1.4 }}>
                        {item.label}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}

            {/* Bouton générer — seulement si tout validé */}
            {allChecked && canGenerate && (
              <button
                onClick={generateRapport}
                disabled={generating}
                style={{ ...styles.btn("primary"), width: "100%", fontSize: 15, padding: "16px", marginTop: 14, background: COLORS.green, color: "#fff" }}
              >
                {generating ? "⏳ Génération du PDF…" : "📥 Validation confirmée — Télécharger le rapport PDF"}
              </button>
            )}

            {/* Bouton direct sans validation complète */}
            {!allChecked && canGenerate && (
              <button
                onClick={generateRapport}
                disabled={generating}
                style={{ ...styles.btn("secondary"), width: "100%", fontSize: 13, padding: "12px", marginTop: 8 }}
              >
                {generating ? "⏳ Génération du PDF…" : "📥 Télécharger le rapport PDF"}
              </button>
            )}

            {/* Bouton bloqué si pas assez d'infos */}
            {!canGenerate && (
              <div style={{ padding: "14px", borderRadius: 10, background: COLORS.red + "15", border: `1px solid ${COLORS.red}44`, textAlign: "center", marginTop: 8 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.red, marginBottom: 4 }}>❌ Rapport incomplet</div>
                <div style={{ fontSize: 12, color: COLORS.muted }}>Complétez les étapes manquantes ci-dessus avant de générer.</div>
              </div>
            )}
          </div>
        )}

        <div style={{ fontSize: 11, color: COLORS.muted, textAlign: "center", marginTop: 8 }}>
          Le rapport s'ouvrira dans un nouvel onglet — utilisez <strong>Fichier → Imprimer → Enregistrer en PDF</strong> pour l'exporter.
        </div>
      </div>
    </div>
  );
}

// ---- App ----
// ---- Panneau Admin ----

// ═══════════════════════════════════════════════════════════════════════
// MODULE AMIANTE — Bibliothèque NFX 46-020 + Veille réglementaire IA
// ═══════════════════════════════════════════════════════════════════════

const AMIANTE_MATERIALS = [
  // ── LISTE A ──
  { id:"calorifugeage", name:"Calorifugeage", list:"A", family:"Isolation thermique",
    location:"Tuyauteries, chaufferies, sous-sols, locaux techniques", period:"Avant 1997", risk:"Élevé",
    status:"Friable possible", sampling:"Prélèvement si doute",
    description:"Enrobage isolant autour de canalisations ou équipements. Peut être très friable et libérer des fibres lors d'une dégradation.",
    indices:["Aspect fibreux ou cotonneux","Enveloppe plâtreuse ou textile","Dégradation en poussière","Présence en chaufferie"],
    action:"Évaluation état de conservation. Analyse si doute. Intervention avec protocole adapté.",
    csi:"1—Bon état : surveillance\n2—Dégradation légère : analyse + action sous 3 ans\n3—Dégradation importante : retrait",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706' rx='4'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309' rx='4'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706' rx='4'/%3E%3Ctext x='200' y='290' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3ECalorifugeage%3C/text%3E%3C/svg%3E"] },

  { id:"faux-plafond", name:"Faux plafond (dalles)", list:"A", family:"Plafond",
    location:"Bureaux, ERP, circulations, parties communes", period:"Avant 1997", risk:"Élevé",
    status:"Friable possible", sampling:"Analyse si doute",
    description:"Dalles de faux plafond pouvant contenir de l'amiante. Surveillance prioritaire.",
    indices:["Dalles suspendues anciennes","Bords friables","Aspect fibreux","Ossature métallique"],
    action:"Évaluation conservation selon grille réglementaire.",
    csi:"1—Surveillance triennale\n2—Mesures conservatoires\n3—Retrait",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='30' width='400' height='100' fill='%234b5563'/%3E%3Cline x1='100' y1='30' x2='100' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='200' y1='30' x2='200' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='300' y1='30' x2='300' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='0' y1='80' x2='400' y2='80' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='200' y1='130' x2='200' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='130' x2='100' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='300' y1='130' x2='300' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Ctext x='200' y='270' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaux plafond%3C/text%3E%3C/svg%3E"] },

  { id:"flocage", name:"Flocage", list:"A", family:"Protection incendie / isolation",
    location:"Structures métalliques, plafonds, parkings, sous-sols", period:"Avant 1997", risk:"Très élevé",
    status:"Friable", sampling:"Prélèvement fortement recommandé",
    description:"Matériau projeté très friable pour protection incendie. Libère des fibres par vieillissement.",
    indices:["Aspect mousseux ou laineux","Application projetée","Support métal ou béton","Chutes ou poussières"],
    action:"Priorité de repérage. Ne pas toucher sans protocole. Retrait ou confinement.",
    csi:"1—Mesures empoussièrement\n2—Confinement immédiat\n3—Retrait immédiat",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3Crect x='60' y='130' width='240' height='20' fill='%236b7280'/%3E%3Crect x='60' y='230' width='240' height='30' fill='%236b7280'/%3E%3Ctext x='200' y='285' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EFlocage / structure%3C/text%3E%3C/svg%3E"] },

  { id:"paroi-amiante-ciment-int", name:"Paroi / cloison amiante-ciment (intérieur)", list:"B", family:"Paroi intérieure",
    location:"Locaux techniques, couloirs, sous-sols, bâtiments industriels", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant intervention",
    description:"Cloison ou paroi intérieure en fibrociment pouvant libérer des fibres par perçage ou dégradation.",
    indices:["Plaque grise uniforme","Bords nets ou sciés","Zone technique","Texture dense"],
    action:"Identifier avant perçage ou retrait.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563' rx='4'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='290' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Ctext x='200' y='200' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaçade fibrociment%3C/text%3E%3C/svg%3E"] },

  // ── LISTE B — TOITURE ──
  { id:"ardoise-fibrociment", name:"Ardoise artificielle en fibrociment", list:"B", family:"Toiture",
    location:"Couvertures, façades, maisons, immeubles anciens", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux",
    description:"Élément de couverture imitant l'ardoise naturelle. Les modèles anciens peuvent contenir de l'amiante.",
    indices:["Format régulier non naturel","Aspect gris mat","Bords artificiels","Marquage fabricant possible"],
    action:"Comparer avec documents fabricant. Analyser si doute avant travaux.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"plaque-fibrociment", name:"Plaque ondulée en fibrociment", list:"B", family:"Toiture / enveloppe",
    location:"Toitures, bardages, garages, annexes, bâtiments agricoles", period:"Avant 1997", risk:"Moyen",
    status:"Non friable, dégradable", sampling:"Analyse si doute",
    description:"Plaque ciment renforcée par fibres, très répandue en couverture. Risque si cassée ou découpée.",
    indices:["Plaque grise ondulée","Aspect ciment","Bords fibreux si cassée","Vieillissement blanchâtre"],
    action:"Repérage, état de conservation, analyse si doute.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"faitages-fibrociment", name:"Faîtages et accessoires toiture en fibrociment", list:"B", family:"Toiture",
    location:"Faîtières, arêtiers, solins", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux toiture",
    description:"Pièces accessoires de toiture en fibrociment pouvant contenir de l'amiante.",
    indices:["Pièce ciment grise","Profil faîte ou arête","Vieillissement blanchâtre"],
    action:"Repérage visuel et analyse avant intervention de couverture.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"feutre-bitumeux", name:"Feutre bitumeux sous toiture", list:"B", family:"Toiture / sous-couche",
    location:"Sous couverture, sarking, toitures en pente", period:"Avant 1997", risk:"Moyen",
    status:"Caché sous tuiles", sampling:"Prélèvement avant dépose couverture",
    description:"Sous-couche bitumineuse posée sous les tuiles pouvant contenir de l'amiante.",
    indices:["Feutre noir sous tuiles","Matériau souple dense","Application ancienne"],
    action:"Prélèvement avant dépose ou réfection de couverture.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"fibro-chapeaux-cheminee", name:"Chapeaux de cheminée en fibrociment", list:"B", family:"Toiture / cheminée",
    location:"Couronnement de cheminées, souches de toiture", period:"Avant 1997", risk:"Moyen",
    status:"Dégradé par intempéries", sampling:"Analyse avant remplacement",
    description:"Chapeaux anti-pluie et couvre-cheminée en fibrociment souvent dégradés.",
    indices:["Chapeau gris sur cheminée","Forme conique ou plate","Dégradation blanchâtre"],
    action:"Identifier avant remplacement ou travaux sur souche.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  // ── LISTE B — FACADE ──
  { id:"bardage-fibrociment", name:"Bardage en fibrociment", list:"B", family:"Façade / bardage",
    location:"Façades de maisons, bâtiments industriels, extensions", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant perçage",
    description:"Panneaux de bardage en fibrociment fixés en façade. Risque lors de perçage ou retrait.",
    indices:["Plaques grises en façade","Surface lisse ou texturée","Fixation par vissage"],
    action:"Repérage, état de conservation, prélèvement avant intervention.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563' rx='4'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='290' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Ctext x='200' y='200' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaçade fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"elements-facade", name:"Éléments de façade (allèges, appuis fenêtres)", list:"B", family:"Façade",
    location:"Sous-fenêtres, appuis, allèges, soubassements", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant remplacement menuiserie",
    description:"Éléments préfabriqués de façade en fibrociment, notamment sous les fenêtres.",
    indices:["Panneau sous fenêtre","Finition ciment lisse","Dégradation en surface"],
    action:"Prélèvement avant perçage ou remplacement de menuiserie.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563' rx='4'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='290' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Ctext x='200' y='200' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaçade fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"fibro-panneaux-sandwich", name:"Panneaux sandwich avec âme fibrociment", list:"B", family:"Façade / isolation",
    location:"Façades industrielles, bardages sandwich", period:"Avant 1997", risk:"Moyen",
    status:"Composant intégré", sampling:"Analyse avant perçage ou dépose",
    description:"Panneaux sandwich dont les parements peuvent contenir du fibrociment amianté.",
    indices:["Panneau multicouche en façade","Parement gris","Fixation par visserie"],
    action:"Analyser les différentes couches avant perçage ou dépose.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563' rx='4'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Crect x='290' y='60' width='80' height='60' fill='%236b7280' rx='2'/%3E%3Ctext x='200' y='200' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaçade fibrociment%3C/text%3E%3C/svg%3E"] },

  // ── LISTE B — SOL ──
  { id:"dalle-sol-vinyle", name:"Dalle de sol vinyle-amiante", list:"B", family:"Revêtement de sol",
    location:"Logements, bureaux, écoles, circulations", period:"Années 1950 à 1980", risk:"Moyen",
    status:"Non friable, risque travaux", sampling:"Prélèvement matériau + colle avant retrait",
    description:"Dalles plastiques anciennes pouvant contenir de l'amiante, souvent associées à une colle amiantée.",
    indices:["Format 20×20 ou 30×30 cm","Motifs mouchetés","Dalles cassantes","Colle noire dessous"],
    action:"Prélèvement matériau et colle avant retrait ou travaux.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='300' y1='150' x2='300' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='400' y2='200' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='400' y2='250' stroke='%236b7280' stroke-width='1'/%3E%3Ctext x='200' y='100' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EDalle vinyle amiante%3C/text%3E%3C/svg%3E"] },

  { id:"colle-bitumineuse", name:"Colle bitumineuse noire", list:"B", family:"Revêtement de sol",
    location:"Sous dalles vinyle, sols anciens", period:"Années 1950 à 1990", risk:"Moyen",
    status:"Caché sous revêtement", sampling:"Prélèvement spécifique recommandé",
    description:"Colle noire sous revêtement de sol pouvant être amiantée même si la dalle ne l'est pas.",
    indices:["Couleur noire ou brun foncé","Aspect goudronneux","Adhérence très forte"],
    action:"Prélèvement avant tous travaux sur sol.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%231a1a1a'/%3E%3Crect x='0' y='200' width='400' height='100' fill='%23111'/%3E%3Cellipse cx='200' cy='200' rx='180' ry='30' fill='%23222'/%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23888' font-size='14' font-family='Arial'%3EColle bitumineuse%3C/text%3E%3Ctext x='200' y='175' text-anchor='middle' fill='%23555' font-size='11' font-family='Arial'%3ENoire - sous revêtement%3C/text%3E%3C/svg%3E"] },

  { id:"vinyl-rouleau", name:"Revêtement sol vinyle-amiante en rouleau", list:"B", family:"Revêtement de sol",
    location:"Logements, couloirs, locaux anciens", period:"Années 1950 à 1985", risk:"Moyen",
    status:"Non friable, risque à la dépose", sampling:"Prélèvement avant retrait",
    description:"Revêtement de sol souple en rouleau pouvant contenir de l'amiante.",
    indices:["Revêtement plastique épais ancien","Difficile à décoller","Odeur bitumineuse"],
    action:"Prélèvement avant retrait ou pose par-dessus.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='300' y1='150' x2='300' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='400' y2='200' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='400' y2='250' stroke='%236b7280' stroke-width='1'/%3E%3Ctext x='200' y='100' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EDalle vinyle amiante%3C/text%3E%3C/svg%3E"] },

  { id:"colle-moquette", name:"Colle de moquette ancienne", list:"B", family:"Revêtement de sol",
    location:"Sous moquette collée, bureaux, couloirs", period:"Avant 1997", risk:"Moyen",
    status:"Caché sous moquette", sampling:"Prélèvement avant retrait de moquette",
    description:"Colles de pose de moquettes collées pouvant contenir de l'amiante.",
    indices:["Moquette collée ancienne","Colle visible au bord","Résistance au décollement"],
    action:"Prélèvement avant retrait. Ne pas gratter sans protection.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%231a1a1a'/%3E%3Crect x='0' y='200' width='400' height='100' fill='%23111'/%3E%3Cellipse cx='200' cy='200' rx='180' ry='30' fill='%23222'/%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23888' font-size='14' font-family='Arial'%3EColle bitumineuse%3C/text%3E%3Ctext x='200' y='175' text-anchor='middle' fill='%23555' font-size='11' font-family='Arial'%3ENoire - sous revêtement%3C/text%3E%3C/svg%3E"] },

  { id:"sous-couche-acoustique", name:"Sous-couche acoustique sous parquet", list:"B", family:"Revêtement de sol",
    location:"Sous parquet, sous revêtement flottant", period:"Avant 1997", risk:"Moyen",
    status:"Caché sous revêtement", sampling:"Prélèvement avant dépose parquet",
    description:"Sous-couches acoustiques anciennes pouvant contenir de l'amiante.",
    indices:["Feutre sous parquet","Matériau gris dense","Application ancienne"],
    action:"Prélèvement avant dépose de revêtement.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='300' y1='150' x2='300' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='400' y2='200' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='400' y2='250' stroke='%236b7280' stroke-width='1'/%3E%3Ctext x='200' y='100' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EDalle vinyle amiante%3C/text%3E%3C/svg%3E"] },

  { id:"colle-carrelage", name:"Colle de carrelage ancienne", list:"B", family:"Revêtement de sol / mur",
    location:"Sous carrelage mural ou de sol", period:"Avant 1997", risk:"Moyen",
    status:"Caché sous carrelage", sampling:"Prélèvement avant retrait carrelage",
    description:"Colles anciennes pour pose de carrelage pouvant contenir de l'amiante.",
    indices:["Carrelage posé avant 1997","Colle épaisse grise ou blanche","Dégradation au décollement"],
    action:"Prélèvement avant retrait de carrelage.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%231a1a1a'/%3E%3Crect x='0' y='200' width='400' height='100' fill='%23111'/%3E%3Cellipse cx='200' cy='200' rx='180' ry='30' fill='%23222'/%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23888' font-size='14' font-family='Arial'%3EColle bitumineuse%3C/text%3E%3Ctext x='200' y='175' text-anchor='middle' fill='%23555' font-size='11' font-family='Arial'%3ENoire - sous revêtement%3C/text%3E%3C/svg%3E"] },

  // ── LISTE B — CONDUITS ──
  { id:"conduit-fibrociment", name:"Conduit en fibrociment (ventilation/fumée)", list:"B", family:"Conduit / canalisation",
    location:"Ventilation, évacuation, toiture, gaines techniques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse si doute",
    description:"Conduit rigide en fibrociment pour ventilation ou évacuation des fumées.",
    indices:["Aspect gris ciment","Surface légèrement fibreuse","Conduit rigide et lourd","Vieillissement poudreux"],
    action:"Identifier, localiser, évaluer l'état et analyser si nécessaire.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3Ctext x='200' y='280' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EConduit fibrociment%3C/text%3E%3C/svg%3E"] },

  // ── LISTE B — JOINTS / ÉQUIPEMENTS ──
  { id:"joint-amiante", name:"Joint amianté", list:"B", family:"Joint / étanchéité",
    location:"Chaudières, portes coupe-feu, brides, conduits", period:"Avant 1997", risk:"Moyen",
    status:"Variable", sampling:"Analyse documentaire ou prélèvement",
    description:"Joint plat, tressé ou compressé pouvant contenir de l'amiante.",
    indices:["Joint fibreux blanc ou gris","Présence sur brides","Tressage visible","Équipement ancien"],
    action:"Prélèvement ou analyse documentaire avant intervention.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3Ctext x='200' y='260' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EJoint amianté%3C/text%3E%3C/svg%3E"] },

  { id:"porte-coupe-feu", name:"Porte coupe-feu", list:"B", family:"Menuiserie technique",
    location:"Locaux techniques, parkings, cages d'escalier, ERP", period:"Avant 1997", risk:"Moyen",
    status:"Composant intégré", sampling:"Vérification documentaire avant dépose",
    description:"Portes coupe-feu anciennes pouvant intégrer des plaques ou joints amiantés.",
    indices:["Porte lourde ancienne","Joint périphérique","Local technique","Absence fiche fabricant"],
    action:"Vérification documentaire avant percement ou dépose.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='100' y='40' width='200' height='240' fill='%234b5563' rx='4'/%3E%3Crect x='110' y='50' width='80' height='100' fill='%236b7280' rx='2'/%3E%3Crect x='210' y='50' width='80' height='100' fill='%236b7280' rx='2'/%3E%3Crect x='110' y='160' width='80' height='100' fill='%236b7280' rx='2'/%3E%3Crect x='210' y='160' width='80' height='100' fill='%236b7280' rx='2'/%3E%3Ccircle cx='290' cy='170' r='8' fill='%23d97706'/%3E%3Ctext x='200' y='295' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EPorte coupe-feu%3C/text%3E%3C/svg%3E"] },

  { id:"clapet-coupe-feu", name:"Clapet / volet coupe-feu", list:"B", family:"Équipement technique",
    location:"Gaines techniques, réseaux de ventilation", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement si nécessaire",
    description:"Équipement coupe-feu pouvant comporter des plaques ou joints amiantés.",
    indices:["Présence dans gaine","Plaques internes","Joints anciens","Marquage technique ancien"],
    action:"Repérage visuel et prélèvement si nécessaire.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3Crect x='60' y='130' width='240' height='20' fill='%236b7280'/%3E%3Crect x='60' y='230' width='240' height='30' fill='%236b7280'/%3E%3Ctext x='200' y='285' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EFlocage / structure%3C/text%3E%3C/svg%3E"] },

  { id:"tableau-electrique", name:"Tableau électrique (fond de tableau)", list:"B", family:"Électricité",
    location:"Locaux techniques, logements, parties communes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant modification",
    description:"Fonds de tableaux électriques anciens en carton ou plaque ignifuge pouvant contenir de l'amiante.",
    indices:["Tableau ancien en métal","Fond gris ou beige","Plaques vissées","Absence marquage CE"],
    action:"Analyse avant modification ou remplacement.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3Crect x='60' y='130' width='240' height='20' fill='%236b7280'/%3E%3Crect x='60' y='230' width='240' height='30' fill='%236b7280'/%3E%3Ctext x='200' y='285' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EFlocage / structure%3C/text%3E%3C/svg%3E"] },

  { id:"garniture-freinage", name:"Garniture de freinage (ascenseurs)", list:"B", family:"Équipement mécanique",
    location:"Ascenseurs, monte-charges, équipements industriels", period:"Avant 1997", risk:"Moyen",
    status:"Variable selon usure", sampling:"Consultation fabricant avant intervention",
    description:"Pièces de friction pouvant contenir de l'amiante dans les équipements anciens.",
    indices:["Équipement de levage ancien","Pièce de friction grisâtre","Poussière lors du fonctionnement"],
    action:"Consultation documentaire. Prélèvement ou remplacement préventif.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3Ctext x='200' y='260' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EJoint amianté%3C/text%3E%3C/svg%3E"] },

  { id:"plaques-coupe-feu", name:"Plaques coupe-feu (Sokalit, Marinite)", list:"B", family:"Protection incendie",
    location:"Derrière chaudières, poêles, habillages", period:"Avant 1997", risk:"Moyen",
    status:"Non friable sauf dégradation", sampling:"Analyse avant remplacement",
    description:"Plaques de protection thermique et coupe-feu contenant de l'amiante.",
    indices:["Plaque derrière chaudière","Couleur blanc cassé ou grise","Marquage fabricant","Bords sciés"],
    action:"Ne pas scier ni percer sans analyse.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3Crect x='60' y='130' width='240' height='20' fill='%236b7280'/%3E%3Crect x='60' y='230' width='240' height='30' fill='%236b7280'/%3E%3Ctext x='200' y='285' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EFlocage / structure%3C/text%3E%3C/svg%3E"] },

  { id:"dalle-terrasse", name:"Dalle de terrasse en fibrociment", list:"B", family:"Terrasse / balcon",
    location:"Terrasses, balcons, toitures accessibles", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant dépose",
    description:"Dalles de finition sur terrasse ou balcon en fibrociment.",
    indices:["Dalle grise ancienne","Terrasse non rénovée","Fissuration ou érosion"],
    action:"Prélèvement avant travaux ou dépose.",
    csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='300' y1='150' x2='300' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='400' y2='200' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='400' y2='250' stroke='%236b7280' stroke-width='1'/%3E%3Ctext x='200' y='100' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EDalle vinyle amiante%3C/text%3E%3C/svg%3E"] },

  { id:"fibro-bacs-fleurs", name:"Bacs à fleurs en fibrociment", list:"B", family:"Divers / extérieur",
    location:"Jardin, terrasses, balcons", period:"Avant 1997", risk:"Faible",
    status:"Non friable", sampling:"Identification lors repérage",
    description:"Bacs à fleurs en fibrociment souvent oubliés lors du repérage.",
    indices:["Bac gris lourd","Surface rugueuse","Extérieur bâtiment"],
    action:"Identifier et signaler. Éviter cassure ou perçage.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EToiture fibrociment%3C/text%3E%3C/svg%3E"] },

  { id:"fibro-reservoirs", name:"Réservoirs et cuves en fibrociment", list:"B", family:"Divers / technique",
    location:"Combles, extérieur, locaux techniques", period:"Avant 1997", risk:"Faible",
    status:"Non friable en service", sampling:"Identification avant retrait",
    description:"Cuves et réservoirs en fibrociment.",
    indices:["Cuve grise lourde","Couvercle fibrociment","En combles ou extérieur"],
    action:"Identifier avant retrait ou vidange.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3Ctext x='200' y='280' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EConduit fibrociment%3C/text%3E%3C/svg%3E"] },

  // ── LISTE C ──
  { id:"mastic-peinture-facade", name:"Mastic, enduit ou peinture texturée", list:"C", family:"Finition / façade",
    location:"Façades, menuiseries, murs intérieurs", period:"Avant 1997", risk:"Variable",
    status:"Souvent caché", sampling:"Selon périmètre travaux",
    description:"Produits de finition susceptibles de contenir de l'amiante.",
    indices:["Aspect épais ou graveleux","Texture granuleuse","Application ancienne"],
    action:"Intégrer dans le programme de repérage avant travaux.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='url(%23g)'/%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23555'/%3E%3Cstop offset='1' stop-color='%23333'/%3E%3C/linearGradient%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EEnduit - Finition%3C/text%3E%3C/svg%3E"] },

  { id:"enduit-lissage", name:"Enduit de lissage intérieur", list:"C", family:"Finition intérieure",
    location:"Murs et plafonds intérieurs", period:"Avant 1997", risk:"Variable",
    status:"Caché sous peinture", sampling:"Prélèvement avant travaux",
    description:"Enduit de lissage fin pouvant contenir de l'amiante. Distinct du ragréage.",
    indices:["Couche fine de finition","Aspect très lisse","Sur support plâtre ou béton"],
    action:"Prélèvement spécifique avant décapage ou démolition.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='url(%23g)'/%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23555'/%3E%3Cstop offset='1' stop-color='%23333'/%3E%3C/linearGradient%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EEnduit - Finition%3C/text%3E%3C/svg%3E"] },

  { id:"enduit-ragreage", name:"Enduit de ragréage", list:"C", family:"Finition sol / mur",
    location:"Sols, murs, correction de support", period:"Avant 1997", risk:"Variable",
    status:"Caché sous revêtement", sampling:"Prélèvement distinct de la colle et du revêtement",
    description:"Produit de ragréage pour rattraper les niveaux. À distinguer de l'enduit de lissage.",
    indices:["Couche épaisse sous revêtement","Aspect granuleux ou poreux","Support irrégulier comblé"],
    action:"Prélèvement distinct avant travaux.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='url(%23g)'/%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23555'/%3E%3Cstop offset='1' stop-color='%23333'/%3E%3C/linearGradient%3E%3Ctext x='200' y='150' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EEnduit - Finition%3C/text%3E%3C/svg%3E"] },

  { id:"beton-ragreage", name:"Béton de ragréage (chape)", list:"C", family:"Sol / structure",
    location:"Sols industriels, dalles béton, corrections de niveau", period:"Avant 1997", risk:"Variable",
    status:"Caché ou apparent", sampling:"Prélèvement avant sciage ou démolition chape",
    description:"Chape ou béton de ragréage pouvant contenir de l'amiante. Distinct de l'enduit mince.",
    indices:["Chape épaisse sur dalle","Surface rugueuse","Épaisseur > 1 cm"],
    action:"Prélèvement spécifique avant sciage ou démolition.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='300' y1='150' x2='300' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='200' x2='400' y2='200' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='0' y1='250' x2='400' y2='250' stroke='%236b7280' stroke-width='1'/%3E%3Ctext x='200' y='100' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EDalle vinyle amiante%3C/text%3E%3C/svg%3E"] },

  { id:"carton-papier-amiante", name:"Carton et papier amianté", list:"C", family:"Protection thermique",
    location:"Derrière radiateurs, équipements électriques", period:"Avant 1997", risk:"Variable",
    status:"Friable si dégradé", sampling:"Prélèvement avant retrait",
    description:"Feuilles ou cartons ignifuges contenant de l'amiante.",
    indices:["Feuille grise derrière radiateur","Aspect papier dense","Fragilité au toucher"],
    action:"Prélèvement avant retrait ou rénovation.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706' rx='4'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309' rx='4'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706' rx='4'/%3E%3Ctext x='200' y='290' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3ECalorifugeage%3C/text%3E%3C/svg%3E"] },

  { id:"joints-dilatation", name:"Joints de dilatation (sol, façade)", list:"C", family:"Joint / structure",
    location:"Jonctions structurelles, sols, façades", period:"Avant 1997", risk:"Variable",
    status:"Souple ou durci", sampling:"Selon périmètre de repérage",
    description:"Joints de dilatation entre éléments structurels pouvant contenir de l'amiante.",
    indices:["Joint souple entre dalles","Matériau gris ou beige","Application ancienne"],
    action:"Intégrer dans le programme avant démolition.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3Ctext x='200' y='260' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EJoint amianté%3C/text%3E%3C/svg%3E"] },

  { id:"dalle-plafond-acoustique", name:"Dalles acoustiques de plafond", list:"C", family:"Plafond acoustique",
    location:"Bureaux, salles de réunion, halls", period:"Avant 1997", risk:"Variable",
    status:"Non friable sauf dégradation", sampling:"Prélèvement avant retrait",
    description:"Dalles acoustiques perforées en fibres minérales pouvant contenir de l'amiante.",
    indices:["Dalles perforées en fibres","Aspect poreux acoustique","Teinte beige ou blanche"],
    action:"Prélèvement avant retrait dans le cadre de rénovation.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='30' width='400' height='100' fill='%234b5563'/%3E%3Cline x1='100' y1='30' x2='100' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='200' y1='30' x2='200' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='300' y1='30' x2='300' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='0' y1='80' x2='400' y2='80' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='200' y1='130' x2='200' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='130' x2='100' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='300' y1='130' x2='300' y2='220' stroke='%236b7280' stroke-width='2'/%3E%3Ctext x='200' y='270' text-anchor='middle' fill='%23d1d5db' font-size='14' font-family='Arial'%3EFaux plafond%3C/text%3E%3C/svg%3E"] },

  { id:"peinture-intumescente", name:"Peinture intumescente ancienne", list:"C", family:"Protection incendie",
    location:"Structures métalliques, charpentes, colonnes", period:"Avant 1997", risk:"Variable",
    status:"Sur structure acier", sampling:"Prélèvement avant décapage",
    description:"Peintures intumescentes anciennes pouvant contenir de l'amiante comme charge.",
    indices:["Peinture épaisse sur métal","Structure acier ancienne","Couleur grise ou blanche"],
    action:"Prélèvement avant décapage ou travaux sur structure.",
    csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3Crect x='60' y='130' width='240' height='20' fill='%236b7280'/%3E%3Crect x='60' y='230' width='240' height='30' fill='%236b7280'/%3E%3Ctext x='200' y='285' text-anchor='middle' fill='%23d1d5db' font-size='13' font-family='Arial'%3EFlocage / structure%3C/text%3E%3C/svg%3E"] },,
  // ══ LISTE B — MANQUANTS ══

  // TOITURE
  { id:"tuiles-fibrociment", name:"Tuiles en fibrociment", list:"B", family:"Toiture / couverture",
    location:"Toitures de maisons, bâtiments anciens", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux",
    description:"Tuiles de couverture en fibrociment pouvant contenir de l'amiante.",
    indices:["Aspect ciment gris ou coloré","Format régulier","Bords nets","Marquage fabricant possible"],
    action:"Identifier et analyser avant intervention sur toiture.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3C/svg%3E"] },

  { id:"plaques-planes-toiture", name:"Plaques planes de toiture en fibrociment", list:"B", family:"Toiture / couverture",
    location:"Toitures planes, locaux techniques, annexes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse si doute",
    description:"Plaques planes en fibrociment pour toiture ou usage technique.",
    indices:["Plaque plane grise","Surface lisse","Bords sciés","Épaisseur uniforme"],
    action:"Identifier avant perçage ou retrait.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3C/svg%3E"] },

  { id:"rives-bandes-toiture", name:"Rives et bandes de toiture en fibrociment", list:"B", family:"Toiture / couverture",
    location:"Bords de toiture, débords, habillages de rive", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Vérification avant travaux de couverture",
    description:"Éléments de finition de rive en fibrociment, souvent négligés lors du repérage.",
    indices:["Bande grise en bord de toiture","Profil de rive","Fixation par vissage"],
    action:"Repérer et analyser avant travaux de couverture.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3C/svg%3E"] },

  { id:"plaques-translucides", name:"Plaques translucides (renfort fibrociment)", list:"B", family:"Toiture / couverture",
    location:"Toitures, vérandas, abris de jardin, appentis", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse si doute avant travaux",
    description:"Plaques translucides de couverture pouvant être renforcées par des fibres d'amiante.",
    indices:["Plaque translucide jaunâtre","Renfort fibreux visible","Ancienne couverture véranda","Fragilité au choc"],
    action:"Identifier avant perçage ou remplacement.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cpolygon points='200,40 360,180 40,180' fill='%236b7280'/%3E%3Crect x='100' y='180' width='200' height='80' fill='%234b5563'/%3E%3C/svg%3E"] },

  // FACADE
  { id:"plaques-facade-decoratives", name:"Plaques décoratives de façade", list:"B", family:"Façade / bardage",
    location:"Façades de maisons individuelles, décoration extérieure", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant retrait ou perçage",
    description:"Plaques décoratives à motifs en fibrociment utilisées en habillage de façade.",
    indices:["Motifs décoratifs en façade","Aspect ciment","Format standardisé","Fixation ancienne"],
    action:"Identifier avant travaux de rénovation façade.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"revetements-muraux-ext", name:"Revêtements muraux extérieurs en fibrociment", list:"B", family:"Façade / bardage",
    location:"Façades extérieures, habillages muraux", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant perçage ou dépose",
    description:"Panneaux de revêtement mural extérieur en fibrociment, posés sur ossature.",
    indices:["Panneaux en façade","Surface lisse ou striée","Fixation par vis","Bords sciés"],
    action:"Repérage avant perçage, vissage ou dépose.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"plaques-remplissage-facade", name:"Plaques de remplissage (façade, menuiserie)", list:"B", family:"Façade / bardage",
    location:"Allèges, trumeaux, remplissages de menuiseries", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant remplacement menuiserie",
    description:"Plaques de remplissage entre menuiseries ou en allège de fenêtre en fibrociment.",
    indices:["Panneau sous fenêtre","Trumeau entre fenêtres","Matériau dense gris","Fixation encastrée"],
    action:"Analyser avant remplacement de menuiserie ou ravalement.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"habillages-colonnes", name:"Habillages de colonnes et poutres", list:"B", family:"Structure / façade",
    location:"Parkings, halls, bâtiments industriels, structures acier", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant perçage ou travaux sur structure",
    description:"Habillages de colonnes ou poutres en fibrociment pour protection incendie ou finition.",
    indices:["Plaque autour d'un poteau","Assemblage de plaques","Support acier","Aspect ciment"],
    action:"Identifier nature du matériau avant tout perçage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  // CANALISATIONS / CONDUITS
  { id:"descentes-eaux-pluviales", name:"Descentes d'eaux pluviales en fibrociment", list:"B", family:"Canalisation",
    location:"Façades, angles de bâtiment, évacuation toiture", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification avant remplacement",
    description:"Tuyaux de descente d'eaux pluviales en fibrociment fixés en façade.",
    indices:["Tuyau gris cylindrique en façade","Section ronde ou carrée","Raccords emboîtés"],
    action:"Identifier avant remplacement ou travaux de façade.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"tuyaux-pression-eau", name:"Tuyaux amiante-ciment sous pression (eau potable)", list:"B", family:"Canalisation eau",
    location:"Réseaux enterrés eau potable, distribution", period:"Avant 1997", risk:"Moyen",
    status:"Non friable en service", sampling:"Prélèvement lors de terrassement",
    description:"Canalisations en amiante-ciment pour eau potable sous pression, très répandues.",
    indices:["Tuyau gris dense lourd","Réseau enterré","Raccords en fonte","Section circulaire rigide"],
    action:"Repérage lors de terrassement. Prélèvement si doute.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"tuyaux-eu-ep", name:"Canalisations EU/EP en fibrociment", list:"B", family:"Canalisation",
    location:"Eaux usées et eaux pluviales, réseaux extérieurs", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification lors de travaux réseau",
    description:"Canalisations d'eaux usées ou pluviales en fibrociment en réseau enterré ou apparent.",
    indices:["Tuyau gris lourd","Raccords emboîtés","Réseau extérieur ou enterré"],
    action:"Prélèvement si doute lors de terrassement.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"conduits-fumee-fibrociment", name:"Conduits de fumée en fibrociment", list:"B", family:"Conduit technique",
    location:"Cheminées, conduits de fumée, locaux techniques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux sur conduit",
    description:"Conduits d'évacuation des fumées de chaudière en fibrociment.",
    indices:["Conduit gris en chaufferie","Raccords emboîtés","Présence en local chaudière"],
    action:"Identifier avant remplacement ou modification.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"gaines-vmc-fibrociment", name:"Gaines VMC en fibrociment", list:"B", family:"Ventilation",
    location:"Gaines de ventilation, combles, locaux techniques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant perçage ou intervention",
    description:"Gaines de ventilation mécanique en fibrociment dans les installations anciennes.",
    indices:["Gaine grise rectangulaire","Réseau de ventilation","Fixation par pattes","Installation ancienne"],
    action:"Identifier avant perçage ou travaux dans gaine.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='140' y='20' width='120' height='260' fill='%234b5563' rx='4'/%3E%3Crect x='155' y='35' width='90' height='230' fill='%23374151' rx='2'/%3E%3Crect x='100' y='100' width='40' height='20' fill='%236b7280'/%3E%3Crect x='260' y='100' width='40' height='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"fourreaux-electriques", name:"Fourreaux et conduits électriques en fibrociment", list:"B", family:"Électricité",
    location:"Gaines électriques enterrées, colonnes montantes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification avant travaux électriques",
    description:"Fourreaux de protection des câbles électriques en fibrociment.",
    indices:["Fourreau gris carré ou circulaire","Réseau enterré ou encastré","Installation ancienne"],
    action:"Identification avant tout travaux électriques.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='80' y='60' width='240' height='180' fill='%234b5563' rx='4'/%3E%3Crect x='100' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='170' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='240' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='100' y='130' width='200' height='8' fill='%23d97706' rx='2'/%3E%3Crect x='100' y='150' width='200' height='8' fill='%23d97706' rx='2'/%3E%3C/svg%3E"] },

  // PAROIS INTÉRIEURES
  { id:"cloisons-fibrociment", name:"Cloisons en fibrociment", list:"B", family:"Cloison intérieure",
    location:"Locaux techniques, caves, bâtiments industriels", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant démolition ou perçage",
    description:"Cloisons intérieures en fibrociment dans les locaux techniques ou industriels.",
    indices:["Plaque grise en cloison","Son dense au tapotement","Local technique","Bords sciés"],
    action:"Analyser avant démolition ou perçage.", csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='180' y='20' width='40' height='260' fill='%234b5563'/%3E%3Crect x='0' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3Crect x='220' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3C/svg%3E"] },

  { id:"plaques-doublage", name:"Plaques de doublage en fibrociment", list:"B", family:"Paroi intérieure",
    location:"Murs intérieurs, doublages, locaux techniques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant retrait ou perçage",
    description:"Plaques de doublage intérieur en fibrociment posées sur ossature ou collées.",
    indices:["Plaque grise intérieure","Ossature métallique visible","Surface lisse","Local technique"],
    action:"Identifier avant perçage ou démolition.", csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='180' y='20' width='40' height='260' fill='%234b5563'/%3E%3Crect x='0' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3Crect x='220' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3C/svg%3E"] },

  { id:"plaques-plafond-fibrociment", name:"Plaques de plafond en fibrociment", list:"B", family:"Plafond",
    location:"Plafonds, locaux techniques, garages, sous-sols", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse si doute avant retrait ou perçage",
    description:"Plaques de plafond en fibrociment dans locaux techniques.",
    indices:["Plaque plane au plafond","Aspect ciment","Vissée sur ossature","Local technique"],
    action:"Identifier avant perçage ou retrait.", csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='30' width='400' height='100' fill='%234b5563'/%3E%3Cline x1='100' y1='30' x2='100' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='200' y1='30' x2='200' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='300' y1='30' x2='300' y2='130' stroke='%236b7280' stroke-width='2'/%3E%3C/svg%3E"] },

  // ÉQUIPEMENTS TECHNIQUES
  { id:"boites-encastrement", name:"Boîtes d'encastrement électriques (fond)", list:"B", family:"Électricité",
    location:"Murs, cloisons, installations électriques anciennes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Vérification avant travaux électriques",
    description:"Boîtes d'encastrement dont le fond peut être en matériau amianté.",
    indices:["Boîte ancienne","Fond gris ou beige","Installation avant 1997","Matériau dense"],
    action:"Analyse avant remplacement ou travaux électriques.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='80' y='60' width='240' height='180' fill='%234b5563' rx='4'/%3E%3Crect x='100' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='170' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='240' y='80' width='60' height='40' fill='%23374151' rx='2'/%3E%3Crect x='100' y='130' width='200' height='8' fill='%23d97706' rx='2'/%3E%3Crect x='100' y='150' width='200' height='8' fill='%23d97706' rx='2'/%3E%3C/svg%3E"] },

  { id:"habillages-chaufferie", name:"Habillage de chaufferie", list:"B", family:"Chauffage / technique",
    location:"Chaufferies, locaux de production de chaleur", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux en chaufferie",
    description:"Habillages et protections des équipements de chaufferie en fibrociment.",
    indices:["Plaques en local chaudière","Habillage de tuyauterie","Protection thermique"],
    action:"Identifier avant tous travaux en chaufferie.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"plaques-protection-thermique", name:"Plaques de protection thermique (Sokalit)", list:"B", family:"Protection thermique",
    location:"Derrière chaudières, poêles, conduits chauds", period:"Avant 1997", risk:"Moyen",
    status:"Non friable sauf dégradation", sampling:"Analyse avant remplacement équipement",
    description:"Plaques coupe-chaleur en fibrociment (Sokalit, Marinite, Sindanyo) derrière équipements chauds.",
    indices:["Plaque derrière chaudière","Couleur blanc cassé","Bords sciés","Marquage fabricant"],
    action:"Ne pas scier ni percer sans analyse.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"caissons-volets", name:"Caissons de volets roulants en fibrociment", list:"B", family:"Menuiserie",
    location:"Caissons de volets roulants, stores, tablettes de fenêtre", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Vérification avant remplacement menuiserie",
    description:"Caissons de volets roulants en fibrociment dans les menuiseries anciennes.",
    indices:["Caisson gris lourd","Tablette de volet ancien","Matériau dense","Fixation par vis"],
    action:"Identification avant dépose ou remplacement.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='100' y='40' width='200' height='240' fill='%234b5563'/%3E%3Crect x='110' y='50' width='80' height='100' fill='%236b7280'/%3E%3Crect x='210' y='50' width='80' height='100' fill='%236b7280'/%3E%3Ccircle cx='290' cy='170' r='8' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"supports-equipements", name:"Supports et platines d'équipements", list:"B", family:"Technique",
    location:"Supports de pompes, tableaux, équipements techniques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification avant remplacement",
    description:"Platines et supports d'équipements techniques en fibrociment.",
    indices:["Platine grise sous équipement","Trous de fixation","Local technique"],
    action:"Identifier avant dépose ou remplacement.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"plaques-jardin", name:"Plaques de jardin et allées en fibrociment", list:"B", family:"Divers / extérieur",
    location:"Allées, bordures, dalles de jardin", period:"Avant 1997", risk:"Faible",
    status:"Non friable", sampling:"Identification lors repérage extérieur",
    description:"Plaques et dalles de jardin en fibrociment pour allées ou bordures.",
    indices:["Dalle grise en allée","Bordure de jardin","Format rectangulaire","Aspect ciment"],
    action:"Identifier et signaler. Éviter cassure ou meulage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"coffres-techniques-ext", name:"Coffres techniques extérieurs en fibrociment", list:"B", family:"Divers / technique",
    location:"Extérieur bâtiment, accès techniques, coffrets compteurs", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification avant remplacement",
    description:"Coffres de protection d'équipements techniques extérieurs en fibrociment.",
    indices:["Coffre gris en extérieur","Porte ou couvercle","Présence compteur ou vanne"],
    action:"Identifier avant remplacement ou modification.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='140' y='20' width='120' height='260' fill='%234b5563' rx='4'/%3E%3Crect x='155' y='35' width='90' height='230' fill='%23374151' rx='2'/%3E%3Crect x='100' y='100' width='40' height='20' fill='%236b7280'/%3E%3Crect x='260' y='100' width='40' height='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"panneaux-coupe-feu-int", name:"Panneaux coupe-feu intérieurs", list:"B", family:"Protection incendie",
    location:"Locaux techniques, portes coupe-feu, gaines", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant perçage ou dépose",
    description:"Panneaux de protection coupe-feu intérieurs en fibrociment ou matériau amianté.",
    indices:["Panneau technique dense","Présence en local technique","Bords sciés","Gris ou blanc"],
    action:"Analyser avant perçage ou dépose.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"isolant-non-friable", name:"Isolants techniques non friables", list:"B", family:"Isolation technique",
    location:"Équipements, tuyauteries, chaufferies", period:"Avant 1997", risk:"Moyen",
    status:"Non friable — risque à la découpe", sampling:"Prélèvement avant intervention",
    description:"Isolants techniques non friables (coquilles, plaques) pouvant contenir de l'amiante.",
    indices:["Isolation autour tuyauterie","Coquille rigide","Plaque isolante grise"],
    action:"Prélèvement avant intervention sur isolation.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"panneaux-cloison-legers", name:"Panneaux de cloison légère", list:"B", family:"Cloison intérieure",
    location:"Cloisons intérieures, bureaux, logements", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant démolition",
    description:"Panneaux de cloison légère (Viroc, fibrociment) pouvant contenir de l'amiante.",
    indices:["Cloison légère ancienne","Plaques sur ossature","Son creux au tapotement"],
    action:"Analyser avant démolition ou perçage.", csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='180' y='20' width='40' height='260' fill='%234b5563'/%3E%3Crect x='0' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3Crect x='220' y='20' width='180' height='260' fill='%23455060' opacity='0.3'/%3E%3C/svg%3E"] },

  { id:"platre-technique", name:"Plâtres techniques anciens", list:"B", family:"Paroi / plafond",
    location:"Murs, plafonds, doublages intérieurs", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Vérification avant perçage",
    description:"Plâtres techniques anciens pouvant contenir de l'amiante comme charge.",
    indices:["Plâtre gris dense","Finition intérieure ancienne","Résistance au grattage"],
    action:"Identifier avant perçage ou démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='%23555' opacity='0.5'/%3E%3C/svg%3E"] },

  { id:"mastic-calfeutrement", name:"Mastics de calfeutrement (menuiserie, façade)", list:"B", family:"Joint / menuiserie",
    location:"Périmètre de menuiseries, joints de façade", period:"Avant 1997", risk:"Faible",
    status:"Souple", sampling:"Identification lors de repérage",
    description:"Mastics souples de calfeutrement autour des menuiseries pouvant contenir de l'amiante.",
    indices:["Joint souple autour fenêtre","Mastic gris ou noir","Application ancienne"],
    action:"Intégrer dans le programme de repérage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"enduit-projete-b", name:"Enduits projetés (murs, parkings)", list:"B", family:"Paroi / plafond",
    location:"Murs, plafonds, poutres, parkings, sous-sols", period:"Avant 1997", risk:"Élevé",
    status:"Friabilité possible", sampling:"Analyse si doute",
    description:"Enduit appliqué sur support, parfois confondu avec flocage.",
    indices:["Surface granuleuse","Couche projetée","Support béton/métal","Dégradation locale"],
    action:"Distinguer flocage/enduit, prélever si nécessaire.", csi:"Évaluation état conservation",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"gaine-technique-rigide", name:"Gaines techniques rigides", list:"B", family:"Réseau / technique",
    location:"Gaines techniques, locaux techniques, colonnes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant perçage",
    description:"Gaines et coffres techniques rigides en fibrociment pour réseaux.",
    indices:["Gaine grise rigide","En colonne montante","Fixation par pattes"],
    action:"Identifier avant perçage ou travaux.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='140' y='20' width='120' height='260' fill='%234b5563' rx='4'/%3E%3Crect x='155' y='35' width='90' height='230' fill='%23374151' rx='2'/%3E%3Crect x='100' y='100' width='40' height='20' fill='%236b7280'/%3E%3Crect x='260' y='100' width='40' height='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"elements-prefabriques-b", name:"Éléments préfabriqués en fibrociment", list:"B", family:"Structure / divers",
    location:"Éléments de construction préfabriqués divers", period:"Avant 1997", risk:"Moyen",
    status:"Non friable sauf cassure", sampling:"Prélèvement avant démolition",
    description:"Éléments préfabriqués en fibrociment non répertoriés dans d'autres catégories.",
    indices:["Élément préfabriqué gris","Surface ciment lisse","Usage structural ou décoratif"],
    action:"Prélèvement avant démolition ou sciage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  // ══ LISTE C — MANQUANTS ══

  { id:"mortier-technique", name:"Mortiers techniques anciens", list:"C", family:"Structure / maçonnerie",
    location:"Murs, sols, jointements, extérieurs", period:"Avant 1997", risk:"Variable",
    status:"Non friable sauf cassure", sampling:"Prélèvement avant démolition",
    description:"Mortiers de pose ou de réparation anciens pouvant contenir de l'amiante.",
    indices:["Mortier de jointoiement ancien","Réparation maçonnerie","Couleur grise uniforme"],
    action:"Prélèvement avant démolition ou sciage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"chape-ancienne", name:"Chapes anciennes (sol)", list:"C", family:"Sol / structure",
    location:"Sols de logements, bureaux, locaux anciens", period:"Avant 1997", risk:"Variable",
    status:"Caché sous revêtement", sampling:"Prélèvement avant sciage",
    description:"Chapes de sol anciennes pouvant contenir de l'amiante.",
    indices:["Chape grise sous revêtement","Épaisseur 3-6 cm","Surface lissée"],
    action:"Prélèvement spécifique avant sciage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"mastic-vitrage", name:"Mastics de vitrage anciens", list:"C", family:"Menuiserie / vitrage",
    location:"Fenêtres à vitrage simple, châssis anciens", period:"Avant 1997", risk:"Faible",
    status:"Durci ou friable selon état", sampling:"Prélèvement avant remplacement vitrage",
    description:"Mastics de pose de vitrage anciens pouvant contenir de l'amiante.",
    indices:["Mastic durci entre verre et bois","Couleur grise ou blanche","Fenêtre ancienne"],
    action:"Prélèvement avant remplacement de vitrage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"joint-etancheite-c", name:"Joints d'étanchéité (façade, menuiserie)", list:"C", family:"Joint / étanchéité",
    location:"Façades, assemblages de panneaux, menuiseries", period:"Avant 1997", risk:"Faible",
    status:"Souple ou durci", sampling:"Selon périmètre de repérage",
    description:"Joints d'étanchéité entre panneaux de façade pouvant contenir de l'amiante.",
    indices:["Joint entre panneaux","Aspect souple ou durci","Application ancienne"],
    action:"Intégrer au programme de repérage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"peinture-epaisse-c", name:"Peintures épaisses anciennes (anti-corrosion)", list:"C", family:"Finition / protection",
    location:"Structures métalliques, murs, plafonds industriels", period:"Avant 1997", risk:"Faible",
    status:"Non friable sauf dégradation", sampling:"Prélèvement avant décapage",
    description:"Peintures épaisses de protection pouvant contenir de l'amiante.",
    indices:["Peinture épaisse sur métal","Aspect écaillé","Structure acier ancienne"],
    action:"Prélèvement avant décapage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='%23555' opacity='0.5'/%3E%3C/svg%3E"] },

  { id:"isolant-integre", name:"Isolants intégrés (mur, plafond)", list:"C", family:"Isolation intégrée",
    location:"Dans l'épaisseur des murs, plafonds, planchers", period:"Avant 1997", risk:"Variable",
    status:"Variable — friable si dégradé", sampling:"Prélèvement avant démolition",
    description:"Isolants intégrés dans la construction pouvant contenir de l'amiante.",
    indices:["Isolant dans cavité de mur","Matériau fibreux ou laineux","Présence en combles"],
    action:"Investigation avant démolition. Protection si friable.",
    csi:"N/A", photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"coffrage-encastre", name:"Coffrages encastrés (gaines, murs)", list:"C", family:"Structure / coffrage",
    location:"Gaines encastrées, boîtes de dérivation, murs", period:"Avant 1997", risk:"Variable",
    status:"Non friable", sampling:"Prélèvement avant ouverture",
    description:"Coffrages encastrés pour réseaux pouvant être en matériau amianté.",
    indices:["Coffrage dans mur ou sol","Accès technique","Construction avant 1997"],
    action:"Prélèvement avant ouverture ou démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='140' y='20' width='120' height='260' fill='%234b5563' rx='4'/%3E%3Crect x='155' y='35' width='90' height='230' fill='%23374151' rx='2'/%3E%3Crect x='100' y='100' width='40' height='20' fill='%236b7280'/%3E%3Crect x='260' y='100' width='40' height='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"sous-couche-isolante-c", name:"Sous-couches isolantes (sol, mur)", list:"C", family:"Isolation / revêtement",
    location:"Sous revêtements de sol, sous peinture", period:"Avant 1997", risk:"Variable",
    status:"Caché sous revêtement", sampling:"Prélèvement avant dépose",
    description:"Sous-couches d'isolation pouvant contenir de l'amiante.",
    indices:["Feutre ou mousse sous revêtement","Matériau dense grisâtre","Application ancienne"],
    action:"Prélèvement distinct du revêtement avant dépose.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"complexe-multicouche", name:"Complexes multicouches (mur, sol)", list:"C", family:"Assemblage composite",
    location:"Murs composites, sols multicouches", period:"Avant 1997", risk:"Variable",
    status:"Composants multiples", sampling:"Prélèvement couche par couche",
    description:"Assemblages multicouches dont certaines couches peuvent contenir de l'amiante.",
    indices:["Assemblage de plusieurs matériaux","Couches visibles en coupe","Construction ancienne"],
    action:"Analyser chaque couche séparément.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"plancher-chauffant-c", name:"Plancher chauffant (chape, isolant)", list:"C", family:"Sol / chauffage",
    location:"Sous plancher chauffant, chapes", period:"Avant 1997", risk:"Variable",
    status:"Caché sous chape", sampling:"Prélèvement avant démolition chape",
    description:"Chapes ou isolants sous plancher chauffant pouvant contenir de l'amiante.",
    indices:["Plancher chauffant ancien","Chape épaisse","Construction avant 1997"],
    action:"Prélèvement avant démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },

  { id:"feutre-isolant-radiateur", name:"Feutre isolant derrière radiateurs", list:"C", family:"Isolation / chauffage",
    location:"Derrière radiateurs anciens, habillages chaufferie", period:"Avant 1997", risk:"Variable",
    status:"Caché derrière équipement", sampling:"Prélèvement avant dépose radiateur",
    description:"Feutres ou panneaux isolants derrière des radiateurs anciens.",
    indices:["Feutre gris derrière radiateur","Matériau souple dense","Fixation ancienne"],
    action:"Prélèvement avant dépose de radiateur.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"colles-parquet", name:"Colles de parquet anciennes", list:"C", family:"Revêtement de sol",
    location:"Sous parquet collé, locaux anciens", period:"Avant 1997", risk:"Variable",
    status:"Caché sous parquet", sampling:"Prélèvement avant dépose parquet",
    description:"Colles de pose de parquets anciens pouvant contenir de l'amiante.",
    indices:["Parquet collé ancien","Colle épaisse sous lame","Odeur caractéristique"],
    action:"Prélèvement avant dépose de parquet collé.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%231a1a1a'/%3E%3Crect x='0' y='200' width='400' height='100' fill='%23111'/%3E%3Cellipse cx='200' cy='200' rx='180' ry='30' fill='%23222'/%3E%3C/svg%3E"] },

  { id:"fibrociment-general-c", name:"Fibrociment en général (usages divers)", list:"C", family:"Fibrociment divers",
    location:"Tous usages non classés en liste A ou B", period:"Avant 1997", risk:"Variable",
    status:"Variable selon usage", sampling:"Selon périmètre avant démolition",
    description:"Ensemble des matériaux en fibrociment non répertoriés en liste A ou B.",
    indices:["Matériau gris dense","Surface lisse","Usage divers","Absence d'identification"],
    action:"Intégrer dans le programme de repérage avant démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Ccircle cx='200' cy='150' r='80' fill='%234b5563'/%3E%3Ctext x='200' y='160' text-anchor='middle' fill='%23dc2626' font-size='60' font-family='Arial'%3E%E2%98%A2%EF%B8%8F%3C/text%3E%3C/svg%3E"] },

  { id:"beton-fibre-c", name:"Béton fibré amiante (éléments préfabriqués)", list:"C", family:"Structure",
    location:"Dalles préfabriquées, éléments de structure", period:"Avant 1997", risk:"Variable",
    status:"Non friable sauf cassure", sampling:"Prélèvement avant démolition ou sciage",
    description:"Éléments en béton renforcé de fibres d'amiante.",
    indices:["Élément préfabriqué ancien","Surface béton lisse","Bords nets"],
    action:"Prélèvement avant démolition, sciage ou perçage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"joints-salle-bain", name:"Joints baignoire, douche, plan de travail", list:"C", family:"Salle de bain / cuisine",
    location:"Périmètre baignoire, bac douche, plan de travail", period:"Avant 1997", risk:"Variable",
    status:"Souple, soumis humidité", sampling:"Prélèvement avant rénovation",
    description:"Joints de finition autour des équipements sanitaires anciens.",
    indices:["Joint gris ou blanc ancien","Autour baignoire ou douche","Dégradation ou jaunissement"],
    action:"Prélèvement avant rénovation salle de bain.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='40' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='220' y='100' width='140' height='100' fill='%234b5563'/%3E%3Crect x='180' y='80' width='40' height='140' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"plaques-cuisiniere-c", name:"Plaques de protection derrière cuisinières", list:"C", family:"Cuisine",
    location:"Derrière cuisinières gaz ou électriques anciennes", period:"Avant 1997", risk:"Variable",
    status:"Caché derrière équipement", sampling:"Prélèvement avant dépose cuisinière",
    description:"Plaques de protection thermique derrière cuisinières anciennes.",
    indices:["Plaque murale derrière cuisinière","Matériau gris ou blanc","Fixation au mur"],
    action:"Prélèvement avant dépose de cuisinière.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='%23555' opacity='0.5'/%3E%3C/svg%3E"] },

  { id:"enduit-facade-c", name:"Enduits de façade anciens", list:"C", family:"Façade",
    location:"Façades extérieures, soubassements", period:"Avant 1997", risk:"Variable",
    status:"Extérieur, soumis aux intempéries", sampling:"Prélèvement avant ravalement",
    description:"Enduits de façade anciens pouvant contenir de l'amiante.",
    indices:["Enduit épais en façade","Aspect gratté ou talochè","Fissures ou décollements"],
    action:"Prélèvement avant ravalement ou démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3Crect x='170' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"vernis-lasures-c", name:"Vernis et lasures anciens", list:"C", family:"Finition",
    location:"Boiseries, menuiseries, structures bois", period:"Avant 1997", risk:"Variable",
    status:"Non friable sauf dégradation", sampling:"Prélèvement avant décapage",
    description:"Vernis et lasures anciens pouvant contenir de l'amiante comme charge.",
    indices:["Vernis ancien sur bois","Aspect brillant ou mat","Application avant 1997"],
    action:"Prélèvement avant décapage ou ponçage.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='0' width='400' height='300' fill='%23555' opacity='0.5'/%3E%3C/svg%3E"] },

  { id:"mousse-projetee-c", name:"Mousse et résine projetée", list:"C", family:"Isolation",
    location:"Combles, toitures, structures diverses", period:"Avant 1997", risk:"Variable",
    status:"Non friable en général", sampling:"Prélèvement avant démolition",
    description:"Mousse ou résine projetée ancienne pouvant contenir de l'amiante.",
    indices:["Mousse projetée sur structure","Combles ou toiture","Application irrégulière"],
    action:"Prélèvement avant démolition ou retrait.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='60' width='280' height='60' fill='%23d97706'/%3E%3Crect x='60' y='130' width='280' height='60' fill='%23b45309'/%3E%3Crect x='60' y='200' width='280' height='60' fill='%23d97706'/%3E%3C/svg%3E"] },

  { id:"faux-plancher-c", name:"Faux planchers techniques", list:"C", family:"Sol technique",
    location:"Planchers techniques informatiques, bureaux anciens", period:"Avant 1997", risk:"Variable",
    status:"Composant intégré", sampling:"Prélèvement avant démolition",
    description:"Dalles de faux plancher techniques pouvant contenir de l'amiante dans les supports.",
    indices:["Dalle de plancher technique","Plots de support","Espace sous-plancher","Bureau ancien"],
    action:"Prélèvement avant dépose ou démolition.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3Cline x1='100' y1='150' x2='100' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3Cline x1='200' y1='150' x2='200' y2='300' stroke='%236b7280' stroke-width='1'/%3E%3C/svg%3E"] },
,
  { id:"tuyaux-enterres-b", name:"Tuyaux enterrés en amiante-ciment (réseau)", list:"B", family:"Canalisation enterrée",
    location:"Réseaux enterrés, adduction eau, assainissement", period:"Avant 1997", risk:"Moyen",
    status:"Non friable en service", sampling:"Prélèvement lors de terrassement",
    description:"Canalisations enterrées en amiante-ciment dans les réseaux anciens d'eau ou d'assainissement.",
    indices:["Tuyau gris dense lourd","Raccords en fonte","Réseau enterré","Diamètre variable"],
    action:"Prélèvement si doute lors de terrassement ou travaux réseau.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"conduits-electriques-b", name:"Conduits électriques en fibrociment", list:"B", family:"Électricité",
    location:"Gaines électriques encastrées, colonnes montantes", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Identification avant travaux électriques",
    description:"Conduits de protection des câbles électriques en fibrociment.",
    indices:["Conduit gris","Réseau électrique ancien","Installation encastrée"],
    action:"Identification avant tout travaux électriques.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"habillages-structure-b", name:"Habillages de structures (poutres, poteaux)", list:"B", family:"Structure",
    location:"Poutres, poteaux, charpentes métalliques", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant travaux structurels",
    description:"Habillages de protection ou de finition des éléments structurels en fibrociment.",
    indices:["Plaque autour poteau","Habillage de poutre","Assemblage de plaques","Support acier"],
    action:"Identifier avant perçage ou travaux sur structure.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='60' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='160' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='260' y='40' width='40' height='220' fill='%234b5563'/%3E%3Crect x='60' y='40' width='240' height='30' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"conduits-chaudiere-b", name:"Conduits de chaudière en fibrociment", list:"B", family:"Chauffage / technique",
    location:"Chaufferies, conduits d'évacuation chaudière", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant remplacement chaudière",
    description:"Conduits d'évacuation des fumées de chaudière en fibrociment.",
    indices:["Conduit gris en chaufferie","Raccords emboîtés","Diamètre variable"],
    action:"Identifier avant remplacement ou modification.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"dalle-terrasse-fibrociment", name:"Dalles extérieures en fibrociment", list:"B", family:"Terrasse / extérieur",
    location:"Terrasses extérieures, zones de circulation", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Prélèvement avant dépose ou percement",
    description:"Dalles de circulation extérieure en fibrociment.",
    indices:["Dalle grise extérieure","Circulation ou terrasse","Format régulier"],
    action:"Prélèvement avant travaux ou dépose.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='0' y='150' width='400' height='150' fill='%234b5563'/%3E%3Cline x1='0' y1='150' x2='400' y2='150' stroke='%236b7280' stroke-width='2'/%3E%3C/svg%3E"] },

  { id:"reservoir-eau-pluie", name:"Réservoirs eau de pluie en fibrociment", list:"B", family:"Divers / extérieur",
    location:"Jardins, extérieur bâtiment", period:"Avant 1997", risk:"Faible",
    status:"Non friable en service", sampling:"Identification avant retrait",
    description:"Réservoirs de récupération eau pluviale en fibrociment.",
    indices:["Cuve enterrée ou semi-enterrée","Matériau gris dense","Couvercle béton"],
    action:"Identifier avant retrait ou modification.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Cellipse cx='200' cy='80' rx='60' ry='20' fill='%234b5563'/%3E%3Crect x='140' y='80' width='120' height='160' fill='%234b5563'/%3E%3Cellipse cx='200' cy='240' rx='60' ry='20' fill='%236b7280'/%3E%3C/svg%3E"] },

  { id:"plaques-facade-b2", name:"Panneaux de façade en fibrociment (grands formats)", list:"B", family:"Façade / bardage",
    location:"Grands immeubles collectifs, bâtiments tertiaires", period:"Avant 1997", risk:"Moyen",
    status:"Non friable", sampling:"Analyse avant perçage ou dépose",
    description:"Panneaux de façade en grands formats en fibrociment sur les bâtiments collectifs.",
    indices:["Grand panneau de façade","Assemblage en travées","Joints entre panneaux","Bâtiment collectif"],
    action:"Analyser avant perçage ou dépose de panneau.", csi:"N/A",
    photos:["data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect width='400' height='300' fill='%23374151'/%3E%3Crect x='30' y='30' width='340' height='240' fill='%234b5563'/%3E%3Crect x='50' y='60' width='80' height='60' fill='%236b7280'/%3E%3C/svg%3E"] },

];

const AMIANTE_LIST_META = {
  A: { color:"#dc2626", bg:"#fef2f2", label:"Liste A", subtitle:"Matériaux susceptibles de libérer des fibres par vieillissement", badge:"🔴 Prioritaire" },
  B: { color:"#d97706", bg:"#fffbeb", label:"Liste B", subtitle:"Matériaux accessibles sans investigation destructive", badge:"🟠 Courant" },
  C: { color:"#4f46e5", bg:"#eef2ff", label:"Liste C", subtitle:"Repérage étendu avant démolition", badge:"🔵 Avant démolition" },
};

// ═══════════════════════════════════════════════════════════════════════
// MODULE SCAN/ELEC — Référentiel COMPLET XP C 16-600 (95 items)
// Format de réponse : OUI / NON / NV / SO + commentaire libre
// ═══════════════════════════════════════════════════════════════════════
const ELEC_ITEMS = {
  B1: { title: "AGCP — Appareil Général de Commande et de Protection", items: [
    { id: "B1.3.a", label: "Présence (y compris annexe à usage d'habitation)", severity: "critique" },
    { id: "B1.3.b", label: "Placé à l'intérieur du logement ou dans un local annexe accessible directement", severity: "majeur" },
    { id: "B1.3.c", label: "Assure la coupure de l'ensemble de l'installation", severity: "critique" },
    { id: "B1.3.d", label: "Interrupteur ou disjoncteur", severity: "majeur" },
    { id: "B1.3.e", label: "Uniquement à commande manuelle", severity: "majeur" },
    { id: "B1.3.f", label: "Coupure simultanée et omnipolaire", severity: "majeur" },
    { id: "B1.3.g", label: "Placé à une hauteur ≤ 1,80 m du sol fini (hauteur supérieure admise si marches ou estrade)", severity: "mineur" },
    { id: "B1.3.h", label: "Placé en un endroit dont l'accès ne se fait pas par une trappe incluant ou non un escalier escamotable", severity: "majeur" },
    { id: "B1.3.i", label: "Tableau, armoire, placard ou gaine accessible sans l'utilisation d'une clé ou d'un outil", severity: "majeur" },
    { id: "B1.3.j", label: "Non placé au-dessus de feux ou plaques de cuisson ni sous un point d'eau", severity: "critique" },
  ]},
  B2: { title: "DDR — Dispositifs de Protection Différentielle", items: [
    { id: "B2.3.1.a", label: "Présence d'un dispositif de protection différentiel", severity: "critique" },
    { id: "B2.3.1.b", label: "Indication sur le ou les appareils du courant différentiel assigné (sensibilité)", severity: "mineur" },
    { id: "B2.3.1.c", label: "Protection de l'ensemble de l'installation", severity: "majeur" },
    { id: "B2.3.1.d", label: "Non réglable en courant différentiel résiduel (sensibilité) et en temps de déclenchement", severity: "majeur" },
    { id: "B2.3.1.f", label: "Courant différentiel assigné (sensibilité) au plus égal à 650 mA (sauf branchement à puissance surveillée)", severity: "critique" },
    { id: "B2.3.1.h", label: "Déclenche, lors de l'essai de fonctionnement, pour un courant de défaut au plus égal à son courant différentiel-résiduel assigné (sensibilité)", severity: "critique" },
    { id: "B2.3.1.i", label: "Déclenche par action sur le bouton test quand ce dernier est présent", severity: "majeur" },
    { id: "B2.3.2.a", label: "Liaison de classe II entre le disjoncteur de branchement non différentiel et les bornes aval des dispositifs différentiels protégeant l'ensemble de l'installation", severity: "majeur" },
  ]},
  B3: { title: "Prise de terre et installation de mise à la terre", items: [
    { id: "B3.3.1.b", label: "Élément constituant la prise de terre approprié", severity: "majeur" },
    { id: "B3.3.1.c", label: "Prises de terre multiples interconnectées pour un même bâtiment", severity: "majeur" },
    { id: "B3.3.1.d", label: "Valeur de la résistance de la prise de terre adaptée au(x) dispositif(s) différentiel(s)", severity: "critique" },
    { id: "B3.3.1.e", label: "Étiquette absence prise de terre + DDR 30mA + liaison équipotentielle supplémentaire en cuisine", severity: "majeur" },
    { id: "B3.3.2.a", label: "Présence d'un conducteur de terre", severity: "critique" },
    { id: "B3.3.2.b", label: "Section du conducteur de terre satisfaisante", severity: "majeur" },
    { id: "B3.3.3.a", label: "Qualité satisfaisante de la connexion du conducteur de terre, de la liaison équipotentielle principale, du conducteur principal de protection, sur la borne ou barrette de terre principale", severity: "majeur" },
    { id: "B3.3.4.a", label: "Connexion assurée des éléments conducteurs de la structure porteuse et des canalisations métalliques à la liaison équipotentielle principale (résistance de continuité ≤ 2 ohms)", severity: "majeur" },
    { id: "B3.3.4.b", label: "Section satisfaisante du conducteur de liaison équipotentielle principale", severity: "majeur" },
    { id: "B3.3.4.d", label: "Qualité satisfaisante de la connexion du conducteur de liaison équipotentielle principale, du conducteur principal de protection, sur éléments conducteurs", severity: "majeur" },
    { id: "B3.3.5.a2", label: "(Coll) Présence d'une dérivation individuelle de terre au répartiteur de terre du tableau de répartition en partie privative", severity: "majeur" },
    { id: "B3.3.5.b2", label: "(Coll) Section satisfaisante de la dérivation individuelle de terre visible en partie privative", severity: "majeur" },
    { id: "B3.3.5.c", label: "Éléments constituant le conducteur principal de protection appropriés", severity: "majeur" },
    { id: "B3.3.5.d", label: "Continuité satisfaisante du conducteur principal de protection", severity: "critique" },
    { id: "B3.3.6.a1", label: "Tous les socles de prise de courant comportent un contact de terre", severity: "majeur" },
    { id: "B3.3.6.a2", label: "Tous les socles de prise courant comportant un contact de terre sont reliés à la terre", severity: "critique" },
    { id: "B3.3.6.a3", label: "Tous les circuits autres que ceux alimentant les socles de prises de courant sont reliés à la terre", severity: "majeur" },
    { id: "B3.3.6.a4", label: "Dans le cas d'un ascenseur ou d'un monte-charge privés, porte palière reliée à la terre", severity: "majeur" },
    { id: "B3.3.6.b", label: "Éléments constituant les conducteurs de protection appropriés", severity: "majeur" },
    { id: "B3.3.6.c", label: "Section satisfaisante des conducteurs de protection", severity: "majeur" },
    { id: "B3.3.6.1", label: "Mesure compensatoire correctement mise en oeuvre, en l'absence de conducteur de protection (3.3.6a1, a2 et a3)", severity: "majeur" },
    { id: "B3.3.7.a", label: "Conduits métalliques en montage apparent, contenant des conducteurs, reliés à la terre", severity: "majeur" },
    { id: "B3.3.7.b", label: "Absence de conduits métalliques en montage apparent dans les locaux contenant une baignoire ou une douche", severity: "critique" },
    { id: "B3.3.7.1", label: "Mesure compensatoire correctement mise en oeuvre, en l'absence de mise à la terre des conduits métalliques (3.3.7a)", severity: "majeur" },
    { id: "B3.3.8.a", label: "Huisseries ou goulottes métalliques contenant des conducteurs, reliées à la terre", severity: "majeur" },
    { id: "B3.3.8.b", label: "Absence de conducteurs cheminant dans les huisseries métalliques des locaux contenant une baignoire ou une douche", severity: "critique" },
    { id: "B3.3.8.1", label: "Mesure compensatoire correctement mise en oeuvre, en l'absence de mise à la terre des huisseries (3.3.8a)", severity: "majeur" },
    { id: "B3.3.9.a", label: "Absence de boîtes de connexion métalliques en montage apparent dans les locaux contenant une baignoire ou une douche", severity: "critique" },
    { id: "B3.3.9.b", label: "Boîtes de connexion métalliques en montage apparent, contenant des conducteurs, reliées à la terre", severity: "majeur" },
    { id: "B3.3.9.1", label: "Mesure compensatoire correctement mise en oeuvre, en l'absence de mise à la terre des boîtes de connexion (3.3.9b)", severity: "majeur" },
    { id: "B3.3.10.a", label: "Socles de prise de courant situés à l'extérieur protégés par DDR à haute sensibilité ≤ 30 mA", severity: "critique" },
  ]},
  B4: { title: "Dispositif de protection contre les surintensités", items: [
    { id: "B4.3.a1", label: "Présence d'une protection contre les surintensités à l'origine de chaque circuit", severity: "critique" },
    { id: "B4.3.a2", label: "Tous les dispositifs de protection contre les surintensités sont placés sur les conducteurs de phase", severity: "majeur" },
    { id: "B4.3.b", label: "Le type de fusible est d'un modèle autorisé. Le type de disjoncteur n'est pas réglable en courant", severity: "majeur" },
    { id: "B4.3.c", label: "Conducteurs de phase regroupés sous la même protection en présence de conducteur neutre commun", severity: "majeur" },
    { id: "B4.3.e", label: "Courant assigné (calibre) de la protection contre les surintensités adapté à la section des conducteurs", severity: "critique" },
    { id: "B4.3.f1", label: "Section des conducteurs de la canalisation alimentant le seul tableau en adéquation avec le dispositif amont", severity: "majeur" },
    { id: "B4.3.f2", label: "Section des conducteurs de la canalisation d'alimentation de chacun des tableaux en adéquation avec le dispositif amont", severity: "majeur" },
    { id: "B4.3.f3", label: "Section des conducteurs de pontage à l'intérieur du tableau en adéquation avec le disjoncteur de branchement", severity: "majeur" },
    { id: "B4.3.g", label: "Aucun tableau placé au-dessous d'un point d'eau, au dessus de feux ou plaques de cuisson", severity: "critique" },
    { id: "B4.3.h", label: "Aucun point de connexion de conducteur ou d'appareillage ne présente de trace d'échauffement", severity: "critique" },
    { id: "B4.3.i", label: "Courant assigné (calibre) de l'interrupteur assurant la coupure de l'ensemble adapté", severity: "majeur" },
    { id: "B4.3.j1", label: "Calibre adapté de l'interrupteur différentiel placé en aval du disjoncteur de branchement", severity: "majeur" },
    { id: "B4.3.j2", label: "Calibres adaptés de plusieurs interrupteurs différentiels en aval du disjoncteur de branchement", severity: "majeur" },
  ]},
  B5: { title: "Liaison équipotentielle supplémentaire (LES) — Salle d'eau", items: [
    { id: "B5.3.a", label: "Continuité satisfaisante de la liaison équipotentielle supplémentaire", severity: "critique" },
    { id: "B5.3.b", label: "Section satisfaisante du conducteur de liaison équipotentielle supplémentaire", severity: "majeur" },
    { id: "B5.3.d", label: "Qualité satisfaisante des connexions du conducteur de la LES aux éléments conducteurs et masses", severity: "majeur" },
    { id: "B5.3.1", label: "Mesure compensatoire à B.5.3 a) correctement mise en oeuvre", severity: "majeur" },
  ]},
  B6: { title: "Respect des règles liées aux zones — Salle d'eau", items: [
    { id: "B6.3.1.a", label: "Installation électrique répondant aux prescriptions particulières appliquées à ces locaux", severity: "critique" },
    { id: "B6.3.1.c", label: "Matériel électrique BT (>50V ac ou >120V cc) sous la baignoire accessible qu'en retirant le tablier ou la trappe à l'aide d'un outil", severity: "critique" },
  ]},
  B7: { title: "Matériels présentant des risques de contact direct", items: [
    { id: "B7.3.a", label: "Enveloppe des matériels électriques en place et non détériorée", severity: "critique" },
    { id: "B7.3.b", label: "Isolant des conducteurs en bon état", severity: "critique" },
    { id: "B7.3.c2", label: "Conducteurs nus ou parties actives accessibles alimentés sous TBTS (≤25V ac ou ≤60V dc)", severity: "majeur" },
    { id: "B7.3.d", label: "Aucune connexion présentant des parties actives nues sous tension", severity: "critique" },
    { id: "B7.3.e", label: "Aucun dispositif de protection présentant des parties actives nues sous tension", severity: "critique" },
    { id: "B7.3.f", label: "Installation en amont du disjoncteur de branchement (partie privative) sans risque de contacts directs", severity: "critique" },
  ]},
  B8: { title: "Matériels électriques vétustes ou inadaptés", items: [
    { id: "B8.3.a", label: "Absence de matériel électrique vétuste", severity: "majeur" },
    { id: "B8.3.b", label: "Absence de matériel électrique inadapté à l'usage", severity: "majeur" },
    { id: "B8.3.c", label: "Absence de conducteur vert/jaune utilisé comme conducteur actif", severity: "critique" },
    { id: "B8.3.d", label: "Absence de conducteur actif de diamètre < 12/10 mm (1,13 mm²)", severity: "majeur" },
    { id: "B8.3.e", label: "Conducteurs isolés protégés par conduits, goulottes, plinthes ou huisseries en matière isolante ou métallique", severity: "majeur" },
  ]},
  B9: { title: "Appareils d'utilisation communs/privatifs", items: [
    { id: "B9.3.1.a", label: "Installation issue des parties communes alimentant des matériels en partie privative, mise en oeuvre correctement", severity: "majeur" },
    { id: "B9.3.2.a", label: "Installation issue de la partie privative alimentant des matériels en parties communes, mise en oeuvre correctement", severity: "majeur" },
  ]},
  B10: { title: "Piscine privée et bassin de fontaine", items: [
    { id: "B10.3.1.a", label: "Piscine privée : installation conforme aux prescriptions particulières (volumes, chocs électriques)", severity: "critique" },
    { id: "B10.3.2.a", label: "Bassin de fontaine : installation conforme aux prescriptions particulières (volumes, chocs électriques)", severity: "critique" },
    { id: "B10.3.1.b", label: "Piscine : canalisations en volumes 0/1/2 sans revêtement métallique ou limitées aux matériels installés", severity: "majeur" },
    { id: "B10.3.2.b", label: "Bassin de fontaine : canalisations en volumes 0/1 sans revêtement métallique ou limitées", severity: "majeur" },
    { id: "B10.3.1.c", label: "Piscine : matériels spéciaux dans local technique correctement installés", severity: "majeur" },
    { id: "B10.3.2.c", label: "Bassin de fontaine : matériels électriques des volumes 0/1 inaccessibles", severity: "majeur" },
    { id: "B10.3.1.d", label: "Piscine : matériels basse tension prévus pour volume 1 correctement installés", severity: "majeur" },
    { id: "B10.3.2.d", label: "Bassin de fontaine : luminaires des volumes 0 et 1 fixés", severity: "majeur" },
    { id: "B10.3.1.e", label: "Piscine : continuité de la liaison équipotentielle supplémentaire ≤ 2 ohms", severity: "majeur" },
    { id: "B10.3.2.e", label: "Bassin de fontaine : continuité de la liaison équipotentielle supplémentaire ≤ 2 ohms", severity: "majeur" },
  ]},
  B11: { title: "Autres vérifications recommandées (informatives)", items: [
    { id: "B11.a", label: "Ensemble de l'installation protégée par au moins un DDR à haute sensibilité ≤ 30 mA", severity: "mineur" },
    { id: "B11.a3", label: "Présence d'un DDR à haute sensibilité ≤ 30 mA", severity: "mineur" },
    { id: "B11.b", label: "Ensemble des socles de prise de courant à obturateur", severity: "mineur" },
    { id: "B11.c", label: "Ensemble des socles de prise de courant avec puits de 15 mm", severity: "mineur" },
  ]},
};

const ELEC_SEVERITY = {
  critique: { color: "#dc2626", bg: "#7f1d1d", label: "Critique", icon: "🔴" },
  majeur:   { color: "#ea580c", bg: "#7c2d12", label: "Majeur",   icon: "🟠" },
  mineur:   { color: "#d97706", bg: "#78350f", label: "Mineur",   icon: "🟡" },
};

// ─── Codes de réponse XP C 16-600 (OUI/NON/NV/SO) ───
const ELEC_RESPONSE_CODES = {
  OUI: { color: "#22c55e", bg: "#14532d", label: "OUI", icon: "✓", description: "Conforme" },
  NON: { color: "#dc2626", bg: "#7f1d1d", label: "NON", icon: "✗", description: "Non conforme (anomalie)" },
  NV:  { color: "#94a3b8", bg: "#334155", label: "NV",  icon: "—", description: "Non Visible" },
  SO:  { color: "#a3a3a3", bg: "#262626", label: "SO",  icon: "○", description: "Sans Objet" },
};

// ─── Liste des pièces (menu déroulant par photo) ───
const ELEC_PIECES = [
  "Entrée",
  "Couloir 1", "Couloir 2", "Couloir 3", "Couloir 4",
  "Salon 1", "Salon 2",
  "Séjour",
  "Cuisine", "Arrière-cuisine",
  "Chambre 1", "Chambre 2", "Chambre 3", "Chambre 4", "Chambre 5",
  "Chambre 6", "Chambre 7", "Chambre 8",
  "SDB 1", "SDB 2", "SDB 3", "SDB 4",
  "SDE 1", "SDE 2", "SDE 3", "SDE 4",
  "WC 1", "WC 2", "WC 3",
  "Laverie", "Buanderie", "Cellier", "Cave",
  "Garage", "Sous-sol", "Grenier",
  "Tableau électrique", "Local technique",
  "Extérieur",
  "Autre",
];


// ── AmianteDetail ──
function AmianteDetail({ material, onBack }) {
  const [lightbox, setLightbox] = useState(null);
  if (!material) return <div style={{ padding: 20, color: "#999" }}>Matériau introuvable.</div>;
  const meta = AMIANTE_LIST_META[material.list] || { color: "#888", label: "Liste ?" };
  const risk = material.risk || "Moyen";
  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", overflowY:"auto" }}>
      <button onClick={onBack} style={{ background:"none", border:"none", color:"#ccc", fontSize:13, fontWeight:700, padding:"8px 0", cursor:"pointer", textAlign:"left" }}>← Retour</button>
      <div style={{ position:"relative", height:180, borderRadius:12, overflow:"hidden", background:"#1a1a1a", flexShrink:0 }}>
        {material.photos?.[0]
          ? <img src={material.photos[0]} alt="" style={{ width:"100%",height:"100%",objectFit:"cover",opacity:0.7 }} onError={e=>{e.target.style.display="none"}} />
          : <div style={{ width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:50 }}>☢️</div>}
        <div style={{ position:"absolute",inset:0,background:"linear-gradient(to top,rgba(13,13,20,1) 0%,rgba(13,13,20,0.2) 60%,transparent 100%)" }} />
        <div style={{ position:"absolute",top:10,left:10 }}><span style={{ background:meta.color,color:"#fff",padding:"3px 10px",borderRadius:5,fontSize:11,fontWeight:900 }}>LISTE {material.list || "?"}</span></div>
        <div style={{ position:"absolute",top:10,right:10,background:risk.includes("Très")?"#dc2626":risk.includes("Élevé")?"#ea580c":"#d97706",color:"#fff",padding:"3px 10px",borderRadius:5,fontSize:11,fontWeight:700 }}>⚠️ {risk}</div>
        <div style={{ position:"absolute",bottom:12,left:14 }}>
          <div style={{ fontSize:18,fontWeight:900,color:"#fff" }}>{material.name || "Sans nom"}</div>
          <div style={{ fontSize:11,color:"#ccc",marginTop:2 }}>{material.family || ""}</div>
        </div>
      </div>
      {material.photos?.length > 0 && (
        <div style={{ display:"flex",gap:6,marginTop:8,flexShrink:0 }}>
          {material.photos.map((url,i) => (
            <div key={i} onClick={()=>setLightbox(url)} style={{ width:80,height:55,borderRadius:6,overflow:"hidden",cursor:"zoom-in",border:"2px solid "+meta.color+"55",flexShrink:0,background:"#222" }}>
              <img src={url} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }} onError={e=>{e.target.parentNode.style.display="none"}} />
            </div>
          ))}
        </div>
      )}
      <div style={{ display:"flex",flexDirection:"column",gap:10,marginTop:10 }}>
        <div style={{ background:meta.color+"22",border:"1px solid "+meta.color+"55",borderRadius:8,padding:"8px 12px",fontSize:11,fontWeight:700,color:meta.color }}>{meta.badge} — {meta.subtitle}</div>
        <div style={{ display:"flex",gap:8 }}>
          <div style={{ flex:1,background:"#151520",borderRadius:8,padding:"8px 10px" }}><div style={{ fontSize:9,color:"#999",textTransform:"uppercase",marginBottom:3 }}>📍 Localisation</div><div style={{ fontSize:11,color:"#bbb" }}>{material.location}</div></div>
          <div style={{ flex:1,background:"#151520",borderRadius:8,padding:"8px 10px" }}><div style={{ fontSize:9,color:"#999",textTransform:"uppercase",marginBottom:3 }}>📅 Période</div><div style={{ fontSize:11,color:"#bbb" }}>{material.period}</div></div>
        </div>
        <div style={{ background:"#151520",borderRadius:8,padding:"10px 12px" }}>
          <div style={{ fontSize:10,fontWeight:700,color:"#F5C800",textTransform:"uppercase",marginBottom:5 }}>🔬 Prélèvement</div>
          <div style={{ fontSize:12,color:"#ccc" }}>{material.sampling}</div>
        </div>
        <div style={{ background:"#151520",borderRadius:8,padding:"10px 12px" }}>
          <div style={{ fontSize:10,fontWeight:700,color:"#F5C800",textTransform:"uppercase",marginBottom:5 }}>📋 Description</div>
          <div style={{ fontSize:12,color:"#ccc",lineHeight:1.7 }}>{material.description}</div>
        </div>
        <div style={{ background:"#151520",borderRadius:8,padding:"10px 12px" }}>
          <div style={{ fontSize:10,fontWeight:700,color:"#F5C800",textTransform:"uppercase",marginBottom:6 }}>👁️ Indices visuels</div>
          {material.indices.map((ind,i)=>(
            <div key={i} style={{ display:"flex",alignItems:"center",gap:7,marginBottom:4 }}>
              <div style={{ width:5,height:5,borderRadius:"50%",background:meta.color,flexShrink:0 }} />
              <div style={{ fontSize:12,color:"#ccc" }}>{ind}</div>
            </div>
          ))}
        </div>
        <div style={{ background:"#1a0a0a",border:"1px solid #dc262633",borderRadius:8,padding:"10px 12px" }}>
          <div style={{ fontSize:10,fontWeight:700,color:"#dc2626",textTransform:"uppercase",marginBottom:5 }}>📋 Action diagnostiqueur</div>
          <div style={{ fontSize:12,color:"#eee",lineHeight:1.7 }}>{material.action}</div>
        </div>
        {material.csi && !material.csi.startsWith("N/A") && (
          <div style={{ background:"#0a150a",border:"1px solid #22c55e33",borderRadius:8,padding:"10px 12px" }}>
            <div style={{ fontSize:10,fontWeight:700,color:"#22c55e",textTransform:"uppercase",marginBottom:5 }}>📊 Cotation CSI</div>
            <pre style={{ fontSize:11,color:"#ccc",whiteSpace:"pre-wrap",lineHeight:1.8,fontFamily:"inherit",margin:0 }}>{material.csi}</pre>
          </div>
        )}
        <div style={{ background:"#151520",borderRadius:8,padding:"10px 12px" }}>
          <div style={{ fontSize:10,fontWeight:700,color:"#3b82f6",textTransform:"uppercase",marginBottom:6 }}>⚖️ Références</div>
          <div style={{ fontSize:11,color:"#ccc",lineHeight:1.9 }}>
            <div>• <span style={{ color:"#fff" }}>NF X 46-020</span></div>
            <div>• CSP : <span style={{ color:"#fff" }}>Articles L.1334-13 à L.1334-17</span></div>
            <div>• Décret : <span style={{ color:"#fff" }}>n° 96-97 du 7 février 1996</span></div>
          </div>
        </div>
        <div style={{ background:"#1a1500",border:"1px solid #fcd34d33",borderRadius:8,padding:"8px 12px",fontSize:11,color:"#fcd34d",marginBottom:8 }}>
          ⚠️ Seul un prélèvement analysé par un laboratoire accrédité COFRAC confirme la présence d'amiante.
        </div>
      </div>
      {lightbox && (
        <div onClick={()=>setLightbox(null)} style={{ position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.95)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",cursor:"zoom-out" }}>
          <img src={lightbox} alt="" style={{ maxWidth:"90vw",maxHeight:"85vh",borderRadius:12 }} />
          <button onClick={()=>setLightbox(null)} style={{ position:"absolute",top:20,right:24,background:"none",border:"none",color:"#fff",fontSize:36,cursor:"pointer" }}>×</button>
        </div>
      )}
    </div>
  );
}

// ── AmianteNormes ──
function AmianteNormes({ onBack }) {
  const [query, setQuery] = useState("");
  const [aiAnswer, setAiAnswer] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [veille, setVeille] = useState(null);
  const [veilleLoading, setVeilleLoading] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);
  const [activeTab, setActiveTab] = useState("biblio");

  // Charger dernière veille depuis storage partagé
  useEffect(() => {
    const load = async () => {
      try {
        const r = await appStorage.get("amiante_veille_reglementaire");
        if (r) {
          const data = JSON.parse(r.value);
          setVeille(data.content);
          setLastCheck(data.date);
        }
      } catch(e) {}
    };
    load();
  }, []);

  // Lancer la veille réglementaire via IA + recherche web
  const lancerVeille = async () => {
    setVeilleLoading(true);
    try {
      const today = new Date().toLocaleDateString("fr-FR");
      const resp = await fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{ "Content-Type":"application/json","anthropic-version":"2023-06-01","anthropic-dangerous-direct-browser-access":"true" },
        body: JSON.stringify({
          model:"claude-sonnet-4-6", max_tokens:1200,
          tools:[{ type:"web_search_20250305", name:"web_search" }],
          messages:[{ role:"user", content:"Date: "+today+"\n\nTu es expert en réglementation amiante française. Effectue une veille réglementaire sur les dernières évolutions (décrets, arrêtés, NF X 46-020, INRS, DGT, certification diagnostiqueurs, RAT).\n\nRéponds UNIQUEMENT en JSON valide:\n{\"date_veille\":\""+today+"\",\"statut\":\"A jour ou Mises à jour disponibles\",\"alertes\":[{\"niveau\":\"urgent ou important ou info\",\"titre\":\"...\",\"detail\":\"...\",\"source\":\"...\",\"date\":\"...\"}],\"resume\":\"résumé 2-3 phrases\",\"prochaines_echeances\":[\"échéance 1\"]}" }]
        })
      });
      const d = await resp.json();
      const txt = d.content?.filter(b=>b.type==="text").map(b=>b.text).join("") || "";
      const json = txt.match(/\{[\s\S]*\}/)?.[0];
      let result;
      if (json) {
        result = JSON.parse(json);
      } else {
        result = { date_veille: today, statut:"Veille effectuée", alertes:[], resume: txt.slice(0,300), prochaines_echeances:[] };
      }
      // Sauvegarder pour tous les utilisateurs
      await appStorage.set("amiante_veille_reglementaire", JSON.stringify({ content: result, date: today }));
      setVeille(result);
      setLastCheck(today);
    } catch(e) {
      setVeille({ date_veille: new Date().toLocaleDateString("fr-FR"), statut:"Erreur", alertes:[], resume:"Erreur lors de la veille. Vérifiez votre connexion.", prochaines_echeances:[] });
    }
    setVeilleLoading(false);
  };

  const askAI = async () => {
    if (!query.trim()) return;
    setAiLoading(true); setAiAnswer("");
    try {
      const resp = await fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{ "Content-Type":"application/json","anthropic-version":"2023-06-01","anthropic-dangerous-direct-browser-access":"true" },
        body: JSON.stringify({ model:"claude-sonnet-4-6", max_tokens:600,
          tools:[{ type:"web_search_20250305", name:"web_search" }],
          messages:[{ role:"user", content:`Tu es expert en réglementation amiante française pour les diagnostiqueurs immobiliers. Réponds de manière précise à: ${query}. Cite les textes réglementaires applicables et recherche les informations récentes si nécessaire.` }]
        })
      });
      const d = await resp.json();
      setAiAnswer(d.content?.filter(b=>b.type==="text").map(b=>b.text).join("") || "Erreur");
    } catch(e) { setAiAnswer("Erreur de connexion"); }
    setAiLoading(false);
  };

  const NIVEAU_COLOR = { urgent:"#dc2626", important:"#d97706", info:"#3b82f6" };
  const NIVEAU_ICON = { urgent:"🚨", important:"⚠️", info:"ℹ️" };

  const DOCS = [
    { cat:"📋 Norme", items:[{ title:"NF X 46-020", desc:"Repérage des matériaux contenant de l'amiante", url:"https://www.boutique.afnor.org", tag:"AFNOR" }]},
    { cat:"⚖️ Code santé publique", items:[
      { title:"L.1334-13 à L.1334-17", desc:"Obligations de repérage — DTA, listes A et B", url:"https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006072665/LEGISCTA000006171171/", tag:"Legifrance" },
      { title:"R.1334-14 à R.1334-29", desc:"Modalités techniques — contenu du rapport", url:"https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006072665/LEGISCTA000006190995/", tag:"Legifrance" },
    ]},
    { cat:"🔨 Code du travail", items:[
      { title:"R.4412-94 à R.4412-148", desc:"Repérage avant travaux — RAT", url:"https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006072050/LEGISCTA000018533635/", tag:"Legifrance" },
    ]},
    { cat:"📜 Décrets & Arrêtés", items:[
      { title:"Décret n° 96-97", desc:"Protection population — risques amiante", url:"https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000196306/", tag:"Legifrance" },
      { title:"Arrêté 12/12/2012", desc:"Modalités de repérage et certification", url:"https://www.legifrance.gouv.fr/loda/id/JORFTEXT000026876723/", tag:"Legifrance" },
      { title:"Arrêté 16/07/2019", desc:"Certification opérateurs RAT", url:"https://www.legifrance.gouv.fr/loda/id/JORFTEXT000038783953/", tag:"Legifrance" },
    ]},
    { cat:"📚 Guides INRS", items:[
      { title:"Guide ED 6091", desc:"Repérage matériaux amiantés", url:"https://www.inrs.fr/media.html?refINRS=ED%206091", tag:"INRS" },
      { title:"Guide ED 6229", desc:"Repérage avant travaux", url:"https://www.inrs.fr/media.html?refINRS=ED%206229", tag:"INRS" },
    ]},
    { cat:"🏛️ Organismes", items:[
      { title:"COFRAC — Labos accrédités", desc:"Recherche laboratoires analyse amiante", url:"https://www.cofrac.fr/accreditation/recherche-entite/", tag:"COFRAC" },
      { title:"DGT — Prévention amiante", desc:"Fiches et circulaires risque amiante", url:"https://travail-emploi.gouv.fr/sante-au-travail/prevention-des-risques-pour-la-sante-au-travail/article/amiante", tag:"DGT" },
    ]},
  ];
  const TAG_COLORS = { AFNOR:"#3b82f6", Legifrance:"#dc2626", INRS:"#16a34a", COFRAC:"#d97706", DGT:"#7c3aed", ANSES:"#0891b2" };

  return (
    <div style={{ display:"flex",flexDirection:"column",height:"100%",overflowY:"auto" }}>
      <button onClick={onBack} style={{ background:"none",border:"none",color:"#ccc",fontSize:13,fontWeight:700,padding:"8px 0",cursor:"pointer",textAlign:"left",flexShrink:0 }}>← Retour</button>
      <div style={{ fontSize:16,fontWeight:900,color:"#fff",marginBottom:4 }}>⚖️ Normes & Réglementation</div>
      <div style={{ fontSize:11,color:"#999",marginBottom:10 }}>Textes officiels — NFX 46-020 — Diagnostiqueurs immobiliers</div>

      {/* Onglets */}
      <div style={{ display:"flex",gap:5,marginBottom:12,flexShrink:0 }}>
        {[["biblio","📚 Bibliothèque"],["veille","🔔 Veille"],["ia","✨ Question IA"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setActiveTab(id)}
            style={{ flex:1,padding:"7px 4px",borderRadius:8,border:"none",cursor:"pointer",fontWeight:700,fontSize:10,
              background:activeTab===id?"#F5C800":COLORS.surface,
              color:activeTab===id?"#111":COLORS.muted }}>
            {lbl}
          </button>
        ))}
      </div>

      {/* BIBLIOTHÈQUE */}
      {activeTab==="biblio" && (
        <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
          {DOCS.map((section,i)=>(
            <div key={i}>
              <div style={{ fontSize:10,fontWeight:900,color:"#F5C800",marginBottom:5,textTransform:"uppercase",letterSpacing:1 }}>{section.cat}</div>
              <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
                {section.items.map((doc,j)=>(
                  <a key={j} href={doc.url} target="_blank" rel="noreferrer"
                    style={{ display:"flex",alignItems:"center",gap:10,background:"#151520",border:"1px solid #222",borderRadius:8,padding:"9px 12px",textDecoration:"none" }}>
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex",alignItems:"center",gap:5,marginBottom:2 }}>
                        <span style={{ background:TAG_COLORS[doc.tag]||"#666",color:"#fff",borderRadius:4,padding:"1px 6px",fontSize:9,fontWeight:900 }}>{doc.tag}</span>
                        <div style={{ fontWeight:700,fontSize:12,color:"#fff" }}>{doc.title}</div>
                      </div>
                      <div style={{ fontSize:11,color:"#999",lineHeight:1.4 }}>{doc.desc}</div>
                    </div>
                    <div style={{ color:"#555",fontSize:14,flexShrink:0 }}>↗</div>
                  </a>
                ))}
              </div>
            </div>
          ))}
          <div style={{ background:"#1a1500",border:"1px solid #fcd34d33",borderRadius:8,padding:"8px 10px",fontSize:11,color:"#fcd34d" }}>
            ⚠️ Vérifiez toujours la version consolidée sur Légifrance.
          </div>
        </div>
      )}

      {/* VEILLE RÉGLEMENTAIRE */}
      {activeTab==="veille" && (
        <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
          <div style={{ background:"#0f172a",border:"1px solid #1e3a5f",borderRadius:10,padding:"14px" }}>
            <div style={{ fontWeight:800,fontSize:14,color:"#60a5fa",marginBottom:6 }}>🔔 Veille réglementaire automatique</div>
            <div style={{ fontSize:11,color:"#999",marginBottom:10,lineHeight:1.5 }}>
              L'IA effectue une recherche web des dernières évolutions. Résultats partagés avec tous les utilisateurs.
            </div>
            {lastCheck && <div style={{ fontSize:11,color:"#64748b",marginBottom:10 }}>🕐 Dernière mise à jour : <strong style={{ color:"#94a3b8" }}>{lastCheck}</strong></div>}
            <button onClick={lancerVeille} disabled={veilleLoading}
              style={{ width:"100%",padding:"11px",borderRadius:8,border:"none",cursor:"pointer",fontWeight:800,fontSize:13,
                background:veilleLoading?"#334155":"linear-gradient(135deg,#1d4ed8,#3b82f6)",color:"#fff" }}>
              {veilleLoading?"⏳ Recherche en cours...":"🔍 Lancer la veille maintenant"}
            </button>
          </div>
          {veille && (
            <div style={{ display:"flex",flexDirection:"column",gap:8 }}>
              <div style={{ background:veille.statut?.includes("jour")?"#14532d22":"#7f1d1d22",
                border:"1px solid "+(veille.statut?.includes("jour")?"#16a34a44":"#dc262644"),
                borderRadius:10,padding:"12px 14px" }}>
                <div style={{ fontWeight:800,fontSize:13,color:veille.statut?.includes("jour")?"#22c55e":"#f87171",marginBottom:4 }}>
                  {veille.statut?.includes("jour")?"✅":"🔴"} {veille.statut}
                </div>
                <div style={{ fontSize:12,color:"#ccc",lineHeight:1.6 }}>{veille.resume}</div>
              </div>
              {veille.alertes?.length > 0 && (
                <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
                  <div style={{ fontSize:11,fontWeight:700,color:"#F5C800",textTransform:"uppercase",letterSpacing:1 }}>🚨 Alertes</div>
                  {veille.alertes.map((a,i)=>(
                    <div key={i} style={{ background:"#151520",border:"1px solid "+(NIVEAU_COLOR[a.niveau]||"#333")+"44",borderRadius:8,padding:"10px 12px" }}>
                      <div style={{ display:"flex",alignItems:"center",gap:6,marginBottom:4 }}>
                        <span style={{ background:NIVEAU_COLOR[a.niveau]||"#666",color:"#fff",borderRadius:4,padding:"1px 8px",fontSize:9,fontWeight:900,textTransform:"uppercase" }}>
                          {NIVEAU_ICON[a.niveau]||"ℹ️"} {a.niveau}
                        </span>
                        {a.date && <span style={{ fontSize:10,color:"#666" }}>{a.date}</span>}
                      </div>
                      <div style={{ fontWeight:700,fontSize:12,color:"#fff",marginBottom:3 }}>{a.titre}</div>
                      <div style={{ fontSize:11,color:"#ccc",lineHeight:1.5 }}>{a.detail}</div>
                      {a.source && <div style={{ fontSize:10,color:"#64748b",marginTop:4 }}>Source : {a.source}</div>}
                    </div>
                  ))}
                </div>
              )}
              {veille.prochaines_echeances?.length > 0 && (
                <div style={{ background:"#151520",border:"1px solid #222",borderRadius:10,padding:"12px" }}>
                  <div style={{ fontSize:11,fontWeight:700,color:"#F5C800",textTransform:"uppercase",letterSpacing:1,marginBottom:8 }}>📅 Prochaines échéances</div>
                  {veille.prochaines_echeances.map((e,i)=>(
                    <div key={i} style={{ display:"flex",alignItems:"center",gap:8,marginBottom:5 }}>
                      <div style={{ width:6,height:6,borderRadius:"50%",background:"#3b82f6",flexShrink:0 }} />
                      <div style={{ fontSize:12,color:"#ccc" }}>{e}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {!veille && !veilleLoading && (
            <div style={{ textAlign:"center",color:"#555",fontSize:12,padding:20 }}>
              Cliquez sur "Lancer la veille" pour obtenir les dernières actualités réglementaires
            </div>
          )}
        </div>
      )}

      {/* QUESTION IA */}
      {activeTab==="ia" && (
        <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
          <div style={{ background:"#1a1a2e",border:"1px solid #4f46e5",borderRadius:10,padding:"12px" }}>
            <div style={{ fontSize:12,fontWeight:700,color:"#818cf8",marginBottom:6 }}>✨ Posez une question réglementaire</div>
            <div style={{ fontSize:11,color:"#999",marginBottom:8 }}>L'IA recherche les textes applicables avec les références précises.</div>
            <textarea value={query} onChange={e=>setQuery(e.target.value)}
              placeholder="Ex: Quand doit-on faire un repérage avant travaux ?"
              rows={3} style={{ width:"100%",background:"#0f0f1a",border:"1px solid #333",borderRadius:7,padding:"8px 10px",color:"#fff",fontSize:12,outline:"none",resize:"none",boxSizing:"border-box",marginBottom:8 }} />
            <button onClick={askAI} disabled={aiLoading||!query.trim()}
              style={{ width:"100%",padding:"10px",borderRadius:8,border:"none",cursor:"pointer",fontWeight:700,fontSize:13,
                background:query.trim()?"linear-gradient(135deg,#4f46e5,#7c3aed)":"#333",color:"#fff" }}>
              {aiLoading?"⏳ Recherche...":"✨ Obtenir une réponse"}
            </button>
          </div>
          {aiAnswer && (
            <div style={{ background:"#151520",border:"1px solid #333",borderRadius:10,padding:"14px" }}>
              <div style={{ fontSize:11,fontWeight:700,color:"#818cf8",marginBottom:8 }}>📋 Réponse</div>
              <div style={{ fontSize:12,color:"#ccc",lineHeight:1.8,whiteSpace:"pre-wrap" }}>{aiAnswer}</div>
            </div>
          )}
          <div style={{ background:"#1a1500",border:"1px solid #fcd34d33",borderRadius:8,padding:"8px 10px",fontSize:11,color:"#fcd34d" }}>
            ⚠️ Réponse indicative — vérifiez toujours sur Légifrance.
          </div>
        </div>
      )}
    </div>
  );
}


// ── MODULE AMIANTE PRINCIPAL ──
function Amiante() {
  const [allMaterials, setAllMaterials] = useState(
    AMIANTE_MATERIALS.filter(m => m && m.id).sort((a,b) => a.name.localeCompare(b.name,"fr"))
  );
  const [screen, setScreen] = useState("home");
  const [query, setQuery] = useState("");
  const [selectedList, setSelectedList] = useState("ALL");
  const [selected, setSelected] = useState(allMaterials[0]);
  const [photoResult, setPhotoResult] = useState(null);
  const [photoLoading, setPhotoLoading] = useState(false);
  const [photoInput, setPhotoInput] = useState(null);
  const [photoBase64, setPhotoBase64] = useState(null);
  const [photoMime, setPhotoMime] = useState("image/jpeg");
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== "undefined" && window.innerWidth >= 768);
  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Charger photos partagées + matériaux custom depuis storage
  useEffect(() => {
    const load = async () => {
      try {
        let base = AMIANTE_MATERIALS.filter(m => m && m.id);
        // Photos partagées (cloud Vercel Blob privé, servies via /api/photo)
        try {
          const resp = await fetch("/api/photos");
          if (resp.ok) {
            const data = await resp.json();
            if (data.byMatId) {
              base = base.map(m => {
                const cloudPhotos = (data.byMatId[m.id] || []).map(p => `/api/photo?url=${encodeURIComponent(p.url)}`);
                return { ...m, photos: cloudPhotos.length ? cloudPhotos : (m.photos||[]) };
              });
            }
          }
        } catch(e) {}
        // Matériaux custom
        try {
          const rCustom = await appStorage.get("amiante_custom_materials");
          if (rCustom) {
            const custom = JSON.parse(rCustom.value);
            const ids = base.map(m => m.id);
            base = [...base, ...custom.filter(m => !ids.includes(m.id))];
          }
        } catch(e) {}
        const sorted = base.sort((a,b) => a.name.localeCompare(b.name,"fr"));
        setAllMaterials(sorted);
        setSelected(sorted[0]);
      } catch(e) {}
    };
    load();
  }, []);

  const ALL = allMaterials;
  const filtered = ALL
    .filter(m => m && m.id)
    .filter(m => selectedList==="ALL" || m.list===selectedList)
    .filter(m => ((m.name||"")+" "+(m.family||"")+" "+(m.location||"")).toLowerCase().includes(query.toLowerCase()));

  const counts = { A:ALL.filter(m=>m.list==="A").length, B:ALL.filter(m=>m.list==="B").length, C:ALL.filter(m=>m.list==="C").length };
  const LC = { A:"#dc2626", B:"#d97706", C:"#4f46e5" };
  const LS = { A:"Matériaux dangereux", B:"Matériaux accessibles", C:"Avant démolition" };
  const BG = { background:"radial-gradient(circle at top right,#263446 0,#05070a 42%,#000 100%)" };

  const handlePhotoSearch = async (file) => {
    if (!file) return;
    setPhotoLoading(true); setPhotoResult(null);
    try {
      const base64 = await new Promise((res,rej) => { const r=new FileReader(); r.onload=()=>res(r.result.split(",")[1]); r.onerror=rej; r.readAsDataURL(file); });
      setPhotoBase64(base64); // stocker pour le chat IA suivi
      setPhotoMime(file.type || "image/jpeg");
      const resp = await fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "",
          "anthropic-version":"2023-06-01",
          "anthropic-dangerous-direct-browser-access":"true"
        },
        body:JSON.stringify({ model:"claude-sonnet-4-6", max_tokens:1000,
          messages:[{ role:"user", content:[
            { type:"image", source:{ type:"base64", media_type:file.type||"image/jpeg", data:base64 }},
            { type:"text", text:`Tu es expert amiante (norme NFX 46-020, listes A/B/C, RAAT).

Analyse cette photo en profondeur :
1. Identifie le matériau (faux-plafond, dalle vinyle, plaque fibrociment, calorifuge, joint, etc.)
2. Donne le contexte technique (type de pose, époque probable, état)
3. Évalue la probabilité de présence d'amiante et les indices visuels
4. Classe sur les listes NFX 46-020 (A=dangereux, B=accessibles, C=avant démolition, Inconnu si pas de match)
5. Donne un conseil terrain pratique pour le diagnostiqueur

Réponds UNIQUEMENT en JSON valide :
{"materiau":"nom précis du matériau","liste":"A ou B ou C ou Inconnu","confiance":"Élevée ou Moyenne ou Faible","indices":["indice visuel 1","indice visuel 2","indice visuel 3"],"conseil":"conseil terrain détaillé (procédure, prélèvement, EPI, urgence)","avertissement":"Seul un laboratoire COFRAC peut confirmer la présence d'amiante."}` }
          ]}]
        })
      });
      const d = await resp.json();
      const txt = d.content?.map(b=>b.text||"").join("") || "";
      const json = txt.match(/\{[\s\S]*\}/)?.[0];
      setPhotoResult(json ? JSON.parse(json) : { materiau:"Non identifié", liste:"Inconnu", confiance:"Faible", indices:[], conseil:"Faites appel à un expert terrain.", avertissement:"Seul un laboratoire COFRAC peut confirmer la présence d'amiante." });
    } catch(e) {
      console.error("Erreur scan amiante:", e);
      setPhotoResult({ materiau:"Erreur d'analyse", liste:"Inconnu", confiance:"Faible", indices:[], conseil:"Vérifiez votre connexion ou réessayez.", avertissement:"Seul un laboratoire COFRAC peut confirmer la présence d'amiante." });
    }
    setPhotoLoading(false);
  };

  return (
    <div style={{ ...BG, display:"flex", flexDirection:"column", height:"calc(100vh - 160px)", borderRadius:12, overflow:"hidden", color:"#fff" }}>
      {/* HEADER */}
      <div style={{ padding:"12px 14px 0", flexShrink:0 }}>
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}>
          <div style={{ width:44,height:44,borderRadius:12,background:"linear-gradient(135deg,#dc2626,#7f1d1d)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
            <div style={{ fontSize:20,fontWeight:900,lineHeight:1 }}>a</div>
            <div style={{ fontSize:6,fontWeight:800,textTransform:"uppercase",letterSpacing:1 }}>Amiante</div>
          </div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:18,fontWeight:900,letterSpacing:0.5 }}>BIBLE AMIANTE</div>
            <div style={{ fontSize:9,color:"#dc2626",fontWeight:800,textTransform:"uppercase",letterSpacing:1 }}>Pour les diagnostiqueurs — NFX 46-020</div>
          </div>
          {screen!=="home" && <button onClick={()=>setScreen("home")} style={{ background:"none",border:"1px solid #333",borderRadius:8,color:"#ccc",padding:"4px 10px",fontSize:11,cursor:"pointer" }}>← Retour</button>}
        </div>
        {/* Boutons A/B/C — couleurs pleines, alignés */}
        <div style={{ display:"flex",gap: isDesktop ? 8 : 5, marginBottom:10 }}>
          {["A","B","C"].map(l=>(
            <div key={l} onClick={()=>{ setSelectedList(l); setScreen("library"); }}
              style={{
                flex:1, borderRadius:9, padding: isDesktop ? "12px 12px" : "10px 8px",
                cursor:"pointer",
                display:"flex", flexDirection:"column",
                minHeight: isDesktop ? 78 : 64,
                background: LC[l],
                border:"1px solid "+LC[l],
                boxShadow:`0 2px 8px ${LC[l]}55`,
                transition:"transform 0.1s",
              }}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center" }}>
                <div style={{ fontSize: isDesktop ? 16 : 13, fontWeight:900, color:"#fff", letterSpacing:0.5 }}>LISTE {l}</div>
                <div style={{ color:"#ffffffaa", fontSize: isDesktop ? 18 : 14 }}>›</div>
              </div>
              <div style={{ fontSize: isDesktop ? 11 : 9, color:"#ffffffdd", marginTop:2, lineHeight:1.3, fontWeight:600 }}>{LS[l]}</div>
              <div style={{ fontSize: isDesktop ? 13 : 11, fontWeight:800, color:"#fff", marginTop:"auto", paddingTop:4 }}>{counts[l]} matériaux</div>
            </div>
          ))}
        </div>
      </div>

      {/* CONTENU */}
      <div style={{ flex:1,overflowY:"auto",padding:"6px 14px 14px" }}>

        {/* HOME */}
        {screen==="home" && (
          <div style={{ display:"flex",flexDirection:"column",gap:8 }}>
            {[
              { s:"photo",n:"1",icon:"📷",color:"#dc2626",title:"Identification par photo IA",text:"Prenez une photo — l'IA identifie le matériau dans la bibliothèque NFX 46-020." },
              { s:"library",n:"2",icon:"🔍",color:"#f97316",title:"Recherche rapide",text:"Saisissez un mot-clé et trouvez le matériau avec sa fiche illustrée." },
              { s:"library",n:"3",icon:"📋",color:"#22c55e",title:"Fiches détaillées",text:"Photos, descriptifs, indices visuels, risques et actions terrain." },
            ].map(b=>(
              <div key={b.s+b.n} onClick={()=>setScreen(b.s)} style={{ display:"flex",alignItems:"center",gap:12,padding:"12px",borderRadius:12,background:"rgba(0,0,0,0.5)",border:"1px solid #333",cursor:"pointer" }}>
                <div style={{ width:56,height:56,borderRadius:12,border:"1px solid "+b.color+"55",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0,background:b.color+"11" }}>{b.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:"flex",alignItems:"center",gap:7,marginBottom:3 }}>
                    <div style={{ background:b.color,color:"#fff",borderRadius:6,padding:"1px 8px",fontSize:12,fontWeight:900 }}>{b.n}</div>
                    <div style={{ fontSize:13,fontWeight:900,textTransform:"uppercase" }}>{b.title}</div>
                  </div>
                  <div style={{ fontSize:11,color:"#ccc",lineHeight:1.5 }}>{b.text}</div>
                </div>
                <div style={{ color:"#999",fontSize:16 }}>›</div>
              </div>
            ))}
            <div style={{ background:"#dc262611",border:"1px solid #dc262633",borderRadius:10,padding:"10px 12px",display:"flex",gap:8 }}>
              <div style={{ fontSize:20,flexShrink:0 }}>⚠️</div>
              <div><div style={{ fontWeight:800,color:"#dc2626",fontSize:11,textTransform:"uppercase" }}>Une photo ne confirme jamais la présence d'amiante</div><div style={{ fontSize:11,color:"#ccc",marginTop:2 }}>Seul un prélèvement analysé par un labo accrédité COFRAC fait foi.</div></div>
            </div>
            <div onClick={()=>setScreen("normes")} style={{ display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid #333",cursor:"pointer" }}>
              <div style={{ fontSize:22 }}>⚖️</div>
              <div style={{ flex:1 }}><div style={{ fontWeight:800,fontSize:12,textTransform:"uppercase" }}>Normes & Réglementation</div><div style={{ fontSize:10,color:"#bbb" }}>NF X 46-020, obligations légales, textes officiels.</div></div>
              <div style={{ color:"#999" }}>›</div>
            </div>
            <div style={{ display:"flex",gap:6,padding:"8px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid #222",textAlign:"center" }}>
              {[["☢️",ALL.length+" matériaux"],["✅","NF X 46-020"],["🛡️","Sécurité terrain"],["⚡","Gain de temps"]].map(([icon,lbl],i)=>(
                <div key={i} style={{ flex:1 }}><div style={{ fontSize:14 }}>{icon}</div><div style={{ fontSize:8,color:"#ccc",marginTop:2,lineHeight:1.2 }}>{lbl}</div></div>
              ))}
            </div>
          </div>
        )}

        {/* BIBLIOTHÈQUE */}
        {screen==="library" && (
          <div>
            <div style={{ marginBottom:8 }}>
              <input value={query} onChange={e=>setQuery(e.target.value)} placeholder="🔍 Rechercher un matériau..."
                style={{ width:"100%",background:"#1a1a1a",border:"1px solid #333",borderRadius:8,padding:"8px 12px",color:"#fff",fontSize:12,outline:"none",boxSizing:"border-box" }} />
              <div style={{ display:"flex",gap:5,marginTop:6 }}>
                {["ALL","A","B","C"].map(l=>(
                  <button key={l} onClick={()=>setSelectedList(l)}
                    style={{ padding:"4px 12px",borderRadius:20,fontSize:11,fontWeight:700,cursor:"pointer",border:"none",
                      background:selectedList===l?(l==="ALL"?"#fff":LC[l]):"#1a1a1a",
                      color:selectedList===l?(l==="ALL"?"#000":"#fff"):"#666" }}>
                    {l==="ALL"?"Toutes":"Liste "+l}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
              {filtered.filter(m => m && m.id).map(m=>{
                const mm = AMIANTE_LIST_META[m.list] || { color: "#888", label: "Liste ?" };
                const risk = m.risk || "Moyen";
                return (
                  <div key={m.id} onClick={()=>{ setSelected(m); setScreen("detail"); }}
                    style={{ display:"flex",gap:10,padding:"8px 10px",borderRadius:10,background:"rgba(255,255,255,0.04)",border:"1px solid #222",cursor:"pointer" }}>
                    <div style={{ width:64,height:48,borderRadius:7,overflow:"hidden",flexShrink:0,background:"#2a1a0a",display:"flex",alignItems:"center",justifyContent:"center" }}>
                      {m.photos?.[0]
                        ? <img src={m.photos[0]} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }}
                            onError={e=>{e.target.style.display="none"; e.target.parentNode.querySelector('.ph-fallback').style.display="flex";}} />
                        : null}
                      <span className="ph-fallback" style={{ display: m.photos?.[0] ? "none" : "flex", fontSize:20 }}>☢️</span>
                    </div>
                    <div style={{ flex:1,minWidth:0 }}>
                      <div style={{ display:"flex",gap:4,marginBottom:3 }}>
                        <span style={{ background:mm.color,color:"#fff",borderRadius:4,padding:"1px 6px",fontSize:9,fontWeight:900 }}>LISTE {m.list || "?"}</span>
                        <span style={{ background:risk.includes("Très")?"#dc262222":risk.includes("Élevé")?"#ea580c22":"#d9770622",color:risk.includes("Très")?"#f87171":risk.includes("Élevé")?"#fb923c":"#fbbf24",borderRadius:4,padding:"1px 5px",fontSize:9,fontWeight:700 }}>{risk}</span>
                      </div>
                      <div style={{ fontWeight:700,fontSize:12,color:"#fff",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{m.name || "Sans nom"}</div>
                      <div style={{ fontSize:10,color:"#999",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{m.location || ""}</div>
                    </div>
                    <div style={{ color:"#444",fontSize:16,alignSelf:"center" }}>›</div>
                  </div>
                );
              })}
              {filtered.length===0 && <div style={{ textAlign:"center",color:"#999",fontSize:13,padding:20 }}>Aucun résultat pour "{query}"</div>}
            </div>
          </div>
        )}

        {screen==="detail" && selected && <AmianteDetail material={selected} onBack={()=>setScreen("library")} />}

        {screen==="normes" && <AmianteNormes onBack={()=>setScreen("home")} />}

        {/* PHOTO IA */}
        {screen==="photo" && (
          <div style={{ display:"flex",flexDirection:"column",gap:10 }}>
            <button onClick={()=>setScreen("home")} style={{ background:"none",border:"none",color:"#ccc",fontSize:13,fontWeight:700,cursor:"pointer",textAlign:"left" }}>← Retour</button>
            <div style={{ background:"#dc262611",border:"1px solid #dc262633",borderRadius:12,padding:"14px",textAlign:"center" }}>
              <div style={{ fontSize:36,marginBottom:8 }}>📷</div>
              <div style={{ fontWeight:900,fontSize:14,textTransform:"uppercase",marginBottom:12 }}>Identification par photo</div>
              <div style={{ textAlign:"left",display:"flex",flexDirection:"column",gap:8,marginBottom:14 }}>
                <div style={{ display:"flex",alignItems:"flex-start",gap:10,background:"rgba(255,255,255,0.05)",borderRadius:8,padding:"8px 10px" }}>
                  <div style={{ background:"#dc2626",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:12,flexShrink:0 }}>1</div>
                  <div style={{ fontSize:12,color:"#ccc",lineHeight:1.5 }}>Prenez en photo le matériau ou produit suspect</div>
                </div>
                <div style={{ display:"flex",alignItems:"flex-start",gap:10,background:"rgba(255,255,255,0.05)",borderRadius:8,padding:"8px 10px" }}>
                  <div style={{ background:"#d97706",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:12,flexShrink:0 }}>2</div>
                  <div style={{ fontSize:12,color:"#ccc",lineHeight:1.5 }}>L'application recherche une correspondance dans sa bibliothèque</div>
                </div>
                <div style={{ display:"flex",alignItems:"flex-start",gap:10,background:"rgba(255,255,255,0.05)",borderRadius:8,padding:"8px 10px" }}>
                  <div style={{ background:"#4f46e5",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:12,flexShrink:0 }}>3</div>
                  <div style={{ fontSize:12,color:"#ccc",lineHeight:1.5 }}>Si le produit n'est pas identifié, l'intelligence artificielle prend le relais pour affiner l'analyse</div>
                </div>
              </div>
              <div style={{ display:"flex",gap:8 }}>
                <label style={{ flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:8,background:"#dc2626",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer" }}>
                  📷 Prendre une photo
                  <input type="file" accept="image/*" capture="environment" style={{ display:"none" }} onChange={e=>{ if(e.target.files[0]){ setPhotoInput(URL.createObjectURL(e.target.files[0])); handlePhotoSearch(e.target.files[0]); } }} />
                </label>
                <label style={{ flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:8,background:"#1a1a2e",border:"1px solid #333",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer" }}>
                  🖼️ Télécharger image
                  <input type="file" accept="image/*" style={{ display:"none" }} onChange={e=>{ if(e.target.files[0]){ setPhotoInput(URL.createObjectURL(e.target.files[0])); handlePhotoSearch(e.target.files[0]); } }} />
                </label>
              </div>
            </div>
            {photoInput && <div style={{ borderRadius:10,overflow:"hidden",background:"#1a1a1a",height:160 }}><img src={photoInput} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }} /></div>}
            {photoLoading && <div style={{ textAlign:"center",padding:20,color:"#F5C800" }}><div style={{ fontSize:28,marginBottom:6 }}>⏳</div><div style={{ fontSize:13,fontWeight:700 }}>Analyse IA en cours...</div></div>}
            {photoResult && !photoLoading && (
              <div style={{ display:"flex",flexDirection:"column",gap:8 }}>
                <div style={{ background:(photoResult.liste!=="Inconnu"&&AMIANTE_LIST_META[photoResult.liste])?AMIANTE_LIST_META[photoResult.liste].color+"22":"#33333322",border:"1px solid "+((photoResult.liste!=="Inconnu"&&AMIANTE_LIST_META[photoResult.liste])?AMIANTE_LIST_META[photoResult.liste].color+"55":"#555"),borderRadius:10,padding:"12px" }}>
                  <div style={{ fontWeight:900,fontSize:14,color:"#fff",marginBottom:6 }}>{photoResult.materiau}</div>
                  <div style={{ display:"flex",gap:6,marginBottom:8 }}>
                    {photoResult.liste!=="Inconnu" && AMIANTE_LIST_META[photoResult.liste] && <span style={{ background:AMIANTE_LIST_META[photoResult.liste].color,color:"#fff",borderRadius:5,padding:"2px 8px",fontSize:10,fontWeight:900 }}>LISTE {photoResult.liste}</span>}
                    <span style={{ background:"#22222255",color:"#ccc",borderRadius:5,padding:"2px 8px",fontSize:10 }}>Confiance : {photoResult.confiance}</span>
                  </div>
                  {photoResult.indices?.map((ind,i)=><div key={i} style={{ fontSize:11,color:"#ccc",marginBottom:2 }}>• {ind}</div>)}
                  <div style={{ fontSize:11,color:"#bbb",marginTop:6,lineHeight:1.6 }}>{photoResult.conseil}</div>
                </div>
                <div style={{ background:"#1a1500",border:"1px solid #fcd34d33",borderRadius:8,padding:"8px 10px",fontSize:11,color:"#fcd34d" }}>⚠️ {photoResult.avertissement}</div>
                {photoResult.liste!=="Inconnu" && AMIANTE_LIST_META[photoResult.liste] && (
                  <button onClick={()=>{ setSelectedList(photoResult.liste); setQuery(photoResult.materiau.split(" ")[0]); setScreen("library"); }}
                    style={{ background:"#dc2626",color:"#fff",borderRadius:8,padding:"10px",fontWeight:700,fontSize:12,border:"none",cursor:"pointer" }}>
                    🔍 Voir les fiches Liste {photoResult.liste}
                  </button>
                )}

                {/* Chat IA + bouton Nouvelle photo */}
                <ScanFollowupChat
                  imageBase64={photoBase64}
                  imageMime={photoMime}
                  context={`Matériau identifié : ${photoResult.materiau}\nListe NFX 46-020 : ${photoResult.liste}\nConfiance : ${photoResult.confiance}\nIndices : ${(photoResult.indices||[]).join(" ; ")}\nConseil terrain : ${photoResult.conseil}`}
                  systemPrompt="Tu es un expert amiante (norme NFX 46-020, listes A/B/C). Tu réponds aux questions du diagnostiqueur sur le matériau de la photo : risques, prélèvement, urgence, procédure laboratoire COFRAC, classification. Concis et factuel. Rappelle qu'aucune confirmation amiante ne peut être donnée sans analyse en laboratoire."
                  color="#dc2626"
                  onReset={() => {
                    setPhotoResult(null);
                    setPhotoInput(null);
                    setPhotoBase64(null);
                  }}
                />
              </div>
            )}
            <div style={{ background:"#1a1500",border:"1px solid #fcd34d22",borderRadius:8,padding:"8px 10px",fontSize:10,color:"#fcd34d" }}>⚠️ L'IA ne confirme jamais la présence d'amiante. Seul un laboratoire accrédité COFRAC peut le faire.</div>
          </div>
        )}
      </div>
    </div>
  );
}


// ── Composant : ligne d'un item ELEC avec 4 boutons OUI/NON/NV/SO + commentaire ──
function ElecItemRow({ item, response, sev, onChangeValue, onChangeComment, highlight }) {
  const [showComment, setShowComment] = React.useState(!!response?.comment);
  const r = response || { value: "", comment: "" };
  const hasResponse = r.value || r.comment;

  return (
    <div style={{
      background: highlight ? "#7f1d1d22" : "#0a0a0a",
      borderRadius: 6, padding: "8px 10px", marginBottom: 6,
      border: `1px solid ${highlight ? "#dc262644" : "#222"}`,
    }}>
      {/* Ligne 1 : code + libellé + sévérité (cliquable pour effacer) */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 10, fontFamily: "monospace", fontWeight: 800, color: "#fcd34d", flexShrink: 0, paddingTop: 2 }}>
          {item.id}
        </span>
        <span style={{ fontSize: 11, color: "#ddd", flex: 1, lineHeight: 1.35 }}>
          {item.label}
        </span>
        {hasResponse ? (
          <button
            onClick={() => { onChangeValue(""); onChangeComment(""); setShowComment(false); }}
            title="Cliquer pour rejeter cette anomalie / effacer la réponse"
            style={{
              fontSize: 11, fontWeight: 800, color: "#fff",
              padding: "3px 7px", borderRadius: 4,
              background: sev.color, border: "none",
              cursor: "pointer", flexShrink: 0,
              display: "flex", alignItems: "center", gap: 4,
            }}>
            {sev.icon} ✕
          </button>
        ) : (
          <span style={{ fontSize: 9, fontWeight: 800, color: sev.color, padding: "2px 5px", borderRadius: 3, background: "#0008", flexShrink: 0 }}>
            {sev.icon}
          </span>
        )}
      </div>

      {/* Ligne 2 : 4 boutons OUI/NON/NV/SO */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 4, marginBottom: r.comment || showComment ? 6 : 0 }}>
        {["OUI", "NON", "NV", "SO"].map(v => {
          const code = ELEC_RESPONSE_CODES[v];
          const active = r.value === v;
          return (
            <button key={v} onClick={() => onChangeValue(v)}
              style={{
                padding: "6px 4px", borderRadius: 5, border: `1px solid ${active ? code.color : "#333"}`,
                background: active ? code.bg : "transparent",
                color: active ? "#fff" : code.color,
                fontSize: 10, fontWeight: 800, cursor: "pointer", letterSpacing: 0.3,
              }}>
              {code.icon} {v}
            </button>
          );
        })}
      </div>

      {/* Ligne 3 : commentaire (si actif ou existant) */}
      {(r.comment || showComment) ? (
        <textarea
          value={r.comment || ""}
          onChange={e => onChangeComment(e.target.value)}
          placeholder="Commentaire (optionnel) — pièce, observations, contexte..."
          rows={2}
          style={{
            width: "100%", padding: "6px 8px", borderRadius: 5,
            border: "1px solid #333", background: "#0a0a0a",
            color: "#ddd", fontSize: 11, fontFamily: "inherit",
            resize: "vertical", boxSizing: "border-box",
          }}
        />
      ) : (
        <button onClick={() => setShowComment(true)}
          style={{
            background: "none", border: "none", color: "#666", fontSize: 10,
            cursor: "pointer", padding: "2px 0",
          }}>
          + Ajouter un commentaire
        </button>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════
// MODULE SCAN/ELEC — Helpers pour le format de réponses V2
// ══════════════════════════════════════════════════════

// Récupère le format unifié des réponses (responses ou anomalies legacy)
// Retourne un objet { id: { value: "OUI"|"NON"|"NV"|"SO", comment: string } }
function getPhotoResponses(photo) {
  if (!photo) return {};
  // Nouveau format
  if (photo.responses && typeof photo.responses === "object") return photo.responses;
  // Legacy : tableau d'anomalies (codes cochés = NON)
  if (Array.isArray(photo.anomalies)) {
    const responses = {};
    for (const id of photo.anomalies) {
      responses[id] = { value: "NON", comment: "" };
    }
    return responses;
  }
  return {};
}

// Compte les anomalies (réponses NON) d'une photo
function countAnomalies(photo) {
  const responses = getPhotoResponses(photo);
  return Object.values(responses).filter(r => r && r.value === "NON").length;
}

// Compte par sévérité pour un dossier
function countBySeverity(photos) {
  const counts = { critique: 0, majeur: 0, mineur: 0 };
  for (const photo of photos || []) {
    const responses = getPhotoResponses(photo);
    for (const [id, r] of Object.entries(responses)) {
      if (r && r.value === "NON") {
        const item = findElecItem(id);
        if (item) counts[item.severity] = (counts[item.severity] || 0) + 1;
      }
    }
  }
  return counts;
}

// Trouve un item dans le référentiel ELEC_ITEMS
function findElecItem(id) {
  for (const sec of Object.values(ELEC_ITEMS)) {
    const it = sec.items.find(i => i.id === id);
    if (it) return it;
  }
  return null;
}

// ══════════════════════════════════════════════════════
// MODULE PARASITE SCAN — Analyse IA pathologies du bois (mérule, termites, champignons...)
// ══════════════════════════════════════════════════════
function ParasiteRadar() {
  const [view, setView] = useState("home"); // "home" | "analyze"
  const [localisation, setLocalisation] = useState("");
  const [photoCloseup, setPhotoCloseup] = useState(null);
  const [photoFar, setPhotoFar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const PARASITE_GREEN = "#65d11c";
  const PARASITE_GREEN_DARK = "#4a9c14";

  // Compression image
  const handleFileSelect = (file, target) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const maxWidth = 1280;
        const ratio = Math.min(1, maxWidth / img.width);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL("image/jpeg", 0.78);
        if (target === "closeup") setPhotoCloseup({ dataUrl });
        else setPhotoFar({ dataUrl });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleAnalyze = async () => {
    if (!photoCloseup || !photoFar) {
      setError("Les 2 photos sont requises (gros plan + recul).");
      return;
    }
    setError("");
    setLoading(true);
    setResult(null);
    try {
      const res = await fetch("/api/parasite-analyze", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          photoCloseup: photoCloseup.dataUrl,
          photoFar: photoFar.dataUrl,
          localisation: localisation || "Non précisé",
        }),
      });
      if (!res.ok) throw new Error("Erreur analyse IA");
      const data = await res.json();
      setResult(data);
    } catch (e) {
      setError("Erreur lors de l'analyse. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setLocalisation("");
    setPhotoCloseup(null);
    setPhotoFar(null);
    setResult(null);
    setError("");
  };

  const confianceColor = (niv) => {
    if (niv === "Élevé" || niv === "Élevée" || niv === "high") return "#22c55e";
    if (niv === "Moyen" || niv === "Moyenne" || niv === "medium") return "#f97316";
    return "#94a3b8";
  };

  const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;

  // ─────────────────────────────────────────────
  // VUE HOME — Page d'accueil punchy
  // ─────────────────────────────────────────────
  if (view === "home") {
    return (
      <div>
        {/* Page d'accueil engageante */}
        <div style={{ textAlign: "center", padding: isDesktop ? "40px 16px 30px" : "28px 12px 22px" }}>
          <div style={{ fontSize: isDesktop ? 72 : 56, marginBottom: 8 }}>🔬</div>
          <div style={{
            fontSize: isDesktop ? 30 : 24, fontWeight: 900, color: PARASITE_GREEN,
            marginBottom: 6, letterSpacing: -0.5,
          }}>
            PARASITE/SCAN
          </div>
          <div style={{ fontSize: isDesktop ? 13 : 12, color: "#aaa", lineHeight: 1.5, maxWidth: 360, margin: "0 auto" }}>
            Identifiez un désordre parasitaire en un clic.<br />
            Mérule · Termites · Parasites · Champignons
          </div>
        </div>

        {/* Bouton démarrer */}
        <button onClick={() => { handleReset(); setView("analyze"); }}
          style={{
            width: "100%",
            padding: isDesktop ? "20px 32px" : "18px 24px",
            background: `linear-gradient(135deg, ${PARASITE_GREEN} 0%, ${PARASITE_GREEN_DARK} 100%)`,
            color: "#fff", border: "none", borderRadius: 14,
            fontSize: isDesktop ? 17 : 16, fontWeight: 800, cursor: "pointer",
            boxShadow: `0 4px 20px ${PARASITE_GREEN}66`,
            display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 12,
            marginBottom: 20,
          }}>
          <span style={{ fontSize: 22 }}>📷</span>
          <span>Démarrer une analyse</span>
        </button>

        {/* 4 cards pathologies */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
          {[
            { icon: "🍄", label: "MÉRULE" },
            { icon: "🦗", label: "TERMITES" },
            { icon: "🐛", label: "PARASITES BOIS" },
            { icon: "🍂", label: "POURRITURES" },
          ].map(c => (
            <div key={c.label} style={{
              background: PARASITE_GREEN + "11", border: `1px solid ${PARASITE_GREEN}33`,
              borderRadius: 10, padding: 12, textAlign: "center",
            }}>
              <div style={{ fontSize: 22, marginBottom: 4 }}>{c.icon}</div>
              <div style={{ fontSize: 10, fontWeight: 700, color: PARASITE_GREEN }}>{c.label}</div>
            </div>
          ))}
        </div>

        <div style={{ fontSize: 10, color: "#666", textAlign: "center", fontStyle: "italic", padding: 8, marginBottom: 14 }}>
          ⚡ Analyse IA · 2 photos · Résultat en 10 secondes
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────────
  // VUE ANALYZE — Saisie photos + analyse + résultat
  // ─────────────────────────────────────────────
  return (
    <div>
      {/* Bouton retour */}
      <button onClick={() => { setView("home"); handleReset(); }}
        style={{ marginBottom: 12, padding: "8px 14px", background: "#1e293b", color: "#94a3b8", border: "none", borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
        ← Retour
      </button>

      <div style={{ ...styles.card, background: `${PARASITE_GREEN}11`, borderColor: PARASITE_GREEN }}>
        <div style={{ fontSize: 16, fontWeight: 800, color: PARASITE_GREEN, marginBottom: 6 }}>
          🔬 Nouvelle analyse
        </div>
        <div style={{ fontSize: 12, color: "#aaa", lineHeight: 1.5 }}>
          Prenez 2 photos de la pathologie : un <strong>gros plan</strong> (5-15 cm) et une vue <strong>de recul</strong> (1,5 à 2 m).
        </div>
        <div style={{ marginTop: 10, padding: 8, background: "#7f1d1d22", border: "1px solid #dc262644", borderRadius: 6, fontSize: 11, color: "#fca5a5" }}>
          ⚠️ Analyse INDICATIVE — Une analyse précise en laboratoire confirmera la nature exacte de la pathologie.
        </div>
      </div>

      {/* Localisation */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📍 Localisation</div>
        <input type="text" style={styles.input} value={localisation}
          onChange={e => setLocalisation(e.target.value)}
          placeholder="ex: cave nord-ouest, poutre n°2" />
      </div>

      {/* Photos */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📷 Photos de la pathologie</div>

        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#aaa", marginBottom: 6 }}>1️⃣ Gros plan (5-15 cm)</div>
          {photoCloseup ? (
            <div style={{ position: "relative" }}>
              <img src={photoCloseup.dataUrl} alt="Gros plan"
                style={{ width: "100%", maxHeight: 240, objectFit: "cover", borderRadius: 8, border: `1px solid ${COLORS.border}` }} />
              <button onClick={() => setPhotoCloseup(null)}
                style={{ position: "absolute", top: 8, right: 8, padding: "6px 12px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                ✕ Retirer
              </button>
            </div>
          ) : (
            <label style={{ display: "block", padding: 30, background: COLORS.surface, border: `2px dashed ${COLORS.border}`, borderRadius: 8, cursor: "pointer", textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 6 }}>📷</div>
              <div style={{ fontSize: 13, color: COLORS.muted, fontWeight: 600 }}>Cliquer pour ajouter</div>
              <input type="file" accept="image/*" capture="environment"
                onChange={e => handleFileSelect(e.target.files[0], "closeup")}
                style={{ display: "none" }} />
            </label>
          )}
        </div>

        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#aaa", marginBottom: 6 }}>2️⃣ Recul (1,5 à 2 m)</div>
          {photoFar ? (
            <div style={{ position: "relative" }}>
              <img src={photoFar.dataUrl} alt="Recul"
                style={{ width: "100%", maxHeight: 240, objectFit: "cover", borderRadius: 8, border: `1px solid ${COLORS.border}` }} />
              <button onClick={() => setPhotoFar(null)}
                style={{ position: "absolute", top: 8, right: 8, padding: "6px 12px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                ✕ Retirer
              </button>
            </div>
          ) : (
            <label style={{ display: "block", padding: 30, background: COLORS.surface, border: `2px dashed ${COLORS.border}`, borderRadius: 8, cursor: "pointer", textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 6 }}>📷</div>
              <div style={{ fontSize: 13, color: COLORS.muted, fontWeight: 600 }}>Cliquer pour ajouter</div>
              <input type="file" accept="image/*" capture="environment"
                onChange={e => handleFileSelect(e.target.files[0], "far")}
                style={{ display: "none" }} />
            </label>
          )}
        </div>

        <button onClick={handleAnalyze}
          disabled={!photoCloseup || !photoFar || loading}
          style={{
            width: "100%", marginTop: 16, padding: "14px",
            background: (!photoCloseup || !photoFar || loading) ? "#1e293b" : `linear-gradient(135deg, ${PARASITE_GREEN} 0%, ${PARASITE_GREEN_DARK} 100%)`,
            color: (!photoCloseup || !photoFar || loading) ? "#666" : "#fff",
            border: "none", borderRadius: 10, fontSize: 15, fontWeight: 800,
            cursor: (!photoCloseup || !photoFar || loading) ? "not-allowed" : "pointer",
            boxShadow: (!photoCloseup || !photoFar || loading) ? "none" : `0 4px 14px ${PARASITE_GREEN}44`,
          }}>
          {loading ? "⏳ Analyse en cours..." : "🔍 Analyser la pathologie"}
        </button>

        {error && (
          <div style={{ marginTop: 10, padding: 10, background: "#7f1d1d44", border: "1px solid #dc262644", borderRadius: 6, color: "#fca5a5", fontSize: 12 }}>
            ❌ {error}
          </div>
        )}
      </div>

      {/* Résultat IA */}
      {result && (
        <div style={{ ...styles.card, borderColor: PARASITE_GREEN, borderWidth: 2 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
            <div style={styles.cardTitle}>🍄 Analyse IA</div>
            <div style={{ fontSize: 10, padding: "3px 8px", background: confianceColor(result.confiance) + "33", color: confianceColor(result.confiance), borderRadius: 4, fontWeight: 700 }}>
              Confiance : {result.confiance || "—"}
            </div>
          </div>

          <div style={{ background: PARASITE_GREEN + "22", padding: 12, borderRadius: 8, marginBottom: 10 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: PARASITE_GREEN, letterSpacing: 1, marginBottom: 4 }}>SUSPICION</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#fff" }}>{result.pathologie || "Indéterminée"}</div>
          </div>

          {result.description && (
            <div style={{ marginBottom: 12, fontSize: 13, color: "#ddd", lineHeight: 1.6, padding: 10, background: "#0a0a0a", borderRadius: 6 }}>
              {result.description}
            </div>
          )}

          {result.indices && result.indices.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#888", letterSpacing: 1, marginBottom: 6 }}>📍 INDICES DÉTECTÉS</div>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 12, color: "#ddd", lineHeight: 1.7 }}>
                {result.indices.map((ind, i) => <li key={i}>{ind}</li>)}
              </ul>
            </div>
          )}

          {result.recommandations && result.recommandations.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#888", letterSpacing: 1, marginBottom: 6 }}>💡 RECOMMANDATIONS</div>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 12, color: "#ddd", lineHeight: 1.7 }}>
                {result.recommandations.map((rec, i) => <li key={i}>{rec}</li>)}
              </ul>
            </div>
          )}

          <div style={{ padding: 10, background: "#7f1d1d22", border: "1px solid #dc262644", borderRadius: 6, fontSize: 11, color: "#fca5a5", marginTop: 12 }}>
            ⚠️ Cette analyse est <strong>INDICATIVE</strong>. Une confirmation par laboratoire spécialisé est requise pour identification précise.
          </div>

          {/* Chat IA + bouton Nouvelle photo */}
          <ScanFollowupChat
            imageBase64={photoCloseup?.dataUrl ? photoCloseup.dataUrl.replace(/^data:[^;]+;base64,/, "") : null}
            imageMime="image/jpeg"
            context={`Localisation : ${localisation || "Non précisée"}\nDiagnostic IA : ${result?.diagnostic || "?"}\nNiveau de risque : ${result?.urgence || result?.gravite || "?"}\nIndices : ${(result?.indices || result?.observations || []).join(" ; ")}\nRecommandations : ${(result?.recommandations || []).join(" ; ")}`}
            systemPrompt="Tu es un expert en pathologies du bois (mérule, termites, capricornes, vrillettes, lyctus, champignons lignivores). Tu réponds aux questions du diagnostiqueur sur la photo : identification, niveau d'infestation, mesures conservatoires, traitements curatifs, normes (NF EN 1390, etc.). Concis et factuel. Rappelle qu'aucun diagnostic définitif ne peut être posé sans expertise terrain."
            color="#65d11c"
            onReset={handleReset}
          />
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════
// MODULE SCAN/ELEC — Diagnostic électrique assisté IA
// ══════════════════════════════════════════════════════
function Elec() {
  // VIEWS : home (page principale 3 sections) | new | analyse | photos
  const [view, setView] = useState("home");
  const [dossiers, setDossiers] = useState([]);
  const [loadingDossiers, setLoadingDossiers] = useState(false);
  const [error, setError] = useState("");
  const [currentDossier, setCurrentDossier] = useState(null);
  const [currentPhotoIdx, setCurrentPhotoIdx] = useState(0);
  const [newDossierName, setNewDossierName] = useState("");
  const [creating, setCreating] = useState(false);
  const [analysing, setAnalysing] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [msg, setMsg] = useState("");
  const [analysisStep, setAnalysisStep] = useState(0);
  const [photoZoom, setPhotoZoom] = useState(false);
  const [showAllControls, setShowAllControls] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== "undefined" && window.innerWidth >= 768);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const ELEC_YELLOW = "#eab308";
  const ELEC_YELLOW_DARK = "#a16207";

  const loadDossiers = async () => {
    setLoadingDossiers(true); setError("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch("/api/elec-dossiers", { headers: { Authorization: `Bearer ${token}` } });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok) setDossiers(data.dossiers || []);
      else throw new Error(data.error || "Erreur de chargement");
    } catch (e) { setError(e.message); }
    setLoadingDossiers(false);
  };

  useEffect(() => { loadDossiers(); /* eslint-disable-next-line */ }, []);

  const fileInputRef = useRef(null);
  const triggerPhotoCapture = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const startNewDossier = () => {
    setNewDossierName("");
    setError("");
    setView("new");
  };

  const createDossier = async () => {
    if (!newDossierName.trim()) { setError("Donnez un nom au dossier"); return; }
    setCreating(true); setError("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch("/api/elec-dossiers", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: newDossierName.trim() }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur de création");
      setCurrentDossier(data.dossier);
      setCurrentPhotoIdx(0);
      setNewDossierName("");
      setDossiers(prev => [data.dossier, ...prev]);
      // Retour à l'accueil après création + déclenchement caméra
      setView("home");
      setTimeout(() => triggerPhotoCapture(), 200);
    } catch (e) { setError(e.message); }
    setCreating(false);
  };

  const handlePhotoCapture = async (file) => {
    if (!file || !currentDossier) return;
    setView("analyse");
    setAnalysing(true);
    setError("");
    setAnalysisStep(0);
    setTimeout(() => setAnalysisStep(1), 400);

    try {
      const base64 = await compressImageBase64(file, 1280, 0.78);
      setAnalysisStep(2);

      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch("/api/elec-analyze", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ dossierId: currentDossier.id, base64 }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur d'analyse IA");

      setAnalysisStep(3);
      // _localBase64 : photo en mémoire pour affichage immédiat (contourne le proxy)
      const photoWithBase64 = { ...data.photo, _localBase64: base64 };
      const updated = { ...currentDossier, photos: [...(currentDossier.photos || []), photoWithBase64] };
      setCurrentDossier(updated);
      setCurrentPhotoIdx(updated.photos.length - 1);
      setDossiers(prev => prev.map(d => d.id === updated.id ? updated : d));

      setTimeout(() => {
        setAnalysing(false);
        setView("photos");
      }, 600);
    } catch (e) {
      setError(e.message);
      setAnalysing(false);
      setView("home");
    }
  };

  // Modifier la réponse OUI/NON/NV/SO d'un item pour la photo en cours
  const setResponse = async (photoIdx, itemId, value) => {
    const photo = currentDossier.photos[photoIdx];
    const oldResponses = getPhotoResponses(photo);
    const oldR = oldResponses[itemId] || { value: "", comment: "" };
    let newResponses;
    if (!value || oldR.value === value) {
      // value vide OU re-cliquer sur la même valeur → efface la réponse
      newResponses = { ...oldResponses };
      delete newResponses[itemId];
    } else {
      newResponses = { ...oldResponses, [itemId]: { value, comment: oldR.comment || "" } };
    }
    const newPhoto = { ...photo, responses: newResponses };
    delete newPhoto.anomalies; // supprime l'ancien format
    const newPhotos = currentDossier.photos.map((p, i) => i === photoIdx ? newPhoto : p);
    const updated = { ...currentDossier, photos: newPhotos };
    setCurrentDossier(updated);
    setDossiers(prev => prev.map(d => d.id === updated.id ? updated : d));
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      await fetch("/api/elec-dossiers", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id: currentDossier.id, photos: newPhotos }),
      });
    } catch (e) {}
  };

  // Modifier le commentaire d'un item
  const setComment = async (photoIdx, itemId, comment) => {
    const photo = currentDossier.photos[photoIdx];
    const oldResponses = getPhotoResponses(photo);
    const oldR = oldResponses[itemId] || { value: "", comment: "" };
    const newResponses = { ...oldResponses, [itemId]: { value: oldR.value || "", comment } };
    const newPhoto = { ...photo, responses: newResponses };
    delete newPhoto.anomalies;
    const newPhotos = currentDossier.photos.map((p, i) => i === photoIdx ? newPhoto : p);
    const updated = { ...currentDossier, photos: newPhotos };
    setCurrentDossier(updated);
    setDossiers(prev => prev.map(d => d.id === updated.id ? updated : d));
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      await fetch("/api/elec-dossiers", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id: currentDossier.id, photos: newPhotos }),
      });
    } catch (e) {}
  };

  // Modifier la pièce associée à la photo
  const setPiece = async (photoIdx, piece) => {
    const photo = currentDossier.photos[photoIdx];
    const newPhoto = { ...photo, piece };
    const newPhotos = currentDossier.photos.map((p, i) => i === photoIdx ? newPhoto : p);
    const updated = { ...currentDossier, photos: newPhotos };
    setCurrentDossier(updated);
    setDossiers(prev => prev.map(d => d.id === updated.id ? updated : d));
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      await fetch("/api/elec-dossiers", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id: currentDossier.id, photos: newPhotos }),
      });
    } catch (e) {}
  };

  const deletePhoto = async (photoIdx) => {
    if (!window.confirm("Supprimer cette photo ?")) return;
    const newPhotos = currentDossier.photos.filter((_, i) => i !== photoIdx);
    const updated = { ...currentDossier, photos: newPhotos };
    setCurrentDossier(updated);
    setDossiers(prev => prev.map(d => d.id === updated.id ? updated : d));
    if (newPhotos.length === 0) {
      setView("home");
    } else {
      setCurrentPhotoIdx(Math.min(currentPhotoIdx, newPhotos.length - 1));
    }
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      await fetch("/api/elec-dossiers", {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id: currentDossier.id, photos: newPhotos }),
      });
    } catch (e) {}
  };

  const openDossier = (d) => {
    setCurrentDossier(d);
    setCurrentPhotoIdx(0);
    if ((d.photos || []).length > 0) setView("photos");
  };

  const deleteDossier = async (id, e) => {
    if (e) e.stopPropagation();
    if (!window.confirm("Supprimer ce dossier et toutes ses photos ?")) return;
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      await fetch(`/api/elec-dossiers?id=${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      setDossiers(prev => prev.filter(d => d.id !== id));
      if (currentDossier && currentDossier.id === id) {
        setCurrentDossier(null);
      }
    } catch (err) { setError(err.message); }
  };

  const generatePDF = async () => {
    if (!currentDossier || (currentDossier.photos || []).length === 0) {
      setError("Ajoutez au moins une photo avant de générer le PDF"); return;
    }
    setEmailSending(true); setError(""); setMsg("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch("/api/elec-pdf", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ dossierId: currentDossier.id }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur de génération");
      setMsg(`✅ Rapport envoyé par email à ${data.sentTo}`);
      setTimeout(() => setMsg(""), 8000);
    } catch (e) { setError(e.message); }
    setEmailSending(false);
  };

  const daysLeft = (createdAt) => {
    const created = new Date(createdAt).getTime();
    const expiry = created + 14 * 24 * 60 * 60 * 1000;
    const left = Math.ceil((expiry - Date.now()) / (24 * 60 * 60 * 1000));
    return Math.max(0, left);
  };

  const PADDING = isDesktop ? 24 : 14;

  const HiddenFileInput = (
    <input ref={fileInputRef} type="file" accept="image/*" capture="environment"
      style={{ display: "none" }}
      onChange={e => { if (e.target.files[0]) handlePhotoCapture(e.target.files[0]); }} />
  );

  // Dossier en cours = currentDossier ou le dernier
  const dossierEnCours = currentDossier || dossiers[0] || null;

  // ═══════════════════════════════════════════════════
  // HOME — Page principale avec 3 sections empilées
  // ═══════════════════════════════════════════════════
  if (view === "home") {
    return (
      <div style={{ padding: PADDING, color: COLORS.text, maxWidth: 800, margin: "0 auto" }}>
        {HiddenFileInput}

        {/* Header titre */}
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: isDesktop ? 24 : 19, fontWeight: 900, color: ELEC_YELLOW }}>💡 SCAN/ELEC</div>
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>Diagnostic terrain XP C 16-600 — assisté par IA</div>
        </div>

        {error && <div style={{ background: "#7f1d1d", color: "#fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #ef4444" }}>❌ {error}</div>}
        {msg && <div style={{ background: "#14532d", color: "#bbf7d0", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #22c55e" }}>{msg}</div>}

        {/* ═══════════════════════════════════════════════ */}
        {/* SECTION 1 : NOUVEAU SCAN (style SCAN/DPE) */}
        {/* ═══════════════════════════════════════════════ */}
        <div style={{
          background: COLORS.surface, border: `1px solid ${COLORS.border}`,
          borderRadius: 14, padding: isDesktop ? 30 : 20, marginBottom: 14, textAlign: "center",
        }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📷</div>
          <div style={{ fontSize: isDesktop ? 19 : 16, fontWeight: 800, color: ELEC_YELLOW, marginBottom: 8 }}>
            Identifiez les anomalies électriques
          </div>
          <div style={{ fontSize: isDesktop ? 13 : 12, color: COLORS.muted, marginBottom: 14, lineHeight: 1.5 }}>
            Prenez une photo de votre installation.<br/>
            L'IA détecte automatiquement&nbsp;:
          </div>

          {/* Pills équipements visibles */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, justifyContent: "center", marginBottom: 18 }}>
            {[
              { icon: "🔌", label: "Tableau" },
              { icon: "💡", label: "Luminaires" },
              { icon: "⚡", label: "Prise de terre" },
              { icon: "🛡️", label: "Disjoncteur" },
            ].map((p, i) => (
              <span key={i} style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "6px 12px", borderRadius: 999,
                background: `${ELEC_YELLOW}15`, border: `1px solid ${ELEC_YELLOW}33`,
                fontSize: 12, fontWeight: 600, color: ELEC_YELLOW,
              }}>
                {p.icon} {p.label}
              </span>
            ))}
          </div>

          {/* Gros bouton jaune */}
          <button onClick={startNewDossier}
            style={{
              padding: isDesktop ? "16px 36px" : "14px 28px",
              background: ELEC_YELLOW, color: "#111",
              border: "none", borderRadius: 12,
              fontSize: isDesktop ? 16 : 14, fontWeight: 800, cursor: "pointer",
              boxShadow: `0 4px 14px ${ELEC_YELLOW}55`,
              display: "inline-flex", alignItems: "center", gap: 10,
            }}>
            📷 Prendre une photo
          </button>

          {/* Texte bas — autres équipements */}
          <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 14, fontWeight: 500 }}>
            Conducteurs · DDR · Salle d'eau · Repérage · Échauffement · Protection
          </div>
        </div>

        {/* ═══════════════════════════════════════════════ */}
        {/* SECTION 2 : DOSSIER EN COURS (Photos & Anomalies) */}
        {/* ═══════════════════════════════════════════════ */}
        {dossierEnCours && (dossierEnCours.photos || []).length > 0 ? (
          <div style={{
            background: COLORS.surface, border: `1px solid ${ELEC_YELLOW}55`,
            borderRadius: 14, padding: 16, marginBottom: 14,
            cursor: "pointer", transition: "transform 0.15s",
          }} onClick={() => openDossier(dossierEnCours)}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{
                width: 50, height: 50, borderRadius: 10,
                background: `linear-gradient(135deg, ${ELEC_YELLOW} 0%, ${ELEC_YELLOW_DARK} 100%)`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 24, flexShrink: 0,
                boxShadow: `0 2px 8px ${ELEC_YELLOW}44`,
              }}>📷</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: ELEC_YELLOW, textTransform: "uppercase", letterSpacing: 0.5 }}>
                  📷 Photos & anomalies — Dossier en cours
                </div>
                <div style={{ fontSize: 14, fontWeight: 800, color: COLORS.text, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {dossierEnCours.name}
                </div>
                <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 10, fontWeight: 700, color: ELEC_YELLOW, background: `${ELEC_YELLOW}22`, padding: "2px 7px", borderRadius: 4 }}>
                    📸 {(dossierEnCours.photos || []).length} photo{(dossierEnCours.photos || []).length > 1 ? "s" : ""}
                  </span>
                  <span style={{ fontSize: 10, fontWeight: 700, color: "#fca5a5", background: "#7f1d1d44", padding: "2px 7px", borderRadius: 4 }}>
                    ⚠️ {(dossierEnCours.photos || []).reduce((s, p) => s + countAnomalies(p), 0)} anomalie(s)
                  </span>
                </div>
              </div>
              <div style={{ color: COLORS.muted, fontSize: 18 }}>›</div>
            </div>
          </div>
        ) : (
          <div style={{
            background: COLORS.surface, border: `1px dashed ${COLORS.border}`,
            borderRadius: 14, padding: 16, marginBottom: 14, textAlign: "center",
          }}>
            <div style={{ fontSize: 11, color: COLORS.muted, fontWeight: 500 }}>
              📷 Aucun dossier en cours — créez un nouveau scan ci-dessus.
            </div>
          </div>
        )}

        {/* ═══════════════════════════════════════════════ */}
        {/* SECTION 3 : MES DOSSIERS — Carte cliquable */}
        {/* ═══════════════════════════════════════════════ */}
        <div style={{
          background: COLORS.surface, border: `1px solid ${COLORS.border}`,
          borderRadius: 14, padding: 16, marginBottom: 14,
          cursor: "pointer", transition: "transform 0.15s",
        }} onClick={() => setView("dossiers")}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{
              width: 50, height: 50, borderRadius: 10,
              background: `linear-gradient(135deg, ${ELEC_YELLOW} 0%, ${ELEC_YELLOW_DARK} 100%)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 24, flexShrink: 0,
              boxShadow: `0 2px 8px ${ELEC_YELLOW}44`,
            }}>📁</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: ELEC_YELLOW, textTransform: "uppercase", letterSpacing: 0.5 }}>
                📁 Mes dossiers — Tous les diagnostics
              </div>
              <div style={{ fontSize: 14, fontWeight: 800, color: COLORS.text, marginTop: 2 }}>
                {dossiers.length} dossier{dossiers.length > 1 ? "s" : ""} ELEC
              </div>
              <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>
                {dossiers.length === 0
                  ? "Aucun dossier pour l'instant"
                  : "Conservés 14 jours · Cliquer pour voir tous"}
              </div>
            </div>
            <div style={{ color: COLORS.muted, fontSize: 18 }}>›</div>
          </div>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════════════
  // DOSSIERS — Liste détaillée de tous les dossiers
  // ═══════════════════════════════════════════════════
  if (view === "dossiers") {
    return (
      <div style={{ padding: PADDING, color: COLORS.text, maxWidth: 800, margin: "0 auto" }}>
        <button onClick={() => { setView("home"); setError(""); }}
          style={{ background: "none", border: "none", color: "#ccc", fontSize: 13, fontWeight: 700, padding: "8px 0", cursor: "pointer", marginBottom: 8 }}>← Accueil</button>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <div>
            <div style={{ fontSize: isDesktop ? 20 : 17, fontWeight: 900, color: ELEC_YELLOW }}>📁 Mes dossiers ELEC</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>{dossiers.length} dossier{dossiers.length > 1 ? "s" : ""}</div>
          </div>
          <button onClick={loadDossiers} disabled={loadingDossiers}
            style={{ padding: "6px 12px", borderRadius: 7, border: `1px solid ${COLORS.border}`,
              background: COLORS.surface, color: COLORS.text, fontSize: 11, fontWeight: 700, cursor: loadingDossiers ? "wait" : "pointer" }}>
            {loadingDossiers ? "⏳" : "🔄 Actualiser"}
          </button>
        </div>

        {error && <div style={{ background: "#7f1d1d", color: "#fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #ef4444" }}>❌ {error}</div>}

        {loadingDossiers ? (
          <div style={{ textAlign: "center", padding: 30, color: COLORS.muted, fontSize: 13 }}>⏳ Chargement...</div>
        ) : dossiers.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 20px", background: COLORS.surface, borderRadius: 12, color: COLORS.muted, fontSize: 13, border: `1px dashed ${COLORS.border}` }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>📁</div>
            Aucun dossier pour l'instant.<br/>
            <button onClick={() => setView("new")}
              style={{ marginTop: 14, padding: "10px 20px", background: ELEC_YELLOW, color: "#111", border: "none", borderRadius: 8, fontWeight: 800, fontSize: 13, cursor: "pointer" }}>
              ➕ Créer mon premier dossier
            </button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr", gap: 8 }}>
            {dossiers.map(d => {
              const nbPhotos = (d.photos || []).length;
              const nbAnomalies = (d.photos || []).reduce((s, p) => s + countAnomalies(p), 0);
              const left = daysLeft(d.createdAt);
              const expColor = left <= 3 ? "#dc2626" : left <= 7 ? "#ea580c" : "#22c55e";
              const expBg = left <= 3 ? "#7f1d1d44" : left <= 7 ? "#7c2d1244" : "#14532d44";
              const isCurrent = currentDossier && currentDossier.id === d.id;
              return (
                <div key={d.id}
                  style={{
                    background: isCurrent ? `${ELEC_YELLOW}11` : "linear-gradient(135deg, #1a1a1a 0%, #0d0d14 100%)",
                    borderRadius: 12, padding: 14,
                    border: `1px solid ${isCurrent ? `${ELEC_YELLOW}55` : COLORS.border}`,
                    display: "flex", alignItems: "center", gap: 12,
                  }}>
                  <div style={{
                    width: 50, height: 50, borderRadius: 10, flexShrink: 0,
                    background: `linear-gradient(135deg, ${ELEC_YELLOW} 0%, ${ELEC_YELLOW_DARK} 100%)`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 24, boxShadow: `0 2px 8px ${ELEC_YELLOW}44`,
                  }}>📁</div>

                  <div onClick={() => openDossier(d)} style={{ flex: 1, minWidth: 0, cursor: "pointer" }}>
                    <div style={{ fontWeight: 800, fontSize: 14, color: "#fff", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {d.name}
                    </div>
                    <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                      <span style={{ fontSize: 10, fontWeight: 700, color: ELEC_YELLOW, background: `${ELEC_YELLOW}22`, padding: "2px 7px", borderRadius: 4 }}>
                        📸 {nbPhotos}
                      </span>
                      <span style={{ fontSize: 10, fontWeight: 700, color: nbAnomalies > 0 ? "#fca5a5" : "#86efac", background: nbAnomalies > 0 ? "#7f1d1d44" : "#14532d44", padding: "2px 7px", borderRadius: 4 }}>
                        ⚠️ {nbAnomalies}
                      </span>
                      <span style={{ fontSize: 10, fontWeight: 700, color: expColor, background: expBg, padding: "2px 7px", borderRadius: 4 }}>
                        ⏱️ {left}j
                      </span>
                    </div>
                    <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 3 }}>
                      Créé le {new Date(d.createdAt).toLocaleDateString("fr-FR")}
                    </div>
                  </div>

                  <button onClick={(e) => deleteDossier(d.id, e)}
                    style={{ background: "#7f1d1d", border: "none", color: "#fff", borderRadius: 6,
                      padding: "6px 9px", fontSize: 12, cursor: "pointer", flexShrink: 0 }}>
                    🗑️
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <div style={{ marginTop: 14, background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 8, padding: "10px 12px", fontSize: 10, color: COLORS.muted, lineHeight: 1.5, textAlign: "center" }}>
          ℹ️ Les dossiers sont automatiquement supprimés après <strong>14 jours</strong>. Pensez à générer le PDF avant.
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════════════
  // NEW — Saisie nom dossier
  // ═══════════════════════════════════════════════════
  if (view === "new") {
    return (
      <div style={{ padding: PADDING, color: COLORS.text }}>
        {HiddenFileInput}
        <button onClick={() => { setView("home"); setError(""); }}
          style={{ background: "none", border: "none", color: "#ccc", fontSize: 13, fontWeight: 700, padding: "8px 0", cursor: "pointer", marginBottom: 8 }}>← Retour</button>

        <div style={{ background: COLORS.surface, borderRadius: 12, padding: 24, border: `1px solid ${COLORS.border}`, maxWidth: 500, margin: "0 auto" }}>
          <div style={{ fontSize: 18, fontWeight: 900, color: ELEC_YELLOW, marginBottom: 4 }}>➕ Nouveau dossier ELEC</div>
          <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 16, lineHeight: 1.5 }}>
            Donnez un nom à votre dossier (usage interne).
          </div>

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
            Nom du dossier
          </label>
          <input type="text" placeholder="Ex: Maison Dupont, Tour Concorde..."
            value={newDossierName} onChange={e => setNewDossierName(e.target.value)}
            onKeyDown={e => e.key === "Enter" && createDossier()}
            style={{ ...styles.input, width: "100%", fontSize: 14, marginBottom: 14 }}
            autoFocus />

          {error && <div style={{ background: "#7f1d1d", color: "#fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #ef4444" }}>❌ {error}</div>}

          <button onClick={createDossier} disabled={creating || !newDossierName.trim()}
            style={{ width: "100%", padding: "14px", borderRadius: 10, border: "none",
              cursor: creating ? "wait" : "pointer", background: ELEC_YELLOW, color: "#111", fontWeight: 800, fontSize: 14 }}>
            {creating ? "⏳ Création..." : "📷 Commencer le diagnostic"}
          </button>
        </div>
      </div>
    );
  }

  // ═══════════════════════════════════════════════════
  // ANALYSE
  // ═══════════════════════════════════════════════════
  if (view === "analyse") {
    const steps = [
      { label: "Photo uploadée", done: analysisStep >= 1 },
      { label: "Compression", done: analysisStep >= 2 },
      { label: "Analyse IA en cours...", done: analysisStep >= 3, current: analysisStep >= 1 && analysisStep < 3 },
      { label: "Résultats", done: false, current: analysisStep >= 3 },
    ];
    return (
      <div style={{ padding: PADDING, color: COLORS.text, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", minHeight: "60vh", paddingTop: isDesktop ? 30 : 16 }}>
        <div style={{
          background: `linear-gradient(135deg, ${ELEC_YELLOW} 0%, ${ELEC_YELLOW_DARK} 100%)`,
          borderRadius: 12, padding: isDesktop ? "16px 20px" : "12px 14px", marginBottom: isDesktop ? 32 : 24,
          maxWidth: 560, width: "100%", textAlign: "left",
          boxShadow: `0 4px 16px ${ELEC_YELLOW}44`,
        }}>
          <div style={{ fontSize: isDesktop ? 15 : 13, fontWeight: 900, color: "#111", marginBottom: 6 }}>
            ⚡ Analyse en cours par l'IA Claude Vision
          </div>
          <div style={{ fontSize: isDesktop ? 12 : 10.5, color: "#1c1917", lineHeight: 1.5, fontWeight: 500 }}>
            Photo conservée, anomalies XP C 16-600 détectées. Quelques secondes...
          </div>
        </div>

        <div style={{ fontSize: 60, marginBottom: 18, animation: "elecPulse 1.5s infinite" }}>⚡</div>
        <div style={{ fontSize: 18, fontWeight: 900, color: ELEC_YELLOW, marginBottom: 24 }}>Analyse IA en cours...</div>

        <div style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: 16, width: "100%", maxWidth: 380, textAlign: "left" }}>
          {steps.map((s, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, marginBottom: i === steps.length - 1 ? 0 : 8 }}>
              <div style={{
                width: 22, height: 22, borderRadius: "50%",
                background: s.done ? "#22c55e" : s.current ? ELEC_YELLOW : COLORS.border,
                color: s.current ? "#111" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700,
                animation: s.current ? "elecPulse 1s infinite" : "none",
              }}>{s.done ? "✓" : s.current ? "⏳" : ""}</div>
              <span style={{ color: s.done ? "#bbf7d0" : s.current ? ELEC_YELLOW : COLORS.muted, fontWeight: s.current ? 700 : 400 }}>{s.label}</span>
            </div>
          ))}
        </div>

        <style>{`@keyframes elecPulse { 0%,100% { transform:scale(1); opacity:1; } 50% { transform:scale(1.1); opacity:0.7; } }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════════════
  // PHOTOS — Photo + anomalies (validation directe)
  // ═══════════════════════════════════════════════════
  if (view === "photos" && currentDossier) {
    const photos = currentDossier.photos || [];
    const photo = photos[currentPhotoIdx];
    const totalAnomalies = photos.reduce((s, p) => s + countAnomalies(p), 0);

    return (
      <div style={{ padding: PADDING, color: COLORS.text }}>
        {HiddenFileInput}

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, gap: 8 }}>
          <button onClick={() => { setView("home"); setError(""); setMsg(""); }}
            style={{ background: "none", border: "none", color: "#ccc", fontSize: 12, fontWeight: 700, padding: "4px 0", cursor: "pointer" }}>
            ← Accueil
          </button>
          <div style={{ flex: 1, textAlign: "right", minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: ELEC_YELLOW, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              📁 {currentDossier.name}
            </div>
            <div style={{ fontSize: 10, color: COLORS.muted }}>
              {photos.length} photo{photos.length > 1 ? "s" : ""} · {totalAnomalies} anomalie{totalAnomalies !== 1 ? "s" : ""}
            </div>
          </div>
        </div>

        {photos.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 20px", background: COLORS.surface, borderRadius: 10, color: COLORS.muted, fontSize: 13, border: `1px dashed ${COLORS.border}` }}>
            Aucune photo dans ce dossier.<br/>
            <button onClick={triggerPhotoCapture}
              style={{ marginTop: 14, padding: "10px 20px", background: ELEC_YELLOW, color: "#111", border: "none", borderRadius: 8, fontWeight: 800, cursor: "pointer" }}>
              📷 Prendre une photo
            </button>
          </div>
        ) : (
          <>
            <div style={{ display: "flex", gap: 5, overflowX: "auto", marginBottom: 10, paddingBottom: 4 }}>
              {photos.map((p, i) => (
                <div key={i} onClick={() => setCurrentPhotoIdx(i)}
                  style={{ flexShrink: 0, width: 50, height: 50, borderRadius: 6, overflow: "hidden", cursor: "pointer", position: "relative",
                    border: i === currentPhotoIdx ? `3px solid ${ELEC_YELLOW}` : "1px solid #444" }}>
                  <img src={p._localBase64 || `/api/photo?url=${encodeURIComponent(p.url)}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  {countAnomalies(p) > 0 && (
                    <span style={{ position: "absolute", top: 1, right: 1, background: "#dc2626", color: "#fff", fontSize: 9, fontWeight: 800, borderRadius: 3, padding: "1px 4px" }}>
                      {countAnomalies(p)}
                    </span>
                  )}
                </div>
              ))}
            </div>

            {photo && (
              <>
                <div style={{ background: "#000", borderRadius: 10, overflow: "hidden", border: `1px solid ${COLORS.border}`, position: "relative", marginBottom: 12, height: isDesktop ? 280 : 150 }}>
                  <img src={photo._localBase64 || `/api/photo?url=${encodeURIComponent(photo.url)}`} alt="" onClick={() => setPhotoZoom(true)}
                    style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "zoom-in", display: "block" }} />
                  <button onClick={() => deletePhoto(currentPhotoIdx)}
                    style={{ position: "absolute", top: 6, right: 6, background: "#dc2626cc", border: "none", color: "#fff", borderRadius: 5, padding: "4px 9px", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>
                    🗑️
                  </button>
                  <div style={{ position: "absolute", bottom: 6, left: 6, background: "#000a", color: "#fff", padding: "3px 8px", borderRadius: 4, fontSize: 10 }}>
                    Photo {currentPhotoIdx + 1}/{photos.length} · clic pour zoom
                  </div>
                </div>

                {/* Menu déroulant : Pièce */}
                <div style={{ background: COLORS.surface, borderRadius: 10, padding: "10px 12px", border: `1px solid ${COLORS.border}`, marginBottom: 12, display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ fontSize: 18, flexShrink: 0 }}>🏠</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: COLORS.muted, flexShrink: 0 }}>Pièce :</span>
                  <select
                    value={photo.piece || ""}
                    onChange={(e) => setPiece(currentPhotoIdx, e.target.value)}
                    style={{
                      flex: 1, padding: "6px 8px", borderRadius: 6,
                      border: `1px solid ${photo.piece ? ELEC_YELLOW : COLORS.border}`,
                      background: photo.piece ? `${ELEC_YELLOW}11` : COLORS.card,
                      color: photo.piece ? ELEC_YELLOW : COLORS.muted,
                      fontSize: 12, fontWeight: 700, cursor: "pointer",
                    }}>
                    <option value="">— Sélectionner une pièce —</option>
                    {ELEC_PIECES.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>

                <div style={{ background: COLORS.surface, borderRadius: 10, padding: 12, border: `1px solid ${COLORS.border}`, marginBottom: 12 }}>
                  {(() => {
                    const responses = getPhotoResponses(photo);
                    const detectedNon = Object.entries(responses).filter(([id, r]) => r && r.value === "NON");
                    return (
                      <>
                        {/* Anomalies détectées par l'IA */}
                        {detectedNon.length > 0 && (
                          <div style={{ marginBottom: 12 }}>
                            <div style={{ fontWeight: 800, fontSize: 13, color: "#fca5a5", marginBottom: 8 }}>
                              🔴 Anomalies détectées par l'IA ({detectedNon.length})
                            </div>
                            <div style={{ fontSize: 10, color: COLORS.muted, marginBottom: 8, fontStyle: "italic" }}>
                              💡 Validez ou modifiez la réponse de l'IA pour chaque item.
                            </div>
                            {detectedNon.map(([id, r]) => {
                              const it = findElecItem(id);
                              if (!it) return null;
                              const sev = ELEC_SEVERITY[it.severity] || ELEC_SEVERITY.majeur;
                              return (
                                <ElecItemRow
                                  key={id}
                                  item={it}
                                  response={r}
                                  sev={sev}
                                  onChangeValue={(v) => setResponse(currentPhotoIdx, id, v)}
                                  onChangeComment={(c) => setComment(currentPhotoIdx, id, c)}
                                  highlight
                                />
                              );
                            })}
                          </div>
                        )}

                        {/* Bouton "Voir tous les contrôles" */}
                        <button onClick={() => setShowAllControls(s => !s)}
                          style={{
                            width: "100%", padding: "10px 12px", borderRadius: 8,
                            border: `1px solid ${COLORS.border}`,
                            background: showAllControls ? `${ELEC_YELLOW}22` : COLORS.card,
                            color: ELEC_YELLOW, fontWeight: 700, fontSize: 12, cursor: "pointer",
                            marginBottom: showAllControls ? 12 : 0,
                          }}>
                          {showAllControls ? "▼ Masquer la liste complète" : "📋 Voir tous les contrôles XP C 16-600 (95 items)"}
                        </button>

                        {/* Liste complète XP C 16-600 (dépliable) */}
                        {showAllControls && Object.keys(ELEC_ITEMS).map(secKey => {
                          const sec = ELEC_ITEMS[secKey];
                          return (
                            <div key={secKey} style={{ marginBottom: 14 }}>
                              <div style={{ fontSize: 11, fontWeight: 800, color: ELEC_YELLOW, textTransform: "uppercase", marginBottom: 6, letterSpacing: 0.5, paddingBottom: 4, borderBottom: `1px solid ${COLORS.border}` }}>
                                {secKey} · {sec.title}
                              </div>
                              {sec.items.map(it => {
                                const r = responses[it.id] || { value: "", comment: "" };
                                const sev = ELEC_SEVERITY[it.severity] || ELEC_SEVERITY.majeur;
                                return (
                                  <ElecItemRow
                                    key={it.id}
                                    item={it}
                                    response={r}
                                    sev={sev}
                                    onChangeValue={(v) => setResponse(currentPhotoIdx, it.id, v)}
                                    onChangeComment={(c) => setComment(currentPhotoIdx, it.id, c)}
                                  />
                                );
                              })}
                            </div>
                          );
                        })}
                      </>
                    );
                  })()}
                </div>
              </>
            )}

            {error && <div style={{ background: "#7f1d1d", color: "#fecaca", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #ef4444" }}>❌ {error}</div>}
            {msg && <div style={{ background: "#14532d", color: "#bbf7d0", padding: "10px 12px", borderRadius: 8, fontSize: 12, marginBottom: 10, border: "1px solid #22c55e" }}>{msg}</div>}

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              <button onClick={triggerPhotoCapture}
                style={{ padding: "13px 8px", borderRadius: 9, border: "none",
                  background: ELEC_YELLOW, color: "#111", fontWeight: 800, fontSize: 13, cursor: "pointer",
                  boxShadow: `0 2px 8px ${ELEC_YELLOW}55` }}>
                💾 Sauver & Photo suivante
              </button>
              <button onClick={generatePDF} disabled={emailSending}
                style={{ padding: "13px 8px", borderRadius: 9, border: "none",
                  background: emailSending ? "#888" : "#22c55e", color: "#fff", fontWeight: 800, fontSize: 13,
                  cursor: emailSending ? "wait" : "pointer",
                  boxShadow: emailSending ? "none" : "0 2px 8px rgba(34,197,94,0.3)" }}>
                {emailSending ? "⏳ Envoi..." : "📧 Générer PDF"}
              </button>
            </div>
          </>
        )}

        {photoZoom && photo && (
          <div onClick={() => setPhotoZoom(false)}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, cursor: "zoom-out" }}>
            <img src={photo._localBase64 || `/api/photo?url=${encodeURIComponent(photo.url)}`} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8 }} />
            <button onClick={(e) => { e.stopPropagation(); setPhotoZoom(false); }}
              style={{ position: "absolute", top: 20, right: 20, background: "#dc2626", border: "none", color: "#fff", borderRadius: 8, padding: "8px 14px", fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
              ✕ Fermer
            </button>
          </div>
        )}
      </div>
    );
  }

  return null;
}

function AdminPanel({ onLogout }) {
  const [section, setSection] = useState("identifiants");

  // Identifiants
  const [newLogin, setNewLogin] = useState(localStorage.getItem("fndi_login") || DEFAULT_LOGIN);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [savedMsg, setSavedMsg] = useState("");

  // Invitation (prenom + nom séparés pour l'API)
  const [invitePrenom, setInvitePrenom] = useState("");
  const [inviteNom, setInviteNom] = useState("");
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteMsg, setInviteMsg] = useState("");

  // Utilisateurs (multi-user via Upstash)
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [usersError, setUsersError] = useState("");

  // Photos amiante (Vercel Blob)
  const [photosMap, setPhotosMap] = useState({});
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [photosMsg, setPhotosMsg] = useState("");
  const [selectedMatId, setSelectedMatId] = useState("");

  const loadSharedPhotos = async () => {
    try {
      const resp = await fetch("/api/photos");
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.byMatId) {
        // Convertir { matId: [{url, ...}] } → { matId: [url1, url2, ...] }
        const flat = {};
        for (const [matId, photos] of Object.entries(data.byMatId)) {
          flat[matId] = photos.map(p => p.url);
        }
        setPhotosMap(flat);
      }
    } catch (e) {
      console.error("Erreur chargement photos:", e);
    }
  };

  useEffect(() => {
    if (section === "photos") loadSharedPhotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const handlePhotoUpload = async (matId, files) => {
    if (!matId) { setPhotosMsg("❌ Choisissez un matériau d'abord"); return; }
    setUploadingPhoto(true); setPhotosMsg("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const arr = Array.from(files);
      let okCount = 0;
      for (const file of arr) {
        const base64 = await compressImageBase64(file);
        const resp = await fetch("/api/upload-photo", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ matId, base64 }),
        });
        const data = await resp.json().catch(() => ({}));
        if (resp.ok && data.url) {
          okCount++;
          setPhotosMap(prev => ({ ...prev, [matId]: [...(prev[matId] || []), data.url] }));
        } else {
          throw new Error(data.error || "Échec upload");
        }
      }
      setPhotosMsg(`✅ ${okCount} photo(s) ajoutée(s) sur le cloud`);
      setTimeout(() => setPhotosMsg(""), 3000);
    } catch (e) {
      setPhotosMsg("❌ " + (e.message || "Erreur upload"));
    }
    setUploadingPhoto(false);
  };

  const handlePhotoDelete = async (matId, photoUrl) => {
    if (!window.confirm("Supprimer cette photo du cloud ?")) return;
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch(`/api/photos?url=${encodeURIComponent(photoUrl)}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` },
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur suppression");
      setPhotosMap(prev => {
        const newMap = { ...prev };
        newMap[matId] = (newMap[matId] || []).filter(u => u !== photoUrl);
        if (newMap[matId].length === 0) delete newMap[matId];
        return newMap;
      });
      setPhotosMsg("✅ Photo supprimée");
      setTimeout(() => setPhotosMsg(""), 2500);
    } catch (e) {
      setPhotosMsg("❌ " + (e.message || "Erreur"));
    }
  };

  const loadUsers = async () => {
    setUsersLoading(true); setUsersError("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch("/api/users", { headers: { Authorization: `Bearer ${token}` } });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur de chargement");
      setUsers(data.users || []);
    } catch (e) { setUsersError(e.message); }
    setUsersLoading(false);
  };

  useEffect(() => {
    if (section === "users") loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const deleteUser = async (email) => {
    if (!window.confirm(`Supprimer définitivement le compte de ${email} ?`)) return;
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const resp = await fetch(`/api/users?email=${encodeURIComponent(email)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(data.error || "Erreur de suppression");
      setUsers(prev => prev.filter(u => u.email !== email));
      setSavedMsg("✅ Utilisateur supprimé");
      setTimeout(() => setSavedMsg(""), 2500);
    } catch (e) {
      setSavedMsg("❌ " + e.message);
      setTimeout(() => setSavedMsg(""), 4000);
    }
  };

  const saveIdentifiants = () => {
    if (!newLogin.includes("@")) { setSavedMsg("❌ Email invalide"); return; }
    if (newPassword && newPassword.length < 6) { setSavedMsg("❌ Mot de passe trop court (6 caractères min.)"); return; }
    if (newPassword && newPassword !== confirmPassword) { setSavedMsg("❌ Les mots de passe ne correspondent pas"); return; }
    try {
      localStorage.setItem("fndi_login", newLogin);
      if (newPassword) localStorage.setItem("fndi_password", newPassword);
      setSavedMsg("✅ Identifiants sauvegardés ! Reconnectez-vous pour valider.");
      setTimeout(() => setSavedMsg(""), 4000);
      setNewPassword(""); setConfirmPassword("");
    } catch { setSavedMsg("❌ Erreur de sauvegarde"); }
  };

  const sendInvite = async () => {
    if (!invitePrenom || !inviteNom || !inviteEmail) {
      setInviteMsg("❌ Remplissez prénom, nom et email"); return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inviteEmail)) {
      setInviteMsg("❌ Format email invalide"); return;
    }
    setInviteLoading(true); setInviteMsg("");
    try {
      const token = localStorage.getItem("fndi_session_token") || "";
      const res = await fetch("/api/send-invite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          prenom: invitePrenom.trim(),
          nom: inviteNom.trim(),
          email: inviteEmail.trim().toLowerCase(),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setInviteMsg(`✅ Email envoyé à ${invitePrenom} ${inviteNom} (${inviteEmail.trim()})`);
        setInvitePrenom(""); setInviteNom(""); setInviteEmail("");
        if (section === "users") loadUsers();
      } else {
        setInviteMsg("❌ " + (data.error || "Erreur d'envoi"));
      }
    } catch {
      setInviteMsg("❌ Erreur réseau. Vérifiez votre connexion.");
    }
    setInviteLoading(false);
  };


  return (
    <div style={{ padding: "20px 20px 40px", maxWidth: 700, margin: "0 auto" }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: COLORS.accent, marginBottom: 6 }}>⚙️ Administration</div>
      <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 20 }}>
        Gestion des accès et des identifiants de l'application DPE FNDI
      </div>

      {/* Sections */}
      <div style={{ display: "flex", gap: 6, marginBottom: 20, flexWrap: "wrap" }}>
        {[
          ["identifiants", "🔐 Identifiants"],
          ["photos", "📷 Photos Amiante"],
          ["users", "👥 Utilisateurs"],
          ["invitation", "📧 Invitations"],
          ["infos", "ℹ️ Infos app"],
        ].map(([key, lbl]) => (
          <button key={key} onClick={() => setSection(key)}
            style={{
              flex: "1 1 110px", padding: "10px 8px", borderRadius: 10, border: "none", cursor: "pointer",
              fontWeight: 700, fontSize: 12,
              background: section === key ? "#F5C800" : COLORS.surface,
              color: section === key ? "#111" : COLORS.muted,
            }}>{lbl}</button>
        ))}
      </div>

      {/* ===== IDENTIFIANTS ===== */}
      {section === "identifiants" && (
        <div style={{ background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.accent, marginBottom: 16 }}>
            🔐 Changer les identifiants de connexion
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
              Identifiant (email)
            </label>
            <input style={{ ...styles.input }}
              type="email" value={newLogin}
              onChange={e => setNewLogin(e.target.value)}
              placeholder="ex: manager@fnddi.fr" />
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
              Nouveau mot de passe
            </label>
            <div style={{ position: "relative" }}>
              <input style={{ ...styles.input, paddingRight: 44 }}
                type={showPwd ? "text" : "password"}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Laissez vide pour ne pas changer" />
              <button onClick={() => setShowPwd(p => !p)}
                style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 16 }}>
                {showPwd ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
              Confirmer le mot de passe
            </label>
            <input style={{ ...styles.input }}
              type={showPwd ? "text" : "password"}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Répétez le nouveau mot de passe" />
          </div>

          <button onClick={saveIdentifiants}
            style={{ ...styles.btn("primary"), width: "100%", fontSize: 14, padding: "14px" }}>
            💾 Sauvegarder les identifiants
          </button>

          {savedMsg && (
            <div style={{ marginTop: 12, padding: "10px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600,
              background: savedMsg.startsWith("✅") ? COLORS.green + "15" : COLORS.red + "15",
              color: savedMsg.startsWith("✅") ? COLORS.green : COLORS.red,
              border: `1px solid ${savedMsg.startsWith("✅") ? COLORS.green + "44" : COLORS.red + "44"}`,
            }}>
              {savedMsg}
            </div>
          )}

          <div style={{ marginTop: 16, padding: "10px 14px", borderRadius: 8, background: COLORS.surface, border: `1px solid ${COLORS.border}`, fontSize: 12, color: COLORS.muted }}>
            ℹ️ Les identifiants sont sauvegardés sur cet appareil. Pour partager l'accès, envoyez une invitation par email.
          </div>

          <button onClick={() => { if (window.confirm("Se déconnecter ?")) onLogout(); }}
            style={{ ...styles.btn("secondary"), width: "100%", marginTop: 12, color: COLORS.red, fontSize: 13 }}>
            🔓 Se déconnecter
          </button>
        </div>
      )}

      {/* ===== PHOTOS AMIANTE ===== */}
      {section === "photos" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: 18 }}>
            <div style={{ fontWeight: 800, fontSize: 14, color: COLORS.accent, marginBottom: 6 }}>
              📷 Photos Amiante
            </div>
            <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 14, lineHeight: 1.5 }}>
              Cliquez sur le bouton 📸 à côté d'un matériau pour ajouter ses photos illustratives.
              Compression automatique (~50 Ko/photo). <strong>Stockage cloud Vercel Blob — partagé entre tous les diagnostiqueurs ✅</strong>
            </div>

            {photosMsg && (
              <div style={{ marginBottom: 12, padding: "10px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600,
                background: photosMsg.startsWith("✅") ? "#14532d" : "#7f1d1d",
                color: photosMsg.startsWith("✅") ? "#bbf7d0" : "#fecaca",
                border: `1px solid ${photosMsg.startsWith("✅") ? "#22c55e" : "#ef4444"}` }}>
                {photosMsg}
              </div>
            )}

            {/* Filtre par liste A/B/C */}
            <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
              {[
                ["ALL", "Tous", "#888"],
                ["A", "Liste A", "#dc2626"],
                ["B", "Liste B", "#d97706"],
                ["C", "Liste C", "#4f46e5"],
              ].map(([key, lbl, col]) => (
                <button key={key} onClick={() => setSelectedMatId(key === "ALL" ? "" : key)}
                  style={{
                    padding: "6px 12px", borderRadius: 7, border: "none", cursor: "pointer",
                    fontWeight: 700, fontSize: 11,
                    background: (selectedMatId || "ALL") === key ? col : COLORS.surface,
                    color: (selectedMatId || "ALL") === key ? "#fff" : COLORS.muted,
                  }}>{lbl}</button>
              ))}
            </div>

            {/* Liste des matériaux avec upload */}
            <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 600, overflowY: "auto" }}>
              {AMIANTE_MATERIALS
                .filter(m => m && m.id && m.name && m.list)
                .filter(m => !selectedMatId || m.list === selectedMatId)
                .sort((a,b) => (a.name || "").localeCompare(b.name || "", "fr"))
                .map(m => {
                  const photos = photosMap[m.id] || [];
                  const listColor = { A:"#dc2626", B:"#d97706", C:"#4f46e5" }[m.list] || "#888";
                  return (
                    <div key={m.id} style={{ background: COLORS.surface, borderRadius: 10, padding: 12, border: `1px solid ${COLORS.border}` }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: photos.length > 0 ? 8 : 0 }}>
                        <span style={{
                          background: listColor, color: "#fff", fontWeight: 900, fontSize: 10,
                          padding: "3px 8px", borderRadius: 4, flexShrink: 0,
                        }}>{m.list}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 700, fontSize: 12, color: COLORS.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {m.name}
                          </div>
                          <div style={{ fontSize: 10, color: COLORS.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {m.family || ""} {photos.length > 0 ? `· ${photos.length} photo(s)` : ""}
                          </div>
                        </div>
                        <label style={{
                          display: "inline-flex", alignItems: "center", gap: 4,
                          padding: "6px 10px", borderRadius: 7, cursor: uploadingPhoto ? "wait" : "pointer",
                          background: "#F5C800", color: "#111", fontWeight: 700, fontSize: 11, flexShrink: 0,
                        }}>
                          📸 Photos
                          <input type="file" accept="image/*" multiple disabled={uploadingPhoto}
                            style={{ display: "none" }}
                            onChange={e => { if (e.target.files.length) handlePhotoUpload(m.id, e.target.files); }} />
                        </label>
                      </div>
                      {photos.length > 0 && (
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(60px,1fr))", gap: 4 }}>
                          {photos.filter(Boolean).map((src, idx) => (
                            <div key={idx} style={{ position: "relative", aspectRatio: "1/1", borderRadius: 6, overflow: "hidden", background: "#000" }}>
                              <img src={`/api/photo?url=${encodeURIComponent(src)}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                              <button onClick={() => handlePhotoDelete(m.id, src)}
                                style={{ position: "absolute", top: 1, right: 1, background: "#dc2626cc", color: "#fff", border: "none", borderRadius: 3, padding: "1px 5px", fontSize: 9, fontWeight: 700, cursor: "pointer" }}>×</button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          <div style={{ background: "#0b2410", border: "1px solid #22c55e44", borderRadius: 8, padding: "10px 12px", fontSize: 11, color: "#86efac", lineHeight: 1.5 }}>
            ✅ Les photos sont stockées sur <strong>Vercel Blob</strong> (cloud sécurisé). Elles sont visibles par tous les diagnostiqueurs et conservées même après une mise à jour de l'app.
          </div>
        </div>
      )}

      {/* ===== INVITATIONS ===== */}
      {section === "invitation" && (
        <div style={{ background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.accent, marginBottom: 6 }}>
            📧 Inviter un diagnostiqueur
          </div>
          <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 16, lineHeight: 1.5 }}>
            Le diagnostiqueur recevra automatiquement un email depuis <strong>noreply@fnddi.com</strong> avec
            <strong> son mot de passe personnel</strong> et les instructions d'installation pour PC, Mac, iPhone, Android.
          </div>

          <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
                Prénom
              </label>
              <input style={styles.input} type="text" placeholder="Jean"
                value={invitePrenom} onChange={e => setInvitePrenom(e.target.value)} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
                Nom
              </label>
              <input style={styles.input} type="text" placeholder="DUPONT"
                value={inviteNom} onChange={e => setInviteNom(e.target.value)} />
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: COLORS.muted, marginBottom: 6, textTransform: "uppercase" }}>
              Email du diagnostiqueur
            </label>
            <input style={styles.input} type="email" placeholder="jean.dupont@cabinet.fr"
              value={inviteEmail} onChange={e => setInviteEmail(e.target.value)} />
          </div>

          <button onClick={sendInvite} disabled={inviteLoading || !invitePrenom || !inviteNom || !inviteEmail}
            style={{ ...styles.btn("primary"), width: "100%", fontSize: 14, padding: "14px" }}>
            {inviteLoading ? "⏳ Envoi en cours…" : "📧 Envoyer l'invitation"}
          </button>

          {inviteMsg && (
            <div style={{ marginTop: 12, padding: "12px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600,
              background: inviteMsg.startsWith("✅") ? "#14532d" : "#7f1d1d",
              color: inviteMsg.startsWith("✅") ? "#bbf7d0" : "#fecaca",
              border: `1px solid ${inviteMsg.startsWith("✅") ? "#22c55e" : "#ef4444"}` }}>
              {inviteMsg}
            </div>
          )}

          <div style={{ marginTop: 16, padding: "12px 14px", borderRadius: 8, background: COLORS.surface, border: `1px solid ${COLORS.border}`, fontSize: 12, color: COLORS.muted }}>
            <div style={{ fontWeight: 700, marginBottom: 6, color: COLORS.text }}>Le diagnostiqueur reçoit :</div>
            <div>🌐 Lien de l'application</div>
            <div>📧 Identifiant : <strong>son email</strong></div>
            <div>🔐 Mot de passe : <strong>généré automatiquement</strong> (10 caractères)</div>
            <div style={{ marginTop: 6 }}>📲 Instructions PC / Mac / iPhone / Android</div>
          </div>
        </div>
      )}

      {/* ===== UTILISATEURS ===== */}
      {section === "users" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ fontWeight: 800, fontSize: 14, color: COLORS.accent }}>
                👥 Diagnostiqueurs inscrits ({users.length})
              </div>
              <button onClick={loadUsers} disabled={usersLoading}
                style={{ padding: "6px 12px", borderRadius: 7, border: `1px solid ${COLORS.border}`,
                  background: COLORS.surface, color: COLORS.text, fontSize: 11, fontWeight: 700, cursor: usersLoading ? "wait" : "pointer" }}>
                {usersLoading ? "⏳" : "🔄 Actualiser"}
              </button>
            </div>

            {usersError && (
              <div style={{ background: "#7f1d1d", color: "#fecaca", borderRadius: 8, padding: "10px 12px", fontSize: 12, marginBottom: 10, border: "1px solid #ef4444" }}>
                ❌ {usersError}
              </div>
            )}

            {!usersLoading && users.length === 0 && !usersError && (
              <div style={{ fontSize: 12, color: COLORS.muted, padding: "20px 10px", textAlign: "center", fontStyle: "italic" }}>
                Aucun diagnostiqueur inscrit pour l'instant.<br />
                Allez dans <strong>📧 Invitations</strong> pour en inviter un.
              </div>
            )}

            {users.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {users.map(u => (
                  <div key={u.email} style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "10px 12px", background: COLORS.surface, borderRadius: 8, border: `1px solid ${COLORS.border}` }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.text }}>
                        👤 {u.prenom} {u.nom}
                      </div>
                      <div style={{ fontSize: 11, color: COLORS.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {u.email} · inscrit le {new Date(u.createdAt).toLocaleDateString("fr-FR")}
                      </div>
                    </div>
                    <button onClick={() => deleteUser(u.email)}
                      style={{ background: "#7f1d1d", border: "none", color: "#fff", borderRadius: 6,
                        padding: "5px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                      🗑️ Révoquer
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ background: "#1a1500", border: "1px solid #fcd34d33", borderRadius: 8, padding: "10px 12px", fontSize: 11, color: "#fcd34d", lineHeight: 1.5 }}>
            ℹ️ Révoquer un accès supprime le compte. Pour le réactiver, renvoyez une invitation (nouveau mot de passe généré).
          </div>

          {savedMsg && (
            <div style={{ padding: "8px 12px", borderRadius: 8, fontSize: 12, fontWeight: 600,
              background: savedMsg.startsWith("✅") ? "#14532d" : "#7f1d1d",
              color: savedMsg.startsWith("✅") ? "#bbf7d0" : "#fecaca",
              border: `1px solid ${savedMsg.startsWith("✅") ? "#22c55e" : "#ef4444"}` }}>
              {savedMsg}
            </div>
          )}
        </div>
      )}

      {/* ===== INFOS APP ===== */}
      {section === "infos" && (
        <div style={{ background: COLORS.card, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.accent, marginBottom: 16 }}>ℹ️ Informations application</div>
          {[
            ["🌐 URL", "dpe-fndi.vercel.app"],
            ["📱 PWA", "Installable sur iPhone et Android"],
            ["🤖 IA", "Claude Sonnet 4 — Anthropic"],
            ["🏛️ Base DPE", "ADEME open data v2"],
            ["📋 Méthode", "3CL-DPE 2021"],
            ["🔐 Accès", "Sur invitation uniquement"],
            ["💾 Données", "Sauvegardées localement sur l'appareil"],
            ["🔄 Version", "1.0 — Mai 2026"],
          ].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${COLORS.border}`, fontSize: 13 }}>
              <span style={{ color: COLORS.muted }}>{k}</span>
              <span style={{ fontWeight: 600 }}>{v}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ---- Écran de connexion ----
// Identifiants stockés en localStorage (modifiables par l'admin)
const DEFAULT_LOGIN = "manager@fnddi.fr";
const DEFAULT_PASSWORD = "FNDI2024!";

// Liste des emails admins — ont accès à l'onglet Admin
const ADMIN_EMAILS = [
  "manager@fnddi.fr",
  "manager@fnddi.com",
  "olivierd@fnddi.fr",
];

// ─── Wrapper de stockage : window.storage (Claude artefacts) → fallback localStorage ───
const appStorage = {
  async get(key) {
    try {
      if (typeof window !== "undefined" && window.storage && typeof window.storage.get === "function") {
        return await window.storage.get(key, true);
      }
    } catch (_) {}
    try {
      const v = localStorage.getItem("shared:" + key);
      return v != null ? { value: v } : null;
    } catch (_) { return null; }
  },
  async set(key, value) {
    try {
      if (typeof window !== "undefined" && window.storage && typeof window.storage.set === "function") {
        return await window.storage.set(key, value, true);
      }
    } catch (_) {}
    try {
      localStorage.setItem("shared:" + key, value);
      return { value };
    } catch (e) { return null; }
  },
};

// ─── Compression d'image base64 (~50 Ko/photo) ───
async function compressImageBase64(file, maxDim = 1024, quality = 0.72) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        let w = img.width, h = img.height;
        if (w > maxDim || h > maxDim) {
          if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
          else { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        const canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = ev.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const handleLogin = async (e) => {
    e && e.preventDefault();
    setLoading(true); setError("");
    try {
      const resp = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.token) {
        localStorage.setItem("fndi_session", "1");
        localStorage.setItem("fndi_session_email", data.email || email.trim().toLowerCase());
        localStorage.setItem("fndi_session_token", data.token);
        if (data.prenom) localStorage.setItem("fndi_session_prenom", data.prenom);
        if (data.nom) localStorage.setItem("fndi_session_nom", data.nom);
        localStorage.setItem("fndi_session_admin", data.isAdmin ? "1" : "0");
        onLogin();
      } else {
        setError(data.error || "Identifiant ou mot de passe incorrect.");
      }
    } catch (err) {
      setError("Erreur de connexion réseau. Réessayez.");
    }
    setLoading(false);
  };

  const handleForgot = async () => {
    if (!email) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
        }),
      });
      const data = await res.json().catch(() => ({}));

      if (res.ok && data.ok) {
        // Pour des raisons de sécurité, l'API renvoie toujours OK même si l'email n'existe pas.
        // L'utilisateur voit donc toujours le message "email envoyé" pour ne pas révéler
        // quels emails sont enregistrés.
        setForgotSent(true);
      } else if (res.status === 429) {
        setError(data.error || "Trop de demandes. Réessayez dans 1 heure.");
      } else {
        setError(data.error || "Erreur d'envoi. Contactez votre administrateur.");
      }
    } catch {
      setError("Erreur réseau. Vérifiez votre connexion.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#111111",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: 20,
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

      {/* Logos DOMYQO + FNDi côte à côte (pleine largeur, immersif) */}
      <div style={{ marginBottom: 32, textAlign: "center" }}>
        <div style={{ background: "#fff", borderRadius: 16, padding: "28px 24px", border: "3px solid #E8762F", boxShadow: "0 8px 30px rgba(0,0,0,0.4)", display: "inline-block" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 28 }}>
            <img src="/domyqo-logo.png" alt="DOMYQO" style={{ height: 90, width: "auto" }} />
            <div style={{ height: 70, width: 1, background: "#ddd" }} />
            <img src="/fndi-logo.png" alt="FNDi" style={{ height: 80, width: "auto" }} />
          </div>
        </div>
        <div style={{ color: "#fff", fontSize: 13, fontWeight: 600, marginTop: 18, letterSpacing: "1px" }}>
          L'APPLICATION TERRAIN DU DIAGNOSTIQUEUR
        </div>
        <div style={{ color: "#888", fontSize: 11, marginTop: 6 }}>
          L'app utilisée par la FNDi · Fédération Nationale des Diagnostiqueurs Immobiliers
        </div>
      </div>

      {/* Carte de connexion */}
      <div style={{
        width: "100%", maxWidth: 400,
        background: "#1a1a1a", borderRadius: 16,
        border: "1px solid #2a2a2a", padding: 32,
        boxShadow: "0 20px 60px #00000066",
      }}>
        {!showForgot ? (
          <>
            <h2 style={{ color: "#fff", fontSize: 20, fontWeight: 800, marginBottom: 6, margin: 0 }}>Connexion</h2>
            <p style={{ color: "#666", fontSize: 13, marginBottom: 24, marginTop: 4 }}>
              Accès réservé aux diagnostiqueurs adhérents FNDi
            </p>

            <div style={{ marginBottom: 14 }}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Identifiant (email)
              </label>
              <input
                style={{
                  width: "100%", padding: "12px 14px", background: "#222", border: "1px solid #333",
                  borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box", outline: "none",
                }}
                type="email" placeholder="votre@email.fr" value={email}
                onChange={e => { setEmail(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                autoComplete="username"
              />
            </div>

            <div style={{ marginBottom: 8 }}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Mot de passe
              </label>
              <div style={{ position: "relative" }}>
                <input
                  style={{
                    width: "100%", padding: "12px 44px 12px 14px", background: "#222", border: "1px solid #333",
                    borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box", outline: "none",
                  }}
                  type={showPwd ? "text" : "password"} placeholder="••••••••" value={password}
                  onChange={e => { setPassword(e.target.value); setError(""); }}
                  onKeyDown={e => e.key === "Enter" && handleLogin()}
                  autoComplete="current-password"
                />
                <button onClick={() => setShowPwd(p => !p)} style={{
                  position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer", color: "#666", fontSize: 16,
                }}>
                  {showPwd ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <div style={{ textAlign: "right", marginBottom: 20 }}>
              <button onClick={() => { setShowForgot(true); setError(""); }}
                style={{ background: "none", border: "none", color: "#F5C800", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>
                Mot de passe oublié ?
              </button>
            </div>

            {error && (
              <div style={{ padding: "10px 14px", borderRadius: 8, background: "#ef444422", border: "1px solid #ef444444", color: "#ef4444", fontSize: 13, marginBottom: 16 }}>
                ❌ {error}
              </div>
            )}

            <button onClick={handleLogin} disabled={loading || !email || !password}
              style={{
                width: "100%", padding: "14px", borderRadius: 10, border: "none", cursor: "pointer",
                background: (!email || !password) ? "#333" : "#F5C800",
                color: (!email || !password) ? "#555" : "#ffffff",
                fontWeight: 800, fontSize: 15, transition: "all 0.2s",
              }}>
              {loading ? "⏳ Connexion…" : "🔐 Se connecter"}
            </button>

            <div style={{ marginTop: 20, padding: "12px 14px", borderRadius: 8, background: "#222", border: "1px solid #2a2a2a", fontSize: 12, color: "#555", textAlign: "center" }}>
              Accès sur invitation uniquement.<br/>Contactez votre administrateur FNDI.
            </div>
          </>
        ) : (
          <>
            <button onClick={() => { setShowForgot(false); setForgotSent(false); }}
              style={{ background: "none", border: "none", color: "#666", cursor: "pointer", fontSize: 13, marginBottom: 16, padding: 0 }}>
              ← Retour
            </button>
            <h2 style={{ color: "#fff", fontSize: 18, fontWeight: 800, marginBottom: 6, margin: "0 0 6px" }}>
              Réinitialisation du mot de passe
            </h2>
            {!forgotSent ? (
              <>
                <p style={{ color: "#666", fontSize: 13, marginBottom: 20, marginTop: 4 }}>
                  Saisissez votre adresse email. Vous recevrez vos identifiants d'accès.
                </p>
                <input
                  style={{ width: "100%", padding: "12px 14px", background: "#222", border: "1px solid #333", borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box", marginBottom: 16 }}
                  type="email" placeholder="votre@email.fr" value={email}
                  onChange={e => setEmail(e.target.value)} />
                <button onClick={handleForgot} disabled={loading || !email}
                  style={{ width: "100%", padding: "13px", borderRadius: 10, border: "none", cursor: "pointer", background: "#F5C800", color: "#111", fontWeight: 800, fontSize: 14 }}>
                  {loading ? "⏳ Envoi…" : "📧 Envoyer le lien de récupération"}
                </button>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>📬</div>
                <div style={{ color: "#F5C800", fontWeight: 700, fontSize: 15, marginBottom: 8 }}>Email envoyé !</div>
                <div style={{ color: "#666", fontSize: 13 }}>
                  Un email avec vos identifiants a été envoyé à <strong style={{ color: "#fff" }}>{email}</strong>.<br/>
                  Vérifiez votre boîte de réception.
                </div>
                <button onClick={() => { setShowForgot(false); setForgotSent(false); }}
                  style={{ marginTop: 20, padding: "10px 24px", borderRadius: 8, border: "none", cursor: "pointer", background: "#F5C800", color: "#111", fontWeight: 700 }}>
                  Retour à la connexion
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <div style={{ marginTop: 24, color: "#333", fontSize: 11 }}>
        © {new Date().getFullYear()} FNDI — Tous droits réservés
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppRoot />
    </ErrorBoundary>
  );
}

function AppRoot() {
  // ─── Détection lien d'invitation/reset dans l'URL ───
  const [setupContext, setSetupContext] = useState(() => {
    try {
      const url = new URL(window.location.href);
      const setup = url.searchParams.get("setup");
      const reset = url.searchParams.get("reset");
      if (setup) return { mode: "setup", token: setup };
      if (reset) return { mode: "reset", token: reset };
    } catch {}
    return null;
  });

  // Vérifier session au démarrage
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    try { return localStorage.getItem("fndi_session") === "1"; } catch { return false; }
  });

  const handleLogout = () => {
    try {
      localStorage.removeItem("fndi_session");
      localStorage.removeItem("fndi_session_email");
      localStorage.removeItem("fndi_session_token");
      localStorage.removeItem("fndi_session_prenom");
      localStorage.removeItem("fndi_session_nom");
      localStorage.removeItem("fndi_session_admin");
    } catch {}
    setIsAuthenticated(false);
  };

  // ─── Page setup/reset (priorité absolue, même si déjà connecté) ───
  if (setupContext) {
    return <SetupPasswordScreen
      mode={setupContext.mode}
      token={setupContext.token}
      onSuccess={() => {
        // Nettoyer l'URL et marquer connecté
        try {
          window.history.replaceState({}, "", "/");
        } catch {}
        setSetupContext(null);
        setIsAuthenticated(true);
      }}
      onCancel={() => {
        try { window.history.replaceState({}, "", "/"); } catch {}
        setSetupContext(null);
      }}
    />;
  }

  if (!isAuthenticated) {
    return <LoginScreen onLogin={() => setIsAuthenticated(true)} />;
  }

  return <AppMain onLogout={handleLogout} />;
}

// ══════════════════════════════════════════════════════
// SETUP / RESET PASSWORD — Page de création/réinit de mdp via lien
// ══════════════════════════════════════════════════════
function SetupPasswordScreen({ mode, token, onSuccess, onCancel }) {
  // mode: "setup" (1ère fois, depuis invitation) ou "reset" (oubli mdp)
  const [tokenInfo, setTokenInfo] = useState(null);  // { prenom, nom, email }
  const [tokenError, setTokenError] = useState("");
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const isSetup = mode === "setup";
  const apiPath = isSetup ? "/api/setup-password" : "/api/reset-password";

  // Vérifier le token au montage (GET)
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${apiPath}?token=${encodeURIComponent(token)}`);
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (res.ok && data.ok) {
          setTokenInfo({ prenom: data.prenom || "", nom: data.nom || "", email: data.email || "" });
        } else {
          setTokenError(data.error || "Lien invalide ou expiré.");
        }
      } catch {
        if (!cancelled) setTokenError("Erreur réseau. Vérifiez votre connexion.");
      }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [apiPath, token]);

  const submit = async () => {
    if (password.length < 8) {
      setSubmitError("Le mot de passe doit faire 8 caractères minimum.");
      return;
    }
    if (password !== confirm) {
      setSubmitError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true); setSubmitError("");
    try {
      const res = await fetch(apiPath, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        // Auto-login : stocker la session
        try {
          localStorage.setItem("fndi_session", "1");
          localStorage.setItem("fndi_session_email", data.email || "");
          localStorage.setItem("fndi_session_token", data.token || "");
          localStorage.setItem("fndi_session_prenom", data.prenom || "");
          localStorage.setItem("fndi_session_nom", data.nom || "");
          localStorage.setItem("fndi_session_admin", data.isAdmin ? "1" : "0");
        } catch {}
        onSuccess();
      } else {
        setSubmitError(data.error || "Erreur, réessayez.");
      }
    } catch {
      setSubmitError("Erreur réseau. Vérifiez votre connexion.");
    }
    setSubmitting(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#111111",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: 20,
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

      {/* Bandeau marque */}
      <div style={{ background: "#fff", border: "3px solid #E8762F", borderRadius: 12, padding: "14px 22px", marginBottom: 14, display: "flex", alignItems: "center", gap: 18 }}>
        <img src="/domyqo-logo.png" alt="DOMYQO" style={{ height: 44 }} onError={e => { e.target.style.display = "none"; }} />
        <div style={{ width: 1, height: 38, background: "#ddd" }} />
        <img src="/fndi-logo.png" alt="FNDi" style={{ height: 44 }} onError={e => { e.target.style.display = "none"; }} />
      </div>
      <div style={{ color: "#aaa", fontSize: 11, letterSpacing: 1.5, fontWeight: 600, marginBottom: 4 }}>L'APPLICATION TERRAIN DU DIAGNOSTIQUEUR</div>
      <div style={{ color: "#666", fontSize: 11, marginBottom: 24 }}>L'app utilisée par la FNDi · Fédération Nationale des Diagnostiqueurs Immobiliers</div>

      {/* Card */}
      <div style={{ width: "100%", maxWidth: 440, background: "#1a1a1a", borderRadius: 14, padding: 32, boxShadow: "0 0 60px rgba(0,0,0,0.4)", border: "1px solid #2a2a2a" }}>

        {loading ? (
          <div style={{ textAlign: "center", padding: "30px 0" }}>
            <div style={{ fontSize: 32, marginBottom: 14 }}>⏳</div>
            <div style={{ color: "#aaa", fontSize: 13 }}>Vérification du lien…</div>
          </div>
        ) : tokenError ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>❌</div>
            <h2 style={{ color: "#fff", fontSize: 18, fontWeight: 800, marginBottom: 10 }}>Lien invalide</h2>
            <div style={{ color: "#888", fontSize: 13, marginBottom: 22, lineHeight: 1.5 }}>{tokenError}</div>
            <div style={{ color: "#666", fontSize: 12, marginBottom: 18, lineHeight: 1.5 }}>
              Demandez un nouveau lien à votre administrateur ({isSetup ? "votre invitation a peut-être expiré" : "le lien est valable 3h"}).
            </div>
            <button onClick={onCancel}
              style={{ padding: "10px 24px", borderRadius: 8, border: "none", cursor: "pointer", background: "#F5C800", color: "#111", fontWeight: 700 }}>
              Retour à la connexion
            </button>
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 22 }}>
              <div style={{ fontSize: 36, marginBottom: 8 }}>{isSetup ? "👋" : "🔐"}</div>
              <h2 style={{ color: "#fff", fontSize: 19, fontWeight: 800, margin: "0 0 4px" }}>
                {isSetup ? `Bienvenue ${tokenInfo.prenom} !` : "Nouveau mot de passe"}
              </h2>
              <div style={{ color: "#888", fontSize: 13 }}>
                {isSetup ? "Créez votre mot de passe pour activer votre compte" : `Pour ${tokenInfo.email}`}
              </div>
            </div>

            <div style={{ background: "#222", border: "1px solid #2a2a2a", borderRadius: 8, padding: "10px 12px", marginBottom: 16, fontSize: 12, color: "#888" }}>
              Compte : <strong style={{ color: "#fff" }}>{tokenInfo.email}</strong>
            </div>

            <label style={{ display: "block", color: "#aaa", fontSize: 12, fontWeight: 600, marginBottom: 6, letterSpacing: 0.5 }}>NOUVEAU MOT DE PASSE</label>
            <div style={{ position: "relative", marginBottom: 14 }}>
              <input
                type={showPwd ? "text" : "password"}
                placeholder="8 caractères minimum"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoFocus
                style={{ width: "100%", padding: "12px 44px 12px 14px", background: "#222", border: "1px solid #333", borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box" }}
              />
              <button onClick={() => setShowPwd(!showPwd)}
                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: "#666", cursor: "pointer", fontSize: 16 }}>
                {showPwd ? "🙈" : "👁️"}
              </button>
            </div>

            <label style={{ display: "block", color: "#aaa", fontSize: 12, fontWeight: 600, marginBottom: 6, letterSpacing: 0.5 }}>CONFIRMER LE MOT DE PASSE</label>
            <input
              type={showPwd ? "text" : "password"}
              placeholder="Retapez votre mot de passe"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") submit(); }}
              style={{ width: "100%", padding: "12px 14px", background: "#222", border: "1px solid #333", borderRadius: 8, color: "#fff", fontSize: 14, boxSizing: "border-box", marginBottom: 16 }}
            />

            {submitError && (
              <div style={{ background: "#3a1f1f", border: "1px solid #5a2a2a", borderRadius: 6, padding: "10px 12px", marginBottom: 14, color: "#ff8888", fontSize: 12 }}>
                ⚠️ {submitError}
              </div>
            )}

            <button
              onClick={submit}
              disabled={submitting || !password || !confirm}
              style={{
                width: "100%", padding: "14px", borderRadius: 10, border: "none",
                cursor: (submitting || !password || !confirm) ? "not-allowed" : "pointer",
                background: (submitting || !password || !confirm) ? "#444" : "#F5C800",
                color: (submitting || !password || !confirm) ? "#888" : "#111",
                fontWeight: 800, fontSize: 14,
              }}>
              {submitting ? "⏳ Activation…" : (isSetup ? "✅ Créer mon compte" : "✅ Valider le nouveau mot de passe")}
            </button>

            <div style={{ marginTop: 16, fontSize: 11, color: "#666", textAlign: "center", lineHeight: 1.5 }}>
              💡 Choisissez un mot de passe fort, mémorisable et personnel.
            </div>
          </>
        )}
      </div>

      <div style={{ marginTop: 24, color: "#333", fontSize: 11 }}>© 2026 DOMYQO-FNDI</div>
    </div>
  );
}

// ══════════════════════════════════════════════════════
// MODULE DPE PROJETÉ SAISIE — Wizard guidé en 6 étapes
// ══════════════════════════════════════════════════════
const DPE_SAISIE_STEPS = [
  { id: 1, label: "Le Bien",     short: "Le Bien",  icon: "🏠", color: "#8b5cf6" },
  { id: 2, label: "DPE Réalisé", short: "DPE",      icon: "⚡", color: "#8b5cf6" },
  { id: 3, label: "Étape 1",     short: "Étape 1",  icon: "🅰️", color: "#8b5cf6" },
  { id: 4, label: "Étape 2",     short: "Étape 2",  icon: "🅱️", color: "#8b5cf6" },
  { id: 5, label: "Synthèse",    short: "Synthèse", icon: "📊", color: "#8b5cf6" },
  { id: 6, label: "Rapport",     short: "Rapport",  icon: "📄", color: "#8b5cf6" },
];

function DpeSaisieWizard({ logement, onChange, equipments, diag, onDiagChange, setDiag, travaux, setTravaux }) {
  const [step, setStep] = useState(1);
  const [maxStep, setMaxStep] = useState(1);
  // Mode rénovation : "deux_etapes" (par défaut) ou "une_etape"
  const skipEtape2 = logement.dpe_saisie_mode === "une_etape";

  const goToStep = (n) => {
    if (n <= maxStep) {
      // En mode 1 étape, on saute l'étape 4
      if (skipEtape2 && n === 4) return;
      setStep(n);
    }
  };
  const next = () => {
    let newStep = Math.min(step + 1, 6);
    // Si on est sur l'étape 3 et mode "une_etape", on saute l'étape 4 et va directement à 5 (Synthèse)
    if (step === 3 && skipEtape2) {
      newStep = 5;
    }
    setStep(newStep);
    setMaxStep(prev => Math.max(prev, newStep));
  };
  const prev = () => {
    let newStep = Math.max(step - 1, 1);
    // Si on est sur Synthèse (5) et mode "une_etape", reculer va à étape 3 directement
    if (step === 5 && skipEtape2) {
      newStep = 3;
    }
    setStep(newStep);
  };

  // Terminer maintenant : passer directement à la Synthèse
  const terminerIci = () => {
    if (window.confirm("Terminer le projet avec les étapes saisies jusqu'ici ?\n\nVous pourrez toujours revenir compléter avec une 2e étape plus tard.")) {
      // Si on n'a pas encore défini le mode, on bascule automatiquement en "une_etape"
      if (!logement.dpe_saisie_mode) {
        onChange("dpe_saisie_mode", "une_etape");
      }
      setStep(5);
      setMaxStep(prev => Math.max(prev, 5));
    }
  };

  const PURPLE = "#8b5cf6";

  // Adapter le nombre d'étapes affichées selon le mode
  const visibleSteps = skipEtape2
    ? DPE_SAISIE_STEPS.filter(s => s.id !== 4)
    : DPE_SAISIE_STEPS;
  const totalSteps = visibleSteps.length;
  // Numéro affiché : recalculer en fonction de visibleSteps
  const displayStepIdx = visibleSteps.findIndex(s => s.id === step);
  const displayStepNum = displayStepIdx >= 0 ? displayStepIdx + 1 : step;

  // Texte du bouton Suivant
  const nextStepInfo = (() => {
    if (step === 3 && skipEtape2) return DPE_SAISIE_STEPS[4]; // → Synthèse
    if (step < 6) return DPE_SAISIE_STEPS[step]; // step est 1-indexé donc c'est le suivant
    return null;
  })();

  return (
    <div>
      {/* Barre de progression — Style "dossiers" comme DPE XML (plus voyants) */}
      <div style={{
        display: "flex", gap: 2, padding: "0 0 0",
        marginBottom: 0,
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
      }}>
        {visibleSteps.map(s => {
          const visited = s.id <= maxStep;
          const isActive = step === s.id;
          const isComplete = visited && step > s.id;
          // Couleurs (cohérent avec XML : vert si complet, violet si actif, gris sinon)
          const bg = isActive ? PURPLE : (isComplete ? "#14532d" : "#1e293b");
          const color = isActive ? "#fff" : (isComplete ? "#86efac" : "#94a3b8");
          const prefix = isActive ? "▶ " : (isComplete ? "✓ " : "");
          return (
            <button key={s.id}
              onClick={() => goToStep(s.id)}
              disabled={!visited}
              title={visited ? `${s.icon} ${s.label}` : `${s.label} (verrouillée)`}
              style={{
                padding: "10px 12px",
                background: bg,
                border: "none",
                color: color,
                fontSize: 11,
                fontWeight: isActive || isComplete ? 800 : 700,
                cursor: visited ? "pointer" : "not-allowed",
                opacity: visited ? 1 : 0.5,
                borderRadius: "8px 8px 0 0",
                whiteSpace: "nowrap",
                flexShrink: 0,
                transition: "all 0.15s",
              }}>
              {prefix}{s.icon} {s.short}
            </button>
          );
        })}
      </div>

      {/* Trait violet sous les onglets — comme XML */}
      <div style={{ height: 4, background: PURPLE, marginBottom: 16 }} />

      {/* Header étape */}
      <div style={{ textAlign: "center", marginBottom: 18 }}>
        <div style={{ fontSize: 11, color: "#888", letterSpacing: 1.5, fontWeight: 700 }}>
          ÉTAPE {displayStepNum} / {totalSteps}
          {skipEtape2 && <span style={{ marginLeft: 8, color: PURPLE }}>· Mode 1 étape</span>}
        </div>
        <div style={{ fontSize: 20, fontWeight: 800, color: PURPLE, marginTop: 4 }}>
          {DPE_SAISIE_STEPS[step - 1].icon} {DPE_SAISIE_STEPS[step - 1].label}
        </div>
      </div>

      {/* Contenu de l'étape */}
      <div style={{ marginBottom: 18 }}>
        {step === 1 && (
          <SaisieEtape1LeBien data={logement} onChange={onChange} />
        )}
        {step === 2 && (
          <SaisieEtape2DpeRealise data={logement} onChange={onChange} />
        )}
        {step === 3 && (
          <SaisieEtape3Travaux data={logement} onChange={onChange} numEtape={1} />
        )}
        {step === 4 && (
          <SaisieEtape3Travaux data={logement} onChange={onChange} numEtape={2} />
        )}
        {step === 5 && (
          <SaisieEtape5Synthese data={logement} onChange={onChange} skipEtape2={skipEtape2} />
        )}
        {step === 6 && (() => {
          // ── Mapping Saisie → format attendu par RapportTab (style noir/jaune) ──
          const parseList = (s) => { try { return JSON.parse(s || "[]"); } catch { return []; } };
          const parseObj  = (s) => { try { return JSON.parse(s || "{}"); } catch { return {}; } };

          // Travaux Saisie combinés (étape 1 + étape 2 sans doublons)
          const travauxSaisie = Array.from(new Set([
            ...parseList(logement.etape1_travaux),
            ...(skipEtape2 ? [] : parseList(logement.etape2_travaux)),
          ]));

          // Classe finale = étape 2 si mode 2 étapes, sinon étape 1
          const finaleLettre = skipEtape2 ? (logement.etape1_dpe_lettre || "") : (logement.etape2_dpe_lettre || "");
          const finaleConso  = skipEtape2 ? (logement.etape1_dpe_conso  || "") : (logement.etape2_dpe_conso  || "");
          const finaleGesL   = skipEtape2 ? (logement.etape1_ges_lettre || "") : (logement.etape2_ges_lettre || "");
          const finaleGesV   = skipEtape2 ? (logement.etape1_ges_valeur || "") : (logement.etape2_ges_valeur || "");

          // Gain énergie en % (initiale → finale)
          const consoInitNum = parseFloat(logement.dpe_conso || 0);
          const consoFinNum  = parseFloat(finaleConso || 0);
          const gainPct = (consoInitNum > 0 && consoFinNum > 0)
            ? Math.round((consoInitNum - consoFinNum) / consoInitNum * 100)
            : "";

          // ── Coût total des travaux (somme étape 1 + étape 2) ──
          const computeCoutEtape = (prefix) => {
            const ids = parseList(logement[`${prefix}_travaux`]);
            const qts = parseObj(logement[`${prefix}_quantites`]);
            let min = 0, max = 0;
            const items = ids.map(id => {
              const t = TRAVAUX_TYPES.find(x => x.id === id);
              const q = qts[id];
              let costMin = null, costMax = null;
              if (t && t.cout_unitaire_min && q) {
                costMin = Math.round(t.cout_unitaire_min * q);
                costMax = Math.round(t.cout_unitaire_max * q);
                min += costMin;
                max += costMax;
              }
              return { id, t, quantite: q, costMin, costMax };
            });
            return { items, min, max };
          };
          const coutE1 = computeCoutEtape("etape1");
          const coutE2 = skipEtape2 ? { items: [], min: 0, max: 0 } : computeCoutEtape("etape2");
          const coutTotalMin = Math.round(coutE1.min + coutE2.min);
          const coutTotalMax = Math.round(coutE1.max + coutE2.max);
          // Aides moyennes (MaPrimeRénov' + CEE) ~35% du coût brut
          const coutAides = Math.round(coutTotalMin * 0.35);

          // ── Détail des étapes pour la section TRAVAUX du rapport ──
          // Chaque étape : items + coût + classe atteinte + gain énergétique propre
          const consoEtape1 = parseFloat(logement.etape1_dpe_lettre ? (logement.etape1_dpe_conso || 0) : 0);
          const gainE1Pct = consoInitNum > 0 && consoEtape1 > 0
            ? Math.round((consoInitNum - consoEtape1) / consoInitNum * 100) : 0;
          const consoEtape2 = e2 => parseFloat(logement.etape2_dpe_conso || 0);
          const gainE2Pct = !skipEtape2 && consoEtape1 > 0 && parseFloat(logement.etape2_dpe_conso || 0) > 0
            ? Math.round((consoEtape1 - parseFloat(logement.etape2_dpe_conso)) / consoEtape1 * 100) : 0;

          const saisieEtapes = [
            {
              num: 1,
              label: skipEtape2 ? "Travaux préconisés" : "Étape 1",
              items: coutE1.items,
              min: coutE1.min,
              max: coutE1.max,
              lettreFin: logement.etape1_dpe_lettre || "",
              consoFin:  logement.etape1_dpe_conso  || "",
              gesL:      logement.etape1_ges_lettre || "",
              gesV:      logement.etape1_ges_valeur || "",
              gainPct:   gainE1Pct,
            },
            ...(skipEtape2 ? [] : [{
              num: 2,
              label: "Étape 2",
              items: coutE2.items,
              min: coutE2.min,
              max: coutE2.max,
              lettreFin: logement.etape2_dpe_lettre || "",
              consoFin:  logement.etape2_dpe_conso  || "",
              gesL:      logement.etape2_ges_lettre || "",
              gesV:      logement.etape2_ges_valeur || "",
              gainPct:   gainE2Pct,
            }]),
          ];

          // ── Économie annuelle estimée ──
          // Mix énergétique par défaut : 0,18 €/kWh primaire (moyenne France 2026)
          // Si on connaît le chauffage XML on l'utilise, sinon valeur médiane
          const PRIX_ENERGIE = { elec: 0.2516, gaz: 0.1302, fioul: 0.1100, bois: 0.060 };
          const prixEnergie = PRIX_ENERGIE[logement.chauffage] || 0.18;
          const surface = parseFloat(logement.surface) || 0;
          const kwhEconomises = (consoInitNum - consoFinNum) * surface;
          const econMin = kwhEconomises > 0 ? Math.round(kwhEconomises * prixEnergie * 0.85) : 0;
          const econMax = kwhEconomises > 0 ? Math.round(kwhEconomises * prixEnergie * 1.15) : 0;

          // ── ROI (temps de retour sur investissement) — même formule que module XML ──
          const aideRate = 0.35;
          const coutNet = Math.round(coutTotalMin * (1 - aideRate));
          const econMoyenne = (econMin + econMax) / 2;
          const roiMin = econMoyenne > 0 ? Math.ceil(coutNet / (econMax * 1.1)) : 0;
          const roiMax = econMoyenne > 0 ? Math.ceil(coutNet / (econMin * 0.9)) : 0;
          const roi = econMoyenne > 0 ? `${Math.max(2, roiMin)}-${Math.max(3, roiMax)} ans` : "—";

          // data enrichi avec les champs que RapportTab attend (équivalents XML)
          const mappedData = {
            ...logement,
            dpe_lettre_projete:      finaleLettre,
            dpe_conso_projete:       finaleConso,
            dpe_gain_pct:            gainPct,
            ges_lettre_projete:      finaleGesL,
            ges_valeur_projete:      finaleGesV,
            dpe_projete_cout_min:    coutTotalMin > 0 ? coutTotalMin.toLocaleString("fr-FR") : "",
            dpe_projete_cout_max:    coutTotalMax > 0 ? coutTotalMax.toLocaleString("fr-FR") : "",
            dpe_projete_cout_aides:  coutAides    > 0 ? coutAides.toLocaleString("fr-FR")    : "",
            dpe_projete_economie:    econMin      > 0 ? `${econMin.toLocaleString("fr-FR")}–${econMax.toLocaleString("fr-FR")}` : "",
            dpe_projete_roi:         roi,
            // Détail par étape (mode Saisie) — RapportTab affichera les 2 sections distinctement
            saisieEtapes:            saisieEtapes,
          };

          return (
            <RapportTab
              data={mappedData}
              equipments={equipments || []}
              comments={[]}
              travaux={travauxSaisie}
              diag={diag}
              onDiagChange={onDiagChange}
              setDiag={setDiag}
              setActiveTab={() => goToStep(1)}
              onLogementChange={onChange}
              saisieMode={true}
            />
          );
        })()}
      </div>

      {/* Boutons navigation */}
      <div style={{ display: "flex", gap: 8, marginTop: 20, flexWrap: "wrap" }}>
        {step > 1 && (
          <button onClick={prev}
            style={{ flex: "0 1 auto", padding: "12px 16px", background: "#1e293b", color: "#94a3b8",
              border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
            ← Précédent
          </button>
        )}
        {step < 6 && nextStepInfo && (
          <button onClick={next}
            style={{ flex: 2, minWidth: 120, padding: "12px", background: PURPLE, color: "#fff",
              border: "none", borderRadius: 8, fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
            Suivant : {nextStepInfo.label} →
          </button>
        )}
        {/* Bouton "Terminer ici" — visible sur étapes 3 et 4 uniquement */}
        {(step === 3 || step === 4) && (
          <button onClick={terminerIci}
            title="Terminer le projet et aller à la Synthèse"
            style={{ flex: "0 1 auto", padding: "12px 16px", background: "#22c55e22", color: "#22c55e",
              border: "1px solid #22c55e", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
            ✓ Terminer ici
          </button>
        )}
      </div>
    </div>
  );
}

// ─── Étape 1 : Le Bien (réutilise LogementTab vue general SANS l'import XML/ADEME) ───
function SaisieEtape1LeBien({ data, onChange }) {
  return (
    <div>
      <div style={{ fontSize: 12, color: "#aaa", marginBottom: 16, padding: "10px 14px", background: "#8b5cf611", borderRadius: 8, border: "1px solid #8b5cf633" }}>
        💡 Saisissez les coordonnées du bien diagnostiqué. Pas d'import XML — vous remplirez les valeurs DPE de votre logiciel pro à l'étape suivante.
      </div>
      <LogementTabSaisie data={data} onChange={onChange} />
    </div>
  );
}

// LogementTabSaisie : sections 1, 2, 3 SANS l'import XML/ADEME ni avancement
function LogementTabSaisie({ data, onChange }) {
  const sel = (key, label, options) => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <select style={styles.select} value={data[key] || ""} onChange={e => onChange(key, e.target.value)}>
        <option value="">— Choisir —</option>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
  const inp = (key, label, placeholder, type="text") => (
    <div style={styles.field}>
      <label style={styles.label}>{label}</label>
      <input type={type} style={styles.input} value={data[key] || ""} onChange={e => onChange(key, e.target.value)} placeholder={placeholder} />
    </div>
  );

  return (
    <div>
      {/* 1 · DOSSIER */}
      <Section num="1" icon="📁" title="Dossier" isComplete={!!(data.dpe_lettre || data.adresse)} defaultOpen={true}>
        <div style={styles.row}>
          {inp("ademe_numero", "N° ADEME (optionnel)", "ex: 2301E0743361A")}
          <DatePicker label="Date de visite" value={data.date_visite} onChange={v => onChange("date_visite", v)} />
        </div>
        <div style={styles.row}>
          <DatePicker label="Date du rapport" value={data.date_rapport} onChange={v => onChange("date_rapport", v)} />
          {sel("type_diag", "Type de diagnostic", [
            { value: "vente", label: "Vente" },
            { value: "location", label: "Location" },
            { value: "renouvellement", label: "Renouvellement" },
            { value: "audit", label: "Audit / Autre" },
          ])}
        </div>
        {sel("statut_dossier", "Statut du dossier", [
          { value: "brouillon", label: "📝 Brouillon" },
          { value: "a_controler", label: "🔍 À contrôler" },
          { value: "transmis", label: "📤 Transmis" },
        ])}
      </Section>

      {/* 2 · PROPRIÉTAIRE */}
      <Section num="2" icon="👤" title="Propriétaire" isComplete={!!data.proprio_nom}>
        <div style={styles.row}>
          {inp("proprio_nom", "Nom", "ex: DUPONT")}
          {inp("proprio_prenom", "Prénom", "ex: Jean")}
        </div>
        <div style={styles.row}>
          {inp("proprio_tel", "Téléphone", "ex: 06 12 34 56 78", "tel")}
          {inp("proprio_email", "Email", "ex: jean.dupont@email.fr", "email")}
        </div>
        <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.accent, marginTop: 14, marginBottom: 10 }}>Donneur d'ordre</div>
        {sel("donneur_ordre_type", "Type", [
          { value: "proprietaire", label: "Propriétaire" },
          { value: "agence", label: "Agence immobilière" },
          { value: "notaire", label: "Notaire" },
          { value: "mandataire", label: "Mandataire" },
          { value: "autre", label: "Autre" },
        ])}
      </Section>

      {/* 3 · BIEN */}
      <Section num="3" icon="🏠" title="Bien diagnostiqué" isComplete={!!(data.surface || data.type)}>
        <AdresseAutocomplete
          label="Adresse du bien"
          value={data.adresse || ""}
          onChange={v => onChange("adresse", v)}
          onSelect={sel => onChange("adresse", sel.full)}
        />
        <div style={styles.row}>
          {inp("surface", "Surface habitable (m²)", "ex: 75", "number")}
          {sel("type", "Type de logement", [
            { value: "maison", label: "Maison individuelle" },
            { value: "appartement", label: "Appartement" },
            { value: "immeuble", label: "Immeuble entier" },
          ])}
        </div>
        {sel("annee_periode", "Période de construction", [
          { value: "avant_1948", label: "Avant 1948" },
          { value: "1948_1974", label: "1948 – 1974" },
          { value: "1975_1981", label: "1975 – 1981" },
          { value: "1982_1988", label: "1982 – 1988" },
          { value: "1989_2000", label: "1989 – 2000" },
          { value: "2001_2012", label: "2001 – 2012" },
          { value: "apres_2012", label: "Après 2012 (RT 2012)" },
        ])}
        {inp("annee", "Année de construction (si connue)", "ex: 1968", "number")}
      </Section>
    </div>
  );
}

// ─── Étape 2 : DPE Réalisé (saisie depuis logiciel) ───
function SaisieEtape2DpeRealise({ data, onChange }) {
  return (
    <div>
      <div style={{ fontSize: 12, color: "#aaa", marginBottom: 16, padding: "10px 14px", background: "#8b5cf611", borderRadius: 8, border: "1px solid #8b5cf633" }}>
        💡 Reportez les valeurs du DPE actuel calculées par votre logiciel (LICIEL, DPE-Win, etc.).
      </div>
      <div style={styles.card}>
        <div style={styles.cardTitle}>⚡ DPE Réalisé — État actuel</div>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Classe énergétique (DPE)</label>
            <select style={styles.select} value={data.dpe_lettre || ""} onChange={e => onChange("dpe_lettre", e.target.value)}>
              <option value="">— Choisir —</option>
              {["A","B","C","D","E","F","G"].map(l => <option key={l} value={l}>Classe {l}</option>)}
            </select>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Consommation (kWh/m²/an)</label>
            <input type="number" style={styles.input} value={data.dpe_conso || ""} onChange={e => onChange("dpe_conso", e.target.value)} placeholder="ex: 380" />
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Classe GES</label>
            <select style={styles.select} value={data.ges_lettre || ""} onChange={e => onChange("ges_lettre", e.target.value)}>
              <option value="">— Choisir —</option>
              {["A","B","C","D","E","F","G"].map(l => <option key={l} value={l}>Classe {l}</option>)}
            </select>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Émissions GES (kg CO₂/m²/an)</label>
            <input type="number" style={styles.input} value={data.ges_valeur || ""} onChange={e => onChange("ges_valeur", e.target.value)} placeholder="ex: 75" />
          </div>
        </div>
      </div>

      {/* Aperçu visuel */}
      {data.dpe_lettre && (
        <div style={{ ...styles.card, display: "flex", alignItems: "center", gap: 16 }}>
          <DPELetterBadge letter={data.dpe_lettre} size={70} label="DPE" />
          {data.ges_lettre && <DPELetterBadge letter={data.ges_lettre} size={70} label="GES" />}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, color: "#888", letterSpacing: 1, fontWeight: 700 }}>DPE INITIAL ENREGISTRÉ</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginTop: 4 }}>
              {data.dpe_conso || "?"} kWh/m²/an · GES {data.ges_lettre || "?"}
            </div>
            {(data.dpe_lettre === "F" || data.dpe_lettre === "G") && (
              <div style={{ fontSize: 11, color: "#ef4444", marginTop: 4 }}>⚠️ Logement énergivore (passoire thermique)</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Étapes 3 et 4 : Travaux Étape N + Saisie résultat ───
function SaisieEtape3Travaux({ data, onChange, numEtape }) {
  const prefix = numEtape === 1 ? "etape1" : "etape2";
  const otherPrefix = numEtape === 1 ? "etape2" : "etape1";

  // Travaux de cette étape
  let travauxEtape = [];
  try { travauxEtape = JSON.parse(data[`${prefix}_travaux`] || "[]"); } catch {}
  // Travaux de l'AUTRE étape (pour grisage)
  let travauxAutre = [];
  try { travauxAutre = JSON.parse(data[`${otherPrefix}_travaux`] || "[]"); } catch {}
  // Quantités de cette étape
  let quantites = {};
  try { quantites = JSON.parse(data[`${prefix}_quantites`] || "{}"); } catch {}

  const toggleTravail = (id) => {
    const newList = travauxEtape.includes(id)
      ? travauxEtape.filter(t => t !== id)
      : [...travauxEtape, id];
    onChange(`${prefix}_travaux`, JSON.stringify(newList));
  };
  const setQuantite = (id, val) => {
    const newQ = { ...quantites };
    if (val === "" || val === null) delete newQ[id];
    else newQ[id] = parseFloat(val) || 0;
    onChange(`${prefix}_quantites`, JSON.stringify(newQ));
  };

  // Calculs
  let totalMin = 0, totalMax = 0, nbChiffres = 0;
  travauxEtape.forEach(id => {
    const t = TRAVAUX_TYPES.find(x => x.id === id);
    const qty = quantites[id];
    if (t && t.cout_unitaire_min && qty) {
      totalMin += t.cout_unitaire_min * qty;
      totalMax += t.cout_unitaire_max * qty;
      nbChiffres++;
    }
  });

  return (
    <div>
      {/* Toggle plan de rénovation — visible UNIQUEMENT sur l'Étape 1 (pas sur Étape 2) */}
      {numEtape === 1 && (() => {
        const isOneStep = data.dpe_saisie_mode === "une_etape";
        const setMode = (mode) => onChange("dpe_saisie_mode", mode);
        return (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 800, color: "#888", letterSpacing: 1, marginBottom: 8 }}>
              🔄 PLAN DE RÉNOVATION
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setMode("deux_etapes")}
                style={{
                  flex: 1, padding: "12px 14px", borderRadius: 10,
                  background: !isOneStep ? "#8b5cf6" : "#1e293b",
                  color: !isOneStep ? "#fff" : "#94a3b8",
                  border: !isOneStep ? "2px solid #8b5cf6" : "2px solid transparent",
                  cursor: "pointer", textAlign: "left", transition: "all 0.15s",
                }}>
                <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 2 }}>
                  {!isOneStep ? "◉" : "○"} En 2 étapes
                </div>
                <div style={{ fontSize: 10, opacity: 0.85 }}>
                  Rénovation progressive (recommandé)
                </div>
              </button>
              <button onClick={() => setMode("une_etape")}
                style={{
                  flex: 1, padding: "12px 14px", borderRadius: 10,
                  background: isOneStep ? "#8b5cf6" : "#1e293b",
                  color: isOneStep ? "#fff" : "#94a3b8",
                  border: isOneStep ? "2px solid #8b5cf6" : "2px solid transparent",
                  cursor: "pointer", textAlign: "left", transition: "all 0.15s",
                }}>
                <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 2 }}>
                  {isOneStep ? "◉" : "○"} En 1 étape
                </div>
                <div style={{ fontSize: 10, opacity: 0.85 }}>
                  Rénovation simple (1 vague)
                </div>
              </button>
            </div>
          </div>
        );
      })()}

      <div style={{ fontSize: 12, color: "#aaa", marginBottom: 16, padding: "10px 14px", background: "#8b5cf611", borderRadius: 8, border: "1px solid #8b5cf633" }}>
        💡 {numEtape === 1
          ? "1ère vague de travaux : sélectionnez les travaux prioritaires et chiffrez-les en m²."
          : "2e vague de travaux : sélectionnez les travaux complémentaires (ceux de l'étape 1 sont grisés)."}
      </div>

      {/* Travaux à préconiser */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>✅ Travaux pour l'étape {numEtape}</div>
        {["haute", "moyenne", "basse"].map(urgence => (
          <div key={urgence} style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: URGENCE_COLORS[urgence], textTransform: "uppercase", letterSpacing: "1px", marginBottom: 6 }}>
              ● Priorité {urgence}
            </div>
            {TRAVAUX_TYPES.filter(t => t.urgence === urgence).map(t => {
              const selected = travauxEtape.includes(t.id);
              const isInOther = travauxAutre.includes(t.id);
              const qty = quantites[t.id];
              const costMin = t.cout_unitaire_min && qty ? Math.round(t.cout_unitaire_min * qty) : null;
              const costMax = t.cout_unitaire_max && qty ? Math.round(t.cout_unitaire_max * qty) : null;

              return (
                <div key={t.id} style={{ marginBottom: 5 }}>
                  <div onClick={() => !isInOther && toggleTravail(t.id)}
                    style={{
                      display: "flex", alignItems: "center", gap: 10,
                      padding: "9px 12px", borderRadius: 8,
                      cursor: isInOther ? "not-allowed" : "pointer",
                      opacity: isInOther ? 0.4 : 1,
                      background: isInOther ? "#1a1a1a" : (selected ? "#8b5cf611" : COLORS.surface),
                      border: `1px solid ${isInOther ? "#333" : (selected ? "#8b5cf6" : COLORS.border)}`
                    }}>
                    <div style={{
                      width: 20, height: 20, borderRadius: 4, flexShrink: 0,
                      background: isInOther ? "#14532d" : (selected ? "#8b5cf6" : "transparent"),
                      border: `2px solid ${isInOther ? "#22c55e" : (selected ? "#8b5cf6" : COLORS.muted)}`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 12, color: isInOther ? "#86efac" : "#fff", fontWeight: 900
                    }}>{(selected || isInOther) ? "✓" : ""}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: selected ? 700 : 400, textDecoration: isInOther ? "line-through" : "none" }}>{t.label}</div>
                      <div style={{ fontSize: 11, color: isInOther ? "#86efac" : COLORS.muted, marginTop: 1 }}>
                        {isInOther ? `Déjà en étape ${numEtape === 1 ? 2 : 1}` : `${t.cout} · Gain : ${t.gain}`}
                      </div>
                    </div>
                  </div>
                  {selected && t.unite && !isInOther && (
                    <div style={{ marginTop: 4, marginLeft: 32, padding: "8px 12px", background: "#8b5cf608", borderRadius: 6, border: "1px solid #8b5cf622", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8b5cf6", minWidth: 70 }}>Quantité :</label>
                      <input type="number" min="0" step="0.5" value={qty || ""}
                        onClick={e => e.stopPropagation()}
                        onChange={e => setQuantite(t.id, e.target.value)}
                        placeholder="0"
                        style={{ width: 80, padding: "5px 8px", borderRadius: 4, border: `1px solid ${COLORS.border}`, background: COLORS.card, color: COLORS.text, fontSize: 13, fontWeight: 700 }} />
                      <span style={{ fontSize: 12, color: COLORS.muted, fontWeight: 600 }}>{t.unite}</span>
                      {costMin !== null && (
                        <span style={{ marginLeft: "auto", fontSize: 12, fontWeight: 800, color: "#22c55e", background: "#14532d33", padding: "3px 8px", borderRadius: 4 }}>
                          ≈ {costMin.toLocaleString("fr-FR")} – {costMax.toLocaleString("fr-FR")} €
                        </span>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}

        {nbChiffres > 0 && (
          <div style={{ marginTop: 14, padding: "14px 16px", borderRadius: 10, background: "linear-gradient(135deg, #8b5cf622, #8b5cf608)", border: "2px solid #8b5cf6", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#8b5cf6", letterSpacing: 1 }}>ESTIMATION ÉTAPE {numEtape}</div>
              <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 2 }}>{nbChiffres} travail{nbChiffres > 1 ? "x" : ""} chiffré{nbChiffres > 1 ? "s" : ""}</div>
            </div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#8b5cf6" }}>
              {Math.round(totalMin).toLocaleString("fr-FR")} – {Math.round(totalMax).toLocaleString("fr-FR")} €
            </div>
          </div>
        )}
      </div>

      {/* Résultat énergétique après étape */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📊 Résultat après étape {numEtape}</div>
        <div style={{ fontSize: 11, color: "#aaa", marginBottom: 12 }}>
          Saisissez les valeurs calculées par votre logiciel après ces travaux.
        </div>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Classe DPE</label>
            <select style={styles.select} value={data[`${prefix}_dpe_lettre`] || ""} onChange={e => onChange(`${prefix}_dpe_lettre`, e.target.value)}>
              <option value="">— Choisir —</option>
              {["A","B","C","D","E","F","G"].map(l => <option key={l} value={l}>Classe {l}</option>)}
            </select>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Consommation</label>
            <input type="number" style={styles.input} value={data[`${prefix}_dpe_conso`] || ""} onChange={e => onChange(`${prefix}_dpe_conso`, e.target.value)} placeholder="kWh/m²/an" />
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Classe GES</label>
            <select style={styles.select} value={data[`${prefix}_ges_lettre`] || ""} onChange={e => onChange(`${prefix}_ges_lettre`, e.target.value)}>
              <option value="">— Choisir —</option>
              {["A","B","C","D","E","F","G"].map(l => <option key={l} value={l}>Classe {l}</option>)}
            </select>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Émissions GES</label>
            <input type="number" style={styles.input} value={data[`${prefix}_ges_valeur`] || ""} onChange={e => onChange(`${prefix}_ges_valeur`, e.target.value)} placeholder="kg CO₂/m²/an" />
          </div>
        </div>

        {data[`${prefix}_dpe_lettre`] && (
          <div style={{ marginTop: 14, padding: 14, background: "#0a0a0a", borderRadius: 8, display: "flex", alignItems: "center", gap: 12 }}>
            <DPELetterBadge letter={data[`${prefix}_dpe_lettre`]} size={56} />
            <div>
              <div style={{ fontSize: 11, color: "#8b5cf6", fontWeight: 700, letterSpacing: 1 }}>APRÈS ÉTAPE {numEtape}</div>
              <div style={{ fontSize: 13, color: "#fff", marginTop: 2 }}>
                {data[`${prefix}_dpe_conso`] || "?"} kWh/m²/an · GES {data[`${prefix}_ges_lettre`] || "?"}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Étape 5 : Synthèse + Rapport ───
// ─── Étape 5 : Synthèse (3 étiquettes + détail financier + Synthèse IA + Récap) ───
function SaisieEtape5Synthese({ data, onChange, skipEtape2 }) {
  const [analysis, setAnalysis] = useState(() => data.synthese_ia || "");
  const [loading, setLoading] = useState(false);

  // Calculs synthèse
  const calcEtape = (prefix) => {
    let travauxList = [];
    let qts = {};
    try { travauxList = JSON.parse(data[`${prefix}_travaux`] || "[]"); } catch {}
    try { qts = JSON.parse(data[`${prefix}_quantites`] || "{}"); } catch {}
    let min = 0, max = 0;
    travauxList.forEach(id => {
      const t = TRAVAUX_TYPES.find(x => x.id === id);
      const q = qts[id];
      if (t && t.cout_unitaire_min && q) {
        min += t.cout_unitaire_min * q;
        max += t.cout_unitaire_max * q;
      }
    });
    return { travauxList, qts, min, max };
  };
  const e1 = calcEtape("etape1");
  const e2 = calcEtape("etape2");
  const totalMin = e1.min + (skipEtape2 ? 0 : e2.min);
  const totalMax = e1.max + (skipEtape2 ? 0 : e2.max);

  // Lettre finale = celle de l'étape 2 si activée, sinon celle de l'étape 1
  const lettreFinale = skipEtape2 ? data.etape1_dpe_lettre : data.etape2_dpe_lettre;
  const consoFinale = skipEtape2 ? data.etape1_dpe_conso : data.etape2_dpe_conso;

  const totalTravaux = e1.travauxList.length + (skipEtape2 ? 0 : e2.travauxList.length);

  async function generateAnalysis() {
    setLoading(true);
    setAnalysis("");
    const travauxToList = (list, qts, label) => {
      if (list.length === 0) return `${label}: aucun`;
      return `${label} :\n` + list.map(id => {
        const t = TRAVAUX_TYPES.find(x => x.id === id);
        const q = qts[id];
        const qtxt = q && t?.unite ? ` (${q} ${t.unite})` : "";
        return `- ${t?.label || id}${qtxt}`;
      }).join("\n");
    };
    const t1List = travauxToList(e1.travauxList, e1.qts, "Travaux Étape 1");
    const t2List = skipEtape2 ? "" : "\n" + travauxToList(e2.travauxList, e2.qts, "Travaux Étape 2");

    const prompt = `Tu es un expert DPE FNDI certifié. Génère une synthèse professionnelle de ce projet de rénovation ${skipEtape2 ? "en 1 étape" : "en 2 étapes"}.

Logement: ${data.type || "?"}, ${data.surface || "?"} m², ${data.annee || "?"}
Adresse: ${data.adresse || "?"}

DPE INITIAL: Classe ${data.dpe_lettre || "?"}, ${data.dpe_conso || "?"} kWh/m²/an, GES classe ${data.ges_lettre || "?"}

${skipEtape2 ? "" : `APRÈS ÉTAPE 1: Classe ${data.etape1_dpe_lettre || "?"}, ${data.etape1_dpe_conso || "?"} kWh/m²/an, GES ${data.etape1_ges_lettre || "?"}`}

APRÈS ${skipEtape2 ? "TRAVAUX" : "ÉTAPE 2"}: Classe ${lettreFinale || "?"}, ${consoFinale || "?"} kWh/m²/an, GES ${(skipEtape2 ? data.etape1_ges_lettre : data.etape2_ges_lettre) || "?"}

${t1List}${t2List}

Coût total estimé: ${Math.round(totalMin).toLocaleString("fr-FR")} - ${Math.round(totalMax).toLocaleString("fr-FR")} €

Synthèse professionnelle structurée en 3 paragraphes courts :
1. Diagnostic actuel et points faibles du logement
2. Stratégie de rénovation ${skipEtape2 ? "" : "en 2 étapes "}et bénéfices attendus
3. Performance globale, gain énergétique et recommandation finale

Contraintes IMPÉRATIVES :
- Maximum 280 mots au total (synthèse compacte)
- Ton professionnel, factuel et engageant pour le propriétaire
- Termine OBLIGATOIREMENT le 3ème paragraphe par une phrase de conclusion COMPLÈTE (pas de phrase tronquée)
- N'utilise pas de listes à puces ; uniquement des paragraphes en prose continue
- Pas de salutation, pas d'introduction du type "Voici la synthèse"`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_ANTHROPIC_KEY || "", "anthropic-version": "2023-06-01", "anthropic-dangerous-direct-browser-access": "true" },
        body: JSON.stringify({ model: "claude-sonnet-4-6", max_tokens: 1500, messages: [{ role: "user", content: prompt }] })
      });
      const d = await res.json();
      let txt = d.content?.map(b => b.text || "").join("") || "";

      // Nettoyage : supprimer une éventuelle dernière phrase tronquée par l'IA
      // Cas typiques : "**Il est fortement", "Pour conclure,", phrase sans ponctuation finale.
      txt = txt.trim();
      // Si la fin a un ** non fermé ou pas de ponctuation finale, on coupe au dernier point/!/?
      const lastChar = txt.slice(-1);
      const endsCleanly = /[.!?»"\)]$/.test(txt);
      const hasUnclosedBold = (txt.match(/\*\*/g) || []).length % 2 !== 0;
      if (!endsCleanly || hasUnclosedBold) {
        // Trouver la dernière ponctuation forte qui termine une phrase
        const lastPeriod = Math.max(
          txt.lastIndexOf(". "),
          txt.lastIndexOf(".\n"),
          txt.lastIndexOf("! "),
          txt.lastIndexOf("? "),
          txt.lastIndexOf(".\r")
        );
        if (lastPeriod > txt.length / 2) {
          // Garder jusqu'au point inclus
          txt = txt.slice(0, lastPeriod + 1).trim();
          // Ré-équilibrer les ** s'il en manque
          if ((txt.match(/\*\*/g) || []).length % 2 !== 0) {
            // Supprimer le dernier ** orphelin
            const lastBold = txt.lastIndexOf("**");
            if (lastBold !== -1) txt = (txt.slice(0, lastBold) + txt.slice(lastBold + 2)).trim();
          }
        }
      }

      setAnalysis(txt);
      // Persistance : stocker dans le logement pour conservation entre étapes / sessions
      if (txt && onChange) onChange("synthese_ia", txt);
    } catch { setAnalysis("Erreur de génération."); }
    setLoading(false);
  }

  return (
    <div>
      <div style={{ fontSize: 12, color: "#aaa", marginBottom: 16, padding: "10px 14px", background: "#8b5cf611", borderRadius: 8, border: "1px solid #8b5cf633" }}>
        📊 Synthèse de votre projet de rénovation {skipEtape2 ? "en 1 étape" : "en 2 étapes"}.
      </div>

      {/* Badges résumé */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
        {[
          { label: "🔨 Travaux", val: totalTravaux, color: "#f97316" },
          { label: "📊 Étapes", val: skipEtape2 ? 1 : 2, color: "#8b5cf6" },
          { label: "💰 Budget total", val: totalMin > 0 ? `${Math.round(totalMin/1000)}k€` : "—", color: "#22c55e" },
        ].map(b => (
          <div key={b.label} style={{ flex: 1, padding: "12px 10px", borderRadius: 10, textAlign: "center", background: b.color + "15", border: `1px solid ${b.color}33` }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: b.color }}>{b.val}</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>{b.label}</div>
          </div>
        ))}
      </div>

      {/* Étiquettes côte à côte (2 si mode 1 étape, 3 si mode 2 étapes) */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📊 Comparatif énergétique</div>
        <div style={{ display: "grid", gridTemplateColumns: skipEtape2 ? "1fr 1fr" : "1fr 1fr 1fr", gap: 10 }}>
          <div style={{ background: "#ff572222", border: "2px solid #ff5722", borderRadius: 10, padding: 12, textAlign: "center" }}>
            <div style={{ fontSize: 10, color: "#fca5a5", fontWeight: 700, marginBottom: 6 }}>INITIAL</div>
            <DPELetterBadge letter={data.dpe_lettre} size={50} />
            <div style={{ fontSize: 11, color: "#fca5a5", marginTop: 6 }}>{data.dpe_conso || "?"} kWh</div>
          </div>
          {!skipEtape2 && (
            <div style={{ background: "#ff980022", border: "2px solid #ff9800", borderRadius: 10, padding: 12, textAlign: "center" }}>
              <div style={{ fontSize: 10, color: "#ffd180", fontWeight: 700, marginBottom: 6 }}>APRÈS ÉTAPE 1</div>
              <DPELetterBadge letter={data.etape1_dpe_lettre} size={50} />
              <div style={{ fontSize: 11, color: "#ffd180", marginTop: 6 }}>{data.etape1_dpe_conso || "?"} kWh</div>
            </div>
          )}
          <div style={{ background: "#4caf5022", border: "2px solid #4caf50", borderRadius: 10, padding: 12, textAlign: "center" }}>
            <div style={{ fontSize: 10, color: "#86efac", fontWeight: 700, marginBottom: 6 }}>
              {skipEtape2 ? "APRÈS TRAVAUX" : "APRÈS ÉTAPE 2"}
            </div>
            <DPELetterBadge letter={lettreFinale} size={50} />
            <div style={{ fontSize: 11, color: "#86efac", marginTop: 6 }}>
              {consoFinale || "?"} kWh
            </div>
          </div>
        </div>
      </div>

      {/* 🤖 Synthèse IA */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>🤖 Synthèse IA du projet</div>
        {!analysis && !loading && (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ color: COLORS.muted, fontSize: 14, marginBottom: 16 }}>
              Synthèse personnalisée intégrant DPE initial, travaux et performance projetée
            </div>
            <button onClick={generateAnalysis} style={{ padding: "10px 22px", background: "#8b5cf6", color: "#fff", border: "none", borderRadius: 8, fontWeight: 800, fontSize: 14, cursor: "pointer" }}>
              ✨ Générer la synthèse
            </button>
          </div>
        )}
        {loading && <div style={{ textAlign: "center", padding: "20px 0", color: COLORS.muted }}>⏳ Génération…</div>}
        {analysis && (
          <>
            <div style={{ marginBottom: 6, fontSize: 11, color: COLORS.muted, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 13 }}>✏️</span>
              <span>Vous pouvez <strong style={{ color: "#fff" }}>modifier la synthèse</strong> ci-dessous avant de générer le rapport. Les modifications sont sauvegardées automatiquement.</span>
            </div>
            <textarea
              value={analysis}
              onChange={(e) => {
                const newVal = e.target.value;
                setAnalysis(newVal);
                // Sauvegarde immédiate dans le logement (sera persistée à la prochaine sauvegarde)
                if (onChange) onChange("synthese_ia", newVal);
              }}
              style={{
                ...styles.analysisBox,
                width: "100%",
                minHeight: 280,
                resize: "vertical",
                fontFamily: "inherit",
                fontSize: 13,
                lineHeight: 1.6,
                padding: 14,
                color: "#fff",
                background: "#0f0f0f",
                border: "1px solid #8b5cf655",
                borderRadius: 8,
                outline: "none",
                boxSizing: "border-box",
              }}
              placeholder="Synthèse de votre projet de rénovation…"
            />
            <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <button onClick={generateAnalysis} style={styles.btn("secondary")}>🔄 Régénérer (IA)</button>
              <span style={{ fontSize: 11, color: "#16a34a", fontWeight: 700 }}>💾 Modifications sauvegardées automatiquement</span>
            </div>
          </>
        )}
      </div>

      {/* Détail financier */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>💰 Détail financier</div>
        <div style={{ background: "#0a0a0a", borderRadius: 8, padding: 12, marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: "#888", fontWeight: 700, letterSpacing: 1, marginBottom: 8 }}>
            {skipEtape2 ? "TRAVAUX" : "ÉTAPE 1"} — {e1.travauxList.length} travail(x)
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#aaa", padding: "4px 0" }}>
            <span>Coût estimé</span>
            <span style={{ color: "#fff", fontWeight: 700 }}>{Math.round(e1.min).toLocaleString("fr-FR")} – {Math.round(e1.max).toLocaleString("fr-FR")} €</span>
          </div>
        </div>
        {!skipEtape2 && (
          <div style={{ background: "#0a0a0a", borderRadius: 8, padding: 12, marginBottom: 8 }}>
            <div style={{ fontSize: 11, color: "#888", fontWeight: 700, letterSpacing: 1, marginBottom: 8 }}>ÉTAPE 2 — {e2.travauxList.length} travail(x)</div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#aaa", padding: "4px 0" }}>
              <span>Coût estimé</span>
              <span style={{ color: "#fff", fontWeight: 700 }}>{Math.round(e2.min).toLocaleString("fr-FR")} – {Math.round(e2.max).toLocaleString("fr-FR")} €</span>
            </div>
          </div>
        )}

        {(totalMin > 0) && (
          <div style={{ marginTop: 12, padding: 16, background: "linear-gradient(135deg, #4caf5022, #22c55e22)", border: "2px solid #4caf50", borderRadius: 12, textAlign: "center" }}>
            <div style={{ fontSize: 11, color: "#86efac", fontWeight: 700, letterSpacing: 1 }}>
              PERFORMANCE GLOBALE {data.dpe_lettre || "?"} → {lettreFinale || "?"}
            </div>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#4caf50", marginTop: 6 }}>
              {Math.round(totalMin).toLocaleString("fr-FR")} – {Math.round(totalMax).toLocaleString("fr-FR")} €
            </div>
          </div>
        )}
      </div>

      {/* 📋 Récapitulatif */}
      <div style={styles.card}>
        <div style={styles.cardTitle}>📋 Récapitulatif</div>
        <div style={{ fontSize: 14 }}>
          {[
            ["Type de bien", data.type || "—"],
            ["Surface", data.surface ? `${data.surface} m²` : "—"],
            ["Année", data.annee || "—"],
            ["Adresse", data.adresse || "—"],
            ["— DPE Initial —", ""],
            ["Classe DPE", data.dpe_lettre || "—"],
            ["Consommation", data.dpe_conso ? `${data.dpe_conso} kWh/m²/an` : "—"],
            ["Classe GES", data.ges_lettre || "—"],
            ...(skipEtape2 ? [] : [
              ["— Après Étape 1 —", ""],
              ["Classe DPE", data.etape1_dpe_lettre || "—"],
              ["Consommation", data.etape1_dpe_conso ? `${data.etape1_dpe_conso} kWh/m²/an` : "—"],
            ]),
            [`— Après ${skipEtape2 ? "Travaux" : "Étape 2"} —`, ""],
            ["Classe DPE finale", lettreFinale || "—"],
            ["Consommation finale", consoFinale ? `${consoFinale} kWh/m²/an` : "—"],
            ["— Travaux —", ""],
            ["Travaux préconisés", totalTravaux],
            ["Coût total estimé", totalMin > 0 ? `${Math.round(totalMin).toLocaleString("fr-FR")} – ${Math.round(totalMax).toLocaleString("fr-FR")} €` : "—"],
          ].map(([k, v], i) => {
            const isHeader = k.startsWith("—");
            if (isHeader) {
              return (
                <div key={i} style={{ padding: "10px 0 4px", fontSize: 11, fontWeight: 800, color: "#8b5cf6", letterSpacing: 1 }}>
                  {k.replace(/—/g, "").trim()}
                </div>
              );
            }
            return (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${COLORS.border}` }}>
                <span style={{ color: COLORS.muted }}>{k}</span>
                <span style={{ fontWeight: 600 }}>{v}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ─── Étape 6 : Rapport (génération PDF) ───
function SaisieEtape6Rapport({ data, diag, onDiagChange, skipEtape2 }) {
  const [generating, setGenerating] = React.useState(false);

  // Helpers
  const parseList = (s) => { try { return JSON.parse(s || "[]"); } catch { return []; } };
  const parseObj  = (s) => { try { return JSON.parse(s || "{}"); } catch { return {}; } };

  // Calcul d'une étape : items détaillés + total min/max + valeurs DPE/GES atteintes
  const computeEtape = (prefix) => {
    const ids = parseList(data[`${prefix}_travaux`]);
    const qts = parseObj(data[`${prefix}_quantites`]);
    let min = 0, max = 0;
    const items = ids.map(id => {
      const t = TRAVAUX_TYPES.find(x => x.id === id);
      const q = qts[id];
      let costMin = null, costMax = null;
      if (t && t.cout_unitaire_min && q) {
        costMin = Math.round(t.cout_unitaire_min * q);
        costMax = Math.round(t.cout_unitaire_max * q);
        min += costMin;
        max += costMax;
      }
      return {
        id,
        label: t?.label || id,
        gain: t?.gain || "",
        unite: t?.unite || "",
        quantite: q,
        coutAffiche: t?.cout || "",
        costMin, costMax,
      };
    });
    return {
      items,
      lettreDpe: data[`${prefix}_dpe_lettre`] || "",
      consoDpe: data[`${prefix}_dpe_conso`] || "",
      lettreGes: data[`${prefix}_ges_lettre`] || "",
      valeurGes: data[`${prefix}_ges_valeur`] || "",
      min, max,
    };
  };

  const e1 = computeEtape("etape1");
  const e2 = skipEtape2 ? null : computeEtape("etape2");
  const finale = e2 || e1;
  const totalMin = e1.min + (e2 ? e2.min : 0);
  const totalMax = e1.max + (e2 ? e2.max : 0);
  const totalTravaux = e1.items.length + (e2 ? e2.items.length : 0);

  // Gains chiffrés
  const consoInit = parseFloat(data.dpe_conso || 0);
  const consoFin = parseFloat(finale.consoDpe || 0);
  const gainConso = consoInit > 0 && consoFin > 0 ? consoInit - consoFin : 0;
  const gainPct = consoInit > 0 && gainConso > 0 ? Math.round((gainConso / consoInit) * 100) : 0;

  const gesInit = parseFloat(data.ges_valeur || 0);
  const gesFin = parseFloat(finale.valeurGes || 0);
  const gainGes = gesInit > 0 && gesFin > 0 ? gesInit - gesFin : 0;
  const gainGesPct = gesInit > 0 && gainGes > 0 ? Math.round((gainGes / gesInit) * 100) : 0;

  const letterIdx = (l) => ["A","B","C","D","E","F","G"].indexOf((l || "").toUpperCase());
  const sautDpe = (data.dpe_lettre && finale.lettreDpe)
    ? letterIdx(data.dpe_lettre) - letterIdx(finale.lettreDpe)
    : 0;

  const generatePDFSaisie = () => {
    setGenerating(true);
    try {
      const today = new Date().toLocaleDateString("fr-FR");
      const adresse = data.adresse || "Logement";
      const escapeHtml = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

      // Couleurs DPE pour badges du rapport
      const dpeColors = { A:"#319834", B:"#33cc33", C:"#ccdb27", D:"#fff32a", E:"#edb731", F:"#d97706", G:"#dc2626" };
      const dpeTextColors = { A:"#fff", B:"#fff", C:"#000", D:"#000", E:"#fff", F:"#fff", G:"#fff" };
      const renderBadge = (l) => {
        const up = (l || "").toUpperCase();
        if (!up) return `<span style="color:#999">—</span>`;
        const bg = dpeColors[up] || "#888";
        const fg = dpeTextColors[up] || "#fff";
        return `<span style="display:inline-block;padding:6px 14px;border-radius:6px;font-weight:900;font-size:14px;background:${bg};color:${fg};">${up}</span>`;
      };

      // Liste détaillée des travaux d'une étape
      const renderTravauxList = (etape) => {
        if (!etape.items.length) {
          return `<div style="font-size:12px;color:#888;font-style:italic;padding:8px 0">Aucun travail sélectionné.</div>`;
        }
        const rows = etape.items.map(it => `
          <div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #ede9fe;gap:12px">
            <div style="flex:1">
              <div style="font-weight:700;color:#1f2937;font-size:12.5px">${escapeHtml(it.label)}</div>
              ${it.quantite ? `<div style="font-size:11px;color:#6b7280;margin-top:2px">Quantité : ${escapeHtml(it.quantite)}${it.unite ? ` ${escapeHtml(it.unite)}` : ""}${it.gain ? ` · Gain estimé : ${escapeHtml(it.gain)}` : ""}</div>` : it.gain ? `<div style="font-size:11px;color:#6b7280;margin-top:2px">Gain estimé : ${escapeHtml(it.gain)}</div>` : ""}
            </div>
            <div style="font-weight:800;color:#6d28d9;white-space:nowrap;align-self:center;font-size:12px">
              ${it.costMin !== null ? `${it.costMin.toLocaleString("fr-FR")} – ${it.costMax.toLocaleString("fr-FR")} €` : escapeHtml(it.coutAffiche || "—")}
            </div>
          </div>`).join("");
        const total = etape.min > 0 ? `<div style="display:flex;justify-content:space-between;padding:10px 0 4px;margin-top:6px;border-top:2px solid #8b5cf6;font-weight:900;color:#6d28d9"><span>Sous-total étape</span><span>${Math.round(etape.min).toLocaleString("fr-FR")} – ${Math.round(etape.max).toLocaleString("fr-FR")} €</span></div>` : "";
        return `<div style="font-size:12px">${rows}${total}</div>`;
      };

      const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8"/>
<title>Rapport DPE Projeté Saisie — ${escapeHtml(adresse)}</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family:'Helvetica Neue',Arial,sans-serif; background:#fff; color:#111; line-height: 1.5; }
  @media print {
    @page { size: A4; margin: 12mm 14mm; }
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .page-break { page-break-after: always; }
    .no-print { display: none; }
  }
  .page { max-width: 210mm; margin: 0 auto; padding: 14mm; }
  .header { background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%); color: #fff; padding: 28px; border-radius: 12px; margin-bottom: 24px; }
  .header h1 { font-size: 28px; font-weight: 900; letter-spacing: -1px; margin-bottom: 6px; }
  .header .subtitle { font-size: 14px; opacity: 0.9; margin-bottom: 14px; }
  .header .meta { font-size: 11px; opacity: 0.8; }
  .section { margin-bottom: 22px; padding: 18px; border-radius: 10px; background: #faf5ff; border-left: 4px solid #8b5cf6; page-break-inside: avoid; }
  .section h2 { color: #6d28d9; font-size: 16px; margin-bottom: 12px; font-weight: 800; }
  .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; font-size: 12px; }
  .grid > div { display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #e9d5ff; }
  .grid > div > span:first-child { color: #6b7280; font-weight: 600; }
  .grid > div > span:last-child { color: #111; font-weight: 700; text-align: right; max-width: 60%; }
  .footer { margin-top: 30px; padding-top: 16px; border-top: 2px solid #ede9fe; font-size: 10px; color: #6b7280; text-align: center; }
  .disclaimer { background: #fef3c7; border-left: 4px solid #d97706; padding: 12px 16px; margin: 16px 0; font-size: 11px; color: #92400e; border-radius: 6px; }
  .controls { position: fixed; top: 12px; right: 12px; z-index: 99; }
  .controls button { padding: 10px 20px; background: #8b5cf6; color: #fff; border: none; border-radius: 8px; font-weight: 800; cursor: pointer; box-shadow: 0 2px 10px rgba(0,0,0,0.2); margin-left: 8px; font-size: 13px; }
  .controls button:hover { background: #7c3aed; }
  .commentaire { padding: 14px 16px; background: #fff; border-radius: 8px; border: 1px solid #e9d5ff; font-size: 12.5px; line-height: 1.7; color: #1f2937; white-space: pre-wrap; }
  .recap-table { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
  .recap-table th, .recap-table td { padding: 10px 12px; text-align: center; border-bottom: 1px solid #ede9fe; }
  .recap-table th { background: #8b5cf6; color: #fff; font-weight: 800; font-size: 11px; letter-spacing: 0.5px; }
  .recap-table td:first-child { text-align: left; font-weight: 700; color: #6b7280; background: #faf5ff; }
  .gain-box { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-top: 8px; }
  .gain-card { background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); border: 2px solid #22c55e; border-radius: 10px; padding: 14px; text-align: center; }
  .gain-card .gain-label { font-size: 10px; color: #15803d; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; }
  .gain-card .gain-value { font-size: 22px; font-weight: 900; color: #15803d; margin-top: 6px; }
  .gain-card .gain-sub { font-size: 11px; color: #166534; margin-top: 4px; }
  .gain-neutral { background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%); border-color: #8b5cf6; }
  .gain-neutral .gain-label, .gain-neutral .gain-value, .gain-neutral .gain-sub { color: #6d28d9; }
</style>
</head>
<body>
<div class="controls no-print">
  <button onclick="window.print()">🖨️ Imprimer / Sauvegarder PDF</button>
  <button onclick="window.close()" style="background:#6b7280">✕ Fermer</button>
</div>

<div class="page">
  <div class="header">
    <h1>📋 Rapport DPE Projeté</h1>
    <div class="subtitle">Saisie terrain — ${skipEtape2 ? "Projet en 1 étape" : "Projet en 2 étapes"}</div>
    <div class="meta">Généré le ${today} · Document d'aide à la décision (non réglementaire)</div>
  </div>

  <div class="disclaimer">
    ⚠️ <strong>Document indicatif.</strong> Ce rapport est un outil d'aide à la décision pour le diagnostiqueur. Il ne remplace pas un DPE réglementaire signé et certifié.
  </div>

  ${diag && (diag.nom || diag.societe) ? `
  <div class="section">
    <h2>👤 Diagnostiqueur</h2>
    <div class="grid">
      ${diag.nom ? `<div><span>Nom</span><span>${escapeHtml(diag.nom)} ${escapeHtml(diag.prenom || "")}</span></div>` : ""}
      ${diag.societe ? `<div><span>Société</span><span>${escapeHtml(diag.societe)}</span></div>` : ""}
      ${diag.email ? `<div><span>Email</span><span>${escapeHtml(diag.email)}</span></div>` : ""}
      ${diag.telephone ? `<div><span>Téléphone</span><span>${escapeHtml(diag.telephone)}</span></div>` : ""}
      ${diag.certif_numero ? `<div><span>N° certification</span><span>${escapeHtml(diag.certif_numero)}</span></div>` : ""}
      ${diag.certif_organisme ? `<div><span>Organisme</span><span>${escapeHtml(diag.certif_organisme)}</span></div>` : ""}
    </div>
  </div>` : ""}

  ${(data.proprio_nom || data.proprio_prenom) ? `
  <div class="section">
    <h2>🏠 Propriétaire</h2>
    <div class="grid">
      <div><span>Nom</span><span>${escapeHtml(data.proprio_prenom || "")} ${escapeHtml(data.proprio_nom || "")}</span></div>
      ${data.proprio_email ? `<div><span>Email</span><span>${escapeHtml(data.proprio_email)}</span></div>` : ""}
      ${data.proprio_tel ? `<div><span>Téléphone</span><span>${escapeHtml(data.proprio_tel)}</span></div>` : ""}
      ${data.donneur_ordre_type ? `<div><span>Donneur d'ordre</span><span>${escapeHtml(data.donneur_ordre_type)}</span></div>` : ""}
    </div>
  </div>` : ""}

  <div class="section">
    <h2>📍 Bien diagnostiqué</h2>
    <div class="grid">
      ${data.adresse ? `<div><span>Adresse</span><span>${escapeHtml(data.adresse)}</span></div>` : ""}
      ${data.type ? `<div><span>Type</span><span>${escapeHtml(data.type)}</span></div>` : ""}
      ${data.surface ? `<div><span>Surface habitable</span><span>${escapeHtml(data.surface)} m²</span></div>` : ""}
      ${data.annee ? `<div><span>Année construction</span><span>${escapeHtml(data.annee)}</span></div>` : ""}
      ${data.annee_periode ? `<div><span>Période</span><span>${escapeHtml(String(data.annee_periode).replace(/_/g, " "))}</span></div>` : ""}
      ${data.ademe_numero ? `<div><span>N° ADEME</span><span>${escapeHtml(data.ademe_numero)}</span></div>` : ""}
      ${data.date_visite ? `<div><span>Date de visite</span><span>${escapeHtml(data.date_visite)}</span></div>` : ""}
      ${data.type_diag ? `<div><span>Type de diag</span><span>${escapeHtml(data.type_diag)}</span></div>` : ""}
    </div>
  </div>

  <div class="section">
    <h2>🌡️ DPE actuel (initial)</h2>
    <div class="grid">
      <div><span>Classe énergétique</span><span>${renderBadge(data.dpe_lettre)}</span></div>
      <div><span>Classe GES</span><span>${renderBadge(data.ges_lettre)}</span></div>
      <div><span>Consommation</span><span>${data.dpe_conso ? `${escapeHtml(data.dpe_conso)} kWh/m²/an` : "—"}</span></div>
      <div><span>Émissions GES</span><span>${data.ges_valeur ? `${escapeHtml(data.ges_valeur)} kg CO₂/m²/an` : "—"}</span></div>
    </div>
  </div>

  <div class="section">
    <h2>🔨 ${skipEtape2 ? "Travaux préconisés" : "Étape 1 — Travaux préconisés"}</h2>
    ${renderTravauxList(e1)}
  </div>

  <div class="section">
    <h2>📊 Résultat ${skipEtape2 ? "après travaux" : "après Étape 1"}</h2>
    <div class="grid">
      <div><span>Classe énergétique</span><span>${renderBadge(e1.lettreDpe)}</span></div>
      <div><span>Classe GES</span><span>${renderBadge(e1.lettreGes)}</span></div>
      <div><span>Consommation</span><span>${e1.consoDpe ? `${escapeHtml(e1.consoDpe)} kWh/m²/an` : "—"}</span></div>
      <div><span>Émissions GES</span><span>${e1.valeurGes ? `${escapeHtml(e1.valeurGes)} kg CO₂/m²/an` : "—"}</span></div>
    </div>
  </div>

  ${e2 ? `
  <div class="section">
    <h2>🎯 Étape 2 — Travaux préconisés</h2>
    ${renderTravauxList(e2)}
  </div>

  <div class="section">
    <h2>✨ Résultat final (après Étape 2)</h2>
    <div class="grid">
      <div><span>Classe énergétique</span><span>${renderBadge(e2.lettreDpe)}</span></div>
      <div><span>Classe GES</span><span>${renderBadge(e2.lettreGes)}</span></div>
      <div><span>Consommation</span><span>${e2.consoDpe ? `${escapeHtml(e2.consoDpe)} kWh/m²/an` : "—"}</span></div>
      <div><span>Émissions GES</span><span>${e2.valeurGes ? `${escapeHtml(e2.valeurGes)} kg CO₂/m²/an` : "—"}</span></div>
    </div>
  </div>` : ""}

  <div class="section">
    <h2>📋 Tableau récapitulatif</h2>
    <table class="recap-table">
      <thead>
        <tr>
          <th></th>
          <th>Initial</th>
          ${e2 ? `<th>Après Étape 1</th>` : ""}
          <th>${skipEtape2 ? "Après Travaux" : "Final (Étape 2)"}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Classe DPE</td>
          <td>${renderBadge(data.dpe_lettre)}</td>
          ${e2 ? `<td>${renderBadge(e1.lettreDpe)}</td>` : ""}
          <td>${renderBadge(finale.lettreDpe)}</td>
        </tr>
        <tr>
          <td>Conso (kWh/m²/an)</td>
          <td>${escapeHtml(data.dpe_conso || "—")}</td>
          ${e2 ? `<td>${escapeHtml(e1.consoDpe || "—")}</td>` : ""}
          <td>${escapeHtml(finale.consoDpe || "—")}</td>
        </tr>
        <tr>
          <td>Classe GES</td>
          <td>${renderBadge(data.ges_lettre)}</td>
          ${e2 ? `<td>${renderBadge(e1.lettreGes)}</td>` : ""}
          <td>${renderBadge(finale.lettreGes)}</td>
        </tr>
        <tr>
          <td>Émissions GES (kg CO₂/m²/an)</td>
          <td>${escapeHtml(data.ges_valeur || "—")}</td>
          ${e2 ? `<td>${escapeHtml(e1.valeurGes || "—")}</td>` : ""}
          <td>${escapeHtml(finale.valeurGes || "—")}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="section">
    <h2>💚 Gains et bénéfices du projet</h2>
    <div class="gain-box">
      <div class="gain-card ${gainConso > 0 ? "" : "gain-neutral"}">
        <div class="gain-label">Gain énergie</div>
        <div class="gain-value">${gainConso > 0 ? `−${Math.round(gainConso)}` : "—"}</div>
        <div class="gain-sub">${gainConso > 0 ? `kWh/m²/an · −${gainPct}%` : "à renseigner"}</div>
      </div>
      <div class="gain-card ${sautDpe > 0 ? "" : "gain-neutral"}">
        <div class="gain-label">Saut de classes DPE</div>
        <div class="gain-value">${sautDpe > 0 ? `+${sautDpe}` : "—"}</div>
        <div class="gain-sub">${data.dpe_lettre || "?"} → ${finale.lettreDpe || "?"}</div>
      </div>
      <div class="gain-card ${gainGes > 0 ? "" : "gain-neutral"}">
        <div class="gain-label">Gain GES</div>
        <div class="gain-value">${gainGes > 0 ? `−${Math.round(gainGes)}` : "—"}</div>
        <div class="gain-sub">${gainGes > 0 ? `kg CO₂/m²/an · −${gainGesPct}%` : "à renseigner"}</div>
      </div>
      <div class="gain-card gain-neutral">
        <div class="gain-label">Coût total estimé</div>
        <div class="gain-value">${totalMin > 0 ? `${Math.round(totalMin / 1000)}k` : "—"}</div>
        <div class="gain-sub">${totalMin > 0 ? `${Math.round(totalMin).toLocaleString("fr-FR")} – ${Math.round(totalMax).toLocaleString("fr-FR")} €` : "non chiffré"}</div>
      </div>
    </div>
  </div>

  ${data.synthese_ia ? `
  <div class="section">
    <h2>🤖 Synthèse IA du projet</h2>
    <div class="commentaire">${escapeHtml(data.synthese_ia)}</div>
  </div>` : ""}

  <div class="footer">
    <strong>DOMYQO-FNDI</strong> · Outil d'aide à la décision pour diagnostiqueurs certifiés<br/>
    Fédération Nationale des Diagnostiqueurs Immobiliers · adhesion@fnddi.fr<br/>
    Document non réglementaire — Édité le ${today}
  </div>
</div>
</body>
</html>`;

      const win = window.open("", "_blank");
      if (win) {
        win.document.write(html);
        win.document.close();
        setTimeout(() => { win.focus(); win.print(); }, 800);
      } else {
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `rapport_dpe_saisie_${(adresse || "logement").replace(/[^a-z0-9]/gi, "_")}.html`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      alert("Erreur génération : " + (e.message || e));
    }
    setGenerating(false);
  };

  // ── Aperçu inline (rubriques de complétude + chiffres clés) ──
  const PURPLE = "#8b5cf6";
  const sautPositif = sautDpe > 0;

  const completionItems = [
    ["🏠 Bien", !!(data.adresse && data.surface)],
    ["🌡️ DPE initial", !!(data.dpe_lettre && data.dpe_conso)],
    [skipEtape2 ? "🔨 Travaux" : "🔨 Travaux Étape 1", e1.items.length > 0],
    [skipEtape2 ? "📊 Résultat final" : "📊 Résultat Étape 1", !!(e1.lettreDpe && e1.consoDpe)],
    ...(e2 ? [
      ["🎯 Travaux Étape 2", e2.items.length > 0],
      ["✨ Résultat final", !!(e2.lettreDpe && e2.consoDpe)],
    ] : []),
    ["🤖 Synthèse IA", !!data.synthese_ia],
  ];

  return (
    <div>
      <div style={{ fontSize: 12, color: "#aaa", marginBottom: 16, padding: "10px 14px", background: "#8b5cf611", borderRadius: 8, border: "1px solid #8b5cf633" }}>
        📄 Génération du rapport PDF avec les données saisies — projet en {skipEtape2 ? "1 étape" : "2 étapes"}.
      </div>

      {/* Aperçu chiffré */}
      <div style={{ ...styles.card, marginBottom: 12 }}>
        <div style={styles.cardTitle}>👁️ Aperçu du rapport</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8 }}>
          <div style={{ padding: 12, borderRadius: 8, background: "#0a0a0a", textAlign: "center", border: "1px solid #333" }}>
            <div style={{ fontSize: 10, color: "#888", letterSpacing: 1, fontWeight: 700 }}>TRAVAUX</div>
            <div style={{ fontSize: 20, fontWeight: 900, color: "#fff", marginTop: 4 }}>{totalTravaux}</div>
          </div>
          <div style={{ padding: 12, borderRadius: 8, background: "#0a0a0a", textAlign: "center", border: "1px solid #333" }}>
            <div style={{ fontSize: 10, color: "#888", letterSpacing: 1, fontWeight: 700 }}>ÉTAPES</div>
            <div style={{ fontSize: 20, fontWeight: 900, color: PURPLE, marginTop: 4 }}>{skipEtape2 ? 1 : 2}</div>
          </div>
          <div style={{ padding: 12, borderRadius: 8, background: "#0a0a0a", textAlign: "center", border: "1px solid #333" }}>
            <div style={{ fontSize: 10, color: "#888", letterSpacing: 1, fontWeight: 700 }}>SAUT DPE</div>
            <div style={{ fontSize: 14, fontWeight: 900, color: sautPositif ? "#22c55e" : "#888", marginTop: 4 }}>
              {data.dpe_lettre || "?"} → {finale.lettreDpe || "?"}
            </div>
          </div>
          <div style={{ padding: 12, borderRadius: 8, background: "#0a0a0a", textAlign: "center", border: "1px solid #333" }}>
            <div style={{ fontSize: 10, color: "#888", letterSpacing: 1, fontWeight: 700 }}>BUDGET</div>
            <div style={{ fontSize: 16, fontWeight: 900, color: "#22c55e", marginTop: 4 }}>
              {totalMin > 0 ? `${Math.round(totalMin / 1000)}k€` : "—"}
            </div>
          </div>
        </div>

        {/* Indicateur de complétude (vert = OK, rouge = manquant) */}
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${COLORS.border}` }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#888", letterSpacing: 1, marginBottom: 8 }}>
            COMPLÉTUDE DU RAPPORT
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 6 }}>
            {completionItems.map(([label, ok], i) => (
              <div key={i} style={{
                display: "flex", alignItems: "center", gap: 8,
                padding: "6px 10px", borderRadius: 6,
                background: ok ? "#14532d22" : "#7f1d1d22",
                border: `1px solid ${ok ? "#22c55e44" : "#ef444444"}`,
              }}>
                <span style={{ color: ok ? "#22c55e" : "#ef4444", fontWeight: 900 }}>{ok ? "✓" : "✕"}</span>
                <span style={{ fontSize: 11, color: ok ? "#86efac" : "#fca5a5", fontWeight: 600 }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bouton de génération */}
      <div style={{ ...styles.card, textAlign: "center", padding: 32 }}>
        <div style={{ fontSize: 50, marginBottom: 12 }}>📄</div>
        <div style={{ fontSize: 16, fontWeight: 800, color: "#8b5cf6", marginBottom: 8 }}>
          Rapport DPE Projeté Saisie
        </div>
        <div style={{ fontSize: 12, color: COLORS.muted, marginBottom: 24, lineHeight: 1.6 }}>
          Le rapport s'ouvrira dans un nouvel onglet.<br />
          Utilisez <strong>Fichier → Imprimer → Enregistrer en PDF</strong> pour l'exporter.
        </div>

        <button
          onClick={generatePDFSaisie}
          disabled={generating}
          style={{ width: "100%", maxWidth: 360, padding: "14px", background: generating ? "#666" : "#8b5cf6", color: "#fff", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 800, cursor: generating ? "wait" : "pointer" }}>
          {generating ? "⏳ Génération…" : "🖨️ Générer le rapport PDF"}
        </button>

        <div style={{ marginTop: 16, fontSize: 11, color: "#666", fontStyle: "italic" }}>
          ✨ Le rapport reprend toutes les données saisies dans les étapes précédentes
        </div>
      </div>
    </div>
  );
}

function AppMain({ onLogout }) {
  const [module_, setModule] = useState(null);
  const [navLevel, setNavLevel] = useState("welcome"); // "welcome" | "menu" | "module"
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showAbonnement, setShowAbonnement] = useState(false);
  const [showRGPDConsent, setShowRGPDConsent] = useState(false); // Modal RGPD au 1er login
  const [showLegalPage, setShowLegalPage] = useState(null); // null | "mentions" | "privacy" | "cgu"
  const [tab, setTab] = useState(0);
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== "undefined" && window.innerWidth >= 768);
  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Vérifier si le consentement RGPD a été donné — sinon afficher le modal
  useEffect(() => {
    const consent = localStorage.getItem("fndi_rgpd_consent");
    if (!consent) {
      setShowRGPDConsent(true);
    }
  }, []);

  const acceptRGPD = () => {
    const now = new Date().toISOString();
    localStorage.setItem("fndi_rgpd_consent", JSON.stringify({
      accepted: true,
      date: now,
      version: "1.0",
    }));
    // TODO future : POST à /api/rgpd-log pour stocker la preuve sur Upstash
    setShowRGPDConsent(false);
  };

  const declineRGPD = () => {
    if (window.confirm("En refusant, vous serez déconnecté.\n\nL'utilisation de DOMYQO-FNDI nécessite l'acceptation de notre politique de confidentialité.\n\nConfirmer la déconnexion ?")) {
      localStorage.removeItem("fndi_session_email");
      localStorage.removeItem("fndi_session_token");
      onLogout();
    }
  };

  // Charger profil diagnostiqueur depuis l'API au démarrage (sync backend → localStorage)
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("fndi_session_token") || "";
        if (!token) return;
        const r = await fetch("/api/user-profile", { headers: { Authorization: `Bearer ${token}` } });
        if (!r.ok) return;
        const data = await r.json().catch(() => ({}));
        if (data.profile && Object.keys(data.profile).length > 0) {
          setDiag(data.profile);
          try { localStorage.setItem("fndi_diag_profil", JSON.stringify(data.profile)); } catch {}
        }
      } catch (e) {}
    })();
  }, []);

  // Logo amiante officiel français (tombstone noir + "a" blanc + bandeau rouge)
  const renderAmianteBadge = (size = 18) => (
    <svg viewBox="0 0 100 110" width={size} height={Math.round(size * 110/100)} xmlns="http://www.w3.org/2000/svg" style={{ display:"inline-block", verticalAlign:"middle" }}>
      <path d="M 8 8 L 92 8 L 92 78 Q 50 110 50 110 Q 50 110 8 78 Z" fill="#000000"/>
      <text x="50" y="62" fontFamily="Arial Black, sans-serif" fontWeight="900" fontSize="60" fill="#ffffff" textAnchor="middle">a</text>
      <rect x="8" y="78" width="84" height="12" fill="#dc2626"/>
    </svg>
  );

  // Charger le dossier en cours depuis localStorage
  const [equipments, setEquipments] = useState(() => {
    try { const s = localStorage.getItem("fndi_dossier_equipments"); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  const [logement, setLogement] = useState(() => {
    try { const s = localStorage.getItem("fndi_dossier_logement"); return s ? JSON.parse(s) : {}; } catch { return {}; }
  });
  const [comments, setComments] = useState(() => {
    try { const s = localStorage.getItem("fndi_dossier_comments"); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  const [travaux, setTravaux] = useState(() => {
    try { const s = localStorage.getItem("fndi_dossier_travaux"); return s ? JSON.parse(s) : []; } catch { return []; }
  });

  // Charger les infos diagnostiqueur depuis localStorage au démarrage
  const [diag, setDiag] = useState(() => {
    try { const saved = localStorage.getItem("fndi_diag_profil"); return saved ? JSON.parse(saved) : {}; } catch { return {}; }
  });

  // Sauvegarder automatiquement le dossier à chaque changement
  const handleEquipmentAdded = (eq) => {
    setEquipments((prev) => {
      const updated = [eq, ...prev];
      try { localStorage.setItem("fndi_dossier_equipments", JSON.stringify(updated)); } catch {}
      return updated;
    });
  };

  const handleLogementChange = (key, value) => {
    setLogement((prev) => {
      const updated = { ...prev, [key]: value };
      try { localStorage.setItem("fndi_dossier_logement", JSON.stringify(updated)); } catch {}
      return updated;
    });
  };

  const handleCommentsChange = (newComments) => {
    setComments(newComments);
    try { localStorage.setItem("fndi_dossier_comments", JSON.stringify(newComments)); } catch {}
  };

  const handleTravauxChange = (newTravaux) => {
    setTravaux(newTravaux);
    try { localStorage.setItem("fndi_dossier_travaux", JSON.stringify(newTravaux)); } catch {}
  };

  const profileSyncTimerRef = useRef(null);
  const handleDiagChange = (key, value) => {
    setDiag(prev => {
      const updated = { ...prev, [key]: value };
      try { localStorage.setItem("fndi_diag_profil", JSON.stringify(updated)); } catch {}
      // Sync backend (debounce 1s pour éviter trop d'appels en saisie)
      if (profileSyncTimerRef.current) clearTimeout(profileSyncTimerRef.current);
      profileSyncTimerRef.current = setTimeout(async () => {
        try {
          const token = localStorage.getItem("fndi_session_token") || "";
          if (!token) return;
          await fetch("/api/user-profile", {
            method: "PUT",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(updated),
          });
        } catch (e) {}
      }, 1000);
      return updated;
    });
  };

  // Nouveau dossier — réinitialise tout sauf le profil diagnostiqueur
  // ── GESTION DES DOSSIERS ──
  const [showDossiers, setShowDossiers] = useState(false);
  const [showProfil, setShowProfil] = useState(false);
  const [showCenterMenu, setShowCenterMenu] = useState(false);
  const [showAdminAuth, setShowAdminAuth] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [adminError, setAdminError] = useState("");

  const getDossiers = () => {
    try { return JSON.parse(localStorage.getItem("fndi_dossiers_liste") || "[]"); } catch { return []; }
  };

  const saveDossierListe = (liste) => {
    try { localStorage.setItem("fndi_dossiers_liste", JSON.stringify(liste)); } catch {}
  };

  const sauvegarderDossier = () => {
    // Merge state React + localStorage (localStorage est la source de vérité la plus fraîche
    // car écrit synchrone par handleLogementChange, donc capte aussi les saisies très récentes).
    const readLS = (key, fallback) => {
      try { const s = localStorage.getItem(key); return s ? JSON.parse(s) : fallback; } catch { return fallback; }
    };
    const logementData    = { ...logement,    ...readLS("fndi_dossier_logement", {})    };
    const equipmentsData  = readLS("fndi_dossier_equipments", equipments);
    const commentsData    = readLS("fndi_dossier_comments",   comments);
    const travauxData     = readLS("fndi_dossier_travaux",    travaux);

    const dossier = {
      id: Date.now(),
      date: new Date().toLocaleDateString("fr-FR"),
      adresse: logementData.adresse || "—",
      proprietaire: `${logementData.proprio_prenom || ""} ${logementData.proprio_nom || ""}`.trim() || "—",
      ademe_numero: logementData.ademe_numero || "",
      dpe_lettre: logementData.dpe_lettre || "",
      logement: logementData,
      equipments: equipmentsData,
      comments: commentsData,
      travaux: travauxData,
    };
    const liste = getDossiers();
    // Remplacer si même N° ADEME
    const idx = liste.findIndex(d => d.ademe_numero && d.ademe_numero === dossier.ademe_numero);
    if (idx >= 0) liste[idx] = dossier;
    else liste.unshift(dossier);
    saveDossierListe(liste.slice(0, 30)); // max 30 dossiers
    alert(`✅ Dossier sauvegardé — ${dossier.adresse}`);
  };

  const ouvrirDossier = (dossier) => {
    if (!window.confirm(`Ouvrir le dossier :\n${dossier.adresse}\n${dossier.proprietaire}\n\nLe dossier en cours sera remplacé.`)) return;
    setLogement(dossier.logement || {});
    setEquipments(dossier.equipments || []);
    setComments(dossier.comments || []);
    setTravaux(dossier.travaux || []);
    try {
      localStorage.setItem("fndi_dossier_logement", JSON.stringify(dossier.logement || {}));
      localStorage.setItem("fndi_dossier_equipments", JSON.stringify(dossier.equipments || []));
      localStorage.setItem("fndi_dossier_comments", JSON.stringify(dossier.comments || []));
      localStorage.setItem("fndi_dossier_travaux", JSON.stringify(dossier.travaux || []));
    } catch {}
    setShowDossiers(false);
    setTab(0);
  };

  const supprimerDossier = (id) => {
    if (!window.confirm("Supprimer ce dossier ?")) return;
    saveDossierListe(getDossiers().filter(d => d.id !== id));
    setShowDossiers(false);
    setTimeout(() => setShowDossiers(true), 50);
  };

  const nouveauDossier = () => {
    if (!window.confirm("Créer un nouveau dossier ?\nSauvegardez d'abord le dossier en cours si nécessaire.")) return;
    setLogement({}); setEquipments([]); setComments([]); setTravaux([]);
    try {
      localStorage.removeItem("fndi_dossier_logement");
      localStorage.removeItem("fndi_dossier_equipments");
      localStorage.removeItem("fndi_dossier_comments");
      localStorage.removeItem("fndi_dossier_travaux");
      localStorage.removeItem("fndi_travaux_sel");
      localStorage.removeItem("fndi_projection");
      localStorage.removeItem("fndi_dpe_projete");
    } catch {}
    // Aller directement sur DPE Projeté XML, onglet Le Bien
    setModule("dpe_xml");
    setNavLevel("module");
    setTab(0);
  };

  return (
    <div style={styles.app}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

      {/* Header DOMYQO + FNDi — bandeau fond blanc, bordure orange (charte DOMYQO) */}
      <div style={{
        width: "100%", background: "#ffffff", padding: isDesktop ? "12px 22px" : "10px 14px",
        display: "flex", alignItems: "center", gap: isDesktop ? 18 : 12,
        borderBottom: "3px solid #E8762F", boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        boxSizing: "border-box", position: "relative",
      }}>
        {/* Logo DOMYQO + texte */}
        <img src="/domyqo-logo.png" alt="DOMYQO"
          style={{ height: isDesktop ? 50 : 38, width: "auto", flexShrink: 0 }} />
        <div style={{ minWidth: 0, lineHeight: 1.15 }}>
          <div style={{ fontSize: isDesktop ? 16 : 13, fontWeight: 800, color: "#1a2a4a", letterSpacing: 1 }}>DOMYQO</div>
          <div style={{ fontSize: isDesktop ? 11 : 9, color: "#555", letterSpacing: 0.6, marginTop: 2 }}>
            L'APPLICATION TERRAIN DU DIAGNOSTIQUEUR
          </div>
        </div>

        {/* Séparateur + mention FNDi avec logo */}
        <div style={{ height: isDesktop ? 38 : 30, width: 1, background: "#ddd", marginLeft: "auto" }} />
        <div style={{ display: "flex", alignItems: "center", gap: isDesktop ? 10 : 6 }}>
          <div style={{ fontSize: isDesktop ? 9 : 8, color: "#888", letterSpacing: 1, textAlign: "right", lineHeight: 1.2 }}>
            L'APP UTILISÉE<br />PAR LA
          </div>
          <img src="/fndi-logo.png" alt="FNDi"
            style={{ height: isDesktop ? 42 : 32, width: "auto", flexShrink: 0 }} />
        </div>

        {/* Bouton profil utilisateur */}
        <button onClick={() => setShowProfileMenu(s => !s)}
          title="Menu profil"
          style={{
            fontSize: 0, padding: 0, border: "none", borderRadius: "50%",
            cursor: "pointer", background: "#1a2a4a",
            width: isDesktop ? 40 : 32, height: isDesktop ? 40 : 32,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 2px 6px rgba(26,42,74,0.35)", flexShrink: 0, marginLeft: 8,
          }}>
          <svg viewBox="0 0 24 24" width={isDesktop ? 22 : 18} height={isDesktop ? 22 : 18} fill="#fff">
            <path d="M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-3.314 0-8 1.667-8 5v1h16v-1c0-3.333-4.686-5-8-5z"/>
          </svg>
        </button>

        {/* Menu déroulant profil */}
        {showProfileMenu && (
          <>
            <div onClick={() => setShowProfileMenu(false)}
                 style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 998 }} />
            <div style={{
              position: "absolute", top: "calc(100% + 4px)", right: isDesktop ? 20 : 12,
              background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: 12,
              minWidth: 220, boxShadow: "0 8px 32px rgba(0,0,0,0.7)", overflow: "hidden",
              zIndex: 999,
            }}>
              <div style={{ padding: "12px 14px", borderBottom: "1px solid #2a2a2a", background: "#F5C80011" }}>
                <div style={{ fontSize: 13, fontWeight: 800, color: "#F5C800" }}>{diag.nom || "Diagnostiqueur"}</div>
                <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>{diag.email || ""}</div>
              </div>
              <div style={{ padding: "4px 0" }}>
                <button onClick={() => { setShowProfil(true); setShowProfileMenu(false); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#ddd", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>👤</span> Mes coordonnées
                </button>
                <button onClick={() => { setShowDossiers(true); setShowProfileMenu(false); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#ddd", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>📂</span> Mes dossiers
                </button>
                <button onClick={() => { sauvegarderDossier(); setShowProfileMenu(false); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#ddd", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>💾</span> Sauvegarder
                </button>
                <button onClick={() => { nouveauDossier(); setShowProfileMenu(false); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#ddd", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>➕</span> Nouveau dossier
                </button>
              </div>
              <div style={{ borderTop: "1px solid #2a2a2a", padding: "4px 0" }}>
                <button onClick={() => { setShowAbonnement(true); setShowProfileMenu(false); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#ddd", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>💳</span> Mon adhésion
                </button>
              </div>
              <div style={{ borderTop: "1px solid #2a2a2a", padding: "4px 0" }}>
                <button onClick={() => { if (window.confirm("Se déconnecter ?")) onLogout(); }}
                  style={{ width: "100%", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", color: "#fca5a5", fontSize: 13, cursor: "pointer", textAlign: "left" }}>
                  <span style={{ fontSize: 16, width: 20 }}>🔓</span> Se déconnecter
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Modal RGPD - Premier login uniquement */}
      {showRGPDConsent && (
        <>
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.85)", zIndex: 2000 }} />
          <div style={{
            position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            background: "#1a1a1a", border: "2px solid #F5C800", borderRadius: 16,
            width: "92%", maxWidth: 540, maxHeight: "90vh", overflow: "auto",
            zIndex: 2001, padding: isDesktop ? 28 : 20,
            boxShadow: "0 20px 60px rgba(245,200,0,0.2)",
          }}>
            <div style={{ textAlign: "center", marginBottom: 18 }}>
              <div style={{ fontSize: 42, marginBottom: 6 }}>🔒</div>
              <div style={{ fontSize: isDesktop ? 22 : 18, fontWeight: 900, color: "#F5C800", marginBottom: 4 }}>
                Protection de vos données
              </div>
              <div style={{ fontSize: 11, color: "#888", letterSpacing: 1, fontWeight: 700 }}>
                CONFORMITÉ RGPD · ARTICLES 13 & 14
              </div>
            </div>

            <div style={{ fontSize: 13, color: "#ddd", lineHeight: 1.6, marginBottom: 16 }}>
              Bienvenue sur <strong style={{ color: "#F5C800" }}>DOMYQO-FNDI</strong>, l'application de la <strong>Fédération Nationale des Diagnostiqueurs Immobiliers</strong> (association loi 1901).
              <br /><br />
              Avant d'utiliser l'application, nous souhaitons vous informer du traitement de vos données.
            </div>

            <div style={{ background: "#0a0a0a", border: "1px solid #2a2a2a", borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#F5C800", letterSpacing: 1, marginBottom: 8 }}>
                📊 DONNÉES TRAITÉES
              </div>
              <div style={{ fontSize: 12, color: "#ccc", lineHeight: 1.6 }}>
                <strong style={{ color: "#fff" }}>Diagnostiqueur :</strong> nom, email, coordonnées professionnelles, certification<br />
                <strong style={{ color: "#fff" }}>Bien diagnostiqué :</strong> adresse, caractéristiques, photos<br />
                <strong style={{ color: "#fff" }}>Propriétaire :</strong> nom et coordonnées (si renseignés)
              </div>
            </div>

            <div style={{ background: "#0a0a0a", border: "1px solid #2a2a2a", borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#65d11c", letterSpacing: 1, marginBottom: 8 }}>
                🇪🇺 HÉBERGEMENT EN UNION EUROPÉENNE
              </div>
              <div style={{ fontSize: 12, color: "#ccc", lineHeight: 1.6 }}>
                Vos données sont stockées chez <strong>Vercel</strong> (Frankfurt, Allemagne) et <strong>Upstash</strong> (Irlande).<br />
                Aucun transfert hors UE pour le stockage.
              </div>
            </div>

            <div style={{ background: "#0a0a0a", border: "1px solid #f9731644", borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#f97316", letterSpacing: 1, marginBottom: 8 }}>
                🤖 ANALYSE IA — TRANSFERT HORS UE
              </div>
              <div style={{ fontSize: 12, color: "#ccc", lineHeight: 1.6 }}>
                Les photos et données analysées par l'IA sont transmises à <strong>Anthropic</strong> (États-Unis).<br />
                Anthropic ne conserve pas vos données après traitement (max 30 jours).
              </div>
            </div>

            <div style={{ background: "#0a0a0a", border: "1px solid #2a2a2a", borderRadius: 8, padding: 14, marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#3b82f6", letterSpacing: 1, marginBottom: 8 }}>
                ✓ VOS DROITS RGPD
              </div>
              <div style={{ fontSize: 12, color: "#ccc", lineHeight: 1.6 }}>
                Accès · Rectification · Suppression · Portabilité<br />
                Pour exercer vos droits : <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong>
              </div>
            </div>

            <div style={{ fontSize: 11, color: "#888", textAlign: "center", lineHeight: 1.5, marginBottom: 18, fontStyle: "italic" }}>
              En cliquant sur "J'accepte", vous reconnaissez avoir pris connaissance<br />
              du traitement de vos données conformément au RGPD.
            </div>

            <div style={{ display: "flex", gap: 8, flexDirection: isDesktop ? "row" : "column-reverse" }}>
              <button onClick={declineRGPD}
                style={{
                  flex: isDesktop ? "0 1 auto" : "1",
                  padding: "12px 18px",
                  background: "#1e293b", color: "#94a3b8",
                  border: "1px solid #2a2a2a", borderRadius: 8,
                  fontSize: 13, fontWeight: 700, cursor: "pointer",
                }}>
                Refuser et se déconnecter
              </button>
              <button onClick={acceptRGPD}
                style={{
                  flex: 1,
                  padding: "14px 20px",
                  background: "linear-gradient(135deg, #FFD835 0%, #F5C800 50%, #d4a800 100%)",
                  color: "#111",
                  border: "none", borderRadius: 8,
                  fontSize: 14, fontWeight: 900, cursor: "pointer",
                  boxShadow: "0 4px 14px rgba(245,200,0,0.4), inset 0 1px 2px rgba(255,255,255,0.5)",
                }}>
                ✓ J'accepte et continue
              </button>
            </div>

            <div style={{ marginTop: 14, fontSize: 10, color: "#666", textAlign: "center" }}>
              Politique complète : <a href="https://www.diags-fndi.fr/confidentialite" target="_blank" rel="noopener noreferrer" style={{ color: "#F5C800" }}>diags-fndi.fr/confidentialite</a>
            </div>
          </div>
        </>
      )}

      {/* Panel Mon adhésion (placeholder) */}
      {showAbonnement && (
        <>
          <div onClick={() => setShowAbonnement(false)}
            style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", zIndex: 1000 }} />
          <div style={{
            position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: 16,
            width: "90%", maxWidth: 480, maxHeight: "85vh", overflow: "auto",
            zIndex: 1001, padding: 24,
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 20, fontWeight: 900, color: "#F5C800" }}>💳 Mon adhésion FNDi</div>
              <button onClick={() => setShowAbonnement(false)}
                style={{ background: "none", border: "none", color: "#888", fontSize: 22, cursor: "pointer" }}>✕</button>
            </div>

            <div style={{ textAlign: "center", padding: "30px 20px" }}>
              <div style={{ fontSize: 56, marginBottom: 16 }}>🚧</div>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#F5C800", marginBottom: 10 }}>
                Bientôt disponible
              </div>
              <div style={{ fontSize: 13, color: "#aaa", lineHeight: 1.6, marginBottom: 20 }}>
                La gestion des cotisations FNDi sera disponible prochainement.
                <br /><br />
                Vous pourrez gérer votre adhésion, consulter votre quota d'analyses IA et renouveler votre cotisation directement depuis cette interface.
              </div>

              <div style={{ background: "#F5C80011", border: "1px solid #F5C80033", borderRadius: 10, padding: 16, textAlign: "left", marginTop: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#F5C800", letterSpacing: 1, marginBottom: 8 }}>
                  📋 STATUT ACTUEL
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                  <span style={{ color: "#888" }}>Type</span>
                  <span style={{ color: "#fff", fontWeight: 700 }}>Découverte</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                  <span style={{ color: "#888" }}>Accès</span>
                  <span style={{ color: "#22c55e", fontWeight: 700 }}>✓ Tous les modules</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 13 }}>
                  <span style={{ color: "#888" }}>Période</span>
                  <span style={{ color: "#fff", fontWeight: 700 }}>Bêta gratuite</span>
                </div>
              </div>

              <div style={{ marginTop: 20, fontSize: 11, color: "#666", fontStyle: "italic" }}>
                Pour toute question : adhesion@fnddi.fr
              </div>
            </div>
          </div>
        </>
      )}

      {/* Panel Mes Dossiers */}
      {showDossiers && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", zIndex: 1000, display: "flex", alignItems: "flex-end" }}>
          <div style={{ background: COLORS.bg, borderRadius: "20px 20px 0 0", width: "100%", maxHeight: "80vh", overflowY: "auto", padding: "20px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: COLORS.accent }}>📂 Mes dossiers DPE</div>
              <button onClick={() => setShowDossiers(false)} style={{ background: "none", border: "none", color: COLORS.muted, fontSize: 28, cursor: "pointer" }}>×</button>
            </div>

            {/* Dossier en cours */}
            {(logement.adresse || logement.ademe_numero) && (
              <div style={{ background: COLORS.green + "15", border: `1px solid ${COLORS.green}44`, borderRadius: 12, padding: "14px", marginBottom: 16 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.green, marginBottom: 8, textTransform: "uppercase" }}>Dossier en cours</div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{logement.adresse || "—"}</div>
                <div style={{ fontSize: 12, color: COLORS.muted }}>{logement.proprio_prenom} {logement.proprio_nom} {logement.dpe_lettre ? `· DPE ${logement.dpe_lettre}` : ""}</div>
                <button onClick={() => { sauvegarderDossier(); setShowDossiers(false); }}
                  style={{ ...styles.btn("primary"), marginTop: 10, fontSize: 12, width: "100%" }}>
                  💾 Sauvegarder ce dossier
                </button>
              </div>
            )}

            {/* Liste dossiers sauvegardés */}
            {getDossiers().length === 0 ? (
              <div style={{ textAlign: "center", padding: 30, color: COLORS.muted, fontSize: 14 }}>
                <div style={{ fontSize: 40, marginBottom: 10 }}>📭</div>
                Aucun dossier sauvegardé.<br/>Cliquez sur <strong>💾 Sauvegarder</strong> pour conserver le dossier en cours.
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {getDossiers().map(d => (
                  <div key={d.id} style={{ background: COLORS.surface, borderRadius: 12, padding: "14px", border: `1px solid ${COLORS.border}` }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 3 }}>{d.adresse}</div>
                        <div style={{ fontSize: 12, color: COLORS.muted }}>
                          {d.proprietaire} {d.dpe_lettre ? `· DPE ${d.dpe_lettre}` : ""} {d.ademe_numero ? `· N° ${d.ademe_numero}` : ""}
                        </div>
                        <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>Sauvegardé le {d.date}</div>
                      </div>
                      <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                        <button onClick={() => ouvrirDossier(d)}
                          style={{ ...styles.btn("primary"), fontSize: 11, padding: "6px 12px" }}>
                          📂 Ouvrir
                        </button>
                        <button onClick={() => supprimerDossier(d.id)}
                          style={{ ...styles.btn("secondary"), fontSize: 11, padding: "6px 10px", color: COLORS.red }}>
                          🗑️
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal Profil diagnostiqueur (sync localStorage + Upstash) */}
      {showProfil && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
             onClick={() => setShowProfil(false)}>
          <div onClick={e => e.stopPropagation()}
               style={{ background: COLORS.bg, borderRadius: 16, width: "100%", maxWidth: 600, maxHeight: "90vh", overflowY: "auto", padding: "24px", border: `1px solid ${COLORS.border}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#F5C800" }}>👤 Mes coordonnées</div>
                <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 2 }}>
                  Utilisées dans tous vos rapports DOMYQO-FNDI · Synchronisées sur tous vos appareils
                </div>
              </div>
              <button onClick={() => setShowProfil(false)} style={{ background: "none", border: "none", color: COLORS.muted, fontSize: 28, cursor: "pointer", padding: 0 }}>×</button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {/* Identité */}
              <div style={{ fontSize: 10, fontWeight: 700, color: "#F5C800", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 4 }}>Identité</div>
              <input type="text" placeholder="Nom complet (Prénom NOM)"
                value={diag.nom || ""} onChange={e => handleDiagChange("nom", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <input type="email" placeholder="Email professionnel"
                value={diag.email || ""} onChange={e => handleDiagChange("email", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <input type="tel" placeholder="Téléphone"
                value={diag.tel || ""} onChange={e => handleDiagChange("tel", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />

              {/* Société */}
              <div style={{ fontSize: 10, fontWeight: 700, color: "#F5C800", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 10 }}>Société</div>
              <input type="text" placeholder="Société / Entreprise"
                value={diag.entreprise || ""} onChange={e => handleDiagChange("entreprise", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <input type="text" placeholder="Adresse professionnelle"
                value={diag.adresse_diag || ""} onChange={e => handleDiagChange("adresse_diag", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <input type="text" placeholder="SIRET (14 chiffres)"
                value={diag.siret || ""} onChange={e => handleDiagChange("siret", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />

              {/* Certification */}
              <div style={{ fontSize: 10, fontWeight: 700, color: "#F5C800", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 10 }}>Certification</div>
              <input type="text" placeholder="N° de certification"
                value={diag.certification || ""} onChange={e => handleDiagChange("certification", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <input type="text" placeholder="Organisme certificateur (ex: Bureau Veritas, AFNOR...)"
                value={diag.organisme || ""} onChange={e => handleDiagChange("organisme", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ fontSize: 11, color: COLORS.muted, fontWeight: 600 }}>Date de validité (jusqu'au)</label>
                <input type="date"
                  value={diag.validite || ""} onChange={e => handleDiagChange("validite", e.target.value)}
                  style={{ ...styles.input, fontSize: 14 }} />
              </div>

              {/* Assurance */}
              <div style={{ fontSize: 10, fontWeight: 700, color: "#F5C800", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 10 }}>Assurance professionnelle</div>
              <input type="text" placeholder="Compagnie + N° contrat (ex: Allianz N° 123456789)"
                value={diag.assurance || ""} onChange={e => handleDiagChange("assurance", e.target.value)}
                style={{ ...styles.input, fontSize: 14 }} />

              {/* Logo */}
              <div style={{ fontSize: 10, fontWeight: 700, color: "#F5C800", textTransform: "uppercase", letterSpacing: 0.5, marginTop: 10 }}>Logo de la société</div>
              <div style={{ display: "flex", gap: 12, alignItems: "center", padding: 12, borderRadius: 8, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
                {diag.logoBase64
                  ? <img alt="" src={diag.logoBase64} style={{ height: 50, maxWidth: 130, objectFit: "contain", borderRadius: 4, background: "#fff", padding: 4 }} />
                  : <div style={{ width: 100, height: 50, background: COLORS.card, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", color: COLORS.muted, fontSize: 11 }}>Aucun logo</div>}
                <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
                  <input type="file" accept="image/*" id="profil-logo-input"
                    style={{ display: "none" }}
                    onChange={async e => {
                      const file = e.target.files[0];
                      if (!file) return;
                      try {
                        const b64 = await compressImageBase64(file, 400, 0.85);
                        handleDiagChange("logoBase64", b64);
                      } catch (err) { alert("Erreur compression logo"); }
                    }} />
                  <button onClick={() => document.getElementById("profil-logo-input").click()}
                    style={{ padding: "8px 14px", borderRadius: 6, border: "none", background: "#F5C800", color: "#111", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                    📁 Choisir un logo
                  </button>
                  {diag.logoBase64 && (
                    <button onClick={() => handleDiagChange("logoBase64", "")}
                      style={{ padding: "6px 12px", borderRadius: 6, border: `1px solid ${COLORS.border}`, background: "transparent", color: COLORS.muted, fontWeight: 600, fontSize: 11, cursor: "pointer" }}>
                      🗑️ Supprimer
                    </button>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 14, padding: "12px", background: "#F5C80011", border: "1px solid #F5C80033", borderRadius: 8, fontSize: 11, color: "#F5C800", lineHeight: 1.5 }}>
                💡 Vos coordonnées sont automatiquement sauvegardées sur cet appareil et synchronisées avec votre compte FNDi. Elles apparaîtront en bas de tous vos rapports.
              </div>

              <button onClick={() => setShowProfil(false)}
                style={{ marginTop: 8, padding: "12px", borderRadius: 8, border: "none", background: "#F5C800", color: "#111", fontWeight: 800, fontSize: 14, cursor: "pointer" }}>
                ✓ Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Menu Central (FAB) */}
      {showCenterMenu && (
        <div onClick={() => setShowCenterMenu(false)}
             style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.85)", zIndex: 1500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()}
               style={{ background: COLORS.bg, borderRadius: 18, width: "100%", maxWidth: 420, maxHeight: "90vh", overflowY: "auto", padding: "24px 18px", border: `1px solid ${COLORS.border}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: "#888", letterSpacing: 2 }}>CHOISISSEZ UN MODULE</div>
              <button onClick={() => setShowCenterMenu(false)} style={{ background: "none", border: "none", color: COLORS.muted, fontSize: 28, cursor: "pointer", padding: 0, lineHeight: 1 }}>×</button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {MODULES.map(m => {
                const isYellow = m.id === "scanner_dpe";
                return (
                  <button key={m.id} onClick={() => { setModule(m.id); if (m.id === "dpe_xml") setTab(0); setShowCenterMenu(false); }}
                    style={{
                      background: m.color, border: "none", borderRadius: 14,
                      padding: "16px 18px", display: "flex", alignItems: "center", gap: 14,
                      cursor: "pointer", color: isYellow ? "#111" : "#fff", textAlign: "left", width: "100%",
                    }}>
                    <div style={{ fontSize: 28, flexShrink: 0 }}>
                      {m.icon === "amiante-badge" ? renderAmianteBadge(28) : m.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 16, fontWeight: 800 }}>{m.label}</div>
                      <div style={{ fontSize: 11, opacity: 0.85, marginTop: 2 }}>{m.subLabel}</div>
                    </div>
                    <div style={{ fontSize: 22, opacity: 0.5, flexShrink: 0 }}>›</div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Modal Auth Admin */}
      {showAdminAuth && (
        <div onClick={() => { setShowAdminAuth(false); setAdminPassword(""); setAdminError(""); }}
             style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.85)", zIndex: 1600, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()}
               style={{ background: COLORS.bg, borderRadius: 14, width: "100%", maxWidth: 360, padding: "24px 20px", border: `1px solid ${COLORS.border}` }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#F5C800", marginBottom: 6, textAlign: "center" }}>🔐 Accès Administration</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginBottom: 16, textAlign: "center" }}>Saisissez le code d'accès</div>
            <input type="password"
              autoFocus
              placeholder="Code d'accès"
              value={adminPassword}
              onChange={e => { setAdminPassword(e.target.value); setAdminError(""); }}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  if (adminPassword === "FNDI2024!") {
                    setModule("admin");
                    setShowAdminAuth(false);
                    setAdminPassword("");
                    setAdminError("");
                  } else {
                    setAdminError("Code incorrect");
                  }
                }
              }}
              style={{ ...styles.input, fontSize: 16, textAlign: "center", letterSpacing: 2 }} />
            {adminError && (
              <div style={{ marginTop: 10, padding: "8px 12px", background: "#7f1d1d44", border: "1px solid #dc262644", borderRadius: 6, color: "#fca5a5", fontSize: 12, textAlign: "center" }}>
                ❌ {adminError}
              </div>
            )}
            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
              <button onClick={() => { setShowAdminAuth(false); setAdminPassword(""); setAdminError(""); }}
                style={{ flex: 1, padding: "10px", borderRadius: 8, border: `1px solid ${COLORS.border}`, background: "transparent", color: COLORS.muted, fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
                Annuler
              </button>
              <button onClick={() => {
                if (adminPassword === "FNDI2024!") {
                  setModule("admin");
                  setShowAdminAuth(false);
                  setAdminPassword("");
                  setAdminError("");
                } else {
                  setAdminError("Code incorrect");
                }
              }}
                style={{ flex: 1, padding: "10px", borderRadius: 8, border: "none", background: "#F5C800", color: "#111", fontWeight: 800, fontSize: 13, cursor: "pointer" }}>
                Valider
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bouton FAB flottant — retour au menu central, visible seulement dans un module */}
      {navLevel === "module" && (
      <button onClick={() => { setModule(null); setNavLevel("menu"); }}
        title="Retour au menu"
        style={{
          position: "fixed", bottom: 20, right: 20,
          width: 56, height: 56, borderRadius: "50%",
          background: "#F5C800", border: "none",
          boxShadow: "0 4px 16px rgba(245,200,0,0.45), 0 2px 6px rgba(0,0,0,0.3)",
          cursor: "pointer", zIndex: 900,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
        <svg viewBox="0 0 24 24" width="26" height="26" fill="#111">
          <path d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z"/>
        </svg>
      </button>
      )}

      {/* Navigation modules — visible uniquement quand on est dans un module */}
      {navLevel === "module" && (
      <div style={{
        display: isDesktop ? "flex" : "grid",
        gridTemplateColumns: isDesktop ? undefined : "1fr 1fr 1fr",
        flexWrap: isDesktop ? "nowrap" : undefined,
        justifyContent: isDesktop ? "stretch" : undefined,
        gap: isDesktop ? 8 : 6,
        padding: isDesktop ? "10px 14px" : "10px 10px",
        borderBottom: `1px solid ${COLORS.border}`,
        background: COLORS.bg,
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        overflowX: isDesktop ? "auto" : "visible",
        WebkitOverflowScrolling: "touch",
      }}>
        {MODULES.map(m => {
          const active = module_ === m.id;
          const isYellow = m.id === "scanner_dpe";
          return (
            <button key={m.id} onClick={() => { setModule(m.id); if (m.id === "dpe_xml") setTab(0); }}
              style={{
                flex: isDesktop ? "1 1 0" : undefined,
                minWidth: isDesktop ? 100 : 0,
                height: isDesktop ? 80 : 64,
                width: isDesktop ? undefined : "100%",
                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                padding: isDesktop ? "8px 10px" : "6px 7px",
                borderRadius: isDesktop ? 14 : 11,
                border: "none",
                cursor: "pointer",
                fontWeight: 800,
                fontSize: isDesktop ? 12 : 11,
                lineHeight: 1.2,
                transition: "all 0.15s",
                // Couleurs vives au repos, atténuées si actif (logique inverse demandée)
                background: active ? `${m.color}33` : m.color,
                color: active ? m.color : (isYellow ? "#111" : "#fff"),
                outline: active ? `2px solid ${m.color}` : "none",
                outlineOffset: -2,
              }}>
              <span style={{ fontSize: isDesktop ? 26 : 22, marginBottom: 4 }}>
                {m.icon === "amiante-badge" ? renderAmianteBadge(isDesktop ? 26 : 22) : m.icon}
              </span>
              <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                {m.shortLabel}
              </span>
            </button>
          );
        })}
      </div>
      )}

      {/* Barre d'action commune DPE XML + Saisie : Nouveau · Sauvegarder · Mes dossiers */}
      {(module_ === "dpe_xml" || module_ === "dpe_saisie") && (
        <div style={{
          display: "flex", gap: 8, padding: "12px 14px 0",
          maxWidth: 760, margin: "0 auto", width: "100%", boxSizing: "border-box",
          flexWrap: "wrap", justifyContent: "center",
        }}>
          <button onClick={nouveauDossier}
            style={{
              padding: "8px 14px", background: "#16a34a", color: "#fff",
              border: "none", borderRadius: 8, fontSize: 12, fontWeight: 800, cursor: "pointer",
              display: "flex", alignItems: "center", gap: 6,
              boxShadow: "0 2px 6px rgba(22,163,74,0.3)",
            }}>
            ➕ Nouveau dossier
          </button>
          <button onClick={sauvegarderDossier}
            style={{
              padding: "8px 14px", background: "#3b82f6", color: "#fff",
              border: "none", borderRadius: 8, fontSize: 12, fontWeight: 800, cursor: "pointer",
              display: "flex", alignItems: "center", gap: 6,
              boxShadow: "0 2px 6px rgba(59,130,246,0.3)",
            }}>
            💾 Sauvegarder
          </button>
          <button onClick={() => setShowDossiers(true)}
            style={{
              padding: "8px 14px", background: "#1e293b", color: "#94a3b8",
              border: "1px solid #334155", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer",
              display: "flex", alignItems: "center", gap: 6,
            }}>
            📂 Mes dossiers
          </button>
        </div>
      )}

      {/* Sous-onglets DPE Projeté XML — Style "dossiers" avec progression */}
      {module_ === "dpe_xml" && (
        <div style={{
          display: "flex", gap: 2, padding: "16px 14px 0",
          maxWidth: 760, margin: "0 auto", width: "100%", boxSizing: "border-box",
          overflowX: "auto", WebkitOverflowScrolling: "touch",
        }}>
          {DPE_XML_TABS.map((t, i) => {
            const isActive = tab === i;
            const isComplete = i < tab && t.enabled;
            const isDisabled = !t.enabled;
            // Couleurs
            const bg = isActive ? "#3b82f6" : (isComplete ? "#14532d" : "#1e293b");
            const color = isActive ? "#fff" : (isComplete ? "#86efac" : (isDisabled ? "#475569" : "#94a3b8"));
            const prefix = isActive ? "▶ " : (isComplete ? "✓ " : "");
            return (
              <button key={t.id}
                onClick={() => t.enabled && setTab(i)}
                disabled={isDisabled}
                title={isDisabled ? "Bientôt disponible" : t.label}
                style={{
                  padding: "10px 12px",
                  background: bg,
                  border: "none",
                  color: color,
                  fontSize: 11,
                  fontWeight: isActive || isComplete ? 800 : 700,
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  borderRadius: "8px 8px 0 0",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  opacity: isDisabled ? 0.6 : 1,
                  transition: "all 0.15s",
                }}>
                {prefix}{t.label}
              </button>
            );
          })}
        </div>
      )}

      {/* Trait bleu sous les onglets */}
      {module_ === "dpe_xml" && (
        <div style={{
          height: 4, background: "#3b82f6",
          maxWidth: 760, margin: "0 auto", width: "100%", boxSizing: "border-box",
        }} />
      )}

      <div style={styles.content}>
        {/* NIVEAU 1 — Page d'accueil "Bienvenue" avec bouton Go ! cliquable */}
        {navLevel === "welcome" && (
          <div style={{
            padding: isDesktop ? "60px 20px 80px" : "40px 16px 60px",
            textAlign: "center", maxWidth: 480, margin: "0 auto",
            minHeight: isDesktop ? 500 : 400,
            display: "flex", flexDirection: "column", justifyContent: "center",
            position: "relative",
          }}>
            {isDesktop && (
              <svg viewBox="0 0 500 220" style={{
                position: "absolute", top: "50%", left: "50%",
                transform: "translate(-50%, -50%)",
                width: 700, height: "auto",
                opacity: 0.04, pointerEvents: "none", zIndex: 0,
              }} xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="310" cy="110" rx="130" ry="110" fill="#F5C800" />
                <ellipse cx="345" cy="75" rx="70" ry="65" fill="#000" />
                <text x="10" y="175" fontFamily="Arial Black, sans-serif" fontWeight="900" fontSize="175" fill="#F5C800" letterSpacing="-8">FNDi</text>
                <circle cx="462" cy="28" r="22" fill="#F5C800" />
              </svg>
            )}

            <div style={{ position: "relative", zIndex: 1 }}>
              <div style={{
                fontSize: isDesktop ? 32 : 24, fontWeight: 800, color: "#F5C800",
                marginBottom: 22, letterSpacing: 0.3,
              }}>
                Bienvenue sur ton appli !
              </div>

              <div style={{
                fontSize: isDesktop ? 16 : 13, color: "#ddd", lineHeight: 1.75, marginBottom: 16,
              }}>
                Une application conçue par <strong style={{ color: "#E8762F" }}>DOMYQO</strong>
                {" "}en partenariat avec la <strong style={{ color: "#F5C800" }}>FNDi</strong>,
                {" "}par des diagnostiqueurs, pour t'accompagner concrètement sur le terrain.
              </div>

              <div style={{
                fontSize: isDesktop ? 16 : 13, color: "#aaa", lineHeight: 1.75,
                fontStyle: "italic", marginBottom: 36,
              }}>
                Si elle t'aide à réaliser des diagnostics encore plus précis, alors mission accomplie...
              </div>

              <button onClick={() => setNavLevel("menu")}
                style={{
                  margin: "0 auto",
                  padding: isDesktop ? "18px 72px" : "14px 48px",
                  fontSize: isDesktop ? 32 : 24, fontWeight: 900,
                  color: "#111", background: "#F5C800",
                  border: "none", borderRadius: 999,
                  letterSpacing: 2, cursor: "pointer",
                  boxShadow: "0 6px 24px rgba(245,200,0,0.5)",
                  transition: "transform 0.15s, box-shadow 0.15s",
                }}
                onMouseEnter={e => {
                  if (isDesktop) {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 8px 32px rgba(245,200,0,0.7)";
                  }
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0 6px 24px rgba(245,200,0,0.5)";
                }}
                onMouseDown={e => e.currentTarget.style.transform = "scale(0.96)"}
                onMouseUp={e => e.currentTarget.style.transform = isDesktop ? "scale(1.05)" : "scale(1)"}>
                Go !
              </button>
            </div>
          </div>
        )}

        {/* NIVEAU 2 — Menu central avec les modules */}
        {navLevel === "menu" && (
          <div style={{
            padding: isDesktop ? "30px 20px 80px" : "20px 14px 60px",
            maxWidth: isDesktop ? 720 : 460, margin: "0 auto",
          }}>
            <div style={{ textAlign: "center", marginBottom: 22 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#888", letterSpacing: 2 }}>
                CHOISISSEZ UN MODULE
              </div>
            </div>

            <div style={{
              display: isDesktop ? "grid" : "flex",
              gridTemplateColumns: isDesktop ? "1fr 1fr" : undefined,
              flexDirection: isDesktop ? undefined : "column",
              gap: 12,
            }}>
              {MODULES.map((m, idx) => {
                const isYellow = m.id === "scanner_dpe";
                const isLast = idx === MODULES.length - 1;
                const oddCount = MODULES.length % 2 === 1;
                const spanFull = isDesktop && isLast && oddCount;
                return (
                  <button key={m.id}
                    onClick={() => {
                      setModule(m.id);
                      if (m.id === "dpe_xml") setTab(0);
                      setNavLevel("module");
                    }}
                    style={{
                      background: m.color, border: "none", borderRadius: 14,
                      padding: isDesktop ? "20px 22px" : "18px 20px",
                      display: "flex", alignItems: "center", gap: 16,
                      cursor: "pointer", color: isYellow ? "#111" : "#fff", textAlign: "left", width: "100%",
                      boxShadow: `0 4px 14px ${m.color}33`,
                      transition: "transform 0.15s, box-shadow 0.15s",
                      gridColumn: spanFull ? "1 / -1" : undefined,
                      minHeight: isDesktop ? 90 : 70,
                    }}
                    onMouseEnter={e => {
                      if (isDesktop) {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 8px 24px ${m.color}55`;
                      }
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = `0 4px 14px ${m.color}33`;
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
                    onMouseUp={e => e.currentTarget.style.transform = isDesktop ? "translateY(-2px)" : "scale(1)"}>
                    <div style={{ fontSize: isDesktop ? 36 : 30, flexShrink: 0, width: isDesktop ? 48 : 40, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      {m.icon === "amiante-badge" ? renderAmianteBadge(isDesktop ? 36 : 30) : m.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: isDesktop ? 19 : 17, fontWeight: 800 }}>{m.label}</div>
                      <div style={{ fontSize: isDesktop ? 13 : 12, opacity: 0.85, marginTop: 2 }}>{m.subLabel}</div>
                    </div>
                    <div style={{ fontSize: 24, opacity: 0.5, flexShrink: 0 }}>›</div>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* SCAN/DPE — Scanner d'équipements */}
        {module_ === "scanner_dpe" && <IdentifierTab onEquipmentAdded={(eq) => { handleEquipmentAdded(eq); setModule("dpe_xml"); setTab(0); setNavLevel("module"); }} />}

        {/* DPE PROJETÉ XML — 7 sous-onglets */}
        {/* 0 = Le Bien (sections administratives 1-3 + équipements) */}
        {module_ === "dpe_xml" && tab === 0 && (
          <LogementTab
            data={logement} onChange={handleLogementChange}
            equipments={equipments} setActiveTab={setTab}
            view="general"
          />
        )}

        {/* 1 = Descriptif (sections techniques 4-8) */}
        {module_ === "dpe_xml" && tab === 1 && (
          <LogementTab
            data={logement} onChange={handleLogementChange}
            equipments={equipments} setActiveTab={setTab}
            view="descriptif"
          />
        )}

        {/* 2 = Reco (anciennement Reco & Travaux) */}
        {module_ === "dpe_xml" && tab === 2 && (
          <CommentsTravauxTab
            data={logement} onChange={handleLogementChange} equipments={equipments}
            comments={comments} setComments={handleCommentsChange}
            travaux={travaux} setTravaux={handleTravauxChange}
          />
        )}

        {/* 3 = DPE Initial (= DPE Réalisé) */}
        {module_ === "dpe_xml" && tab === 3 && (
          <ResultTab
            data={logement} equipments={equipments} comments={comments}
            travaux={travaux} setTravaux={handleTravauxChange}
            onChange={handleLogementChange}
            section="realise"
          />
        )}

        {/* 4 = DPE Projeté */}
        {module_ === "dpe_xml" && tab === 4 && (
          <ResultTab
            data={logement} equipments={equipments} comments={comments}
            travaux={travaux} setTravaux={handleTravauxChange}
            onChange={handleLogementChange}
            section="projete"
          />
        )}

        {/* 5 = Synthèse */}
        {module_ === "dpe_xml" && tab === 5 && (
          <ResultTab
            data={logement} equipments={equipments} comments={comments}
            travaux={travaux} setTravaux={handleTravauxChange}
            onChange={handleLogementChange}
            section="synthese"
          />
        )}

        {/* 6 = Rapport */}
        {module_ === "dpe_xml" && tab === 6 && <RapportTab data={logement} equipments={equipments} comments={comments} travaux={travaux} diag={diag} onDiagChange={handleDiagChange} setDiag={setDiag} setActiveTab={setTab} />}

        {/* Boutons Précédent / Suivant pour DPE XML — homogénéisé avec DPE Saisie */}
        {module_ === "dpe_xml" && (
          <div style={{ display: "flex", gap: 8, marginTop: 24, flexWrap: "wrap" }}>
            {tab > 0 && (
              <button onClick={() => setTab(tab - 1)}
                style={{ flex: "0 1 auto", padding: "12px 16px", background: "#1e293b", color: "#94a3b8",
                  border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
                ← Précédent
              </button>
            )}
            {tab < DPE_XML_TABS.length - 1 && (
              <button onClick={() => setTab(tab + 1)}
                style={{ flex: 2, minWidth: 120, padding: "12px", background: "#3b82f6", color: "#fff",
                  border: "none", borderRadius: 8, fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
                Suivant : {DPE_XML_TABS[tab + 1].label} →
              </button>
            )}
          </div>
        )}

        {/* DPE PROJETÉ SAISIE — Wizard guidé en 5 étapes */}
        {module_ === "dpe_saisie" && (
          <DpeSaisieWizard
            logement={logement} onChange={handleLogementChange}
            equipments={equipments} diag={diag}
            onDiagChange={handleDiagChange} setDiag={setDiag}
            travaux={travaux} setTravaux={handleTravauxChange}
          />
        )}

        {/* AMIANTE */}
        {module_ === "amiante" && <Amiante />}

        {/* SCAN/ELEC — Module diagnostic électrique IA */}
        {module_ === "elec" && <Elec />}

        {/* PARASITE SCAN — Module 6 */}
        {module_ === "parasite" && <ParasiteRadar />}

        {/* ADMIN */}
        {module_ === "admin" && ADMIN_EMAILS.includes(localStorage.getItem("fndi_session_email") || DEFAULT_LOGIN) && <AdminPanel onLogout={onLogout} />}
        {module_ === "admin" && !ADMIN_EMAILS.includes(localStorage.getItem("fndi_session_email") || DEFAULT_LOGIN) && (
          <div style={{ ...styles.card, textAlign: "center", padding: 40 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
            <div style={{ fontWeight: 700, fontSize: 16 }}>Accès restreint</div>
            <div style={{ fontSize: 13, color: COLORS.muted, marginTop: 8 }}>Seuls les administrateurs FNDI ont accès à cette section.</div>
          </div>
        )}
      </div>

      {/* Footer avec liens légaux + accès Admin */}
      <div style={{
        marginTop: "auto", padding: "16px 14px 70px",
        textAlign: "center", borderTop: `1px solid ${COLORS.border}`,
        background: COLORS.bg, width: "100%", boxSizing: "border-box",
      }}>
        <div style={{ fontSize: 10, color: "#555", marginBottom: 8 }}>
          DOMYQO-FNDI · Outil d'aide à la décision · Non réglementaire
        </div>
        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginBottom: 6 }}>
          <button onClick={() => setShowLegalPage("mentions")}
            style={{ background: "none", border: "none", color: "#888", fontSize: 10, cursor: "pointer", padding: "2px 4px", textDecoration: "underline" }}>
            Mentions légales
          </button>
          <button onClick={() => setShowLegalPage("privacy")}
            style={{ background: "none", border: "none", color: "#888", fontSize: 10, cursor: "pointer", padding: "2px 4px", textDecoration: "underline" }}>
            Politique de confidentialité
          </button>
          <button onClick={() => setShowLegalPage("cgu")}
            style={{ background: "none", border: "none", color: "#888", fontSize: 10, cursor: "pointer", padding: "2px 4px", textDecoration: "underline" }}>
            CGU
          </button>
        </div>
        <button onClick={() => setShowAdminAuth(true)}
          style={{
            background: "none", border: "none", color: "#444",
            fontSize: 9, cursor: "pointer", padding: "2px 6px",
            opacity: 0.5, fontStyle: "italic",
          }}
          onMouseEnter={e => e.target.style.opacity = "1"}
          onMouseLeave={e => e.target.style.opacity = "0.5"}>
          Administration
        </button>
      </div>

      {/* Modal pages légales */}
      {showLegalPage && (
        <>
          <div onClick={() => setShowLegalPage(null)}
            style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.85)", zIndex: 2000 }} />
          <div style={{
            position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: 16,
            width: "94%", maxWidth: 720, maxHeight: "90vh", overflow: "auto",
            zIndex: 2001, padding: isDesktop ? 30 : 20,
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, paddingBottom: 14, borderBottom: "1px solid #2a2a2a" }}>
              <div style={{ fontSize: isDesktop ? 22 : 18, fontWeight: 900, color: "#F5C800" }}>
                {showLegalPage === "mentions" && "📋 Mentions légales"}
                {showLegalPage === "privacy" && "🔒 Politique de confidentialité"}
                {showLegalPage === "cgu" && "📜 Conditions Générales d'Utilisation"}
              </div>
              <button onClick={() => setShowLegalPage(null)}
                style={{ background: "none", border: "none", color: "#888", fontSize: 24, cursor: "pointer" }}>✕</button>
            </div>

            <div style={{ fontSize: 13, color: "#ddd", lineHeight: 1.7 }}>
              {showLegalPage === "mentions" && (
                <>
                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 0, marginBottom: 8 }}>1. Éditeur de l'application</h3>
                  <p>L'application <strong>DOMYQO-FNDI</strong> est éditée par :</p>
                  <p style={{ paddingLeft: 16, color: "#bbb" }}>
                    <strong>Fédération Nationale des Diagnostiqueurs Immobiliers</strong><br />
                    Association loi 1901<br />
                    Adresse : 6 rue d'Armaillé, 75017 Paris<br />
                    N° RNA : W751278527<br />
                    Email : <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong>
                  </p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>2. Directeur de la publication</h3>
                  <p>Julien HENRION, Président de la Fédération Nationale des Diagnostiqueurs Immobiliers</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>3. Hébergement</h3>
                  <p>L'application est hébergée par :</p>
                  <p style={{ paddingLeft: 16, color: "#bbb" }}>
                    <strong>Vercel Inc.</strong> (serveurs européens — Frankfurt, Allemagne)<br />
                    340 S Lemon Ave #4133, Walnut, CA 91789, USA<br />
                    Site : vercel.com
                  </p>
                  <p>Stockage des données :</p>
                  <p style={{ paddingLeft: 16, color: "#bbb" }}>
                    <strong>Upstash Inc.</strong> (serveurs européens — Irlande)<br />
                    Site : upstash.com
                  </p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>4. Propriété intellectuelle</h3>
                  <p>L'ensemble des éléments de l'application (textes, graphismes, logo, code) sont la propriété exclusive de la FNDi ou de ses partenaires. Toute reproduction, même partielle, est strictement interdite sans autorisation écrite préalable.</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>5. Crédits</h3>
                  <p>Conception et développement : FNDi<br />
                  Intelligence artificielle : Anthropic (Claude API)<br />
                  Logo FNDi : © FNDi — Tous droits réservés</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>6. Contact</h3>
                  <p>Pour toute question : <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong></p>

                  <p style={{ fontSize: 11, color: "#666", marginTop: 24, fontStyle: "italic", borderTop: "1px solid #2a2a2a", paddingTop: 12 }}>
                    Dernière mise à jour : Mai 2026
                  </p>
                </>
              )}

              {showLegalPage === "privacy" && (
                <>
                  <p style={{ background: "#0a0a0a", padding: 12, borderRadius: 8, fontSize: 12, marginTop: 0, marginBottom: 16, border: "1px solid #2a2a2a" }}>
                    <strong style={{ color: "#F5C800" }}>En bref :</strong> DOMYQO-FNDI traite vos données dans le strict respect du RGPD. Vos données sont stockées en Union Européenne. Vous gardez le contrôle total : accès, rectification, suppression possibles à tout moment.
                  </p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 0, marginBottom: 8 }}>1. Responsable du traitement</h3>
                  <p><strong>FNDi — Fédération Nationale des Diagnostiqueurs Immobiliers</strong> (association loi 1901)<br />
                  Email : <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong></p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>2. Données collectées</h3>
                  <p><strong>Concernant le diagnostiqueur :</strong></p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Nom, prénom, email</li>
                    <li>Coordonnées professionnelles (société, SIRET, adresse, téléphone)</li>
                    <li>Numéro et organisme de certification</li>
                    <li>Données d'assurance professionnelle (RC Pro)</li>
                    <li>Logo professionnel (optionnel)</li>
                  </ul>
                  <p><strong>Concernant les biens diagnostiqués :</strong></p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Adresse du bien</li>
                    <li>Caractéristiques techniques (surface, année, isolation, etc.)</li>
                    <li>Photos des équipements et zones diagnostiquées</li>
                    <li>Données énergétiques (consommation, classe DPE)</li>
                  </ul>
                  <p><strong>Concernant les propriétaires :</strong> nom et coordonnées (si renseignés par le diagnostiqueur)</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>3. Base légale</h3>
                  <ul style={{ paddingLeft: 20 }}>
                    <li><strong>Consentement</strong> (Article 6.1.a RGPD) : pour l'utilisation de l'application</li>
                    <li><strong>Exécution d'un contrat</strong> (Article 6.1.b) : adhésion à la FNDi</li>
                    <li><strong>Intérêt légitime</strong> (Article 6.1.f) : amélioration et sécurité du service</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>4. Finalités du traitement</h3>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Aide à la saisie et au traitement de dossiers de diagnostic</li>
                    <li>Génération de rapports d'aide à la décision</li>
                    <li>Synchronisation entre vos appareils (PC/Mobile)</li>
                    <li>Analyse IA des photos pour assistance au diagnostiqueur</li>
                    <li>Gestion de votre adhésion à la FNDi</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>5. Hébergement et localisation</h3>
                  <p>🇪🇺 <strong>Stockage en Union Européenne :</strong></p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li><strong>Vercel</strong> (Frankfurt, Allemagne) : hébergement de l'application</li>
                    <li><strong>Upstash</strong> (Irlande) : base de données et stockage des dossiers</li>
                  </ul>

                  <h3 style={{ color: "#f97316", fontSize: 15, marginTop: 18, marginBottom: 8 }}>6. Transfert hors UE — Anthropic (USA)</h3>
                  <p>Pour les fonctionnalités d'analyse par intelligence artificielle (SCAN/DPE, SCAN/ELEC, PARASITE/SCAN), les <strong>photos et données soumises sont transmises à Anthropic Inc.</strong> (États-Unis) qui exploite l'API Claude.</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Anthropic ne conserve pas vos données après traitement (max 30 jours)</li>
                    <li>Anthropic ne réutilise pas vos données pour entraîner ses modèles</li>
                    <li>Transfert basé sur les <strong>Clauses Contractuelles Types</strong> (Article 46.2.c RGPD)</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>7. Durée de conservation</h3>
                  <ul style={{ paddingLeft: 20 }}>
                    <li><strong>Compte diagnostiqueur :</strong> jusqu'à demande de suppression</li>
                    <li><strong>Dossiers de diagnostic :</strong> jusqu'à suppression manuelle par l'utilisateur</li>
                    <li><strong>Photos et analyses IA :</strong> 14 jours puis purge automatique</li>
                    <li><strong>Logs techniques :</strong> 12 mois maximum</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>8. Vos droits RGPD</h3>
                  <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants :</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li><strong>Droit d'accès</strong> : obtenir la copie de vos données</li>
                    <li><strong>Droit de rectification</strong> : corriger vos données inexactes</li>
                    <li><strong>Droit à l'effacement</strong> (oubli) : supprimer votre compte</li>
                    <li><strong>Droit à la portabilité</strong> : récupérer vos données dans un format ouvert</li>
                    <li><strong>Droit d'opposition</strong> : refuser certains traitements</li>
                    <li><strong>Droit de réclamation</strong> auprès de la CNIL (cnil.fr)</li>
                  </ul>
                  <p>Pour exercer ces droits : <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong></p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>9. Sécurité</h3>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Chiffrement HTTPS de toutes les communications</li>
                    <li>Authentification par tokens HMAC sécurisés</li>
                    <li>Hébergement européen ISO 27001</li>
                    <li>Pas de cookies de tracking ni publicité tierce</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>10. Cookies</h3>
                  <p>DOMYQO-FNDI utilise uniquement des données stockées localement (localStorage) pour mémoriser votre session et vos préférences. <strong>Aucun cookie de tracking ni publicitaire.</strong></p>

                  <p style={{ fontSize: 11, color: "#666", marginTop: 24, fontStyle: "italic", borderTop: "1px solid #2a2a2a", paddingTop: 12 }}>
                    Politique mise à jour le : Mai 2026 — Version 1.0
                  </p>
                </>
              )}

              {showLegalPage === "cgu" && (
                <>
                  <p style={{ background: "#0a0a0a", padding: 12, borderRadius: 8, fontSize: 12, marginTop: 0, marginBottom: 16, border: "1px solid #2a2a2a" }}>
                    <strong style={{ color: "#F5C800" }}>En bref :</strong> DOMYQO-FNDI est un outil d'aide à la décision pour les diagnostiqueurs adhérents à la FNDi. Les analyses IA sont indicatives et ne remplacent pas le jugement professionnel certifié.
                  </p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 0, marginBottom: 8 }}>1. Objet</h3>
                  <p>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'usage de l'application <strong>DOMYQO-FNDI</strong>, éditée par la Fédération Nationale des Diagnostiqueurs Immobiliers (FNDi).</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>2. Acceptation</h3>
                  <p>L'utilisation de l'application implique l'acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas, vous devez cesser d'utiliser l'application.</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>3. Conditions d'accès</h3>
                  <p>L'accès à DOMYQO-FNDI est réservé aux <strong>diagnostiqueurs adhérents à la FNDi</strong>. L'utilisateur s'engage à :</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Être un diagnostiqueur immobilier <strong>certifié</strong> en activité</li>
                    <li>Disposer d'une <strong>assurance Responsabilité Civile Professionnelle</strong> en cours</li>
                    <li>Fournir des informations exactes et à jour</li>
                    <li>Maintenir la confidentialité de ses identifiants</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>4. Nature des fonctionnalités IA</h3>
                  <p>⚠️ <strong>Les fonctionnalités d'intelligence artificielle (SCAN/DPE, SCAN/ELEC, PARASITE/SCAN) sont des outils d'aide à la décision INDICATIFS.</strong></p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Les analyses IA <strong>ne remplacent pas</strong> le jugement professionnel certifié du diagnostiqueur</li>
                    <li>Le diagnostiqueur reste <strong>seul responsable</strong> de ses diagnostics et conclusions</li>
                    <li>Les résultats IA peuvent comporter des erreurs et doivent être <strong>systématiquement vérifiés</strong></li>
                    <li>Les pathologies parasitaires identifiées nécessitent <strong>confirmation laboratoire</strong></li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>5. Engagements de l'utilisateur</h3>
                  <p>L'utilisateur s'engage à :</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Utiliser l'application <strong>conformément à sa destination</strong> professionnelle</li>
                    <li>Ne pas tenter de contourner les mesures de sécurité</li>
                    <li>Ne pas surcharger les serveurs (pas d'usage automatisé/bot)</li>
                    <li>Respecter le secret professionnel sur les données clients</li>
                    <li>Ne pas partager son compte avec un tiers</li>
                  </ul>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>6. Limitation de responsabilité</h3>
                  <p>La FNDi met l'application à disposition <strong>"en l'état"</strong> et ne peut garantir :</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>L'absence totale d'erreurs ou de bugs</li>
                    <li>La disponibilité ininterrompue du service</li>
                    <li>L'exactitude absolue des analyses IA</li>
                  </ul>
                  <p>La responsabilité du diagnostiqueur dans l'exercice de sa mission n'est <strong>en aucun cas transférée</strong> à la FNDi par l'utilisation de l'application.</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>7. Propriété des données</h3>
                  <p>Les données saisies par le diagnostiqueur (dossiers, photos, rapports) <strong>lui appartiennent</strong>. La FNDi ne s'octroie aucun droit de réutilisation à des fins commerciales.</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>8. Suspension / Résiliation</h3>
                  <p>La FNDi se réserve le droit de suspendre ou résilier l'accès en cas de :</p>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>Non-respect des CGU</li>
                    <li>Cessation de l'adhésion à la FNDi</li>
                    <li>Usage frauduleux ou abusif</li>
                  </ul>
                  <p>L'utilisateur peut résilier son compte à tout moment en contactant <strong style={{ color: "#F5C800" }}>adhesion@fnddi.fr</strong></p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>9. Évolution des CGU</h3>
                  <p>Les CGU peuvent être modifiées à tout moment. Les utilisateurs sont informés des changements significatifs lors de leur prochaine connexion.</p>

                  <h3 style={{ color: "#F5C800", fontSize: 15, marginTop: 18, marginBottom: 8 }}>10. Droit applicable</h3>
                  <p>Les présentes CGU sont soumises au <strong>droit français</strong>. En cas de litige, et après tentative de résolution amiable, les tribunaux compétents seront ceux du siège social de la FNDi.</p>

                  <p style={{ fontSize: 11, color: "#666", marginTop: 24, fontStyle: "italic", borderTop: "1px solid #2a2a2a", paddingTop: 12 }}>
                    CGU mises à jour le : Mai 2026 — Version 1.0
                  </p>
                </>
              )}
            </div>

            <div style={{ marginTop: 20, paddingTop: 14, borderTop: "1px solid #2a2a2a", textAlign: "center" }}>
              <button onClick={() => setShowLegalPage(null)}
                style={{ padding: "10px 24px", background: "#F5C800", color: "#111", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 800, cursor: "pointer" }}>
                Fermer
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}